import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: number;
  fulfillment_type: 'nurse' | 'shipping';
  geography: import('../lib/geography').Geography;
  geometry: any;
  jsonb: any;
  numeric: number;
  shipping_direction: 'to_client' | 'to_lab';
  timestamptz: any;
  tsvector: any;
};

export type AdministratorLog = {
  __typename?: 'AdministratorLog';
  client?: Maybe<Client>;
  clientId?: Maybe<Scalars['Int']>;
  data?: Maybe<Scalars['jsonb']>;
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['Int']>;
  laboratory?: Maybe<Laboratory>;
  laboratoryId?: Maybe<Scalars['Int']>;
  nextData?: Maybe<Scalars['jsonb']>;
  nurse?: Maybe<Nurse>;
  nurseId?: Maybe<Scalars['Int']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']>;
  orderState?: Maybe<Order_State>;
  orderStateId?: Maybe<Scalars['Int']>;
  orderTest?: Maybe<Order_Test>;
  orderTestId?: Maybe<Scalars['Int']>;
  orderTestResult?: Maybe<Order_Test_Result>;
  prevData?: Maybe<Scalars['jsonb']>;
  sessionAdministrator?: Maybe<Administrator>;
  sessionAdministratorId?: Maybe<Scalars['Int']>;
  sessionClient?: Maybe<Client>;
  sessionClientId?: Maybe<Scalars['Int']>;
  sessionLabUser?: Maybe<Lab_User>;
  sessionLabUserId?: Maybe<Scalars['Int']>;
  sessionNurse?: Maybe<Nurse>;
  sessionNurseId?: Maybe<Scalars['Int']>;
  test?: Maybe<Test>;
  testId?: Maybe<Scalars['Int']>;
  timestamp: Scalars['timestamptz'];
  type: Scalars['String'];
};

export type AdministratorLogoutOutput = {
  __typename?: 'AdministratorLogoutOutput';
  result: Scalars['String'];
};

export type AdministratorOrderShipmentLabelOutput = {
  __typename?: 'AdministratorOrderShipmentLabelOutput';
  fileBase64?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type LabUserPasswordResetInitInput = {
  email: Scalars['String'];
};

export type LabUserPasswordResetInitOutput = {
  __typename?: 'LabUserPasswordResetInitOutput';
  result: Scalars['String'];
};

export type LabUserPasswordUpdateInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LabUserPasswordUpdateOutput = {
  __typename?: 'LabUserPasswordUpdateOutput';
  result: Scalars['String'];
};

export type NursePasswordUpdateInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type NursePasswordUpdateOutput = {
  __typename?: 'NursePasswordUpdateOutput';
  result: Scalars['String'];
};

export type PingOutput = {
  __typename?: 'PingOutput';
  pong: Scalars['Boolean'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "administrator" */
export type Administrator = {
  __typename?: 'administrator';
  email: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  notifications: Array<Administrator_Notification>;
  /** An aggregate relationship */
  notifications_aggregate: Administrator_Notification_Aggregate;
  phoneNumber?: Maybe<Scalars['String']>;
};


/** columns and relationships of "administrator" */
export type AdministratorNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Administrator_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Administrator_Notification_Order_By>>;
  where?: InputMaybe<Administrator_Notification_Bool_Exp>;
};


/** columns and relationships of "administrator" */
export type AdministratorNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Administrator_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Administrator_Notification_Order_By>>;
  where?: InputMaybe<Administrator_Notification_Bool_Exp>;
};

/** aggregated selection of "administrator" */
export type Administrator_Aggregate = {
  __typename?: 'administrator_aggregate';
  aggregate?: Maybe<Administrator_Aggregate_Fields>;
  nodes: Array<Administrator>;
};

/** aggregate fields of "administrator" */
export type Administrator_Aggregate_Fields = {
  __typename?: 'administrator_aggregate_fields';
  avg?: Maybe<Administrator_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Administrator_Max_Fields>;
  min?: Maybe<Administrator_Min_Fields>;
  stddev?: Maybe<Administrator_Stddev_Fields>;
  stddev_pop?: Maybe<Administrator_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Administrator_Stddev_Samp_Fields>;
  sum?: Maybe<Administrator_Sum_Fields>;
  var_pop?: Maybe<Administrator_Var_Pop_Fields>;
  var_samp?: Maybe<Administrator_Var_Samp_Fields>;
  variance?: Maybe<Administrator_Variance_Fields>;
};


/** aggregate fields of "administrator" */
export type Administrator_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Administrator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Administrator_Avg_Fields = {
  __typename?: 'administrator_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "administrator". All fields are combined with a logical 'AND'. */
export type Administrator_Bool_Exp = {
  _and?: InputMaybe<Array<Administrator_Bool_Exp>>;
  _not?: InputMaybe<Administrator_Bool_Exp>;
  _or?: InputMaybe<Array<Administrator_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notifications?: InputMaybe<Administrator_Notification_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Administrator_Notification_Aggregate_Bool_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Administrator_Max_Fields = {
  __typename?: 'administrator_max_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Administrator_Min_Fields = {
  __typename?: 'administrator_min_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "administrator" */
export type Administrator_Mutation_Response = {
  __typename?: 'administrator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Administrator>;
};

/** columns and relationships of "administrator_notification" */
export type Administrator_Notification = {
  __typename?: 'administrator_notification';
  /** An object relationship */
  administrator?: Maybe<Administrator>;
  administratorId: Scalars['Int'];
  email: Scalars['Boolean'];
  id: Scalars['Int'];
  scope: Scalars['String'];
  sms: Scalars['Boolean'];
};

/** aggregated selection of "administrator_notification" */
export type Administrator_Notification_Aggregate = {
  __typename?: 'administrator_notification_aggregate';
  aggregate?: Maybe<Administrator_Notification_Aggregate_Fields>;
  nodes: Array<Administrator_Notification>;
};

export type Administrator_Notification_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Administrator_Notification_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Administrator_Notification_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Administrator_Notification_Aggregate_Bool_Exp_Count>;
};

export type Administrator_Notification_Aggregate_Bool_Exp_Bool_And = {
  arguments: Administrator_Notification_Select_Column_Administrator_Notification_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Administrator_Notification_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Administrator_Notification_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Administrator_Notification_Select_Column_Administrator_Notification_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Administrator_Notification_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Administrator_Notification_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Administrator_Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Administrator_Notification_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "administrator_notification" */
export type Administrator_Notification_Aggregate_Fields = {
  __typename?: 'administrator_notification_aggregate_fields';
  avg?: Maybe<Administrator_Notification_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Administrator_Notification_Max_Fields>;
  min?: Maybe<Administrator_Notification_Min_Fields>;
  stddev?: Maybe<Administrator_Notification_Stddev_Fields>;
  stddev_pop?: Maybe<Administrator_Notification_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Administrator_Notification_Stddev_Samp_Fields>;
  sum?: Maybe<Administrator_Notification_Sum_Fields>;
  var_pop?: Maybe<Administrator_Notification_Var_Pop_Fields>;
  var_samp?: Maybe<Administrator_Notification_Var_Samp_Fields>;
  variance?: Maybe<Administrator_Notification_Variance_Fields>;
};


/** aggregate fields of "administrator_notification" */
export type Administrator_Notification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Administrator_Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "administrator_notification" */
export type Administrator_Notification_Aggregate_Order_By = {
  avg?: InputMaybe<Administrator_Notification_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Administrator_Notification_Max_Order_By>;
  min?: InputMaybe<Administrator_Notification_Min_Order_By>;
  stddev?: InputMaybe<Administrator_Notification_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Administrator_Notification_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Administrator_Notification_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Administrator_Notification_Sum_Order_By>;
  var_pop?: InputMaybe<Administrator_Notification_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Administrator_Notification_Var_Samp_Order_By>;
  variance?: InputMaybe<Administrator_Notification_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Administrator_Notification_Avg_Fields = {
  __typename?: 'administrator_notification_avg_fields';
  administratorId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "administrator_notification" */
export type Administrator_Notification_Avg_Order_By = {
  administratorId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "administrator_notification". All fields are combined with a logical 'AND'. */
export type Administrator_Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Administrator_Notification_Bool_Exp>>;
  _not?: InputMaybe<Administrator_Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Administrator_Notification_Bool_Exp>>;
  administrator?: InputMaybe<Administrator_Bool_Exp>;
  administratorId?: InputMaybe<Int_Comparison_Exp>;
  email?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  sms?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "administrator_notification" */
export enum Administrator_Notification_Constraint {
  /** unique or primary key constraint on columns "scope", "administrator_id" */
  AdministratorNotificationAdministratorIdScopeKey = 'administrator_notification_administrator_id_scope_key',
  /** unique or primary key constraint on columns "id" */
  AdministratorNotificationPkey = 'administrator_notification_pkey'
}

/** input type for incrementing numeric columns in table "administrator_notification" */
export type Administrator_Notification_Inc_Input = {
  administratorId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "administrator_notification" */
export type Administrator_Notification_Insert_Input = {
  administratorId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['Boolean']>;
  scope?: InputMaybe<Scalars['String']>;
  sms?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Administrator_Notification_Max_Fields = {
  __typename?: 'administrator_notification_max_fields';
  administratorId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  scope?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "administrator_notification" */
export type Administrator_Notification_Max_Order_By = {
  administratorId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Administrator_Notification_Min_Fields = {
  __typename?: 'administrator_notification_min_fields';
  administratorId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  scope?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "administrator_notification" */
export type Administrator_Notification_Min_Order_By = {
  administratorId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "administrator_notification" */
export type Administrator_Notification_Mutation_Response = {
  __typename?: 'administrator_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Administrator_Notification>;
};

/** on_conflict condition type for table "administrator_notification" */
export type Administrator_Notification_On_Conflict = {
  constraint: Administrator_Notification_Constraint;
  update_columns?: Array<Administrator_Notification_Update_Column>;
  where?: InputMaybe<Administrator_Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "administrator_notification". */
export type Administrator_Notification_Order_By = {
  administrator?: InputMaybe<Administrator_Order_By>;
  administratorId?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  sms?: InputMaybe<Order_By>;
};

/** primary key columns input for table: administrator_notification */
export type Administrator_Notification_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "administrator_notification" */
export enum Administrator_Notification_Select_Column {
  /** column name */
  AdministratorId = 'administratorId',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Scope = 'scope',
  /** column name */
  Sms = 'sms'
}

/** select "administrator_notification_aggregate_bool_exp_bool_and_arguments_columns" columns of table "administrator_notification" */
export enum Administrator_Notification_Select_Column_Administrator_Notification_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Email = 'email',
  /** column name */
  Sms = 'sms'
}

/** select "administrator_notification_aggregate_bool_exp_bool_or_arguments_columns" columns of table "administrator_notification" */
export enum Administrator_Notification_Select_Column_Administrator_Notification_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Email = 'email',
  /** column name */
  Sms = 'sms'
}

/** input type for updating data in table "administrator_notification" */
export type Administrator_Notification_Set_Input = {
  administratorId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['Boolean']>;
  scope?: InputMaybe<Scalars['String']>;
  sms?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Administrator_Notification_Stddev_Fields = {
  __typename?: 'administrator_notification_stddev_fields';
  administratorId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "administrator_notification" */
export type Administrator_Notification_Stddev_Order_By = {
  administratorId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Administrator_Notification_Stddev_Pop_Fields = {
  __typename?: 'administrator_notification_stddev_pop_fields';
  administratorId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "administrator_notification" */
export type Administrator_Notification_Stddev_Pop_Order_By = {
  administratorId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Administrator_Notification_Stddev_Samp_Fields = {
  __typename?: 'administrator_notification_stddev_samp_fields';
  administratorId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "administrator_notification" */
export type Administrator_Notification_Stddev_Samp_Order_By = {
  administratorId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "administrator_notification" */
export type Administrator_Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Administrator_Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Administrator_Notification_Stream_Cursor_Value_Input = {
  administratorId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<Scalars['String']>;
  sms?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Administrator_Notification_Sum_Fields = {
  __typename?: 'administrator_notification_sum_fields';
  administratorId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "administrator_notification" */
export type Administrator_Notification_Sum_Order_By = {
  administratorId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "administrator_notification" */
export enum Administrator_Notification_Update_Column {
  /** column name */
  AdministratorId = 'administratorId',
  /** column name */
  Email = 'email',
  /** column name */
  Scope = 'scope',
  /** column name */
  Sms = 'sms'
}

export type Administrator_Notification_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Administrator_Notification_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Administrator_Notification_Set_Input>;
  /** filter the rows which have to be updated */
  where: Administrator_Notification_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Administrator_Notification_Var_Pop_Fields = {
  __typename?: 'administrator_notification_var_pop_fields';
  administratorId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "administrator_notification" */
export type Administrator_Notification_Var_Pop_Order_By = {
  administratorId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Administrator_Notification_Var_Samp_Fields = {
  __typename?: 'administrator_notification_var_samp_fields';
  administratorId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "administrator_notification" */
export type Administrator_Notification_Var_Samp_Order_By = {
  administratorId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Administrator_Notification_Variance_Fields = {
  __typename?: 'administrator_notification_variance_fields';
  administratorId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "administrator_notification" */
export type Administrator_Notification_Variance_Order_By = {
  administratorId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "administrator". */
export type Administrator_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Administrator_Notification_Aggregate_Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
};

/** primary key columns input for table: administrator */
export type Administrator_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "administrator" */
export enum Administrator_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phoneNumber'
}

/** input type for updating data in table "administrator" */
export type Administrator_Set_Input = {
  phoneNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Administrator_Stddev_Fields = {
  __typename?: 'administrator_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Administrator_Stddev_Pop_Fields = {
  __typename?: 'administrator_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Administrator_Stddev_Samp_Fields = {
  __typename?: 'administrator_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "administrator" */
export type Administrator_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Administrator_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Administrator_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Administrator_Sum_Fields = {
  __typename?: 'administrator_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

export type Administrator_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Administrator_Set_Input>;
  /** filter the rows which have to be updated */
  where: Administrator_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Administrator_Var_Pop_Fields = {
  __typename?: 'administrator_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Administrator_Var_Samp_Fields = {
  __typename?: 'administrator_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Administrator_Variance_Fields = {
  __typename?: 'administrator_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type AvailableLaboratoryTests_Test_Args = {
  point?: InputMaybe<Scalars['geography']>;
};

export type Available_Laboratory_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  point?: InputMaybe<Scalars['geography']>;
};

export type Available_Shipping_Test_Tag_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
};

export type Available_Test_Tag_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  point?: InputMaybe<Scalars['geography']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "client" */
export type Client = {
  __typename?: 'client';
  auth2FAEnabled: Scalars['Boolean'];
  /** An array relationship */
  clientProfiles: Array<Client_Profile>;
  confirmedOn?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  failedLoginCount: Scalars['Int'];
  id: Scalars['Int'];
  medicalDocumentationAcceptedAt?: Maybe<Scalars['timestamptz']>;
  newsletterConsent: Scalars['Boolean'];
  pushConsent: Scalars['Boolean'];
  regulationsAcceptedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "client" */
export type ClientClientProfilesArgs = {
  distinct_on?: InputMaybe<Array<Client_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Profile_Order_By>>;
  where?: InputMaybe<Client_Profile_Bool_Exp>;
};

/** aggregated selection of "client" */
export type Client_Aggregate = {
  __typename?: 'client_aggregate';
  aggregate?: Maybe<Client_Aggregate_Fields>;
  nodes: Array<Client>;
};

/** aggregate fields of "client" */
export type Client_Aggregate_Fields = {
  __typename?: 'client_aggregate_fields';
  avg?: Maybe<Client_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Client_Max_Fields>;
  min?: Maybe<Client_Min_Fields>;
  stddev?: Maybe<Client_Stddev_Fields>;
  stddev_pop?: Maybe<Client_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Client_Stddev_Samp_Fields>;
  sum?: Maybe<Client_Sum_Fields>;
  var_pop?: Maybe<Client_Var_Pop_Fields>;
  var_samp?: Maybe<Client_Var_Samp_Fields>;
  variance?: Maybe<Client_Variance_Fields>;
};


/** aggregate fields of "client" */
export type Client_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Client_Avg_Fields = {
  __typename?: 'client_avg_fields';
  failedLoginCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "client". All fields are combined with a logical 'AND'. */
export type Client_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Bool_Exp>>;
  _not?: InputMaybe<Client_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Bool_Exp>>;
  auth2FAEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  clientProfiles?: InputMaybe<Client_Profile_Bool_Exp>;
  confirmedOn?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  failedLoginCount?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  medicalDocumentationAcceptedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  newsletterConsent?: InputMaybe<Boolean_Comparison_Exp>;
  pushConsent?: InputMaybe<Boolean_Comparison_Exp>;
  regulationsAcceptedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "client" */
export enum Client_Constraint {
  /** unique or primary key constraint on columns "email" */
  ClientEmailKey = 'client_email_key',
  /** unique or primary key constraint on columns "id" */
  ClientPkey = 'client_pkey'
}

/** columns and relationships of "client_favourite_test" */
export type Client_Favourite_Test = {
  __typename?: 'client_favourite_test';
  clientId: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  test: Test;
  testId: Scalars['Int'];
};

/** order by aggregate values of table "client_favourite_test" */
export type Client_Favourite_Test_Aggregate_Order_By = {
  avg?: InputMaybe<Client_Favourite_Test_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Client_Favourite_Test_Max_Order_By>;
  min?: InputMaybe<Client_Favourite_Test_Min_Order_By>;
  stddev?: InputMaybe<Client_Favourite_Test_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Client_Favourite_Test_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Client_Favourite_Test_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Client_Favourite_Test_Sum_Order_By>;
  var_pop?: InputMaybe<Client_Favourite_Test_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Client_Favourite_Test_Var_Samp_Order_By>;
  variance?: InputMaybe<Client_Favourite_Test_Variance_Order_By>;
};

/** order by avg() on columns of table "client_favourite_test" */
export type Client_Favourite_Test_Avg_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "client_favourite_test". All fields are combined with a logical 'AND'. */
export type Client_Favourite_Test_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Favourite_Test_Bool_Exp>>;
  _not?: InputMaybe<Client_Favourite_Test_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Favourite_Test_Bool_Exp>>;
  clientId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  test?: InputMaybe<Test_Bool_Exp>;
  testId?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "client_favourite_test" */
export type Client_Favourite_Test_Max_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "client_favourite_test" */
export type Client_Favourite_Test_Min_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "client_favourite_test" */
export type Client_Favourite_Test_Mutation_Response = {
  __typename?: 'client_favourite_test_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Favourite_Test>;
};

/** Ordering options when selecting data from "client_favourite_test". */
export type Client_Favourite_Test_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  test?: InputMaybe<Test_Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** select columns of table "client_favourite_test" */
export enum Client_Favourite_Test_Select_Column {
  /** column name */
  ClientId = 'clientId',
  /** column name */
  Id = 'id',
  /** column name */
  TestId = 'testId'
}

/** order by stddev() on columns of table "client_favourite_test" */
export type Client_Favourite_Test_Stddev_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "client_favourite_test" */
export type Client_Favourite_Test_Stddev_Pop_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "client_favourite_test" */
export type Client_Favourite_Test_Stddev_Samp_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "client_favourite_test" */
export type Client_Favourite_Test_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Client_Favourite_Test_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Client_Favourite_Test_Stream_Cursor_Value_Input = {
  clientId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "client_favourite_test" */
export type Client_Favourite_Test_Sum_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "client_favourite_test" */
export type Client_Favourite_Test_Var_Pop_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "client_favourite_test" */
export type Client_Favourite_Test_Var_Samp_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "client_favourite_test" */
export type Client_Favourite_Test_Variance_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "client" */
export type Client_Insert_Input = {
  auth2FAEnabled?: InputMaybe<Scalars['Boolean']>;
  clientProfiles?: InputMaybe<Client_Profile_Arr_Rel_Insert_Input>;
  confirmedOn?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  failedLoginCount?: InputMaybe<Scalars['Int']>;
  medicalDocumentationAcceptedAt?: InputMaybe<Scalars['timestamptz']>;
  newsletterConsent?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  pushConsent?: InputMaybe<Scalars['Boolean']>;
  regulationsAcceptedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Client_Max_Fields = {
  __typename?: 'client_max_fields';
  confirmedOn?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  failedLoginCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  medicalDocumentationAcceptedAt?: Maybe<Scalars['timestamptz']>;
  regulationsAcceptedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Client_Min_Fields = {
  __typename?: 'client_min_fields';
  confirmedOn?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  failedLoginCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  medicalDocumentationAcceptedAt?: Maybe<Scalars['timestamptz']>;
  regulationsAcceptedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "client" */
export type Client_Mutation_Response = {
  __typename?: 'client_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client>;
};

/** input type for inserting object relation for remote table "client" */
export type Client_Obj_Rel_Insert_Input = {
  data: Client_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Client_On_Conflict>;
};

/** on_conflict condition type for table "client" */
export type Client_On_Conflict = {
  constraint: Client_Constraint;
  update_columns?: Array<Client_Update_Column>;
  where?: InputMaybe<Client_Bool_Exp>;
};

/** Ordering options when selecting data from "client". */
export type Client_Order_By = {
  auth2FAEnabled?: InputMaybe<Order_By>;
  clientProfiles_aggregate?: InputMaybe<Client_Profile_Aggregate_Order_By>;
  confirmedOn?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  failedLoginCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medicalDocumentationAcceptedAt?: InputMaybe<Order_By>;
  newsletterConsent?: InputMaybe<Order_By>;
  pushConsent?: InputMaybe<Order_By>;
  regulationsAcceptedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client */
export type Client_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "client_profile" */
export type Client_Profile = {
  __typename?: 'client_profile';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  /** An object relationship */
  client: Client;
  clientId: Scalars['Int'];
  firstName: Scalars['String'];
  gender?: Maybe<Gender_Enum>;
  id: Scalars['Int'];
  identity: Scalars['jsonb'];
  isMain?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  location?: Maybe<Scalars['geography']>;
  pesel?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
};


/** columns and relationships of "client_profile" */
export type Client_ProfileIdentityArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "client_profile" */
export type Client_Profile_Aggregate_Order_By = {
  avg?: InputMaybe<Client_Profile_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Client_Profile_Max_Order_By>;
  min?: InputMaybe<Client_Profile_Min_Order_By>;
  stddev?: InputMaybe<Client_Profile_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Client_Profile_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Client_Profile_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Client_Profile_Sum_Order_By>;
  var_pop?: InputMaybe<Client_Profile_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Client_Profile_Var_Samp_Order_By>;
  variance?: InputMaybe<Client_Profile_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "client_profile" */
export type Client_Profile_Arr_Rel_Insert_Input = {
  data: Array<Client_Profile_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Client_Profile_On_Conflict>;
};

/** order by avg() on columns of table "client_profile" */
export type Client_Profile_Avg_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "client_profile". All fields are combined with a logical 'AND'. */
export type Client_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Profile_Bool_Exp>>;
  _not?: InputMaybe<Client_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Profile_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  client?: InputMaybe<Client_Bool_Exp>;
  clientId?: InputMaybe<Int_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<Gender_Enum_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  identity?: InputMaybe<Jsonb_Comparison_Exp>;
  isMain?: InputMaybe<Boolean_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  pesel?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  postalCode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_profile" */
export enum Client_Profile_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientProfilePkey = 'client_profile_pkey'
}

/** input type for inserting data into table "client_profile" */
export type Client_Profile_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Client_Obj_Rel_Insert_Input>;
  clientId?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender_Enum>;
  identity?: InputMaybe<Scalars['jsonb']>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  name?: InputMaybe<Scalars['String']>;
  pesel?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "client_profile" */
export type Client_Profile_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  clientId?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  pesel?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "client_profile" */
export type Client_Profile_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  clientId?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  pesel?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "client_profile" */
export type Client_Profile_Mutation_Response = {
  __typename?: 'client_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Profile>;
};

/** on_conflict condition type for table "client_profile" */
export type Client_Profile_On_Conflict = {
  constraint: Client_Profile_Constraint;
  update_columns?: Array<Client_Profile_Update_Column>;
  where?: InputMaybe<Client_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "client_profile". */
export type Client_Profile_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  client?: InputMaybe<Client_Order_By>;
  clientId?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Order_By>;
  isMain?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  pesel?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
};

/** select columns of table "client_profile" */
export enum Client_Profile_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  Identity = 'identity',
  /** column name */
  IsMain = 'isMain',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Location = 'location',
  /** column name */
  Pesel = 'pesel',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PostalCode = 'postalCode'
}

/** order by stddev() on columns of table "client_profile" */
export type Client_Profile_Stddev_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "client_profile" */
export type Client_Profile_Stddev_Pop_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "client_profile" */
export type Client_Profile_Stddev_Samp_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "client_profile" */
export type Client_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Client_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Client_Profile_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender_Enum>;
  id?: InputMaybe<Scalars['Int']>;
  identity?: InputMaybe<Scalars['jsonb']>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  pesel?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "client_profile" */
export type Client_Profile_Sum_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "client_profile" (current role has no relevant permissions) */
export enum Client_Profile_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "client_profile" */
export type Client_Profile_Var_Pop_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "client_profile" */
export type Client_Profile_Var_Samp_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "client_profile" */
export type Client_Profile_Variance_Order_By = {
  clientId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "client" */
export enum Client_Select_Column {
  /** column name */
  Auth2FaEnabled = 'auth2FAEnabled',
  /** column name */
  ConfirmedOn = 'confirmedOn',
  /** column name */
  Email = 'email',
  /** column name */
  FailedLoginCount = 'failedLoginCount',
  /** column name */
  Id = 'id',
  /** column name */
  MedicalDocumentationAcceptedAt = 'medicalDocumentationAcceptedAt',
  /** column name */
  NewsletterConsent = 'newsletterConsent',
  /** column name */
  PushConsent = 'pushConsent',
  /** column name */
  RegulationsAcceptedAt = 'regulationsAcceptedAt'
}

/** input type for updating data in table "client" */
export type Client_Set_Input = {
  auth2FAEnabled?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  medicalDocumentationAcceptedAt?: InputMaybe<Scalars['timestamptz']>;
  regulationsAcceptedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Client_Stddev_Fields = {
  __typename?: 'client_stddev_fields';
  failedLoginCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Client_Stddev_Pop_Fields = {
  __typename?: 'client_stddev_pop_fields';
  failedLoginCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Client_Stddev_Samp_Fields = {
  __typename?: 'client_stddev_samp_fields';
  failedLoginCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "client" */
export type Client_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Client_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Client_Stream_Cursor_Value_Input = {
  auth2FAEnabled?: InputMaybe<Scalars['Boolean']>;
  confirmedOn?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  failedLoginCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  medicalDocumentationAcceptedAt?: InputMaybe<Scalars['timestamptz']>;
  newsletterConsent?: InputMaybe<Scalars['Boolean']>;
  pushConsent?: InputMaybe<Scalars['Boolean']>;
  regulationsAcceptedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Client_Sum_Fields = {
  __typename?: 'client_sum_fields';
  failedLoginCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "client" */
export enum Client_Update_Column {
  /** column name */
  Auth2FaEnabled = 'auth2FAEnabled',
  /** column name */
  Email = 'email',
  /** column name */
  MedicalDocumentationAcceptedAt = 'medicalDocumentationAcceptedAt',
  /** column name */
  RegulationsAcceptedAt = 'regulationsAcceptedAt'
}

export type Client_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Client_Set_Input>;
  /** filter the rows which have to be updated */
  where: Client_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Client_Var_Pop_Fields = {
  __typename?: 'client_var_pop_fields';
  failedLoginCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Client_Var_Samp_Fields = {
  __typename?: 'client_var_samp_fields';
  failedLoginCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Client_Variance_Fields = {
  __typename?: 'client_variance_fields';
  failedLoginCount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "collection_slot" */
export type Collection_Slot = {
  __typename?: 'collection_slot';
  /** An object relationship */
  collectionPoint: Laboratory_Collection_Point;
  collectionPointId: Scalars['Int'];
  dateFrom: Scalars['timestamptz'];
  dateTo: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  orderCollection?: Maybe<Order_Collection>;
};

/** aggregated selection of "collection_slot" */
export type Collection_Slot_Aggregate = {
  __typename?: 'collection_slot_aggregate';
  aggregate?: Maybe<Collection_Slot_Aggregate_Fields>;
  nodes: Array<Collection_Slot>;
};

/** aggregate fields of "collection_slot" */
export type Collection_Slot_Aggregate_Fields = {
  __typename?: 'collection_slot_aggregate_fields';
  avg?: Maybe<Collection_Slot_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Collection_Slot_Max_Fields>;
  min?: Maybe<Collection_Slot_Min_Fields>;
  stddev?: Maybe<Collection_Slot_Stddev_Fields>;
  stddev_pop?: Maybe<Collection_Slot_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Collection_Slot_Stddev_Samp_Fields>;
  sum?: Maybe<Collection_Slot_Sum_Fields>;
  var_pop?: Maybe<Collection_Slot_Var_Pop_Fields>;
  var_samp?: Maybe<Collection_Slot_Var_Samp_Fields>;
  variance?: Maybe<Collection_Slot_Variance_Fields>;
};


/** aggregate fields of "collection_slot" */
export type Collection_Slot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Collection_Slot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Collection_Slot_Avg_Fields = {
  __typename?: 'collection_slot_avg_fields';
  collectionPointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "collection_slot". All fields are combined with a logical 'AND'. */
export type Collection_Slot_Bool_Exp = {
  _and?: InputMaybe<Array<Collection_Slot_Bool_Exp>>;
  _not?: InputMaybe<Collection_Slot_Bool_Exp>;
  _or?: InputMaybe<Array<Collection_Slot_Bool_Exp>>;
  collectionPoint?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
  collectionPointId?: InputMaybe<Int_Comparison_Exp>;
  dateFrom?: InputMaybe<Timestamptz_Comparison_Exp>;
  dateTo?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  orderCollection?: InputMaybe<Order_Collection_Bool_Exp>;
};

/** unique or primary key constraints on table "collection_slot" */
export enum Collection_Slot_Constraint {
  /** unique or primary key constraint on columns "id" */
  CollectionSlotPkey = 'collection_slot_pkey'
}

/** input type for incrementing numeric columns in table "collection_slot" */
export type Collection_Slot_Inc_Input = {
  collectionPointId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "collection_slot" */
export type Collection_Slot_Insert_Input = {
  collectionPoint?: InputMaybe<Laboratory_Collection_Point_Obj_Rel_Insert_Input>;
  collectionPointId?: InputMaybe<Scalars['Int']>;
  dateFrom?: InputMaybe<Scalars['timestamptz']>;
  dateTo?: InputMaybe<Scalars['timestamptz']>;
  orderCollection?: InputMaybe<Order_Collection_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Collection_Slot_Max_Fields = {
  __typename?: 'collection_slot_max_fields';
  collectionPointId?: Maybe<Scalars['Int']>;
  dateFrom?: Maybe<Scalars['timestamptz']>;
  dateTo?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Collection_Slot_Min_Fields = {
  __typename?: 'collection_slot_min_fields';
  collectionPointId?: Maybe<Scalars['Int']>;
  dateFrom?: Maybe<Scalars['timestamptz']>;
  dateTo?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "collection_slot" */
export type Collection_Slot_Mutation_Response = {
  __typename?: 'collection_slot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Collection_Slot>;
};

/** input type for inserting object relation for remote table "collection_slot" */
export type Collection_Slot_Obj_Rel_Insert_Input = {
  data: Collection_Slot_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Collection_Slot_On_Conflict>;
};

/** on_conflict condition type for table "collection_slot" */
export type Collection_Slot_On_Conflict = {
  constraint: Collection_Slot_Constraint;
  update_columns?: Array<Collection_Slot_Update_Column>;
  where?: InputMaybe<Collection_Slot_Bool_Exp>;
};

/** Ordering options when selecting data from "collection_slot". */
export type Collection_Slot_Order_By = {
  collectionPoint?: InputMaybe<Laboratory_Collection_Point_Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  dateFrom?: InputMaybe<Order_By>;
  dateTo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderCollection?: InputMaybe<Order_Collection_Order_By>;
};

/** primary key columns input for table: collection_slot */
export type Collection_Slot_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "collection_slot" */
export enum Collection_Slot_Select_Column {
  /** column name */
  CollectionPointId = 'collectionPointId',
  /** column name */
  DateFrom = 'dateFrom',
  /** column name */
  DateTo = 'dateTo',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "collection_slot" */
export type Collection_Slot_Set_Input = {
  collectionPointId?: InputMaybe<Scalars['Int']>;
  dateFrom?: InputMaybe<Scalars['timestamptz']>;
  dateTo?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Collection_Slot_Stddev_Fields = {
  __typename?: 'collection_slot_stddev_fields';
  collectionPointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Collection_Slot_Stddev_Pop_Fields = {
  __typename?: 'collection_slot_stddev_pop_fields';
  collectionPointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Collection_Slot_Stddev_Samp_Fields = {
  __typename?: 'collection_slot_stddev_samp_fields';
  collectionPointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "collection_slot" */
export type Collection_Slot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Collection_Slot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Collection_Slot_Stream_Cursor_Value_Input = {
  collectionPointId?: InputMaybe<Scalars['Int']>;
  dateFrom?: InputMaybe<Scalars['timestamptz']>;
  dateTo?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Collection_Slot_Sum_Fields = {
  __typename?: 'collection_slot_sum_fields';
  collectionPointId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "collection_slot" */
export enum Collection_Slot_Update_Column {
  /** column name */
  CollectionPointId = 'collectionPointId',
  /** column name */
  DateFrom = 'dateFrom',
  /** column name */
  DateTo = 'dateTo'
}

export type Collection_Slot_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Collection_Slot_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Collection_Slot_Set_Input>;
  /** filter the rows which have to be updated */
  where: Collection_Slot_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Collection_Slot_Var_Pop_Fields = {
  __typename?: 'collection_slot_var_pop_fields';
  collectionPointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Collection_Slot_Var_Samp_Fields = {
  __typename?: 'collection_slot_var_samp_fields';
  collectionPointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Collection_Slot_Variance_Fields = {
  __typename?: 'collection_slot_variance_fields';
  collectionPointId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "consultation" */
export type Consultation = {
  __typename?: 'consultation';
  /** An array relationship */
  consultationSlots: Array<Consultation_Slot>;
  /** An aggregate relationship */
  consultationSlots_aggregate: Consultation_Slot_Aggregate;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "consultation_description_i18n" */
  description?: Maybe<Scalars['String']>;
  description_i18n: Scalars['jsonb'];
  id: Scalars['Int'];
  /** A computed field, executes function "consultation_name_i18n" */
  name?: Maybe<Scalars['String']>;
  name_i18n: Scalars['jsonb'];
  /** An array relationship */
  orderConsultations: Array<Order_Consultation>;
  /** An aggregate relationship */
  orderConsultations_aggregate: Order_Consultation_Aggregate;
  price: Scalars['numeric'];
  svgIcon?: Maybe<Scalars['String']>;
};


/** columns and relationships of "consultation" */
export type ConsultationConsultationSlotsArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Slot_Order_By>>;
  where?: InputMaybe<Consultation_Slot_Bool_Exp>;
};


/** columns and relationships of "consultation" */
export type ConsultationConsultationSlots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Slot_Order_By>>;
  where?: InputMaybe<Consultation_Slot_Bool_Exp>;
};


/** columns and relationships of "consultation" */
export type ConsultationDescription_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "consultation" */
export type ConsultationName_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "consultation" */
export type ConsultationOrderConsultationsArgs = {
  distinct_on?: InputMaybe<Array<Order_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Consultation_Order_By>>;
  where?: InputMaybe<Order_Consultation_Bool_Exp>;
};


/** columns and relationships of "consultation" */
export type ConsultationOrderConsultations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Consultation_Order_By>>;
  where?: InputMaybe<Order_Consultation_Bool_Exp>;
};

/** aggregated selection of "consultation" */
export type Consultation_Aggregate = {
  __typename?: 'consultation_aggregate';
  aggregate?: Maybe<Consultation_Aggregate_Fields>;
  nodes: Array<Consultation>;
};

/** aggregate fields of "consultation" */
export type Consultation_Aggregate_Fields = {
  __typename?: 'consultation_aggregate_fields';
  avg?: Maybe<Consultation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Consultation_Max_Fields>;
  min?: Maybe<Consultation_Min_Fields>;
  stddev?: Maybe<Consultation_Stddev_Fields>;
  stddev_pop?: Maybe<Consultation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consultation_Stddev_Samp_Fields>;
  sum?: Maybe<Consultation_Sum_Fields>;
  var_pop?: Maybe<Consultation_Var_Pop_Fields>;
  var_samp?: Maybe<Consultation_Var_Samp_Fields>;
  variance?: Maybe<Consultation_Variance_Fields>;
};


/** aggregate fields of "consultation" */
export type Consultation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consultation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Consultation_Append_Input = {
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Consultation_Avg_Fields = {
  __typename?: 'consultation_avg_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "consultation". All fields are combined with a logical 'AND'. */
export type Consultation_Bool_Exp = {
  _and?: InputMaybe<Array<Consultation_Bool_Exp>>;
  _not?: InputMaybe<Consultation_Bool_Exp>;
  _or?: InputMaybe<Array<Consultation_Bool_Exp>>;
  consultationSlots?: InputMaybe<Consultation_Slot_Bool_Exp>;
  consultationSlots_aggregate?: InputMaybe<Consultation_Slot_Aggregate_Bool_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  description_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  orderConsultations?: InputMaybe<Order_Consultation_Bool_Exp>;
  orderConsultations_aggregate?: InputMaybe<Order_Consultation_Aggregate_Bool_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  svgIcon?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "consultation" */
export enum Consultation_Constraint {
  /** unique or primary key constraint on columns "id" */
  ConsultationPkey = 'consultation_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Consultation_Delete_At_Path_Input = {
  description_i18n?: InputMaybe<Array<Scalars['String']>>;
  name_i18n?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Consultation_Delete_Elem_Input = {
  description_i18n?: InputMaybe<Scalars['Int']>;
  name_i18n?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Consultation_Delete_Key_Input = {
  description_i18n?: InputMaybe<Scalars['String']>;
  name_i18n?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "consultation" */
export type Consultation_Inc_Input = {
  price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "consultation" */
export type Consultation_Insert_Input = {
  consultationSlots?: InputMaybe<Consultation_Slot_Arr_Rel_Insert_Input>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
  price?: InputMaybe<Scalars['numeric']>;
  svgIcon?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Consultation_Max_Fields = {
  __typename?: 'consultation_max_fields';
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "consultation_description_i18n" */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "consultation_name_i18n" */
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  svgIcon?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Consultation_Min_Fields = {
  __typename?: 'consultation_min_fields';
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "consultation_description_i18n" */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "consultation_name_i18n" */
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  svgIcon?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "consultation" */
export type Consultation_Mutation_Response = {
  __typename?: 'consultation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Consultation>;
};

/** input type for inserting object relation for remote table "consultation" */
export type Consultation_Obj_Rel_Insert_Input = {
  data: Consultation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Consultation_On_Conflict>;
};

/** on_conflict condition type for table "consultation" */
export type Consultation_On_Conflict = {
  constraint: Consultation_Constraint;
  update_columns?: Array<Consultation_Update_Column>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};

/** Ordering options when selecting data from "consultation". */
export type Consultation_Order_By = {
  consultationSlots_aggregate?: InputMaybe<Consultation_Slot_Aggregate_Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_i18n?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_i18n?: InputMaybe<Order_By>;
  orderConsultations_aggregate?: InputMaybe<Order_Consultation_Aggregate_Order_By>;
  price?: InputMaybe<Order_By>;
  svgIcon?: InputMaybe<Order_By>;
};

/** primary key columns input for table: consultation */
export type Consultation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Consultation_Prepend_Input = {
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "consultation" */
export enum Consultation_Select_Column {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DescriptionI18n = 'description_i18n',
  /** column name */
  Id = 'id',
  /** column name */
  NameI18n = 'name_i18n',
  /** column name */
  Price = 'price',
  /** column name */
  SvgIcon = 'svgIcon'
}

/** input type for updating data in table "consultation" */
export type Consultation_Set_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
  price?: InputMaybe<Scalars['numeric']>;
  svgIcon?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "consultation_slot" */
export type Consultation_Slot = {
  __typename?: 'consultation_slot';
  consultationId: Scalars['Int'];
  dateFrom: Scalars['timestamptz'];
  dateTo: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  orderConsultation?: Maybe<Order_Consultation>;
};

/** aggregated selection of "consultation_slot" */
export type Consultation_Slot_Aggregate = {
  __typename?: 'consultation_slot_aggregate';
  aggregate?: Maybe<Consultation_Slot_Aggregate_Fields>;
  nodes: Array<Consultation_Slot>;
};

export type Consultation_Slot_Aggregate_Bool_Exp = {
  count?: InputMaybe<Consultation_Slot_Aggregate_Bool_Exp_Count>;
};

export type Consultation_Slot_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Consultation_Slot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Consultation_Slot_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "consultation_slot" */
export type Consultation_Slot_Aggregate_Fields = {
  __typename?: 'consultation_slot_aggregate_fields';
  avg?: Maybe<Consultation_Slot_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Consultation_Slot_Max_Fields>;
  min?: Maybe<Consultation_Slot_Min_Fields>;
  stddev?: Maybe<Consultation_Slot_Stddev_Fields>;
  stddev_pop?: Maybe<Consultation_Slot_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consultation_Slot_Stddev_Samp_Fields>;
  sum?: Maybe<Consultation_Slot_Sum_Fields>;
  var_pop?: Maybe<Consultation_Slot_Var_Pop_Fields>;
  var_samp?: Maybe<Consultation_Slot_Var_Samp_Fields>;
  variance?: Maybe<Consultation_Slot_Variance_Fields>;
};


/** aggregate fields of "consultation_slot" */
export type Consultation_Slot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consultation_Slot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "consultation_slot" */
export type Consultation_Slot_Aggregate_Order_By = {
  avg?: InputMaybe<Consultation_Slot_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Consultation_Slot_Max_Order_By>;
  min?: InputMaybe<Consultation_Slot_Min_Order_By>;
  stddev?: InputMaybe<Consultation_Slot_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Consultation_Slot_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Consultation_Slot_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Consultation_Slot_Sum_Order_By>;
  var_pop?: InputMaybe<Consultation_Slot_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Consultation_Slot_Var_Samp_Order_By>;
  variance?: InputMaybe<Consultation_Slot_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "consultation_slot" */
export type Consultation_Slot_Arr_Rel_Insert_Input = {
  data: Array<Consultation_Slot_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Consultation_Slot_On_Conflict>;
};

/** aggregate avg on columns */
export type Consultation_Slot_Avg_Fields = {
  __typename?: 'consultation_slot_avg_fields';
  consultationId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "consultation_slot" */
export type Consultation_Slot_Avg_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "consultation_slot". All fields are combined with a logical 'AND'. */
export type Consultation_Slot_Bool_Exp = {
  _and?: InputMaybe<Array<Consultation_Slot_Bool_Exp>>;
  _not?: InputMaybe<Consultation_Slot_Bool_Exp>;
  _or?: InputMaybe<Array<Consultation_Slot_Bool_Exp>>;
  consultationId?: InputMaybe<Int_Comparison_Exp>;
  dateFrom?: InputMaybe<Timestamptz_Comparison_Exp>;
  dateTo?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  orderConsultation?: InputMaybe<Order_Consultation_Bool_Exp>;
};

/** unique or primary key constraints on table "consultation_slot" */
export enum Consultation_Slot_Constraint {
  /** unique or primary key constraint on columns "id" */
  ConsultationSlotPkey = 'consultation_slot_pkey'
}

/** input type for incrementing numeric columns in table "consultation_slot" */
export type Consultation_Slot_Inc_Input = {
  consultationId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "consultation_slot" */
export type Consultation_Slot_Insert_Input = {
  consultationId?: InputMaybe<Scalars['Int']>;
  dateFrom?: InputMaybe<Scalars['timestamptz']>;
  dateTo?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Consultation_Slot_Max_Fields = {
  __typename?: 'consultation_slot_max_fields';
  consultationId?: Maybe<Scalars['Int']>;
  dateFrom?: Maybe<Scalars['timestamptz']>;
  dateTo?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "consultation_slot" */
export type Consultation_Slot_Max_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  dateFrom?: InputMaybe<Order_By>;
  dateTo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Consultation_Slot_Min_Fields = {
  __typename?: 'consultation_slot_min_fields';
  consultationId?: Maybe<Scalars['Int']>;
  dateFrom?: Maybe<Scalars['timestamptz']>;
  dateTo?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "consultation_slot" */
export type Consultation_Slot_Min_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  dateFrom?: InputMaybe<Order_By>;
  dateTo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "consultation_slot" */
export type Consultation_Slot_Mutation_Response = {
  __typename?: 'consultation_slot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Consultation_Slot>;
};

/** on_conflict condition type for table "consultation_slot" */
export type Consultation_Slot_On_Conflict = {
  constraint: Consultation_Slot_Constraint;
  update_columns?: Array<Consultation_Slot_Update_Column>;
  where?: InputMaybe<Consultation_Slot_Bool_Exp>;
};

/** Ordering options when selecting data from "consultation_slot". */
export type Consultation_Slot_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  dateFrom?: InputMaybe<Order_By>;
  dateTo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderConsultation?: InputMaybe<Order_Consultation_Order_By>;
};

/** primary key columns input for table: consultation_slot */
export type Consultation_Slot_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "consultation_slot" */
export enum Consultation_Slot_Select_Column {
  /** column name */
  ConsultationId = 'consultationId',
  /** column name */
  DateFrom = 'dateFrom',
  /** column name */
  DateTo = 'dateTo',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "consultation_slot" */
export type Consultation_Slot_Set_Input = {
  consultationId?: InputMaybe<Scalars['Int']>;
  dateFrom?: InputMaybe<Scalars['timestamptz']>;
  dateTo?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Consultation_Slot_Stddev_Fields = {
  __typename?: 'consultation_slot_stddev_fields';
  consultationId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "consultation_slot" */
export type Consultation_Slot_Stddev_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Consultation_Slot_Stddev_Pop_Fields = {
  __typename?: 'consultation_slot_stddev_pop_fields';
  consultationId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "consultation_slot" */
export type Consultation_Slot_Stddev_Pop_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Consultation_Slot_Stddev_Samp_Fields = {
  __typename?: 'consultation_slot_stddev_samp_fields';
  consultationId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "consultation_slot" */
export type Consultation_Slot_Stddev_Samp_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "consultation_slot" */
export type Consultation_Slot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consultation_Slot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consultation_Slot_Stream_Cursor_Value_Input = {
  consultationId?: InputMaybe<Scalars['Int']>;
  dateFrom?: InputMaybe<Scalars['timestamptz']>;
  dateTo?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Consultation_Slot_Sum_Fields = {
  __typename?: 'consultation_slot_sum_fields';
  consultationId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "consultation_slot" */
export type Consultation_Slot_Sum_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "consultation_slot" */
export enum Consultation_Slot_Update_Column {
  /** column name */
  ConsultationId = 'consultationId',
  /** column name */
  DateFrom = 'dateFrom',
  /** column name */
  DateTo = 'dateTo'
}

export type Consultation_Slot_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Consultation_Slot_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Consultation_Slot_Set_Input>;
  /** filter the rows which have to be updated */
  where: Consultation_Slot_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Consultation_Slot_Var_Pop_Fields = {
  __typename?: 'consultation_slot_var_pop_fields';
  consultationId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "consultation_slot" */
export type Consultation_Slot_Var_Pop_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Consultation_Slot_Var_Samp_Fields = {
  __typename?: 'consultation_slot_var_samp_fields';
  consultationId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "consultation_slot" */
export type Consultation_Slot_Var_Samp_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Consultation_Slot_Variance_Fields = {
  __typename?: 'consultation_slot_variance_fields';
  consultationId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "consultation_slot" */
export type Consultation_Slot_Variance_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Consultation_Stddev_Fields = {
  __typename?: 'consultation_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Consultation_Stddev_Pop_Fields = {
  __typename?: 'consultation_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Consultation_Stddev_Samp_Fields = {
  __typename?: 'consultation_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "consultation" */
export type Consultation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consultation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consultation_Stream_Cursor_Value_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
  price?: InputMaybe<Scalars['numeric']>;
  svgIcon?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Consultation_Sum_Fields = {
  __typename?: 'consultation_sum_fields';
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
};

/** update columns of table "consultation" */
export enum Consultation_Update_Column {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DescriptionI18n = 'description_i18n',
  /** column name */
  NameI18n = 'name_i18n',
  /** column name */
  Price = 'price',
  /** column name */
  SvgIcon = 'svgIcon'
}

export type Consultation_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Consultation_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Consultation_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Consultation_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Consultation_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Consultation_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Consultation_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Consultation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Consultation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Consultation_Var_Pop_Fields = {
  __typename?: 'consultation_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Consultation_Var_Samp_Fields = {
  __typename?: 'consultation_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Consultation_Variance_Fields = {
  __typename?: 'consultation_variance_fields';
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

export type CostSummary_Laboratory_Args = {
  date_from?: InputMaybe<Scalars['timestamptz']>;
  date_to?: InputMaybe<Scalars['timestamptz']>;
};

export type CostSummary_Nurse_Args = {
  date_from?: InputMaybe<Scalars['timestamptz']>;
  date_to?: InputMaybe<Scalars['timestamptz']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "discount" */
export type Discount = {
  __typename?: 'discount';
  code: Scalars['String'];
  dateFrom?: Maybe<Scalars['timestamptz']>;
  dateTo?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  discountConsultations: Array<Discount_Consultation>;
  /** An aggregate relationship */
  discountConsultations_aggregate: Discount_Consultation_Aggregate;
  /** An array relationship */
  discountTests: Array<Discount_Test>;
  /** An aggregate relationship */
  discountTests_aggregate: Discount_Test_Aggregate;
  /** An array relationship */
  discountTrainings: Array<Discount_Training>;
  /** An aggregate relationship */
  discountTrainings_aggregate: Discount_Training_Aggregate;
  id: Scalars['Int'];
  /** An array relationship */
  orderDiscounts: Array<Order_Discount>;
  percent: Scalars['numeric'];
  type: Discount_Type_Enum_Enum;
};


/** columns and relationships of "discount" */
export type DiscountDiscountConsultationsArgs = {
  distinct_on?: InputMaybe<Array<Discount_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Consultation_Order_By>>;
  where?: InputMaybe<Discount_Consultation_Bool_Exp>;
};


/** columns and relationships of "discount" */
export type DiscountDiscountConsultations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Consultation_Order_By>>;
  where?: InputMaybe<Discount_Consultation_Bool_Exp>;
};


/** columns and relationships of "discount" */
export type DiscountDiscountTestsArgs = {
  distinct_on?: InputMaybe<Array<Discount_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Test_Order_By>>;
  where?: InputMaybe<Discount_Test_Bool_Exp>;
};


/** columns and relationships of "discount" */
export type DiscountDiscountTests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Test_Order_By>>;
  where?: InputMaybe<Discount_Test_Bool_Exp>;
};


/** columns and relationships of "discount" */
export type DiscountDiscountTrainingsArgs = {
  distinct_on?: InputMaybe<Array<Discount_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Training_Order_By>>;
  where?: InputMaybe<Discount_Training_Bool_Exp>;
};


/** columns and relationships of "discount" */
export type DiscountDiscountTrainings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Training_Order_By>>;
  where?: InputMaybe<Discount_Training_Bool_Exp>;
};


/** columns and relationships of "discount" */
export type DiscountOrderDiscountsArgs = {
  distinct_on?: InputMaybe<Array<Order_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Discount_Order_By>>;
  where?: InputMaybe<Order_Discount_Bool_Exp>;
};

/** aggregated selection of "discount" */
export type Discount_Aggregate = {
  __typename?: 'discount_aggregate';
  aggregate?: Maybe<Discount_Aggregate_Fields>;
  nodes: Array<Discount>;
};

/** aggregate fields of "discount" */
export type Discount_Aggregate_Fields = {
  __typename?: 'discount_aggregate_fields';
  avg?: Maybe<Discount_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Discount_Max_Fields>;
  min?: Maybe<Discount_Min_Fields>;
  stddev?: Maybe<Discount_Stddev_Fields>;
  stddev_pop?: Maybe<Discount_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Discount_Stddev_Samp_Fields>;
  sum?: Maybe<Discount_Sum_Fields>;
  var_pop?: Maybe<Discount_Var_Pop_Fields>;
  var_samp?: Maybe<Discount_Var_Samp_Fields>;
  variance?: Maybe<Discount_Variance_Fields>;
};


/** aggregate fields of "discount" */
export type Discount_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Discount_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Discount_Avg_Fields = {
  __typename?: 'discount_avg_fields';
  id?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "discount". All fields are combined with a logical 'AND'. */
export type Discount_Bool_Exp = {
  _and?: InputMaybe<Array<Discount_Bool_Exp>>;
  _not?: InputMaybe<Discount_Bool_Exp>;
  _or?: InputMaybe<Array<Discount_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  dateFrom?: InputMaybe<Timestamptz_Comparison_Exp>;
  dateTo?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  discountConsultations?: InputMaybe<Discount_Consultation_Bool_Exp>;
  discountConsultations_aggregate?: InputMaybe<Discount_Consultation_Aggregate_Bool_Exp>;
  discountTests?: InputMaybe<Discount_Test_Bool_Exp>;
  discountTests_aggregate?: InputMaybe<Discount_Test_Aggregate_Bool_Exp>;
  discountTrainings?: InputMaybe<Discount_Training_Bool_Exp>;
  discountTrainings_aggregate?: InputMaybe<Discount_Training_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  orderDiscounts?: InputMaybe<Order_Discount_Bool_Exp>;
  percent?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<Discount_Type_Enum_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "discount" */
export enum Discount_Constraint {
  /** unique or primary key constraint on columns "code" */
  DiscountCodeKey = 'discount_code_key',
  /** unique or primary key constraint on columns "id" */
  DiscountPkey = 'discount_pkey'
}

/** columns and relationships of "discount_consultation" */
export type Discount_Consultation = {
  __typename?: 'discount_consultation';
  /** An object relationship */
  consultation: Consultation;
  consultationId: Scalars['Int'];
  /** An object relationship */
  discount: Discount;
  discountId: Scalars['Int'];
  maxCount?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "discount_consultation" */
export type Discount_Consultation_Aggregate = {
  __typename?: 'discount_consultation_aggregate';
  aggregate?: Maybe<Discount_Consultation_Aggregate_Fields>;
  nodes: Array<Discount_Consultation>;
};

export type Discount_Consultation_Aggregate_Bool_Exp = {
  count?: InputMaybe<Discount_Consultation_Aggregate_Bool_Exp_Count>;
};

export type Discount_Consultation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Discount_Consultation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Discount_Consultation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "discount_consultation" */
export type Discount_Consultation_Aggregate_Fields = {
  __typename?: 'discount_consultation_aggregate_fields';
  avg?: Maybe<Discount_Consultation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Discount_Consultation_Max_Fields>;
  min?: Maybe<Discount_Consultation_Min_Fields>;
  stddev?: Maybe<Discount_Consultation_Stddev_Fields>;
  stddev_pop?: Maybe<Discount_Consultation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Discount_Consultation_Stddev_Samp_Fields>;
  sum?: Maybe<Discount_Consultation_Sum_Fields>;
  var_pop?: Maybe<Discount_Consultation_Var_Pop_Fields>;
  var_samp?: Maybe<Discount_Consultation_Var_Samp_Fields>;
  variance?: Maybe<Discount_Consultation_Variance_Fields>;
};


/** aggregate fields of "discount_consultation" */
export type Discount_Consultation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Discount_Consultation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "discount_consultation" */
export type Discount_Consultation_Aggregate_Order_By = {
  avg?: InputMaybe<Discount_Consultation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Discount_Consultation_Max_Order_By>;
  min?: InputMaybe<Discount_Consultation_Min_Order_By>;
  stddev?: InputMaybe<Discount_Consultation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Discount_Consultation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Discount_Consultation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Discount_Consultation_Sum_Order_By>;
  var_pop?: InputMaybe<Discount_Consultation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Discount_Consultation_Var_Samp_Order_By>;
  variance?: InputMaybe<Discount_Consultation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "discount_consultation" */
export type Discount_Consultation_Arr_Rel_Insert_Input = {
  data: Array<Discount_Consultation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Discount_Consultation_On_Conflict>;
};

/** aggregate avg on columns */
export type Discount_Consultation_Avg_Fields = {
  __typename?: 'discount_consultation_avg_fields';
  consultationId?: Maybe<Scalars['Float']>;
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "discount_consultation" */
export type Discount_Consultation_Avg_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "discount_consultation". All fields are combined with a logical 'AND'. */
export type Discount_Consultation_Bool_Exp = {
  _and?: InputMaybe<Array<Discount_Consultation_Bool_Exp>>;
  _not?: InputMaybe<Discount_Consultation_Bool_Exp>;
  _or?: InputMaybe<Array<Discount_Consultation_Bool_Exp>>;
  consultation?: InputMaybe<Consultation_Bool_Exp>;
  consultationId?: InputMaybe<Int_Comparison_Exp>;
  discount?: InputMaybe<Discount_Bool_Exp>;
  discountId?: InputMaybe<Int_Comparison_Exp>;
  maxCount?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "discount_consultation" */
export enum Discount_Consultation_Constraint {
  /** unique or primary key constraint on columns "consultation_id", "discount_id" */
  DiscountConsultationPkey = 'discount_consultation_pkey'
}

/** input type for incrementing numeric columns in table "discount_consultation" */
export type Discount_Consultation_Inc_Input = {
  consultationId?: InputMaybe<Scalars['Int']>;
  discountId?: InputMaybe<Scalars['Int']>;
  maxCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "discount_consultation" */
export type Discount_Consultation_Insert_Input = {
  consultation?: InputMaybe<Consultation_Obj_Rel_Insert_Input>;
  consultationId?: InputMaybe<Scalars['Int']>;
  discount?: InputMaybe<Discount_Obj_Rel_Insert_Input>;
  discountId?: InputMaybe<Scalars['Int']>;
  maxCount?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Discount_Consultation_Max_Fields = {
  __typename?: 'discount_consultation_max_fields';
  consultationId?: Maybe<Scalars['Int']>;
  discountId?: Maybe<Scalars['Int']>;
  maxCount?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "discount_consultation" */
export type Discount_Consultation_Max_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Discount_Consultation_Min_Fields = {
  __typename?: 'discount_consultation_min_fields';
  consultationId?: Maybe<Scalars['Int']>;
  discountId?: Maybe<Scalars['Int']>;
  maxCount?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "discount_consultation" */
export type Discount_Consultation_Min_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "discount_consultation" */
export type Discount_Consultation_Mutation_Response = {
  __typename?: 'discount_consultation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Discount_Consultation>;
};

/** on_conflict condition type for table "discount_consultation" */
export type Discount_Consultation_On_Conflict = {
  constraint: Discount_Consultation_Constraint;
  update_columns?: Array<Discount_Consultation_Update_Column>;
  where?: InputMaybe<Discount_Consultation_Bool_Exp>;
};

/** Ordering options when selecting data from "discount_consultation". */
export type Discount_Consultation_Order_By = {
  consultation?: InputMaybe<Consultation_Order_By>;
  consultationId?: InputMaybe<Order_By>;
  discount?: InputMaybe<Discount_Order_By>;
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
};

/** primary key columns input for table: discount_consultation */
export type Discount_Consultation_Pk_Columns_Input = {
  consultationId: Scalars['Int'];
  discountId: Scalars['Int'];
};

/** select columns of table "discount_consultation" */
export enum Discount_Consultation_Select_Column {
  /** column name */
  ConsultationId = 'consultationId',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  MaxCount = 'maxCount'
}

/** input type for updating data in table "discount_consultation" */
export type Discount_Consultation_Set_Input = {
  consultationId?: InputMaybe<Scalars['Int']>;
  discountId?: InputMaybe<Scalars['Int']>;
  maxCount?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Discount_Consultation_Stddev_Fields = {
  __typename?: 'discount_consultation_stddev_fields';
  consultationId?: Maybe<Scalars['Float']>;
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "discount_consultation" */
export type Discount_Consultation_Stddev_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Discount_Consultation_Stddev_Pop_Fields = {
  __typename?: 'discount_consultation_stddev_pop_fields';
  consultationId?: Maybe<Scalars['Float']>;
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "discount_consultation" */
export type Discount_Consultation_Stddev_Pop_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Discount_Consultation_Stddev_Samp_Fields = {
  __typename?: 'discount_consultation_stddev_samp_fields';
  consultationId?: Maybe<Scalars['Float']>;
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "discount_consultation" */
export type Discount_Consultation_Stddev_Samp_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "discount_consultation" */
export type Discount_Consultation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Discount_Consultation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Discount_Consultation_Stream_Cursor_Value_Input = {
  consultationId?: InputMaybe<Scalars['Int']>;
  discountId?: InputMaybe<Scalars['Int']>;
  maxCount?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Discount_Consultation_Sum_Fields = {
  __typename?: 'discount_consultation_sum_fields';
  consultationId?: Maybe<Scalars['Int']>;
  discountId?: Maybe<Scalars['Int']>;
  maxCount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "discount_consultation" */
export type Discount_Consultation_Sum_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
};

/** update columns of table "discount_consultation" */
export enum Discount_Consultation_Update_Column {
  /** column name */
  ConsultationId = 'consultationId',
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  MaxCount = 'maxCount'
}

export type Discount_Consultation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Discount_Consultation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Discount_Consultation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Discount_Consultation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Discount_Consultation_Var_Pop_Fields = {
  __typename?: 'discount_consultation_var_pop_fields';
  consultationId?: Maybe<Scalars['Float']>;
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "discount_consultation" */
export type Discount_Consultation_Var_Pop_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Discount_Consultation_Var_Samp_Fields = {
  __typename?: 'discount_consultation_var_samp_fields';
  consultationId?: Maybe<Scalars['Float']>;
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "discount_consultation" */
export type Discount_Consultation_Var_Samp_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Discount_Consultation_Variance_Fields = {
  __typename?: 'discount_consultation_variance_fields';
  consultationId?: Maybe<Scalars['Float']>;
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "discount_consultation" */
export type Discount_Consultation_Variance_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "discount" */
export type Discount_Inc_Input = {
  percent?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "discount" */
export type Discount_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['timestamptz']>;
  dateTo?: InputMaybe<Scalars['timestamptz']>;
  discountConsultations?: InputMaybe<Discount_Consultation_Arr_Rel_Insert_Input>;
  discountTests?: InputMaybe<Discount_Test_Arr_Rel_Insert_Input>;
  discountTrainings?: InputMaybe<Discount_Training_Arr_Rel_Insert_Input>;
  percent?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Discount_Type_Enum_Enum>;
};

/** aggregate max on columns */
export type Discount_Max_Fields = {
  __typename?: 'discount_max_fields';
  code?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['timestamptz']>;
  dateTo?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  percent?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Discount_Min_Fields = {
  __typename?: 'discount_min_fields';
  code?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['timestamptz']>;
  dateTo?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  percent?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "discount" */
export type Discount_Mutation_Response = {
  __typename?: 'discount_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Discount>;
};

/** input type for inserting object relation for remote table "discount" */
export type Discount_Obj_Rel_Insert_Input = {
  data: Discount_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Discount_On_Conflict>;
};

/** on_conflict condition type for table "discount" */
export type Discount_On_Conflict = {
  constraint: Discount_Constraint;
  update_columns?: Array<Discount_Update_Column>;
  where?: InputMaybe<Discount_Bool_Exp>;
};

/** Ordering options when selecting data from "discount". */
export type Discount_Order_By = {
  code?: InputMaybe<Order_By>;
  dateFrom?: InputMaybe<Order_By>;
  dateTo?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  discountConsultations_aggregate?: InputMaybe<Discount_Consultation_Aggregate_Order_By>;
  discountTests_aggregate?: InputMaybe<Discount_Test_Aggregate_Order_By>;
  discountTrainings_aggregate?: InputMaybe<Discount_Training_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  orderDiscounts_aggregate?: InputMaybe<Order_Discount_Aggregate_Order_By>;
  percent?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: discount */
export type Discount_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "discount" */
export enum Discount_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  DateFrom = 'dateFrom',
  /** column name */
  DateTo = 'dateTo',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Percent = 'percent',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "discount" */
export type Discount_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['timestamptz']>;
  dateTo?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  percent?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Discount_Type_Enum_Enum>;
};

/** aggregate stddev on columns */
export type Discount_Stddev_Fields = {
  __typename?: 'discount_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Discount_Stddev_Pop_Fields = {
  __typename?: 'discount_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Discount_Stddev_Samp_Fields = {
  __typename?: 'discount_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "discount" */
export type Discount_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Discount_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Discount_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['timestamptz']>;
  dateTo?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  percent?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Discount_Type_Enum_Enum>;
};

/** aggregate sum on columns */
export type Discount_Sum_Fields = {
  __typename?: 'discount_sum_fields';
  id?: Maybe<Scalars['Int']>;
  percent?: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "discount_test" */
export type Discount_Test = {
  __typename?: 'discount_test';
  /** An object relationship */
  discount: Discount;
  discountId: Scalars['Int'];
  maxCount?: Maybe<Scalars['Int']>;
  /** An object relationship */
  test: Test;
  testId: Scalars['Int'];
};

/** aggregated selection of "discount_test" */
export type Discount_Test_Aggregate = {
  __typename?: 'discount_test_aggregate';
  aggregate?: Maybe<Discount_Test_Aggregate_Fields>;
  nodes: Array<Discount_Test>;
};

export type Discount_Test_Aggregate_Bool_Exp = {
  count?: InputMaybe<Discount_Test_Aggregate_Bool_Exp_Count>;
};

export type Discount_Test_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Discount_Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Discount_Test_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "discount_test" */
export type Discount_Test_Aggregate_Fields = {
  __typename?: 'discount_test_aggregate_fields';
  avg?: Maybe<Discount_Test_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Discount_Test_Max_Fields>;
  min?: Maybe<Discount_Test_Min_Fields>;
  stddev?: Maybe<Discount_Test_Stddev_Fields>;
  stddev_pop?: Maybe<Discount_Test_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Discount_Test_Stddev_Samp_Fields>;
  sum?: Maybe<Discount_Test_Sum_Fields>;
  var_pop?: Maybe<Discount_Test_Var_Pop_Fields>;
  var_samp?: Maybe<Discount_Test_Var_Samp_Fields>;
  variance?: Maybe<Discount_Test_Variance_Fields>;
};


/** aggregate fields of "discount_test" */
export type Discount_Test_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Discount_Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "discount_test" */
export type Discount_Test_Aggregate_Order_By = {
  avg?: InputMaybe<Discount_Test_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Discount_Test_Max_Order_By>;
  min?: InputMaybe<Discount_Test_Min_Order_By>;
  stddev?: InputMaybe<Discount_Test_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Discount_Test_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Discount_Test_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Discount_Test_Sum_Order_By>;
  var_pop?: InputMaybe<Discount_Test_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Discount_Test_Var_Samp_Order_By>;
  variance?: InputMaybe<Discount_Test_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "discount_test" */
export type Discount_Test_Arr_Rel_Insert_Input = {
  data: Array<Discount_Test_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Discount_Test_On_Conflict>;
};

/** aggregate avg on columns */
export type Discount_Test_Avg_Fields = {
  __typename?: 'discount_test_avg_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "discount_test" */
export type Discount_Test_Avg_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "discount_test". All fields are combined with a logical 'AND'. */
export type Discount_Test_Bool_Exp = {
  _and?: InputMaybe<Array<Discount_Test_Bool_Exp>>;
  _not?: InputMaybe<Discount_Test_Bool_Exp>;
  _or?: InputMaybe<Array<Discount_Test_Bool_Exp>>;
  discount?: InputMaybe<Discount_Bool_Exp>;
  discountId?: InputMaybe<Int_Comparison_Exp>;
  maxCount?: InputMaybe<Int_Comparison_Exp>;
  test?: InputMaybe<Test_Bool_Exp>;
  testId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "discount_test" */
export enum Discount_Test_Constraint {
  /** unique or primary key constraint on columns "test_id", "discount_id" */
  DiscountTestPkey = 'discount_test_pkey'
}

/** input type for incrementing numeric columns in table "discount_test" */
export type Discount_Test_Inc_Input = {
  discountId?: InputMaybe<Scalars['Int']>;
  maxCount?: InputMaybe<Scalars['Int']>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "discount_test" */
export type Discount_Test_Insert_Input = {
  discount?: InputMaybe<Discount_Obj_Rel_Insert_Input>;
  discountId?: InputMaybe<Scalars['Int']>;
  maxCount?: InputMaybe<Scalars['Int']>;
  test?: InputMaybe<Test_Obj_Rel_Insert_Input>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Discount_Test_Max_Fields = {
  __typename?: 'discount_test_max_fields';
  discountId?: Maybe<Scalars['Int']>;
  maxCount?: Maybe<Scalars['Int']>;
  testId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "discount_test" */
export type Discount_Test_Max_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Discount_Test_Min_Fields = {
  __typename?: 'discount_test_min_fields';
  discountId?: Maybe<Scalars['Int']>;
  maxCount?: Maybe<Scalars['Int']>;
  testId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "discount_test" */
export type Discount_Test_Min_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "discount_test" */
export type Discount_Test_Mutation_Response = {
  __typename?: 'discount_test_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Discount_Test>;
};

/** on_conflict condition type for table "discount_test" */
export type Discount_Test_On_Conflict = {
  constraint: Discount_Test_Constraint;
  update_columns?: Array<Discount_Test_Update_Column>;
  where?: InputMaybe<Discount_Test_Bool_Exp>;
};

/** Ordering options when selecting data from "discount_test". */
export type Discount_Test_Order_By = {
  discount?: InputMaybe<Discount_Order_By>;
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  test?: InputMaybe<Test_Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: discount_test */
export type Discount_Test_Pk_Columns_Input = {
  discountId: Scalars['Int'];
  testId: Scalars['Int'];
};

/** select columns of table "discount_test" */
export enum Discount_Test_Select_Column {
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  MaxCount = 'maxCount',
  /** column name */
  TestId = 'testId'
}

/** input type for updating data in table "discount_test" */
export type Discount_Test_Set_Input = {
  discountId?: InputMaybe<Scalars['Int']>;
  maxCount?: InputMaybe<Scalars['Int']>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Discount_Test_Stddev_Fields = {
  __typename?: 'discount_test_stddev_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "discount_test" */
export type Discount_Test_Stddev_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Discount_Test_Stddev_Pop_Fields = {
  __typename?: 'discount_test_stddev_pop_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "discount_test" */
export type Discount_Test_Stddev_Pop_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Discount_Test_Stddev_Samp_Fields = {
  __typename?: 'discount_test_stddev_samp_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "discount_test" */
export type Discount_Test_Stddev_Samp_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "discount_test" */
export type Discount_Test_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Discount_Test_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Discount_Test_Stream_Cursor_Value_Input = {
  discountId?: InputMaybe<Scalars['Int']>;
  maxCount?: InputMaybe<Scalars['Int']>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Discount_Test_Sum_Fields = {
  __typename?: 'discount_test_sum_fields';
  discountId?: Maybe<Scalars['Int']>;
  maxCount?: Maybe<Scalars['Int']>;
  testId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "discount_test" */
export type Discount_Test_Sum_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** update columns of table "discount_test" */
export enum Discount_Test_Update_Column {
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  MaxCount = 'maxCount',
  /** column name */
  TestId = 'testId'
}

export type Discount_Test_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Discount_Test_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Discount_Test_Set_Input>;
  /** filter the rows which have to be updated */
  where: Discount_Test_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Discount_Test_Var_Pop_Fields = {
  __typename?: 'discount_test_var_pop_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "discount_test" */
export type Discount_Test_Var_Pop_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Discount_Test_Var_Samp_Fields = {
  __typename?: 'discount_test_var_samp_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "discount_test" */
export type Discount_Test_Var_Samp_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Discount_Test_Variance_Fields = {
  __typename?: 'discount_test_variance_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "discount_test" */
export type Discount_Test_Variance_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** columns and relationships of "discount_training" */
export type Discount_Training = {
  __typename?: 'discount_training';
  /** An object relationship */
  discount: Discount;
  discountId: Scalars['Int'];
  maxCount?: Maybe<Scalars['Int']>;
  /** An object relationship */
  training: Training;
  trainingId: Scalars['Int'];
};

/** aggregated selection of "discount_training" */
export type Discount_Training_Aggregate = {
  __typename?: 'discount_training_aggregate';
  aggregate?: Maybe<Discount_Training_Aggregate_Fields>;
  nodes: Array<Discount_Training>;
};

export type Discount_Training_Aggregate_Bool_Exp = {
  count?: InputMaybe<Discount_Training_Aggregate_Bool_Exp_Count>;
};

export type Discount_Training_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Discount_Training_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Discount_Training_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "discount_training" */
export type Discount_Training_Aggregate_Fields = {
  __typename?: 'discount_training_aggregate_fields';
  avg?: Maybe<Discount_Training_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Discount_Training_Max_Fields>;
  min?: Maybe<Discount_Training_Min_Fields>;
  stddev?: Maybe<Discount_Training_Stddev_Fields>;
  stddev_pop?: Maybe<Discount_Training_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Discount_Training_Stddev_Samp_Fields>;
  sum?: Maybe<Discount_Training_Sum_Fields>;
  var_pop?: Maybe<Discount_Training_Var_Pop_Fields>;
  var_samp?: Maybe<Discount_Training_Var_Samp_Fields>;
  variance?: Maybe<Discount_Training_Variance_Fields>;
};


/** aggregate fields of "discount_training" */
export type Discount_Training_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Discount_Training_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "discount_training" */
export type Discount_Training_Aggregate_Order_By = {
  avg?: InputMaybe<Discount_Training_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Discount_Training_Max_Order_By>;
  min?: InputMaybe<Discount_Training_Min_Order_By>;
  stddev?: InputMaybe<Discount_Training_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Discount_Training_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Discount_Training_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Discount_Training_Sum_Order_By>;
  var_pop?: InputMaybe<Discount_Training_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Discount_Training_Var_Samp_Order_By>;
  variance?: InputMaybe<Discount_Training_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "discount_training" */
export type Discount_Training_Arr_Rel_Insert_Input = {
  data: Array<Discount_Training_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Discount_Training_On_Conflict>;
};

/** aggregate avg on columns */
export type Discount_Training_Avg_Fields = {
  __typename?: 'discount_training_avg_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "discount_training" */
export type Discount_Training_Avg_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "discount_training". All fields are combined with a logical 'AND'. */
export type Discount_Training_Bool_Exp = {
  _and?: InputMaybe<Array<Discount_Training_Bool_Exp>>;
  _not?: InputMaybe<Discount_Training_Bool_Exp>;
  _or?: InputMaybe<Array<Discount_Training_Bool_Exp>>;
  discount?: InputMaybe<Discount_Bool_Exp>;
  discountId?: InputMaybe<Int_Comparison_Exp>;
  maxCount?: InputMaybe<Int_Comparison_Exp>;
  training?: InputMaybe<Training_Bool_Exp>;
  trainingId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "discount_training" */
export enum Discount_Training_Constraint {
  /** unique or primary key constraint on columns "training_id", "discount_id" */
  DiscountTrainingPkey = 'discount_training_pkey'
}

/** input type for incrementing numeric columns in table "discount_training" */
export type Discount_Training_Inc_Input = {
  discountId?: InputMaybe<Scalars['Int']>;
  maxCount?: InputMaybe<Scalars['Int']>;
  trainingId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "discount_training" */
export type Discount_Training_Insert_Input = {
  discount?: InputMaybe<Discount_Obj_Rel_Insert_Input>;
  discountId?: InputMaybe<Scalars['Int']>;
  maxCount?: InputMaybe<Scalars['Int']>;
  training?: InputMaybe<Training_Obj_Rel_Insert_Input>;
  trainingId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Discount_Training_Max_Fields = {
  __typename?: 'discount_training_max_fields';
  discountId?: Maybe<Scalars['Int']>;
  maxCount?: Maybe<Scalars['Int']>;
  trainingId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "discount_training" */
export type Discount_Training_Max_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Discount_Training_Min_Fields = {
  __typename?: 'discount_training_min_fields';
  discountId?: Maybe<Scalars['Int']>;
  maxCount?: Maybe<Scalars['Int']>;
  trainingId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "discount_training" */
export type Discount_Training_Min_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "discount_training" */
export type Discount_Training_Mutation_Response = {
  __typename?: 'discount_training_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Discount_Training>;
};

/** on_conflict condition type for table "discount_training" */
export type Discount_Training_On_Conflict = {
  constraint: Discount_Training_Constraint;
  update_columns?: Array<Discount_Training_Update_Column>;
  where?: InputMaybe<Discount_Training_Bool_Exp>;
};

/** Ordering options when selecting data from "discount_training". */
export type Discount_Training_Order_By = {
  discount?: InputMaybe<Discount_Order_By>;
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  training?: InputMaybe<Training_Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: discount_training */
export type Discount_Training_Pk_Columns_Input = {
  discountId: Scalars['Int'];
  trainingId: Scalars['Int'];
};

/** select columns of table "discount_training" */
export enum Discount_Training_Select_Column {
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  MaxCount = 'maxCount',
  /** column name */
  TrainingId = 'trainingId'
}

/** input type for updating data in table "discount_training" */
export type Discount_Training_Set_Input = {
  discountId?: InputMaybe<Scalars['Int']>;
  maxCount?: InputMaybe<Scalars['Int']>;
  trainingId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Discount_Training_Stddev_Fields = {
  __typename?: 'discount_training_stddev_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "discount_training" */
export type Discount_Training_Stddev_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Discount_Training_Stddev_Pop_Fields = {
  __typename?: 'discount_training_stddev_pop_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "discount_training" */
export type Discount_Training_Stddev_Pop_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Discount_Training_Stddev_Samp_Fields = {
  __typename?: 'discount_training_stddev_samp_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "discount_training" */
export type Discount_Training_Stddev_Samp_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "discount_training" */
export type Discount_Training_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Discount_Training_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Discount_Training_Stream_Cursor_Value_Input = {
  discountId?: InputMaybe<Scalars['Int']>;
  maxCount?: InputMaybe<Scalars['Int']>;
  trainingId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Discount_Training_Sum_Fields = {
  __typename?: 'discount_training_sum_fields';
  discountId?: Maybe<Scalars['Int']>;
  maxCount?: Maybe<Scalars['Int']>;
  trainingId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "discount_training" */
export type Discount_Training_Sum_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** update columns of table "discount_training" */
export enum Discount_Training_Update_Column {
  /** column name */
  DiscountId = 'discountId',
  /** column name */
  MaxCount = 'maxCount',
  /** column name */
  TrainingId = 'trainingId'
}

export type Discount_Training_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Discount_Training_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Discount_Training_Set_Input>;
  /** filter the rows which have to be updated */
  where: Discount_Training_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Discount_Training_Var_Pop_Fields = {
  __typename?: 'discount_training_var_pop_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "discount_training" */
export type Discount_Training_Var_Pop_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Discount_Training_Var_Samp_Fields = {
  __typename?: 'discount_training_var_samp_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "discount_training" */
export type Discount_Training_Var_Samp_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Discount_Training_Variance_Fields = {
  __typename?: 'discount_training_variance_fields';
  discountId?: Maybe<Scalars['Float']>;
  maxCount?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "discount_training" */
export type Discount_Training_Variance_Order_By = {
  discountId?: InputMaybe<Order_By>;
  maxCount?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** columns and relationships of "discount_type_enum" */
export type Discount_Type_Enum = {
  __typename?: 'discount_type_enum';
  type: Scalars['String'];
};

/** Boolean expression to filter rows from the table "discount_type_enum". All fields are combined with a logical 'AND'. */
export type Discount_Type_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Discount_Type_Enum_Bool_Exp>>;
  _not?: InputMaybe<Discount_Type_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Discount_Type_Enum_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

export enum Discount_Type_Enum_Enum {
  AllConsultations = 'AllConsultations',
  AllItems = 'AllItems',
  AllTests = 'AllTests',
  AllTrainings = 'AllTrainings',
  CollectionCost = 'CollectionCost',
  SomeItems = 'SomeItems',
  WholeOrder = 'WholeOrder',
  WholeOrderWithItems = 'WholeOrderWithItems'
}

/** Boolean expression to compare columns of type "discount_type_enum_enum". All fields are combined with logical 'AND'. */
export type Discount_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Discount_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Discount_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Discount_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Discount_Type_Enum_Enum>>;
};

/** Ordering options when selecting data from "discount_type_enum". */
export type Discount_Type_Enum_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** select columns of table "discount_type_enum" */
export enum Discount_Type_Enum_Select_Column {
  /** column name */
  Type = 'type'
}

/** Streaming cursor of the table "discount_type_enum" */
export type Discount_Type_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Discount_Type_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Discount_Type_Enum_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "discount" */
export enum Discount_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  DateFrom = 'dateFrom',
  /** column name */
  DateTo = 'dateTo',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Percent = 'percent',
  /** column name */
  Type = 'type'
}

export type Discount_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Discount_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Discount_Set_Input>;
  /** filter the rows which have to be updated */
  where: Discount_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Discount_Var_Pop_Fields = {
  __typename?: 'discount_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Discount_Var_Samp_Fields = {
  __typename?: 'discount_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Discount_Variance_Fields = {
  __typename?: 'discount_variance_fields';
  id?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "feature_flags" */
export type Feature_Flags = {
  __typename?: 'feature_flags';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['bigint'];
  key: Scalars['String'];
  payload?: Maybe<Scalars['jsonb']>;
  project: Scalars['String'];
  rollout_percentage: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "feature_flags" */
export type Feature_FlagsPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Feature_Flags_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "feature_flags". All fields are combined with a logical 'AND'. */
export type Feature_Flags_Bool_Exp = {
  _and?: InputMaybe<Array<Feature_Flags_Bool_Exp>>;
  _not?: InputMaybe<Feature_Flags_Bool_Exp>;
  _or?: InputMaybe<Array<Feature_Flags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  project?: InputMaybe<String_Comparison_Exp>;
  rollout_percentage?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "feature_flags" */
export enum Feature_Flags_Constraint {
  /** unique or primary key constraint on columns "id" */
  FeatureFlagsPkey = 'feature_flags_pkey',
  /** unique or primary key constraint on columns "key", "project" */
  FeatureFlagsProjectKeyKey = 'feature_flags_project_key_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Feature_Flags_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Feature_Flags_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Feature_Flags_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "feature_flags" */
export type Feature_Flags_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  rollout_percentage?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "feature_flags" */
export type Feature_Flags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  key?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  project?: InputMaybe<Scalars['String']>;
  rollout_percentage?: InputMaybe<Scalars['Int']>;
};

/** response of any mutation on the table "feature_flags" */
export type Feature_Flags_Mutation_Response = {
  __typename?: 'feature_flags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feature_Flags>;
};

/** on_conflict condition type for table "feature_flags" */
export type Feature_Flags_On_Conflict = {
  constraint: Feature_Flags_Constraint;
  update_columns?: Array<Feature_Flags_Update_Column>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};

/** Ordering options when selecting data from "feature_flags". */
export type Feature_Flags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  project?: InputMaybe<Order_By>;
  rollout_percentage?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feature_flags */
export type Feature_Flags_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Feature_Flags_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "feature_flags" */
export enum Feature_Flags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Payload = 'payload',
  /** column name */
  Project = 'project',
  /** column name */
  RolloutPercentage = 'rollout_percentage',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "feature_flags" */
export type Feature_Flags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  key?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  project?: InputMaybe<Scalars['String']>;
  rollout_percentage?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "feature_flags" */
export type Feature_Flags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feature_Flags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feature_Flags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  key?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  project?: InputMaybe<Scalars['String']>;
  rollout_percentage?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "feature_flags" */
export enum Feature_Flags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Payload = 'payload',
  /** column name */
  Project = 'project',
  /** column name */
  RolloutPercentage = 'rollout_percentage'
}

export type Feature_Flags_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Feature_Flags_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Feature_Flags_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Feature_Flags_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Feature_Flags_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feature_Flags_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Feature_Flags_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feature_Flags_Bool_Exp;
};

/** columns and relationships of "file" */
export type File = {
  __typename?: 'file';
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  orderDocuments: Array<Order_Document>;
  /** An aggregate relationship */
  orderDocuments_aggregate: Order_Document_Aggregate;
  /** An array relationship */
  orderTestResults: Array<Order_Test_Result>;
  /** An aggregate relationship */
  orderTestResults_aggregate: Order_Test_Result_Aggregate;
  /** An array relationship */
  trainings: Array<Training>;
  /** An aggregate relationship */
  trainings_aggregate: Training_Aggregate;
};


/** columns and relationships of "file" */
export type FileOrderDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Order_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Document_Order_By>>;
  where?: InputMaybe<Order_Document_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileOrderDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Document_Order_By>>;
  where?: InputMaybe<Order_Document_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileOrderTestResultsArgs = {
  distinct_on?: InputMaybe<Array<Order_Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Test_Result_Order_By>>;
  where?: InputMaybe<Order_Test_Result_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileOrderTestResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Test_Result_Order_By>>;
  where?: InputMaybe<Order_Test_Result_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileTrainingsArgs = {
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileTrainings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "file". All fields are combined with a logical 'AND'. */
export type File_Bool_Exp = {
  _and?: InputMaybe<Array<File_Bool_Exp>>;
  _not?: InputMaybe<File_Bool_Exp>;
  _or?: InputMaybe<Array<File_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  orderDocuments?: InputMaybe<Order_Document_Bool_Exp>;
  orderDocuments_aggregate?: InputMaybe<Order_Document_Aggregate_Bool_Exp>;
  orderTestResults?: InputMaybe<Order_Test_Result_Bool_Exp>;
  orderTestResults_aggregate?: InputMaybe<Order_Test_Result_Aggregate_Bool_Exp>;
  trainings?: InputMaybe<Training_Bool_Exp>;
  trainings_aggregate?: InputMaybe<Training_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "file" */
export enum File_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilePkey = 'file_pkey'
}

/** input type for inserting data into table "file" */
export type File_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orderTestResults?: InputMaybe<Order_Test_Result_Arr_Rel_Insert_Input>;
  permission?: InputMaybe<Scalars['String']>;
  trainings?: InputMaybe<Training_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "file" */
export type File_Mutation_Response = {
  __typename?: 'file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<File>;
};

/** input type for inserting object relation for remote table "file" */
export type File_Obj_Rel_Insert_Input = {
  data: File_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<File_On_Conflict>;
};

/** on_conflict condition type for table "file" */
export type File_On_Conflict = {
  constraint: File_Constraint;
  update_columns?: Array<File_Update_Column>;
  where?: InputMaybe<File_Bool_Exp>;
};

/** Ordering options when selecting data from "file". */
export type File_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  orderDocuments_aggregate?: InputMaybe<Order_Document_Aggregate_Order_By>;
  orderTestResults_aggregate?: InputMaybe<Order_Test_Result_Aggregate_Order_By>;
  trainings_aggregate?: InputMaybe<Training_Aggregate_Order_By>;
};

/** select columns of table "file" */
export enum File_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "file" */
export type File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** placeholder for update columns of table "file" (current role has no relevant permissions) */
export enum File_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** Boolean expression to compare columns of type "fulfillment_type". All fields are combined with logical 'AND'. */
export type Fulfillment_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['fulfillment_type']>;
  _gt?: InputMaybe<Scalars['fulfillment_type']>;
  _gte?: InputMaybe<Scalars['fulfillment_type']>;
  _in?: InputMaybe<Array<Scalars['fulfillment_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['fulfillment_type']>;
  _lte?: InputMaybe<Scalars['fulfillment_type']>;
  _neq?: InputMaybe<Scalars['fulfillment_type']>;
  _nin?: InputMaybe<Array<Scalars['fulfillment_type']>>;
};

/** columns and relationships of "gender" */
export type Gender = {
  __typename?: 'gender';
  gender: Scalars['String'];
};

/** Boolean expression to filter rows from the table "gender". All fields are combined with a logical 'AND'. */
export type Gender_Bool_Exp = {
  _and?: InputMaybe<Array<Gender_Bool_Exp>>;
  _not?: InputMaybe<Gender_Bool_Exp>;
  _or?: InputMaybe<Array<Gender_Bool_Exp>>;
  gender?: InputMaybe<String_Comparison_Exp>;
};

export enum Gender_Enum {
  Female = 'female',
  Male = 'male'
}

/** Boolean expression to compare columns of type "gender_enum". All fields are combined with logical 'AND'. */
export type Gender_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Gender_Enum>;
  _in?: InputMaybe<Array<Gender_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Gender_Enum>;
  _nin?: InputMaybe<Array<Gender_Enum>>;
};

/** Ordering options when selecting data from "gender". */
export type Gender_Order_By = {
  gender?: InputMaybe<Order_By>;
};

/** select columns of table "gender" */
export enum Gender_Select_Column {
  /** column name */
  Gender = 'gender'
}

/** Streaming cursor of the table "gender" */
export type Gender_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gender_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gender_Stream_Cursor_Value_Input = {
  gender?: InputMaybe<Scalars['String']>;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']>;
  _gt?: InputMaybe<Scalars['geography']>;
  _gte?: InputMaybe<Scalars['geography']>;
  _in?: InputMaybe<Array<Scalars['geography']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geography']>;
  _lte?: InputMaybe<Scalars['geography']>;
  _neq?: InputMaybe<Scalars['geography']>;
  _nin?: InputMaybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']>;
  _gt?: InputMaybe<Scalars['geometry']>;
  _gte?: InputMaybe<Scalars['geometry']>;
  _in?: InputMaybe<Array<Scalars['geometry']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geometry']>;
  _lte?: InputMaybe<Scalars['geometry']>;
  _neq?: InputMaybe<Scalars['geometry']>;
  _nin?: InputMaybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']>;
};

export type IsAvailable_Test_Args = {
  point?: InputMaybe<Scalars['geography']>;
};

export type IsNurseAvailable_Laboratory_Args = {
  point?: InputMaybe<Scalars['geography']>;
};

export type IsNurseAvailable_Test_Args = {
  point?: InputMaybe<Scalars['geography']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "lab_user" */
export type Lab_User = {
  __typename?: 'lab_user';
  email: Scalars['String'];
  id: Scalars['Int'];
  laboratoryId: Scalars['Int'];
  name: Scalars['String'];
  password?: Maybe<Scalars['String']>;
};

/** aggregated selection of "lab_user" */
export type Lab_User_Aggregate = {
  __typename?: 'lab_user_aggregate';
  aggregate?: Maybe<Lab_User_Aggregate_Fields>;
  nodes: Array<Lab_User>;
};

/** aggregate fields of "lab_user" */
export type Lab_User_Aggregate_Fields = {
  __typename?: 'lab_user_aggregate_fields';
  avg?: Maybe<Lab_User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Lab_User_Max_Fields>;
  min?: Maybe<Lab_User_Min_Fields>;
  stddev?: Maybe<Lab_User_Stddev_Fields>;
  stddev_pop?: Maybe<Lab_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lab_User_Stddev_Samp_Fields>;
  sum?: Maybe<Lab_User_Sum_Fields>;
  var_pop?: Maybe<Lab_User_Var_Pop_Fields>;
  var_samp?: Maybe<Lab_User_Var_Samp_Fields>;
  variance?: Maybe<Lab_User_Variance_Fields>;
};


/** aggregate fields of "lab_user" */
export type Lab_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lab_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Lab_User_Avg_Fields = {
  __typename?: 'lab_user_avg_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "lab_user". All fields are combined with a logical 'AND'. */
export type Lab_User_Bool_Exp = {
  _and?: InputMaybe<Array<Lab_User_Bool_Exp>>;
  _not?: InputMaybe<Lab_User_Bool_Exp>;
  _or?: InputMaybe<Array<Lab_User_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  laboratoryId?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "lab_user" */
export enum Lab_User_Constraint {
  /** unique or primary key constraint on columns "email" */
  LabUserEmailKey = 'lab_user_email_key',
  /** unique or primary key constraint on columns "id" */
  LabUserPkey = 'lab_user_pkey'
}

/** input type for incrementing numeric columns in table "lab_user" */
export type Lab_User_Inc_Input = {
  laboratoryId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lab_user" */
export type Lab_User_Insert_Input = {
  email?: InputMaybe<Scalars['String']>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Lab_User_Max_Fields = {
  __typename?: 'lab_user_max_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  laboratoryId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Lab_User_Min_Fields = {
  __typename?: 'lab_user_min_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  laboratoryId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lab_user" */
export type Lab_User_Mutation_Response = {
  __typename?: 'lab_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Lab_User>;
};

/** on_conflict condition type for table "lab_user" */
export type Lab_User_On_Conflict = {
  constraint: Lab_User_Constraint;
  update_columns?: Array<Lab_User_Update_Column>;
  where?: InputMaybe<Lab_User_Bool_Exp>;
};

/** Ordering options when selecting data from "lab_user". */
export type Lab_User_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lab_user */
export type Lab_User_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "lab_user" */
export enum Lab_User_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  LaboratoryId = 'laboratoryId',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password'
}

/** input type for updating data in table "lab_user" */
export type Lab_User_Set_Input = {
  email?: InputMaybe<Scalars['String']>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Lab_User_Stddev_Fields = {
  __typename?: 'lab_user_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Lab_User_Stddev_Pop_Fields = {
  __typename?: 'lab_user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Lab_User_Stddev_Samp_Fields = {
  __typename?: 'lab_user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "lab_user" */
export type Lab_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lab_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lab_User_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Lab_User_Sum_Fields = {
  __typename?: 'lab_user_sum_fields';
  id?: Maybe<Scalars['Int']>;
  laboratoryId?: Maybe<Scalars['Int']>;
};

/** update columns of table "lab_user" */
export enum Lab_User_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  LaboratoryId = 'laboratoryId',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password'
}

export type Lab_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lab_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lab_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lab_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lab_User_Var_Pop_Fields = {
  __typename?: 'lab_user_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Lab_User_Var_Samp_Fields = {
  __typename?: 'lab_user_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Lab_User_Variance_Fields = {
  __typename?: 'lab_user_variance_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "laboratory" */
export type Laboratory = {
  __typename?: 'laboratory';
  /** A computed field, executes function "laboratory_address" */
  address?: Maybe<Scalars['String']>;
  /** A computed field, executes function "laboratory_city" */
  city?: Maybe<Scalars['String']>;
  /** An array relationship */
  collectionPoints: Array<Laboratory_Collection_Point>;
  /** An aggregate relationship */
  collectionPoints_aggregate: Laboratory_Collection_Point_Aggregate;
  costSummary?: Maybe<Array<Laboratory_Summary>>;
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  /** A computed field, executes function "laboratory_has_nurse_available" */
  isNurseAvailable?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  laboratoryShippings: Array<Laboratory_Shipping>;
  /** An array relationship */
  laboratoryTests: Array<Laboratory_Test>;
  /** An aggregate relationship */
  laboratoryTests_aggregate: Laboratory_Test_Aggregate;
  /** A computed field, executes function "laboratory_location" */
  location?: Maybe<Scalars['geography']>;
  /** An object relationship */
  logoFile?: Maybe<File>;
  logoFileId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** A computed field, executes function "laboratory_postal_code" */
  postalCode?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  useHL7: Scalars['Boolean'];
};


/** columns and relationships of "laboratory" */
export type LaboratoryCollectionPointsArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Collection_Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Collection_Point_Order_By>>;
  where?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
};


/** columns and relationships of "laboratory" */
export type LaboratoryCollectionPoints_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Collection_Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Collection_Point_Order_By>>;
  where?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
};


/** columns and relationships of "laboratory" */
export type LaboratoryCostSummaryArgs = {
  args: CostSummary_Laboratory_Args;
  distinct_on?: InputMaybe<Array<Laboratory_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Summary_Order_By>>;
  where?: InputMaybe<Laboratory_Summary_Bool_Exp>;
};


/** columns and relationships of "laboratory" */
export type LaboratoryIsNurseAvailableArgs = {
  args: IsNurseAvailable_Laboratory_Args;
};


/** columns and relationships of "laboratory" */
export type LaboratoryLaboratoryShippingsArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Shipping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Shipping_Order_By>>;
  where?: InputMaybe<Laboratory_Shipping_Bool_Exp>;
};


/** columns and relationships of "laboratory" */
export type LaboratoryLaboratoryTestsArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Test_Order_By>>;
  where?: InputMaybe<Laboratory_Test_Bool_Exp>;
};


/** columns and relationships of "laboratory" */
export type LaboratoryLaboratoryTests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Test_Order_By>>;
  where?: InputMaybe<Laboratory_Test_Bool_Exp>;
};

export type Laboratory_Aggregate = {
  __typename?: 'laboratory_aggregate';
  aggregate?: Maybe<Laboratory_Aggregate_Fields>;
  nodes: Array<Laboratory>;
};

/** aggregate fields of "laboratory" */
export type Laboratory_Aggregate_Fields = {
  __typename?: 'laboratory_aggregate_fields';
  avg?: Maybe<Laboratory_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Laboratory_Max_Fields>;
  min?: Maybe<Laboratory_Min_Fields>;
  stddev?: Maybe<Laboratory_Stddev_Fields>;
  stddev_pop?: Maybe<Laboratory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Laboratory_Stddev_Samp_Fields>;
  sum?: Maybe<Laboratory_Sum_Fields>;
  var_pop?: Maybe<Laboratory_Var_Pop_Fields>;
  var_samp?: Maybe<Laboratory_Var_Samp_Fields>;
  variance?: Maybe<Laboratory_Variance_Fields>;
};


/** aggregate fields of "laboratory" */
export type Laboratory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Laboratory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "laboratory" */
export type Laboratory_Aggregate_Order_By = {
  avg?: InputMaybe<Laboratory_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Laboratory_Max_Order_By>;
  min?: InputMaybe<Laboratory_Min_Order_By>;
  stddev?: InputMaybe<Laboratory_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Laboratory_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Laboratory_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Laboratory_Sum_Order_By>;
  var_pop?: InputMaybe<Laboratory_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Laboratory_Var_Samp_Order_By>;
  variance?: InputMaybe<Laboratory_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Laboratory_Avg_Fields = {
  __typename?: 'laboratory_avg_fields';
  id?: Maybe<Scalars['Float']>;
  logoFileId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "laboratory" */
export type Laboratory_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  logoFileId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "laboratory". All fields are combined with a logical 'AND'. */
export type Laboratory_Bool_Exp = {
  _and?: InputMaybe<Array<Laboratory_Bool_Exp>>;
  _not?: InputMaybe<Laboratory_Bool_Exp>;
  _or?: InputMaybe<Array<Laboratory_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  collectionPoints?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
  collectionPoints_aggregate?: InputMaybe<Laboratory_Collection_Point_Aggregate_Bool_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  laboratoryShippings?: InputMaybe<Laboratory_Shipping_Bool_Exp>;
  laboratoryTests?: InputMaybe<Laboratory_Test_Bool_Exp>;
  laboratoryTests_aggregate?: InputMaybe<Laboratory_Test_Aggregate_Bool_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  logoFile?: InputMaybe<File_Bool_Exp>;
  logoFileId?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  postalCode?: InputMaybe<String_Comparison_Exp>;
  shortName?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  useHL7?: InputMaybe<Boolean_Comparison_Exp>;
};

/** columns and relationships of "laboratory_collection_point" */
export type Laboratory_Collection_Point = {
  __typename?: 'laboratory_collection_point';
  address: Scalars['String'];
  city: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isExternalResults: Scalars['Boolean'];
  isVoucherEnabled: Scalars['Boolean'];
  /** An object relationship */
  laboratory: Laboratory;
  laboratoryId: Scalars['Int'];
  location: Scalars['geography'];
  name: Scalars['String'];
  openingHours: Scalars['jsonb'];
  /** An array relationship */
  orderTests: Array<Order_Test>;
  postalCode: Scalars['String'];
};


/** columns and relationships of "laboratory_collection_point" */
export type Laboratory_Collection_PointOpeningHoursArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "laboratory_collection_point" */
export type Laboratory_Collection_PointOrderTestsArgs = {
  distinct_on?: InputMaybe<Array<Order_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Test_Order_By>>;
  where?: InputMaybe<Order_Test_Bool_Exp>;
};

/** aggregated selection of "laboratory_collection_point" */
export type Laboratory_Collection_Point_Aggregate = {
  __typename?: 'laboratory_collection_point_aggregate';
  aggregate?: Maybe<Laboratory_Collection_Point_Aggregate_Fields>;
  nodes: Array<Laboratory_Collection_Point>;
};

export type Laboratory_Collection_Point_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Laboratory_Collection_Point_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Laboratory_Collection_Point_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Laboratory_Collection_Point_Aggregate_Bool_Exp_Count>;
};

export type Laboratory_Collection_Point_Aggregate_Bool_Exp_Bool_And = {
  arguments: Laboratory_Collection_Point_Select_Column_Laboratory_Collection_Point_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Laboratory_Collection_Point_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Laboratory_Collection_Point_Select_Column_Laboratory_Collection_Point_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Laboratory_Collection_Point_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Laboratory_Collection_Point_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "laboratory_collection_point" */
export type Laboratory_Collection_Point_Aggregate_Fields = {
  __typename?: 'laboratory_collection_point_aggregate_fields';
  avg?: Maybe<Laboratory_Collection_Point_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Laboratory_Collection_Point_Max_Fields>;
  min?: Maybe<Laboratory_Collection_Point_Min_Fields>;
  stddev?: Maybe<Laboratory_Collection_Point_Stddev_Fields>;
  stddev_pop?: Maybe<Laboratory_Collection_Point_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Laboratory_Collection_Point_Stddev_Samp_Fields>;
  sum?: Maybe<Laboratory_Collection_Point_Sum_Fields>;
  var_pop?: Maybe<Laboratory_Collection_Point_Var_Pop_Fields>;
  var_samp?: Maybe<Laboratory_Collection_Point_Var_Samp_Fields>;
  variance?: Maybe<Laboratory_Collection_Point_Variance_Fields>;
};


/** aggregate fields of "laboratory_collection_point" */
export type Laboratory_Collection_Point_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Laboratory_Collection_Point_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Aggregate_Order_By = {
  avg?: InputMaybe<Laboratory_Collection_Point_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Laboratory_Collection_Point_Max_Order_By>;
  min?: InputMaybe<Laboratory_Collection_Point_Min_Order_By>;
  stddev?: InputMaybe<Laboratory_Collection_Point_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Laboratory_Collection_Point_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Laboratory_Collection_Point_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Laboratory_Collection_Point_Sum_Order_By>;
  var_pop?: InputMaybe<Laboratory_Collection_Point_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Laboratory_Collection_Point_Var_Samp_Order_By>;
  variance?: InputMaybe<Laboratory_Collection_Point_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Laboratory_Collection_Point_Append_Input = {
  openingHours?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Arr_Rel_Insert_Input = {
  data: Array<Laboratory_Collection_Point_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Laboratory_Collection_Point_On_Conflict>;
};

/** aggregate avg on columns */
export type Laboratory_Collection_Point_Avg_Fields = {
  __typename?: 'laboratory_collection_point_avg_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "laboratory_collection_point". All fields are combined with a logical 'AND'. */
export type Laboratory_Collection_Point_Bool_Exp = {
  _and?: InputMaybe<Array<Laboratory_Collection_Point_Bool_Exp>>;
  _not?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
  _or?: InputMaybe<Array<Laboratory_Collection_Point_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isExternalResults?: InputMaybe<Boolean_Comparison_Exp>;
  isVoucherEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  laboratory?: InputMaybe<Laboratory_Bool_Exp>;
  laboratoryId?: InputMaybe<Int_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  openingHours?: InputMaybe<Jsonb_Comparison_Exp>;
  orderTests?: InputMaybe<Order_Test_Bool_Exp>;
  postalCode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "laboratory_collection_point" */
export enum Laboratory_Collection_Point_Constraint {
  /** unique or primary key constraint on columns "id" */
  LaboratoryCollectionPointPkey = 'laboratory_collection_point_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Laboratory_Collection_Point_Delete_At_Path_Input = {
  openingHours?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Laboratory_Collection_Point_Delete_Elem_Input = {
  openingHours?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Laboratory_Collection_Point_Delete_Key_Input = {
  openingHours?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Inc_Input = {
  laboratoryId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  isExternalResults?: InputMaybe<Scalars['Boolean']>;
  isVoucherEnabled?: InputMaybe<Scalars['Boolean']>;
  laboratory?: InputMaybe<Laboratory_Obj_Rel_Insert_Input>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['geography']>;
  name?: InputMaybe<Scalars['String']>;
  openingHours?: InputMaybe<Scalars['jsonb']>;
  orderTests?: InputMaybe<Order_Test_Arr_Rel_Insert_Input>;
  postalCode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Laboratory_Collection_Point_Max_Fields = {
  __typename?: 'laboratory_collection_point_max_fields';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  laboratoryId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Laboratory_Collection_Point_Min_Fields = {
  __typename?: 'laboratory_collection_point_min_fields';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  laboratoryId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Mutation_Response = {
  __typename?: 'laboratory_collection_point_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Laboratory_Collection_Point>;
};

/** input type for inserting object relation for remote table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Obj_Rel_Insert_Input = {
  data: Laboratory_Collection_Point_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Laboratory_Collection_Point_On_Conflict>;
};

/** on_conflict condition type for table "laboratory_collection_point" */
export type Laboratory_Collection_Point_On_Conflict = {
  constraint: Laboratory_Collection_Point_Constraint;
  update_columns?: Array<Laboratory_Collection_Point_Update_Column>;
  where?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
};

/** Ordering options when selecting data from "laboratory_collection_point". */
export type Laboratory_Collection_Point_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isExternalResults?: InputMaybe<Order_By>;
  isVoucherEnabled?: InputMaybe<Order_By>;
  laboratory?: InputMaybe<Laboratory_Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  openingHours?: InputMaybe<Order_By>;
  orderTests_aggregate?: InputMaybe<Order_Test_Aggregate_Order_By>;
  postalCode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: laboratory_collection_point */
export type Laboratory_Collection_Point_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Laboratory_Collection_Point_Prepend_Input = {
  openingHours?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "laboratory_collection_point" */
export enum Laboratory_Collection_Point_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsExternalResults = 'isExternalResults',
  /** column name */
  IsVoucherEnabled = 'isVoucherEnabled',
  /** column name */
  LaboratoryId = 'laboratoryId',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  OpeningHours = 'openingHours',
  /** column name */
  PostalCode = 'postalCode'
}

/** select "laboratory_collection_point_aggregate_bool_exp_bool_and_arguments_columns" columns of table "laboratory_collection_point" */
export enum Laboratory_Collection_Point_Select_Column_Laboratory_Collection_Point_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsExternalResults = 'isExternalResults',
  /** column name */
  IsVoucherEnabled = 'isVoucherEnabled'
}

/** select "laboratory_collection_point_aggregate_bool_exp_bool_or_arguments_columns" columns of table "laboratory_collection_point" */
export enum Laboratory_Collection_Point_Select_Column_Laboratory_Collection_Point_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsExternalResults = 'isExternalResults',
  /** column name */
  IsVoucherEnabled = 'isVoucherEnabled'
}

/** input type for updating data in table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  isExternalResults?: InputMaybe<Scalars['Boolean']>;
  isVoucherEnabled?: InputMaybe<Scalars['Boolean']>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['geography']>;
  name?: InputMaybe<Scalars['String']>;
  openingHours?: InputMaybe<Scalars['jsonb']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Laboratory_Collection_Point_Stddev_Fields = {
  __typename?: 'laboratory_collection_point_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Laboratory_Collection_Point_Stddev_Pop_Fields = {
  __typename?: 'laboratory_collection_point_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Laboratory_Collection_Point_Stddev_Samp_Fields = {
  __typename?: 'laboratory_collection_point_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Laboratory_Collection_Point_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Laboratory_Collection_Point_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isExternalResults?: InputMaybe<Scalars['Boolean']>;
  isVoucherEnabled?: InputMaybe<Scalars['Boolean']>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['geography']>;
  name?: InputMaybe<Scalars['String']>;
  openingHours?: InputMaybe<Scalars['jsonb']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Laboratory_Collection_Point_Sum_Fields = {
  __typename?: 'laboratory_collection_point_sum_fields';
  id?: Maybe<Scalars['Int']>;
  laboratoryId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
};

/** update columns of table "laboratory_collection_point" */
export enum Laboratory_Collection_Point_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  IsExternalResults = 'isExternalResults',
  /** column name */
  IsVoucherEnabled = 'isVoucherEnabled',
  /** column name */
  LaboratoryId = 'laboratoryId',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  OpeningHours = 'openingHours',
  /** column name */
  PostalCode = 'postalCode'
}

export type Laboratory_Collection_Point_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Laboratory_Collection_Point_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Laboratory_Collection_Point_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Laboratory_Collection_Point_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Laboratory_Collection_Point_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Laboratory_Collection_Point_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Laboratory_Collection_Point_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Laboratory_Collection_Point_Set_Input>;
  /** filter the rows which have to be updated */
  where: Laboratory_Collection_Point_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Laboratory_Collection_Point_Var_Pop_Fields = {
  __typename?: 'laboratory_collection_point_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Laboratory_Collection_Point_Var_Samp_Fields = {
  __typename?: 'laboratory_collection_point_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Laboratory_Collection_Point_Variance_Fields = {
  __typename?: 'laboratory_collection_point_variance_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "laboratory_collection_point" */
export type Laboratory_Collection_Point_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "laboratory" */
export enum Laboratory_Constraint {
  /** unique or primary key constraint on columns "id" */
  LaboratoryPkey = 'laboratory_pkey'
}

/** input type for incrementing numeric columns in table "laboratory" */
export type Laboratory_Inc_Input = {
  logoFileId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "laboratory" */
export type Laboratory_Insert_Input = {
  collectionPoints?: InputMaybe<Laboratory_Collection_Point_Arr_Rel_Insert_Input>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  laboratoryShippings?: InputMaybe<Laboratory_Shipping_Arr_Rel_Insert_Input>;
  laboratoryTests?: InputMaybe<Laboratory_Test_Arr_Rel_Insert_Input>;
  logoFile?: InputMaybe<File_Obj_Rel_Insert_Input>;
  logoFileId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  useHL7?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Laboratory_Max_Fields = {
  __typename?: 'laboratory_max_fields';
  /** A computed field, executes function "laboratory_address" */
  address?: Maybe<Scalars['String']>;
  /** A computed field, executes function "laboratory_city" */
  city?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logoFileId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** A computed field, executes function "laboratory_postal_code" */
  postalCode?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "laboratory" */
export type Laboratory_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  logoFileId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  shortName?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Laboratory_Min_Fields = {
  __typename?: 'laboratory_min_fields';
  /** A computed field, executes function "laboratory_address" */
  address?: Maybe<Scalars['String']>;
  /** A computed field, executes function "laboratory_city" */
  city?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logoFileId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** A computed field, executes function "laboratory_postal_code" */
  postalCode?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "laboratory" */
export type Laboratory_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  logoFileId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  shortName?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "laboratory" */
export type Laboratory_Mutation_Response = {
  __typename?: 'laboratory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Laboratory>;
};

/** input type for inserting object relation for remote table "laboratory" */
export type Laboratory_Obj_Rel_Insert_Input = {
  data: Laboratory_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Laboratory_On_Conflict>;
};

/** on_conflict condition type for table "laboratory" */
export type Laboratory_On_Conflict = {
  constraint: Laboratory_Constraint;
  update_columns?: Array<Laboratory_Update_Column>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};

/** Ordering options when selecting data from "laboratory". */
export type Laboratory_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  collectionPoints_aggregate?: InputMaybe<Laboratory_Collection_Point_Aggregate_Order_By>;
  enabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryShippings_aggregate?: InputMaybe<Laboratory_Shipping_Aggregate_Order_By>;
  laboratoryTests_aggregate?: InputMaybe<Laboratory_Test_Aggregate_Order_By>;
  location?: InputMaybe<Order_By>;
  logoFile?: InputMaybe<File_Order_By>;
  logoFileId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  shortName?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  useHL7?: InputMaybe<Order_By>;
};

/** primary key columns input for table: laboratory */
export type Laboratory_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "laboratory" */
export enum Laboratory_Select_Column {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  LogoFileId = 'logoFileId',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Url = 'url',
  /** column name */
  UseHl7 = 'useHL7'
}

/** input type for updating data in table "laboratory" */
export type Laboratory_Set_Input = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  logoFileId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  useHL7?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "laboratory_shipping" */
export type Laboratory_Shipping = {
  __typename?: 'laboratory_shipping';
  createdAt: Scalars['timestamptz'];
  email: Scalars['String'];
  id: Scalars['bigint'];
  /** An object relationship */
  laboratory: Laboratory;
  laboratoryId: Scalars['Int'];
  phone: Scalars['String'];
  pointName: Scalars['String'];
  /** An object relationship */
  shipping: Shipping;
  shippingId: Scalars['bigint'];
  updatedAt: Scalars['timestamptz'];
};

/** order by aggregate values of table "laboratory_shipping" */
export type Laboratory_Shipping_Aggregate_Order_By = {
  avg?: InputMaybe<Laboratory_Shipping_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Laboratory_Shipping_Max_Order_By>;
  min?: InputMaybe<Laboratory_Shipping_Min_Order_By>;
  stddev?: InputMaybe<Laboratory_Shipping_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Laboratory_Shipping_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Laboratory_Shipping_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Laboratory_Shipping_Sum_Order_By>;
  var_pop?: InputMaybe<Laboratory_Shipping_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Laboratory_Shipping_Var_Samp_Order_By>;
  variance?: InputMaybe<Laboratory_Shipping_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "laboratory_shipping" */
export type Laboratory_Shipping_Arr_Rel_Insert_Input = {
  data: Array<Laboratory_Shipping_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Laboratory_Shipping_On_Conflict>;
};

/** order by avg() on columns of table "laboratory_shipping" */
export type Laboratory_Shipping_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "laboratory_shipping". All fields are combined with a logical 'AND'. */
export type Laboratory_Shipping_Bool_Exp = {
  _and?: InputMaybe<Array<Laboratory_Shipping_Bool_Exp>>;
  _not?: InputMaybe<Laboratory_Shipping_Bool_Exp>;
  _or?: InputMaybe<Array<Laboratory_Shipping_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  laboratory?: InputMaybe<Laboratory_Bool_Exp>;
  laboratoryId?: InputMaybe<Int_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  pointName?: InputMaybe<String_Comparison_Exp>;
  shipping?: InputMaybe<Shipping_Bool_Exp>;
  shippingId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "laboratory_shipping" */
export enum Laboratory_Shipping_Constraint {
  /** unique or primary key constraint on columns "id" */
  LaboratoryShippingPkey = 'laboratory_shipping_pkey'
}

/** input type for incrementing numeric columns in table "laboratory_shipping" */
export type Laboratory_Shipping_Inc_Input = {
  laboratoryId?: InputMaybe<Scalars['Int']>;
  shippingId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "laboratory_shipping" */
export type Laboratory_Shipping_Insert_Input = {
  email?: InputMaybe<Scalars['String']>;
  laboratory?: InputMaybe<Laboratory_Obj_Rel_Insert_Input>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  pointName?: InputMaybe<Scalars['String']>;
  shippingId?: InputMaybe<Scalars['bigint']>;
};

/** order by max() on columns of table "laboratory_shipping" */
export type Laboratory_Shipping_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  pointName?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "laboratory_shipping" */
export type Laboratory_Shipping_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  pointName?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "laboratory_shipping" */
export type Laboratory_Shipping_Mutation_Response = {
  __typename?: 'laboratory_shipping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Laboratory_Shipping>;
};

/** on_conflict condition type for table "laboratory_shipping" */
export type Laboratory_Shipping_On_Conflict = {
  constraint: Laboratory_Shipping_Constraint;
  update_columns?: Array<Laboratory_Shipping_Update_Column>;
  where?: InputMaybe<Laboratory_Shipping_Bool_Exp>;
};

/** Ordering options when selecting data from "laboratory_shipping". */
export type Laboratory_Shipping_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory?: InputMaybe<Laboratory_Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  pointName?: InputMaybe<Order_By>;
  shipping?: InputMaybe<Shipping_Order_By>;
  shippingId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: laboratory_shipping */
export type Laboratory_Shipping_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "laboratory_shipping" */
export enum Laboratory_Shipping_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  LaboratoryId = 'laboratoryId',
  /** column name */
  Phone = 'phone',
  /** column name */
  PointName = 'pointName',
  /** column name */
  ShippingId = 'shippingId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "laboratory_shipping" */
export type Laboratory_Shipping_Set_Input = {
  email?: InputMaybe<Scalars['String']>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  pointName?: InputMaybe<Scalars['String']>;
  shippingId?: InputMaybe<Scalars['bigint']>;
};

/** order by stddev() on columns of table "laboratory_shipping" */
export type Laboratory_Shipping_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "laboratory_shipping" */
export type Laboratory_Shipping_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "laboratory_shipping" */
export type Laboratory_Shipping_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "laboratory_shipping" */
export type Laboratory_Shipping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Laboratory_Shipping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Laboratory_Shipping_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  pointName?: InputMaybe<Scalars['String']>;
  shippingId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "laboratory_shipping" */
export type Laboratory_Shipping_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** update columns of table "laboratory_shipping" */
export enum Laboratory_Shipping_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  LaboratoryId = 'laboratoryId',
  /** column name */
  Phone = 'phone',
  /** column name */
  PointName = 'pointName',
  /** column name */
  ShippingId = 'shippingId'
}

export type Laboratory_Shipping_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Laboratory_Shipping_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Laboratory_Shipping_Set_Input>;
  /** filter the rows which have to be updated */
  where: Laboratory_Shipping_Bool_Exp;
};

/** order by var_pop() on columns of table "laboratory_shipping" */
export type Laboratory_Shipping_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "laboratory_shipping" */
export type Laboratory_Shipping_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "laboratory_shipping" */
export type Laboratory_Shipping_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Laboratory_Stddev_Fields = {
  __typename?: 'laboratory_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  logoFileId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "laboratory" */
export type Laboratory_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  logoFileId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Laboratory_Stddev_Pop_Fields = {
  __typename?: 'laboratory_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  logoFileId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "laboratory" */
export type Laboratory_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  logoFileId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Laboratory_Stddev_Samp_Fields = {
  __typename?: 'laboratory_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  logoFileId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "laboratory" */
export type Laboratory_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  logoFileId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "laboratory" */
export type Laboratory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Laboratory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Laboratory_Stream_Cursor_Value_Input = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  logoFileId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  useHL7?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Laboratory_Sum_Fields = {
  __typename?: 'laboratory_sum_fields';
  id?: Maybe<Scalars['Int']>;
  logoFileId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "laboratory" */
export type Laboratory_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  logoFileId?: InputMaybe<Order_By>;
};

/** columns and relationships of "laboratory_summary" */
export type Laboratory_Summary = {
  __typename?: 'laboratory_summary';
  costSum?: Maybe<Scalars['numeric']>;
  orderCount?: Maybe<Scalars['bigint']>;
  testCount?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "laboratory_summary". All fields are combined with a logical 'AND'. */
export type Laboratory_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<Laboratory_Summary_Bool_Exp>>;
  _not?: InputMaybe<Laboratory_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Laboratory_Summary_Bool_Exp>>;
  costSum?: InputMaybe<Numeric_Comparison_Exp>;
  orderCount?: InputMaybe<Bigint_Comparison_Exp>;
  testCount?: InputMaybe<Bigint_Comparison_Exp>;
};

/** Ordering options when selecting data from "laboratory_summary". */
export type Laboratory_Summary_Order_By = {
  costSum?: InputMaybe<Order_By>;
  orderCount?: InputMaybe<Order_By>;
  testCount?: InputMaybe<Order_By>;
};

/** select columns of table "laboratory_summary" */
export enum Laboratory_Summary_Select_Column {
  /** column name */
  CostSum = 'costSum',
  /** column name */
  OrderCount = 'orderCount',
  /** column name */
  TestCount = 'testCount'
}

/** Streaming cursor of the table "laboratory_summary" */
export type Laboratory_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Laboratory_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Laboratory_Summary_Stream_Cursor_Value_Input = {
  costSum?: InputMaybe<Scalars['numeric']>;
  orderCount?: InputMaybe<Scalars['bigint']>;
  testCount?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "laboratory_test" */
export type Laboratory_Test = {
  __typename?: 'laboratory_test';
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object relationship */
  laboratory: Laboratory;
  laboratoryId: Scalars['Int'];
  price: Scalars['numeric'];
  /** An object relationship */
  test: Test;
  testId: Scalars['Int'];
  /** A computed field, executes function "laboratory_test_waiting_time_i18n" */
  waitingTime?: Maybe<Scalars['String']>;
  waitingTime_i18n: Scalars['jsonb'];
};


/** columns and relationships of "laboratory_test" */
export type Laboratory_TestWaitingTime_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "laboratory_test" */
export type Laboratory_Test_Aggregate = {
  __typename?: 'laboratory_test_aggregate';
  aggregate?: Maybe<Laboratory_Test_Aggregate_Fields>;
  nodes: Array<Laboratory_Test>;
};

export type Laboratory_Test_Aggregate_Bool_Exp = {
  count?: InputMaybe<Laboratory_Test_Aggregate_Bool_Exp_Count>;
};

export type Laboratory_Test_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Laboratory_Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Laboratory_Test_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "laboratory_test" */
export type Laboratory_Test_Aggregate_Fields = {
  __typename?: 'laboratory_test_aggregate_fields';
  avg?: Maybe<Laboratory_Test_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Laboratory_Test_Max_Fields>;
  min?: Maybe<Laboratory_Test_Min_Fields>;
  stddev?: Maybe<Laboratory_Test_Stddev_Fields>;
  stddev_pop?: Maybe<Laboratory_Test_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Laboratory_Test_Stddev_Samp_Fields>;
  sum?: Maybe<Laboratory_Test_Sum_Fields>;
  var_pop?: Maybe<Laboratory_Test_Var_Pop_Fields>;
  var_samp?: Maybe<Laboratory_Test_Var_Samp_Fields>;
  variance?: Maybe<Laboratory_Test_Variance_Fields>;
};


/** aggregate fields of "laboratory_test" */
export type Laboratory_Test_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Laboratory_Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "laboratory_test" */
export type Laboratory_Test_Aggregate_Order_By = {
  avg?: InputMaybe<Laboratory_Test_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Laboratory_Test_Max_Order_By>;
  min?: InputMaybe<Laboratory_Test_Min_Order_By>;
  stddev?: InputMaybe<Laboratory_Test_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Laboratory_Test_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Laboratory_Test_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Laboratory_Test_Sum_Order_By>;
  var_pop?: InputMaybe<Laboratory_Test_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Laboratory_Test_Var_Samp_Order_By>;
  variance?: InputMaybe<Laboratory_Test_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Laboratory_Test_Append_Input = {
  waitingTime_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "laboratory_test" */
export type Laboratory_Test_Arr_Rel_Insert_Input = {
  data: Array<Laboratory_Test_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Laboratory_Test_On_Conflict>;
};

/** aggregate avg on columns */
export type Laboratory_Test_Avg_Fields = {
  __typename?: 'laboratory_test_avg_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "laboratory_test" */
export type Laboratory_Test_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "laboratory_test". All fields are combined with a logical 'AND'. */
export type Laboratory_Test_Bool_Exp = {
  _and?: InputMaybe<Array<Laboratory_Test_Bool_Exp>>;
  _not?: InputMaybe<Laboratory_Test_Bool_Exp>;
  _or?: InputMaybe<Array<Laboratory_Test_Bool_Exp>>;
  externalId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  laboratory?: InputMaybe<Laboratory_Bool_Exp>;
  laboratoryId?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  test?: InputMaybe<Test_Bool_Exp>;
  testId?: InputMaybe<Int_Comparison_Exp>;
  waitingTime?: InputMaybe<String_Comparison_Exp>;
  waitingTime_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "laboratory_test" */
export enum Laboratory_Test_Constraint {
  /** unique or primary key constraint on columns "id" */
  LaboratoryTestPkey = 'laboratory_test_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Laboratory_Test_Delete_At_Path_Input = {
  waitingTime_i18n?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Laboratory_Test_Delete_Elem_Input = {
  waitingTime_i18n?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Laboratory_Test_Delete_Key_Input = {
  waitingTime_i18n?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "laboratory_test" */
export type Laboratory_Test_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "laboratory_test" */
export type Laboratory_Test_Insert_Input = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  laboratory?: InputMaybe<Laboratory_Obj_Rel_Insert_Input>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  test?: InputMaybe<Test_Obj_Rel_Insert_Input>;
  testId?: InputMaybe<Scalars['Int']>;
  waitingTime_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Laboratory_Test_Max_Fields = {
  __typename?: 'laboratory_test_max_fields';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  laboratoryId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  testId?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "laboratory_test_waiting_time_i18n" */
  waitingTime?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "laboratory_test" */
export type Laboratory_Test_Max_Order_By = {
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Laboratory_Test_Min_Fields = {
  __typename?: 'laboratory_test_min_fields';
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  laboratoryId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  testId?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "laboratory_test_waiting_time_i18n" */
  waitingTime?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "laboratory_test" */
export type Laboratory_Test_Min_Order_By = {
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "laboratory_test" */
export type Laboratory_Test_Mutation_Response = {
  __typename?: 'laboratory_test_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Laboratory_Test>;
};

/** on_conflict condition type for table "laboratory_test" */
export type Laboratory_Test_On_Conflict = {
  constraint: Laboratory_Test_Constraint;
  update_columns?: Array<Laboratory_Test_Update_Column>;
  where?: InputMaybe<Laboratory_Test_Bool_Exp>;
};

/** Ordering options when selecting data from "laboratory_test". */
export type Laboratory_Test_Order_By = {
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory?: InputMaybe<Laboratory_Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  test?: InputMaybe<Test_Order_By>;
  testId?: InputMaybe<Order_By>;
  waitingTime?: InputMaybe<Order_By>;
  waitingTime_i18n?: InputMaybe<Order_By>;
};

/** primary key columns input for table: laboratory_test */
export type Laboratory_Test_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Laboratory_Test_Prepend_Input = {
  waitingTime_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "laboratory_test" */
export enum Laboratory_Test_Select_Column {
  /** column name */
  ExternalId = 'externalId',
  /** column name */
  Id = 'id',
  /** column name */
  LaboratoryId = 'laboratoryId',
  /** column name */
  Price = 'price',
  /** column name */
  TestId = 'testId',
  /** column name */
  WaitingTimeI18n = 'waitingTime_i18n'
}

/** input type for updating data in table "laboratory_test" */
export type Laboratory_Test_Set_Input = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  testId?: InputMaybe<Scalars['Int']>;
  waitingTime_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Laboratory_Test_Stddev_Fields = {
  __typename?: 'laboratory_test_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "laboratory_test" */
export type Laboratory_Test_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Laboratory_Test_Stddev_Pop_Fields = {
  __typename?: 'laboratory_test_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "laboratory_test" */
export type Laboratory_Test_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Laboratory_Test_Stddev_Samp_Fields = {
  __typename?: 'laboratory_test_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "laboratory_test" */
export type Laboratory_Test_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "laboratory_test" */
export type Laboratory_Test_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Laboratory_Test_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Laboratory_Test_Stream_Cursor_Value_Input = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  testId?: InputMaybe<Scalars['Int']>;
  waitingTime_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type Laboratory_Test_Sum_Fields = {
  __typename?: 'laboratory_test_sum_fields';
  id?: Maybe<Scalars['Int']>;
  laboratoryId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  testId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "laboratory_test" */
export type Laboratory_Test_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** update columns of table "laboratory_test" */
export enum Laboratory_Test_Update_Column {
  /** column name */
  ExternalId = 'externalId',
  /** column name */
  Id = 'id',
  /** column name */
  LaboratoryId = 'laboratoryId',
  /** column name */
  Price = 'price',
  /** column name */
  TestId = 'testId',
  /** column name */
  WaitingTimeI18n = 'waitingTime_i18n'
}

export type Laboratory_Test_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Laboratory_Test_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Laboratory_Test_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Laboratory_Test_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Laboratory_Test_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Laboratory_Test_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Laboratory_Test_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Laboratory_Test_Set_Input>;
  /** filter the rows which have to be updated */
  where: Laboratory_Test_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Laboratory_Test_Var_Pop_Fields = {
  __typename?: 'laboratory_test_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "laboratory_test" */
export type Laboratory_Test_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Laboratory_Test_Var_Samp_Fields = {
  __typename?: 'laboratory_test_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "laboratory_test" */
export type Laboratory_Test_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Laboratory_Test_Variance_Fields = {
  __typename?: 'laboratory_test_variance_fields';
  id?: Maybe<Scalars['Float']>;
  laboratoryId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "laboratory_test" */
export type Laboratory_Test_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** update columns of table "laboratory" */
export enum Laboratory_Update_Column {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  LogoFileId = 'logoFileId',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Url = 'url',
  /** column name */
  UseHl7 = 'useHL7'
}

export type Laboratory_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Laboratory_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Laboratory_Set_Input>;
  /** filter the rows which have to be updated */
  where: Laboratory_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Laboratory_Var_Pop_Fields = {
  __typename?: 'laboratory_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  logoFileId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "laboratory" */
export type Laboratory_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  logoFileId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Laboratory_Var_Samp_Fields = {
  __typename?: 'laboratory_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  logoFileId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "laboratory" */
export type Laboratory_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  logoFileId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Laboratory_Variance_Fields = {
  __typename?: 'laboratory_variance_fields';
  id?: Maybe<Scalars['Float']>;
  logoFileId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "laboratory" */
export type Laboratory_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  logoFileId?: InputMaybe<Order_By>;
};

/** columns and relationships of "material" */
export type Material = {
  __typename?: 'material';
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  nurseMaterials: Array<Nurse_Material>;
  /** An aggregate relationship */
  nurseMaterials_aggregate: Nurse_Material_Aggregate;
};


/** columns and relationships of "material" */
export type MaterialNurseMaterialsArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Material_Order_By>>;
  where?: InputMaybe<Nurse_Material_Bool_Exp>;
};


/** columns and relationships of "material" */
export type MaterialNurseMaterials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Material_Order_By>>;
  where?: InputMaybe<Nurse_Material_Bool_Exp>;
};

/** aggregated selection of "material" */
export type Material_Aggregate = {
  __typename?: 'material_aggregate';
  aggregate?: Maybe<Material_Aggregate_Fields>;
  nodes: Array<Material>;
};

/** aggregate fields of "material" */
export type Material_Aggregate_Fields = {
  __typename?: 'material_aggregate_fields';
  avg?: Maybe<Material_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Material_Max_Fields>;
  min?: Maybe<Material_Min_Fields>;
  stddev?: Maybe<Material_Stddev_Fields>;
  stddev_pop?: Maybe<Material_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Material_Stddev_Samp_Fields>;
  sum?: Maybe<Material_Sum_Fields>;
  var_pop?: Maybe<Material_Var_Pop_Fields>;
  var_samp?: Maybe<Material_Var_Samp_Fields>;
  variance?: Maybe<Material_Variance_Fields>;
};


/** aggregate fields of "material" */
export type Material_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Material_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Material_Avg_Fields = {
  __typename?: 'material_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "material". All fields are combined with a logical 'AND'. */
export type Material_Bool_Exp = {
  _and?: InputMaybe<Array<Material_Bool_Exp>>;
  _not?: InputMaybe<Material_Bool_Exp>;
  _or?: InputMaybe<Array<Material_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nurseMaterials?: InputMaybe<Nurse_Material_Bool_Exp>;
  nurseMaterials_aggregate?: InputMaybe<Nurse_Material_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "material" */
export enum Material_Constraint {
  /** unique or primary key constraint on columns "id" */
  MaterialPkey = 'material_pkey'
}

/** input type for inserting data into table "material" */
export type Material_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
  nurseMaterials?: InputMaybe<Nurse_Material_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Material_Max_Fields = {
  __typename?: 'material_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Material_Min_Fields = {
  __typename?: 'material_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "material" */
export type Material_Mutation_Response = {
  __typename?: 'material_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Material>;
};

/** input type for inserting object relation for remote table "material" */
export type Material_Obj_Rel_Insert_Input = {
  data: Material_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Material_On_Conflict>;
};

/** on_conflict condition type for table "material" */
export type Material_On_Conflict = {
  constraint: Material_Constraint;
  update_columns?: Array<Material_Update_Column>;
  where?: InputMaybe<Material_Bool_Exp>;
};

/** Ordering options when selecting data from "material". */
export type Material_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nurseMaterials_aggregate?: InputMaybe<Nurse_Material_Aggregate_Order_By>;
};

/** primary key columns input for table: material */
export type Material_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "material" */
export enum Material_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "material" */
export type Material_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Material_Stddev_Fields = {
  __typename?: 'material_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Material_Stddev_Pop_Fields = {
  __typename?: 'material_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Material_Stddev_Samp_Fields = {
  __typename?: 'material_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "material" */
export type Material_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Material_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Material_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Material_Sum_Fields = {
  __typename?: 'material_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "material" */
export enum Material_Update_Column {
  /** column name */
  Name = 'name'
}

export type Material_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Material_Set_Input>;
  /** filter the rows which have to be updated */
  where: Material_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Material_Var_Pop_Fields = {
  __typename?: 'material_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Material_Var_Samp_Fields = {
  __typename?: 'material_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Material_Variance_Fields = {
  __typename?: 'material_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  administrator_logout?: Maybe<AdministratorLogoutOutput>;
  /** delete data from the table: "administrator_notification" */
  delete_administrator_notification?: Maybe<Administrator_Notification_Mutation_Response>;
  /** delete single row from the table: "administrator_notification" */
  delete_administrator_notification_by_pk?: Maybe<Administrator_Notification>;
  /** delete data from the table: "client_favourite_test" */
  delete_client_favourite_test?: Maybe<Client_Favourite_Test_Mutation_Response>;
  /** delete single row from the table: "client_favourite_test" */
  delete_client_favourite_test_by_pk?: Maybe<Client_Favourite_Test>;
  /** delete data from the table: "collection_slot" */
  delete_collection_slot?: Maybe<Collection_Slot_Mutation_Response>;
  /** delete single row from the table: "collection_slot" */
  delete_collection_slot_by_pk?: Maybe<Collection_Slot>;
  /** delete data from the table: "consultation_slot" */
  delete_consultation_slot?: Maybe<Consultation_Slot_Mutation_Response>;
  /** delete single row from the table: "consultation_slot" */
  delete_consultation_slot_by_pk?: Maybe<Consultation_Slot>;
  /** delete data from the table: "discount" */
  delete_discount?: Maybe<Discount_Mutation_Response>;
  /** delete single row from the table: "discount" */
  delete_discount_by_pk?: Maybe<Discount>;
  /** delete data from the table: "discount_consultation" */
  delete_discount_consultation?: Maybe<Discount_Consultation_Mutation_Response>;
  /** delete single row from the table: "discount_consultation" */
  delete_discount_consultation_by_pk?: Maybe<Discount_Consultation>;
  /** delete data from the table: "discount_test" */
  delete_discount_test?: Maybe<Discount_Test_Mutation_Response>;
  /** delete single row from the table: "discount_test" */
  delete_discount_test_by_pk?: Maybe<Discount_Test>;
  /** delete data from the table: "discount_training" */
  delete_discount_training?: Maybe<Discount_Training_Mutation_Response>;
  /** delete single row from the table: "discount_training" */
  delete_discount_training_by_pk?: Maybe<Discount_Training>;
  /** delete data from the table: "feature_flags" */
  delete_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** delete single row from the table: "feature_flags" */
  delete_feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** delete data from the table: "lab_user" */
  delete_lab_user?: Maybe<Lab_User_Mutation_Response>;
  /** delete single row from the table: "lab_user" */
  delete_lab_user_by_pk?: Maybe<Lab_User>;
  /** delete data from the table: "laboratory" */
  delete_laboratory?: Maybe<Laboratory_Mutation_Response>;
  /** delete single row from the table: "laboratory" */
  delete_laboratory_by_pk?: Maybe<Laboratory>;
  /** delete data from the table: "laboratory_test" */
  delete_laboratory_test?: Maybe<Laboratory_Test_Mutation_Response>;
  /** delete single row from the table: "laboratory_test" */
  delete_laboratory_test_by_pk?: Maybe<Laboratory_Test>;
  /** delete data from the table: "material" */
  delete_material?: Maybe<Material_Mutation_Response>;
  /** delete single row from the table: "material" */
  delete_material_by_pk?: Maybe<Material>;
  /** delete data from the table: "nurse_material" */
  delete_nurse_material?: Maybe<Nurse_Material_Mutation_Response>;
  /** delete single row from the table: "nurse_material" */
  delete_nurse_material_by_pk?: Maybe<Nurse_Material>;
  /** delete data from the table: "nurse_test" */
  delete_nurse_test?: Maybe<Nurse_Test_Mutation_Response>;
  /** delete single row from the table: "nurse_test" */
  delete_nurse_test_by_pk?: Maybe<Nurse_Test>;
  /** delete data from the table: "order_test" */
  delete_order_test?: Maybe<Order_Test_Mutation_Response>;
  /** delete single row from the table: "order_test" */
  delete_order_test_by_pk?: Maybe<Order_Test>;
  /** delete data from the table: "order_test_result" */
  delete_order_test_result?: Maybe<Order_Test_Result_Mutation_Response>;
  /** delete single row from the table: "order_test_result" */
  delete_order_test_result_by_pk?: Maybe<Order_Test_Result>;
  /** delete data from the table: "tag" */
  delete_tag?: Maybe<Tag_Mutation_Response>;
  /** delete single row from the table: "tag" */
  delete_tag_by_pk?: Maybe<Tag>;
  /** delete data from the table: "test" */
  delete_test?: Maybe<Test_Mutation_Response>;
  /** delete single row from the table: "test" */
  delete_test_by_pk?: Maybe<Test>;
  /** delete data from the table: "test_material" */
  delete_test_material?: Maybe<Test_Material_Mutation_Response>;
  /** delete single row from the table: "test_material" */
  delete_test_material_by_pk?: Maybe<Test_Material>;
  /** delete data from the table: "test_tag" */
  delete_test_tag?: Maybe<Test_Tag_Mutation_Response>;
  /** delete single row from the table: "test_tag" */
  delete_test_tag_by_pk?: Maybe<Test_Tag>;
  /** insert data into the table: "administrator_notification" */
  insert_administrator_notification?: Maybe<Administrator_Notification_Mutation_Response>;
  /** insert a single row into the table: "administrator_notification" */
  insert_administrator_notification_one?: Maybe<Administrator_Notification>;
  /** insert data into the table: "client" */
  insert_client?: Maybe<Client_Mutation_Response>;
  /** insert a single row into the table: "client" */
  insert_client_one?: Maybe<Client>;
  /** insert data into the table: "client_profile" */
  insert_client_profile?: Maybe<Client_Profile_Mutation_Response>;
  /** insert a single row into the table: "client_profile" */
  insert_client_profile_one?: Maybe<Client_Profile>;
  /** insert data into the table: "collection_slot" */
  insert_collection_slot?: Maybe<Collection_Slot_Mutation_Response>;
  /** insert a single row into the table: "collection_slot" */
  insert_collection_slot_one?: Maybe<Collection_Slot>;
  /** insert data into the table: "consultation" */
  insert_consultation?: Maybe<Consultation_Mutation_Response>;
  /** insert a single row into the table: "consultation" */
  insert_consultation_one?: Maybe<Consultation>;
  /** insert data into the table: "consultation_slot" */
  insert_consultation_slot?: Maybe<Consultation_Slot_Mutation_Response>;
  /** insert a single row into the table: "consultation_slot" */
  insert_consultation_slot_one?: Maybe<Consultation_Slot>;
  /** insert data into the table: "discount" */
  insert_discount?: Maybe<Discount_Mutation_Response>;
  /** insert data into the table: "discount_consultation" */
  insert_discount_consultation?: Maybe<Discount_Consultation_Mutation_Response>;
  /** insert a single row into the table: "discount_consultation" */
  insert_discount_consultation_one?: Maybe<Discount_Consultation>;
  /** insert a single row into the table: "discount" */
  insert_discount_one?: Maybe<Discount>;
  /** insert data into the table: "discount_test" */
  insert_discount_test?: Maybe<Discount_Test_Mutation_Response>;
  /** insert a single row into the table: "discount_test" */
  insert_discount_test_one?: Maybe<Discount_Test>;
  /** insert data into the table: "discount_training" */
  insert_discount_training?: Maybe<Discount_Training_Mutation_Response>;
  /** insert a single row into the table: "discount_training" */
  insert_discount_training_one?: Maybe<Discount_Training>;
  /** insert data into the table: "feature_flags" */
  insert_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** insert a single row into the table: "feature_flags" */
  insert_feature_flags_one?: Maybe<Feature_Flags>;
  /** insert data into the table: "file" */
  insert_file?: Maybe<File_Mutation_Response>;
  /** insert a single row into the table: "file" */
  insert_file_one?: Maybe<File>;
  /** insert data into the table: "lab_user" */
  insert_lab_user?: Maybe<Lab_User_Mutation_Response>;
  /** insert a single row into the table: "lab_user" */
  insert_lab_user_one?: Maybe<Lab_User>;
  /** insert data into the table: "laboratory" */
  insert_laboratory?: Maybe<Laboratory_Mutation_Response>;
  /** insert data into the table: "laboratory_collection_point" */
  insert_laboratory_collection_point?: Maybe<Laboratory_Collection_Point_Mutation_Response>;
  /** insert a single row into the table: "laboratory_collection_point" */
  insert_laboratory_collection_point_one?: Maybe<Laboratory_Collection_Point>;
  /** insert a single row into the table: "laboratory" */
  insert_laboratory_one?: Maybe<Laboratory>;
  /** insert data into the table: "laboratory_shipping" */
  insert_laboratory_shipping?: Maybe<Laboratory_Shipping_Mutation_Response>;
  /** insert a single row into the table: "laboratory_shipping" */
  insert_laboratory_shipping_one?: Maybe<Laboratory_Shipping>;
  /** insert data into the table: "laboratory_test" */
  insert_laboratory_test?: Maybe<Laboratory_Test_Mutation_Response>;
  /** insert a single row into the table: "laboratory_test" */
  insert_laboratory_test_one?: Maybe<Laboratory_Test>;
  /** insert data into the table: "material" */
  insert_material?: Maybe<Material_Mutation_Response>;
  /** insert a single row into the table: "material" */
  insert_material_one?: Maybe<Material>;
  /** insert data into the table: "nurse" */
  insert_nurse?: Maybe<Nurse_Mutation_Response>;
  /** insert data into the table: "nurse_material" */
  insert_nurse_material?: Maybe<Nurse_Material_Mutation_Response>;
  /** insert a single row into the table: "nurse_material" */
  insert_nurse_material_one?: Maybe<Nurse_Material>;
  /** insert a single row into the table: "nurse" */
  insert_nurse_one?: Maybe<Nurse>;
  /** insert data into the table: "nurse_test" */
  insert_nurse_test?: Maybe<Nurse_Test_Mutation_Response>;
  /** insert a single row into the table: "nurse_test" */
  insert_nurse_test_one?: Maybe<Nurse_Test>;
  /** insert data into the table: "order" */
  insert_order?: Maybe<Order_Mutation_Response>;
  /** insert data into the table: "order_collection" */
  insert_order_collection?: Maybe<Order_Collection_Mutation_Response>;
  /** insert a single row into the table: "order_collection" */
  insert_order_collection_one?: Maybe<Order_Collection>;
  /** insert a single row into the table: "order" */
  insert_order_one?: Maybe<Order>;
  /** insert data into the table: "order_state" */
  insert_order_state?: Maybe<Order_State_Mutation_Response>;
  /** insert a single row into the table: "order_state" */
  insert_order_state_one?: Maybe<Order_State>;
  /** insert data into the table: "order_test" */
  insert_order_test?: Maybe<Order_Test_Mutation_Response>;
  /** insert a single row into the table: "order_test" */
  insert_order_test_one?: Maybe<Order_Test>;
  /** insert data into the table: "order_test_result" */
  insert_order_test_result?: Maybe<Order_Test_Result_Mutation_Response>;
  /** insert a single row into the table: "order_test_result" */
  insert_order_test_result_one?: Maybe<Order_Test_Result>;
  /** insert data into the table: "push_notification" */
  insert_push_notification?: Maybe<Push_Notification_Mutation_Response>;
  /** insert data into the table: "push_notification_client" */
  insert_push_notification_client?: Maybe<Push_Notification_Client_Mutation_Response>;
  /** insert a single row into the table: "push_notification_client" */
  insert_push_notification_client_one?: Maybe<Push_Notification_Client>;
  /** insert a single row into the table: "push_notification" */
  insert_push_notification_one?: Maybe<Push_Notification>;
  /** insert data into the table: "rate" */
  insert_rate?: Maybe<Rate_Mutation_Response>;
  /** insert a single row into the table: "rate" */
  insert_rate_one?: Maybe<Rate>;
  /** insert data into the table: "tag" */
  insert_tag?: Maybe<Tag_Mutation_Response>;
  /** insert a single row into the table: "tag" */
  insert_tag_one?: Maybe<Tag>;
  /** insert data into the table: "test" */
  insert_test?: Maybe<Test_Mutation_Response>;
  /** insert data into the table: "test_material" */
  insert_test_material?: Maybe<Test_Material_Mutation_Response>;
  /** insert a single row into the table: "test_material" */
  insert_test_material_one?: Maybe<Test_Material>;
  /** insert a single row into the table: "test" */
  insert_test_one?: Maybe<Test>;
  /** insert data into the table: "test_tag" */
  insert_test_tag?: Maybe<Test_Tag_Mutation_Response>;
  /** insert a single row into the table: "test_tag" */
  insert_test_tag_one?: Maybe<Test_Tag>;
  /** insert data into the table: "training" */
  insert_training?: Maybe<Training_Mutation_Response>;
  /** insert a single row into the table: "training" */
  insert_training_one?: Maybe<Training>;
  lab_user_password_reset_init?: Maybe<LabUserPasswordResetInitOutput>;
  lab_user_password_update?: Maybe<LabUserPasswordUpdateOutput>;
  nurse_password_update?: Maybe<NursePasswordUpdateOutput>;
  ping?: Maybe<PingOutput>;
  /** update data of the table: "administrator" */
  update_administrator?: Maybe<Administrator_Mutation_Response>;
  /** update single row of the table: "administrator" */
  update_administrator_by_pk?: Maybe<Administrator>;
  /** update multiples rows of table: "administrator" */
  update_administrator_many?: Maybe<Array<Maybe<Administrator_Mutation_Response>>>;
  /** update data of the table: "administrator_notification" */
  update_administrator_notification?: Maybe<Administrator_Notification_Mutation_Response>;
  /** update single row of the table: "administrator_notification" */
  update_administrator_notification_by_pk?: Maybe<Administrator_Notification>;
  /** update multiples rows of table: "administrator_notification" */
  update_administrator_notification_many?: Maybe<Array<Maybe<Administrator_Notification_Mutation_Response>>>;
  /** update data of the table: "client" */
  update_client?: Maybe<Client_Mutation_Response>;
  /** update single row of the table: "client" */
  update_client_by_pk?: Maybe<Client>;
  /** update multiples rows of table: "client" */
  update_client_many?: Maybe<Array<Maybe<Client_Mutation_Response>>>;
  /** update data of the table: "collection_slot" */
  update_collection_slot?: Maybe<Collection_Slot_Mutation_Response>;
  /** update single row of the table: "collection_slot" */
  update_collection_slot_by_pk?: Maybe<Collection_Slot>;
  /** update multiples rows of table: "collection_slot" */
  update_collection_slot_many?: Maybe<Array<Maybe<Collection_Slot_Mutation_Response>>>;
  /** update data of the table: "consultation" */
  update_consultation?: Maybe<Consultation_Mutation_Response>;
  /** update single row of the table: "consultation" */
  update_consultation_by_pk?: Maybe<Consultation>;
  /** update multiples rows of table: "consultation" */
  update_consultation_many?: Maybe<Array<Maybe<Consultation_Mutation_Response>>>;
  /** update data of the table: "consultation_slot" */
  update_consultation_slot?: Maybe<Consultation_Slot_Mutation_Response>;
  /** update single row of the table: "consultation_slot" */
  update_consultation_slot_by_pk?: Maybe<Consultation_Slot>;
  /** update multiples rows of table: "consultation_slot" */
  update_consultation_slot_many?: Maybe<Array<Maybe<Consultation_Slot_Mutation_Response>>>;
  /** update data of the table: "discount" */
  update_discount?: Maybe<Discount_Mutation_Response>;
  /** update single row of the table: "discount" */
  update_discount_by_pk?: Maybe<Discount>;
  /** update data of the table: "discount_consultation" */
  update_discount_consultation?: Maybe<Discount_Consultation_Mutation_Response>;
  /** update single row of the table: "discount_consultation" */
  update_discount_consultation_by_pk?: Maybe<Discount_Consultation>;
  /** update multiples rows of table: "discount_consultation" */
  update_discount_consultation_many?: Maybe<Array<Maybe<Discount_Consultation_Mutation_Response>>>;
  /** update multiples rows of table: "discount" */
  update_discount_many?: Maybe<Array<Maybe<Discount_Mutation_Response>>>;
  /** update data of the table: "discount_test" */
  update_discount_test?: Maybe<Discount_Test_Mutation_Response>;
  /** update single row of the table: "discount_test" */
  update_discount_test_by_pk?: Maybe<Discount_Test>;
  /** update multiples rows of table: "discount_test" */
  update_discount_test_many?: Maybe<Array<Maybe<Discount_Test_Mutation_Response>>>;
  /** update data of the table: "discount_training" */
  update_discount_training?: Maybe<Discount_Training_Mutation_Response>;
  /** update single row of the table: "discount_training" */
  update_discount_training_by_pk?: Maybe<Discount_Training>;
  /** update multiples rows of table: "discount_training" */
  update_discount_training_many?: Maybe<Array<Maybe<Discount_Training_Mutation_Response>>>;
  /** update data of the table: "feature_flags" */
  update_feature_flags?: Maybe<Feature_Flags_Mutation_Response>;
  /** update single row of the table: "feature_flags" */
  update_feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** update multiples rows of table: "feature_flags" */
  update_feature_flags_many?: Maybe<Array<Maybe<Feature_Flags_Mutation_Response>>>;
  /** update data of the table: "lab_user" */
  update_lab_user?: Maybe<Lab_User_Mutation_Response>;
  /** update single row of the table: "lab_user" */
  update_lab_user_by_pk?: Maybe<Lab_User>;
  /** update multiples rows of table: "lab_user" */
  update_lab_user_many?: Maybe<Array<Maybe<Lab_User_Mutation_Response>>>;
  /** update data of the table: "laboratory" */
  update_laboratory?: Maybe<Laboratory_Mutation_Response>;
  /** update single row of the table: "laboratory" */
  update_laboratory_by_pk?: Maybe<Laboratory>;
  /** update data of the table: "laboratory_collection_point" */
  update_laboratory_collection_point?: Maybe<Laboratory_Collection_Point_Mutation_Response>;
  /** update single row of the table: "laboratory_collection_point" */
  update_laboratory_collection_point_by_pk?: Maybe<Laboratory_Collection_Point>;
  /** update multiples rows of table: "laboratory_collection_point" */
  update_laboratory_collection_point_many?: Maybe<Array<Maybe<Laboratory_Collection_Point_Mutation_Response>>>;
  /** update multiples rows of table: "laboratory" */
  update_laboratory_many?: Maybe<Array<Maybe<Laboratory_Mutation_Response>>>;
  /** update data of the table: "laboratory_shipping" */
  update_laboratory_shipping?: Maybe<Laboratory_Shipping_Mutation_Response>;
  /** update single row of the table: "laboratory_shipping" */
  update_laboratory_shipping_by_pk?: Maybe<Laboratory_Shipping>;
  /** update multiples rows of table: "laboratory_shipping" */
  update_laboratory_shipping_many?: Maybe<Array<Maybe<Laboratory_Shipping_Mutation_Response>>>;
  /** update data of the table: "laboratory_test" */
  update_laboratory_test?: Maybe<Laboratory_Test_Mutation_Response>;
  /** update single row of the table: "laboratory_test" */
  update_laboratory_test_by_pk?: Maybe<Laboratory_Test>;
  /** update multiples rows of table: "laboratory_test" */
  update_laboratory_test_many?: Maybe<Array<Maybe<Laboratory_Test_Mutation_Response>>>;
  /** update data of the table: "material" */
  update_material?: Maybe<Material_Mutation_Response>;
  /** update single row of the table: "material" */
  update_material_by_pk?: Maybe<Material>;
  /** update multiples rows of table: "material" */
  update_material_many?: Maybe<Array<Maybe<Material_Mutation_Response>>>;
  /** update data of the table: "nurse" */
  update_nurse?: Maybe<Nurse_Mutation_Response>;
  /** update single row of the table: "nurse" */
  update_nurse_by_pk?: Maybe<Nurse>;
  /** update multiples rows of table: "nurse" */
  update_nurse_many?: Maybe<Array<Maybe<Nurse_Mutation_Response>>>;
  /** update data of the table: "nurse_test" */
  update_nurse_test?: Maybe<Nurse_Test_Mutation_Response>;
  /** update single row of the table: "nurse_test" */
  update_nurse_test_by_pk?: Maybe<Nurse_Test>;
  /** update multiples rows of table: "nurse_test" */
  update_nurse_test_many?: Maybe<Array<Maybe<Nurse_Test_Mutation_Response>>>;
  /** update data of the table: "order" */
  update_order?: Maybe<Order_Mutation_Response>;
  /** update single row of the table: "order" */
  update_order_by_pk?: Maybe<Order>;
  /** update data of the table: "order_collection" */
  update_order_collection?: Maybe<Order_Collection_Mutation_Response>;
  /** update single row of the table: "order_collection" */
  update_order_collection_by_pk?: Maybe<Order_Collection>;
  /** update multiples rows of table: "order_collection" */
  update_order_collection_many?: Maybe<Array<Maybe<Order_Collection_Mutation_Response>>>;
  /** update data of the table: "order_consultation" */
  update_order_consultation?: Maybe<Order_Consultation_Mutation_Response>;
  /** update single row of the table: "order_consultation" */
  update_order_consultation_by_pk?: Maybe<Order_Consultation>;
  /** update multiples rows of table: "order_consultation" */
  update_order_consultation_many?: Maybe<Array<Maybe<Order_Consultation_Mutation_Response>>>;
  /** update multiples rows of table: "order" */
  update_order_many?: Maybe<Array<Maybe<Order_Mutation_Response>>>;
  /** update data of the table: "order_test" */
  update_order_test?: Maybe<Order_Test_Mutation_Response>;
  /** update single row of the table: "order_test" */
  update_order_test_by_pk?: Maybe<Order_Test>;
  /** update multiples rows of table: "order_test" */
  update_order_test_many?: Maybe<Array<Maybe<Order_Test_Mutation_Response>>>;
  /** update data of the table: "order_training" */
  update_order_training?: Maybe<Order_Training_Mutation_Response>;
  /** update single row of the table: "order_training" */
  update_order_training_by_pk?: Maybe<Order_Training>;
  /** update multiples rows of table: "order_training" */
  update_order_training_many?: Maybe<Array<Maybe<Order_Training_Mutation_Response>>>;
  /** update data of the table: "rate" */
  update_rate?: Maybe<Rate_Mutation_Response>;
  /** update single row of the table: "rate" */
  update_rate_by_pk?: Maybe<Rate>;
  /** update multiples rows of table: "rate" */
  update_rate_many?: Maybe<Array<Maybe<Rate_Mutation_Response>>>;
  /** update data of the table: "tag" */
  update_tag?: Maybe<Tag_Mutation_Response>;
  /** update single row of the table: "tag" */
  update_tag_by_pk?: Maybe<Tag>;
  /** update multiples rows of table: "tag" */
  update_tag_many?: Maybe<Array<Maybe<Tag_Mutation_Response>>>;
  /** update data of the table: "test" */
  update_test?: Maybe<Test_Mutation_Response>;
  /** update single row of the table: "test" */
  update_test_by_pk?: Maybe<Test>;
  /** update multiples rows of table: "test" */
  update_test_many?: Maybe<Array<Maybe<Test_Mutation_Response>>>;
  /** update data of the table: "training" */
  update_training?: Maybe<Training_Mutation_Response>;
  /** update single row of the table: "training" */
  update_training_by_pk?: Maybe<Training>;
  /** update multiples rows of table: "training" */
  update_training_many?: Maybe<Array<Maybe<Training_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_Administrator_NotificationArgs = {
  where: Administrator_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Administrator_Notification_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Client_Favourite_TestArgs = {
  where: Client_Favourite_Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Favourite_Test_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Collection_SlotArgs = {
  where: Collection_Slot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Collection_Slot_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Consultation_SlotArgs = {
  where: Consultation_Slot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Consultation_Slot_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DiscountArgs = {
  where: Discount_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discount_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Discount_ConsultationArgs = {
  where: Discount_Consultation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discount_Consultation_By_PkArgs = {
  consultationId: Scalars['Int'];
  discountId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Discount_TestArgs = {
  where: Discount_Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discount_Test_By_PkArgs = {
  discountId: Scalars['Int'];
  testId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Discount_TrainingArgs = {
  where: Discount_Training_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discount_Training_By_PkArgs = {
  discountId: Scalars['Int'];
  trainingId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Feature_FlagsArgs = {
  where: Feature_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feature_Flags_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Lab_UserArgs = {
  where: Lab_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lab_User_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_LaboratoryArgs = {
  where: Laboratory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Laboratory_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Laboratory_TestArgs = {
  where: Laboratory_Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Laboratory_Test_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialArgs = {
  where: Material_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Material_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Nurse_MaterialArgs = {
  where: Nurse_Material_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nurse_Material_By_PkArgs = {
  materialId: Scalars['Int'];
  nurseId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Nurse_TestArgs = {
  where: Nurse_Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nurse_Test_By_PkArgs = {
  nurseId: Scalars['Int'];
  testId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Order_TestArgs = {
  where: Order_Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Test_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Order_Test_ResultArgs = {
  where: Order_Test_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Test_Result_By_PkArgs = {
  fileId: Scalars['Int'];
  orderTestId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TagArgs = {
  where: Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tag_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_TestArgs = {
  where: Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Test_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Test_MaterialArgs = {
  where: Test_Material_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Test_Material_By_PkArgs = {
  materialId: Scalars['Int'];
  testId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Test_TagArgs = {
  where: Test_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Test_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootInsert_Administrator_NotificationArgs = {
  objects: Array<Administrator_Notification_Insert_Input>;
  on_conflict?: InputMaybe<Administrator_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Administrator_Notification_OneArgs = {
  object: Administrator_Notification_Insert_Input;
  on_conflict?: InputMaybe<Administrator_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClientArgs = {
  objects: Array<Client_Insert_Input>;
  on_conflict?: InputMaybe<Client_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_OneArgs = {
  object: Client_Insert_Input;
  on_conflict?: InputMaybe<Client_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_ProfileArgs = {
  objects: Array<Client_Profile_Insert_Input>;
  on_conflict?: InputMaybe<Client_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Profile_OneArgs = {
  object: Client_Profile_Insert_Input;
  on_conflict?: InputMaybe<Client_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Collection_SlotArgs = {
  objects: Array<Collection_Slot_Insert_Input>;
  on_conflict?: InputMaybe<Collection_Slot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Collection_Slot_OneArgs = {
  object: Collection_Slot_Insert_Input;
  on_conflict?: InputMaybe<Collection_Slot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConsultationArgs = {
  objects: Array<Consultation_Insert_Input>;
  on_conflict?: InputMaybe<Consultation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consultation_OneArgs = {
  object: Consultation_Insert_Input;
  on_conflict?: InputMaybe<Consultation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consultation_SlotArgs = {
  objects: Array<Consultation_Slot_Insert_Input>;
  on_conflict?: InputMaybe<Consultation_Slot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consultation_Slot_OneArgs = {
  object: Consultation_Slot_Insert_Input;
  on_conflict?: InputMaybe<Consultation_Slot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DiscountArgs = {
  objects: Array<Discount_Insert_Input>;
  on_conflict?: InputMaybe<Discount_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_ConsultationArgs = {
  objects: Array<Discount_Consultation_Insert_Input>;
  on_conflict?: InputMaybe<Discount_Consultation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_Consultation_OneArgs = {
  object: Discount_Consultation_Insert_Input;
  on_conflict?: InputMaybe<Discount_Consultation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_OneArgs = {
  object: Discount_Insert_Input;
  on_conflict?: InputMaybe<Discount_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_TestArgs = {
  objects: Array<Discount_Test_Insert_Input>;
  on_conflict?: InputMaybe<Discount_Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_Test_OneArgs = {
  object: Discount_Test_Insert_Input;
  on_conflict?: InputMaybe<Discount_Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_TrainingArgs = {
  objects: Array<Discount_Training_Insert_Input>;
  on_conflict?: InputMaybe<Discount_Training_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_Training_OneArgs = {
  object: Discount_Training_Insert_Input;
  on_conflict?: InputMaybe<Discount_Training_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_FlagsArgs = {
  objects: Array<Feature_Flags_Insert_Input>;
  on_conflict?: InputMaybe<Feature_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_Flags_OneArgs = {
  object: Feature_Flags_Insert_Input;
  on_conflict?: InputMaybe<Feature_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileArgs = {
  objects: Array<File_Insert_Input>;
  on_conflict?: InputMaybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_OneArgs = {
  object: File_Insert_Input;
  on_conflict?: InputMaybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lab_UserArgs = {
  objects: Array<Lab_User_Insert_Input>;
  on_conflict?: InputMaybe<Lab_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lab_User_OneArgs = {
  object: Lab_User_Insert_Input;
  on_conflict?: InputMaybe<Lab_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LaboratoryArgs = {
  objects: Array<Laboratory_Insert_Input>;
  on_conflict?: InputMaybe<Laboratory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Laboratory_Collection_PointArgs = {
  objects: Array<Laboratory_Collection_Point_Insert_Input>;
  on_conflict?: InputMaybe<Laboratory_Collection_Point_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Laboratory_Collection_Point_OneArgs = {
  object: Laboratory_Collection_Point_Insert_Input;
  on_conflict?: InputMaybe<Laboratory_Collection_Point_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Laboratory_OneArgs = {
  object: Laboratory_Insert_Input;
  on_conflict?: InputMaybe<Laboratory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Laboratory_ShippingArgs = {
  objects: Array<Laboratory_Shipping_Insert_Input>;
  on_conflict?: InputMaybe<Laboratory_Shipping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Laboratory_Shipping_OneArgs = {
  object: Laboratory_Shipping_Insert_Input;
  on_conflict?: InputMaybe<Laboratory_Shipping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Laboratory_TestArgs = {
  objects: Array<Laboratory_Test_Insert_Input>;
  on_conflict?: InputMaybe<Laboratory_Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Laboratory_Test_OneArgs = {
  object: Laboratory_Test_Insert_Input;
  on_conflict?: InputMaybe<Laboratory_Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialArgs = {
  objects: Array<Material_Insert_Input>;
  on_conflict?: InputMaybe<Material_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Material_OneArgs = {
  object: Material_Insert_Input;
  on_conflict?: InputMaybe<Material_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NurseArgs = {
  objects: Array<Nurse_Insert_Input>;
  on_conflict?: InputMaybe<Nurse_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nurse_MaterialArgs = {
  objects: Array<Nurse_Material_Insert_Input>;
  on_conflict?: InputMaybe<Nurse_Material_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nurse_Material_OneArgs = {
  object: Nurse_Material_Insert_Input;
  on_conflict?: InputMaybe<Nurse_Material_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nurse_OneArgs = {
  object: Nurse_Insert_Input;
  on_conflict?: InputMaybe<Nurse_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nurse_TestArgs = {
  objects: Array<Nurse_Test_Insert_Input>;
  on_conflict?: InputMaybe<Nurse_Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nurse_Test_OneArgs = {
  object: Nurse_Test_Insert_Input;
  on_conflict?: InputMaybe<Nurse_Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrderArgs = {
  objects: Array<Order_Insert_Input>;
  on_conflict?: InputMaybe<Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_CollectionArgs = {
  objects: Array<Order_Collection_Insert_Input>;
  on_conflict?: InputMaybe<Order_Collection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Collection_OneArgs = {
  object: Order_Collection_Insert_Input;
  on_conflict?: InputMaybe<Order_Collection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_OneArgs = {
  object: Order_Insert_Input;
  on_conflict?: InputMaybe<Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_StateArgs = {
  objects: Array<Order_State_Insert_Input>;
  on_conflict?: InputMaybe<Order_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_State_OneArgs = {
  object: Order_State_Insert_Input;
  on_conflict?: InputMaybe<Order_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_TestArgs = {
  objects: Array<Order_Test_Insert_Input>;
  on_conflict?: InputMaybe<Order_Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Test_OneArgs = {
  object: Order_Test_Insert_Input;
  on_conflict?: InputMaybe<Order_Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Test_ResultArgs = {
  objects: Array<Order_Test_Result_Insert_Input>;
  on_conflict?: InputMaybe<Order_Test_Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Test_Result_OneArgs = {
  object: Order_Test_Result_Insert_Input;
  on_conflict?: InputMaybe<Order_Test_Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Push_NotificationArgs = {
  objects: Array<Push_Notification_Insert_Input>;
  on_conflict?: InputMaybe<Push_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Push_Notification_ClientArgs = {
  objects: Array<Push_Notification_Client_Insert_Input>;
  on_conflict?: InputMaybe<Push_Notification_Client_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Push_Notification_Client_OneArgs = {
  object: Push_Notification_Client_Insert_Input;
  on_conflict?: InputMaybe<Push_Notification_Client_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Push_Notification_OneArgs = {
  object: Push_Notification_Insert_Input;
  on_conflict?: InputMaybe<Push_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RateArgs = {
  objects: Array<Rate_Insert_Input>;
  on_conflict?: InputMaybe<Rate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rate_OneArgs = {
  object: Rate_Insert_Input;
  on_conflict?: InputMaybe<Rate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TagArgs = {
  objects: Array<Tag_Insert_Input>;
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_OneArgs = {
  object: Tag_Insert_Input;
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TestArgs = {
  objects: Array<Test_Insert_Input>;
  on_conflict?: InputMaybe<Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_MaterialArgs = {
  objects: Array<Test_Material_Insert_Input>;
  on_conflict?: InputMaybe<Test_Material_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_Material_OneArgs = {
  object: Test_Material_Insert_Input;
  on_conflict?: InputMaybe<Test_Material_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_OneArgs = {
  object: Test_Insert_Input;
  on_conflict?: InputMaybe<Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_TagArgs = {
  objects: Array<Test_Tag_Insert_Input>;
  on_conflict?: InputMaybe<Test_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_Tag_OneArgs = {
  object: Test_Tag_Insert_Input;
  on_conflict?: InputMaybe<Test_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TrainingArgs = {
  objects: Array<Training_Insert_Input>;
  on_conflict?: InputMaybe<Training_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_OneArgs = {
  object: Training_Insert_Input;
  on_conflict?: InputMaybe<Training_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLab_User_Password_Reset_InitArgs = {
  payload: LabUserPasswordResetInitInput;
};


/** mutation root */
export type Mutation_RootLab_User_Password_UpdateArgs = {
  payload: LabUserPasswordUpdateInput;
};


/** mutation root */
export type Mutation_RootNurse_Password_UpdateArgs = {
  payload: NursePasswordUpdateInput;
};


/** mutation root */
export type Mutation_RootUpdate_AdministratorArgs = {
  _set?: InputMaybe<Administrator_Set_Input>;
  where: Administrator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Administrator_By_PkArgs = {
  _set?: InputMaybe<Administrator_Set_Input>;
  pk_columns: Administrator_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Administrator_ManyArgs = {
  updates: Array<Administrator_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Administrator_NotificationArgs = {
  _inc?: InputMaybe<Administrator_Notification_Inc_Input>;
  _set?: InputMaybe<Administrator_Notification_Set_Input>;
  where: Administrator_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Administrator_Notification_By_PkArgs = {
  _inc?: InputMaybe<Administrator_Notification_Inc_Input>;
  _set?: InputMaybe<Administrator_Notification_Set_Input>;
  pk_columns: Administrator_Notification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Administrator_Notification_ManyArgs = {
  updates: Array<Administrator_Notification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClientArgs = {
  _set?: InputMaybe<Client_Set_Input>;
  where: Client_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_By_PkArgs = {
  _set?: InputMaybe<Client_Set_Input>;
  pk_columns: Client_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_ManyArgs = {
  updates: Array<Client_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Collection_SlotArgs = {
  _inc?: InputMaybe<Collection_Slot_Inc_Input>;
  _set?: InputMaybe<Collection_Slot_Set_Input>;
  where: Collection_Slot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Collection_Slot_By_PkArgs = {
  _inc?: InputMaybe<Collection_Slot_Inc_Input>;
  _set?: InputMaybe<Collection_Slot_Set_Input>;
  pk_columns: Collection_Slot_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Collection_Slot_ManyArgs = {
  updates: Array<Collection_Slot_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConsultationArgs = {
  _append?: InputMaybe<Consultation_Append_Input>;
  _delete_at_path?: InputMaybe<Consultation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Consultation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Consultation_Delete_Key_Input>;
  _inc?: InputMaybe<Consultation_Inc_Input>;
  _prepend?: InputMaybe<Consultation_Prepend_Input>;
  _set?: InputMaybe<Consultation_Set_Input>;
  where: Consultation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Consultation_By_PkArgs = {
  _append?: InputMaybe<Consultation_Append_Input>;
  _delete_at_path?: InputMaybe<Consultation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Consultation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Consultation_Delete_Key_Input>;
  _inc?: InputMaybe<Consultation_Inc_Input>;
  _prepend?: InputMaybe<Consultation_Prepend_Input>;
  _set?: InputMaybe<Consultation_Set_Input>;
  pk_columns: Consultation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Consultation_ManyArgs = {
  updates: Array<Consultation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Consultation_SlotArgs = {
  _inc?: InputMaybe<Consultation_Slot_Inc_Input>;
  _set?: InputMaybe<Consultation_Slot_Set_Input>;
  where: Consultation_Slot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Consultation_Slot_By_PkArgs = {
  _inc?: InputMaybe<Consultation_Slot_Inc_Input>;
  _set?: InputMaybe<Consultation_Slot_Set_Input>;
  pk_columns: Consultation_Slot_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Consultation_Slot_ManyArgs = {
  updates: Array<Consultation_Slot_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DiscountArgs = {
  _inc?: InputMaybe<Discount_Inc_Input>;
  _set?: InputMaybe<Discount_Set_Input>;
  where: Discount_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_By_PkArgs = {
  _inc?: InputMaybe<Discount_Inc_Input>;
  _set?: InputMaybe<Discount_Set_Input>;
  pk_columns: Discount_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_ConsultationArgs = {
  _inc?: InputMaybe<Discount_Consultation_Inc_Input>;
  _set?: InputMaybe<Discount_Consultation_Set_Input>;
  where: Discount_Consultation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Consultation_By_PkArgs = {
  _inc?: InputMaybe<Discount_Consultation_Inc_Input>;
  _set?: InputMaybe<Discount_Consultation_Set_Input>;
  pk_columns: Discount_Consultation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Consultation_ManyArgs = {
  updates: Array<Discount_Consultation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_ManyArgs = {
  updates: Array<Discount_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_TestArgs = {
  _inc?: InputMaybe<Discount_Test_Inc_Input>;
  _set?: InputMaybe<Discount_Test_Set_Input>;
  where: Discount_Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Test_By_PkArgs = {
  _inc?: InputMaybe<Discount_Test_Inc_Input>;
  _set?: InputMaybe<Discount_Test_Set_Input>;
  pk_columns: Discount_Test_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Test_ManyArgs = {
  updates: Array<Discount_Test_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_TrainingArgs = {
  _inc?: InputMaybe<Discount_Training_Inc_Input>;
  _set?: InputMaybe<Discount_Training_Set_Input>;
  where: Discount_Training_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Training_By_PkArgs = {
  _inc?: InputMaybe<Discount_Training_Inc_Input>;
  _set?: InputMaybe<Discount_Training_Set_Input>;
  pk_columns: Discount_Training_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Training_ManyArgs = {
  updates: Array<Discount_Training_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_FlagsArgs = {
  _append?: InputMaybe<Feature_Flags_Append_Input>;
  _delete_at_path?: InputMaybe<Feature_Flags_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Feature_Flags_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Feature_Flags_Delete_Key_Input>;
  _inc?: InputMaybe<Feature_Flags_Inc_Input>;
  _prepend?: InputMaybe<Feature_Flags_Prepend_Input>;
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  where: Feature_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Flags_By_PkArgs = {
  _append?: InputMaybe<Feature_Flags_Append_Input>;
  _delete_at_path?: InputMaybe<Feature_Flags_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Feature_Flags_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Feature_Flags_Delete_Key_Input>;
  _inc?: InputMaybe<Feature_Flags_Inc_Input>;
  _prepend?: InputMaybe<Feature_Flags_Prepend_Input>;
  _set?: InputMaybe<Feature_Flags_Set_Input>;
  pk_columns: Feature_Flags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Flags_ManyArgs = {
  updates: Array<Feature_Flags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lab_UserArgs = {
  _inc?: InputMaybe<Lab_User_Inc_Input>;
  _set?: InputMaybe<Lab_User_Set_Input>;
  where: Lab_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lab_User_By_PkArgs = {
  _inc?: InputMaybe<Lab_User_Inc_Input>;
  _set?: InputMaybe<Lab_User_Set_Input>;
  pk_columns: Lab_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lab_User_ManyArgs = {
  updates: Array<Lab_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LaboratoryArgs = {
  _inc?: InputMaybe<Laboratory_Inc_Input>;
  _set?: InputMaybe<Laboratory_Set_Input>;
  where: Laboratory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_By_PkArgs = {
  _inc?: InputMaybe<Laboratory_Inc_Input>;
  _set?: InputMaybe<Laboratory_Set_Input>;
  pk_columns: Laboratory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_Collection_PointArgs = {
  _append?: InputMaybe<Laboratory_Collection_Point_Append_Input>;
  _delete_at_path?: InputMaybe<Laboratory_Collection_Point_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Laboratory_Collection_Point_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Laboratory_Collection_Point_Delete_Key_Input>;
  _inc?: InputMaybe<Laboratory_Collection_Point_Inc_Input>;
  _prepend?: InputMaybe<Laboratory_Collection_Point_Prepend_Input>;
  _set?: InputMaybe<Laboratory_Collection_Point_Set_Input>;
  where: Laboratory_Collection_Point_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_Collection_Point_By_PkArgs = {
  _append?: InputMaybe<Laboratory_Collection_Point_Append_Input>;
  _delete_at_path?: InputMaybe<Laboratory_Collection_Point_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Laboratory_Collection_Point_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Laboratory_Collection_Point_Delete_Key_Input>;
  _inc?: InputMaybe<Laboratory_Collection_Point_Inc_Input>;
  _prepend?: InputMaybe<Laboratory_Collection_Point_Prepend_Input>;
  _set?: InputMaybe<Laboratory_Collection_Point_Set_Input>;
  pk_columns: Laboratory_Collection_Point_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_Collection_Point_ManyArgs = {
  updates: Array<Laboratory_Collection_Point_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_ManyArgs = {
  updates: Array<Laboratory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_ShippingArgs = {
  _inc?: InputMaybe<Laboratory_Shipping_Inc_Input>;
  _set?: InputMaybe<Laboratory_Shipping_Set_Input>;
  where: Laboratory_Shipping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_Shipping_By_PkArgs = {
  _inc?: InputMaybe<Laboratory_Shipping_Inc_Input>;
  _set?: InputMaybe<Laboratory_Shipping_Set_Input>;
  pk_columns: Laboratory_Shipping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_Shipping_ManyArgs = {
  updates: Array<Laboratory_Shipping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_TestArgs = {
  _append?: InputMaybe<Laboratory_Test_Append_Input>;
  _delete_at_path?: InputMaybe<Laboratory_Test_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Laboratory_Test_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Laboratory_Test_Delete_Key_Input>;
  _inc?: InputMaybe<Laboratory_Test_Inc_Input>;
  _prepend?: InputMaybe<Laboratory_Test_Prepend_Input>;
  _set?: InputMaybe<Laboratory_Test_Set_Input>;
  where: Laboratory_Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_Test_By_PkArgs = {
  _append?: InputMaybe<Laboratory_Test_Append_Input>;
  _delete_at_path?: InputMaybe<Laboratory_Test_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Laboratory_Test_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Laboratory_Test_Delete_Key_Input>;
  _inc?: InputMaybe<Laboratory_Test_Inc_Input>;
  _prepend?: InputMaybe<Laboratory_Test_Prepend_Input>;
  _set?: InputMaybe<Laboratory_Test_Set_Input>;
  pk_columns: Laboratory_Test_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_Test_ManyArgs = {
  updates: Array<Laboratory_Test_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialArgs = {
  _set?: InputMaybe<Material_Set_Input>;
  where: Material_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Material_By_PkArgs = {
  _set?: InputMaybe<Material_Set_Input>;
  pk_columns: Material_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Material_ManyArgs = {
  updates: Array<Material_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NurseArgs = {
  _inc?: InputMaybe<Nurse_Inc_Input>;
  _set?: InputMaybe<Nurse_Set_Input>;
  where: Nurse_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nurse_By_PkArgs = {
  _inc?: InputMaybe<Nurse_Inc_Input>;
  _set?: InputMaybe<Nurse_Set_Input>;
  pk_columns: Nurse_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nurse_ManyArgs = {
  updates: Array<Nurse_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Nurse_TestArgs = {
  _inc?: InputMaybe<Nurse_Test_Inc_Input>;
  _set?: InputMaybe<Nurse_Test_Set_Input>;
  where: Nurse_Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nurse_Test_By_PkArgs = {
  _inc?: InputMaybe<Nurse_Test_Inc_Input>;
  _set?: InputMaybe<Nurse_Test_Set_Input>;
  pk_columns: Nurse_Test_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nurse_Test_ManyArgs = {
  updates: Array<Nurse_Test_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrderArgs = {
  _inc?: InputMaybe<Order_Inc_Input>;
  _set?: InputMaybe<Order_Set_Input>;
  where: Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_By_PkArgs = {
  _inc?: InputMaybe<Order_Inc_Input>;
  _set?: InputMaybe<Order_Set_Input>;
  pk_columns: Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_CollectionArgs = {
  _inc?: InputMaybe<Order_Collection_Inc_Input>;
  _set?: InputMaybe<Order_Collection_Set_Input>;
  where: Order_Collection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Collection_By_PkArgs = {
  _inc?: InputMaybe<Order_Collection_Inc_Input>;
  _set?: InputMaybe<Order_Collection_Set_Input>;
  pk_columns: Order_Collection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Collection_ManyArgs = {
  updates: Array<Order_Collection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_ConsultationArgs = {
  _set?: InputMaybe<Order_Consultation_Set_Input>;
  where: Order_Consultation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Consultation_By_PkArgs = {
  _set?: InputMaybe<Order_Consultation_Set_Input>;
  pk_columns: Order_Consultation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Consultation_ManyArgs = {
  updates: Array<Order_Consultation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_ManyArgs = {
  updates: Array<Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_TestArgs = {
  _append?: InputMaybe<Order_Test_Append_Input>;
  _delete_at_path?: InputMaybe<Order_Test_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Order_Test_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Order_Test_Delete_Key_Input>;
  _inc?: InputMaybe<Order_Test_Inc_Input>;
  _prepend?: InputMaybe<Order_Test_Prepend_Input>;
  _set?: InputMaybe<Order_Test_Set_Input>;
  where: Order_Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Test_By_PkArgs = {
  _append?: InputMaybe<Order_Test_Append_Input>;
  _delete_at_path?: InputMaybe<Order_Test_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Order_Test_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Order_Test_Delete_Key_Input>;
  _inc?: InputMaybe<Order_Test_Inc_Input>;
  _prepend?: InputMaybe<Order_Test_Prepend_Input>;
  _set?: InputMaybe<Order_Test_Set_Input>;
  pk_columns: Order_Test_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Test_ManyArgs = {
  updates: Array<Order_Test_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_TrainingArgs = {
  _set?: InputMaybe<Order_Training_Set_Input>;
  where: Order_Training_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Training_By_PkArgs = {
  _set?: InputMaybe<Order_Training_Set_Input>;
  pk_columns: Order_Training_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Training_ManyArgs = {
  updates: Array<Order_Training_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RateArgs = {
  _inc?: InputMaybe<Rate_Inc_Input>;
  _set?: InputMaybe<Rate_Set_Input>;
  where: Rate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rate_By_PkArgs = {
  _inc?: InputMaybe<Rate_Inc_Input>;
  _set?: InputMaybe<Rate_Set_Input>;
  pk_columns: Rate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rate_ManyArgs = {
  updates: Array<Rate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TagArgs = {
  _append?: InputMaybe<Tag_Append_Input>;
  _delete_at_path?: InputMaybe<Tag_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tag_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tag_Delete_Key_Input>;
  _prepend?: InputMaybe<Tag_Prepend_Input>;
  _set?: InputMaybe<Tag_Set_Input>;
  where: Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_By_PkArgs = {
  _append?: InputMaybe<Tag_Append_Input>;
  _delete_at_path?: InputMaybe<Tag_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tag_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tag_Delete_Key_Input>;
  _prepend?: InputMaybe<Tag_Prepend_Input>;
  _set?: InputMaybe<Tag_Set_Input>;
  pk_columns: Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_ManyArgs = {
  updates: Array<Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TestArgs = {
  _append?: InputMaybe<Test_Append_Input>;
  _delete_at_path?: InputMaybe<Test_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Test_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Test_Delete_Key_Input>;
  _inc?: InputMaybe<Test_Inc_Input>;
  _prepend?: InputMaybe<Test_Prepend_Input>;
  _set?: InputMaybe<Test_Set_Input>;
  where: Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Test_By_PkArgs = {
  _append?: InputMaybe<Test_Append_Input>;
  _delete_at_path?: InputMaybe<Test_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Test_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Test_Delete_Key_Input>;
  _inc?: InputMaybe<Test_Inc_Input>;
  _prepend?: InputMaybe<Test_Prepend_Input>;
  _set?: InputMaybe<Test_Set_Input>;
  pk_columns: Test_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Test_ManyArgs = {
  updates: Array<Test_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TrainingArgs = {
  _append?: InputMaybe<Training_Append_Input>;
  _delete_at_path?: InputMaybe<Training_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Training_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Training_Delete_Key_Input>;
  _inc?: InputMaybe<Training_Inc_Input>;
  _prepend?: InputMaybe<Training_Prepend_Input>;
  _set?: InputMaybe<Training_Set_Input>;
  where: Training_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Training_By_PkArgs = {
  _append?: InputMaybe<Training_Append_Input>;
  _delete_at_path?: InputMaybe<Training_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Training_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Training_Delete_Key_Input>;
  _inc?: InputMaybe<Training_Inc_Input>;
  _prepend?: InputMaybe<Training_Prepend_Input>;
  _set?: InputMaybe<Training_Set_Input>;
  pk_columns: Training_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Training_ManyArgs = {
  updates: Array<Training_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "nurse" */
export type Nurse = {
  __typename?: 'nurse';
  auth2FAEnabled: Scalars['Boolean'];
  /** A computed field, executes function "nurse_order_cost" */
  costSummary?: Maybe<Array<Nurse_Order_Cost>>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  geoEnabled: Scalars['Boolean'];
  id: Scalars['Int'];
  labArea?: Maybe<Scalars['geography']>;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  nurseMaterials: Array<Nurse_Material>;
  /** An aggregate relationship */
  nurseMaterials_aggregate: Nurse_Material_Aggregate;
  /** An array relationship */
  nurseTests: Array<Nurse_Test>;
  /** An aggregate relationship */
  nurseTests_aggregate: Nurse_Test_Aggregate;
  orderArea?: Maybe<Scalars['geography']>;
  password?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
};


/** columns and relationships of "nurse" */
export type NurseCostSummaryArgs = {
  args: CostSummary_Nurse_Args;
  distinct_on?: InputMaybe<Array<Nurse_Order_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Order_Cost_Order_By>>;
  where?: InputMaybe<Nurse_Order_Cost_Bool_Exp>;
};


/** columns and relationships of "nurse" */
export type NurseNurseMaterialsArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Material_Order_By>>;
  where?: InputMaybe<Nurse_Material_Bool_Exp>;
};


/** columns and relationships of "nurse" */
export type NurseNurseMaterials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Material_Order_By>>;
  where?: InputMaybe<Nurse_Material_Bool_Exp>;
};


/** columns and relationships of "nurse" */
export type NurseNurseTestsArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Test_Order_By>>;
  where?: InputMaybe<Nurse_Test_Bool_Exp>;
};


/** columns and relationships of "nurse" */
export type NurseNurseTests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Test_Order_By>>;
  where?: InputMaybe<Nurse_Test_Bool_Exp>;
};

/** aggregated selection of "nurse" */
export type Nurse_Aggregate = {
  __typename?: 'nurse_aggregate';
  aggregate?: Maybe<Nurse_Aggregate_Fields>;
  nodes: Array<Nurse>;
};

/** aggregate fields of "nurse" */
export type Nurse_Aggregate_Fields = {
  __typename?: 'nurse_aggregate_fields';
  avg?: Maybe<Nurse_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Nurse_Max_Fields>;
  min?: Maybe<Nurse_Min_Fields>;
  stddev?: Maybe<Nurse_Stddev_Fields>;
  stddev_pop?: Maybe<Nurse_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nurse_Stddev_Samp_Fields>;
  sum?: Maybe<Nurse_Sum_Fields>;
  var_pop?: Maybe<Nurse_Var_Pop_Fields>;
  var_samp?: Maybe<Nurse_Var_Samp_Fields>;
  variance?: Maybe<Nurse_Variance_Fields>;
};


/** aggregate fields of "nurse" */
export type Nurse_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nurse_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Nurse_Avg_Fields = {
  __typename?: 'nurse_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "nurse". All fields are combined with a logical 'AND'. */
export type Nurse_Bool_Exp = {
  _and?: InputMaybe<Array<Nurse_Bool_Exp>>;
  _not?: InputMaybe<Nurse_Bool_Exp>;
  _or?: InputMaybe<Array<Nurse_Bool_Exp>>;
  auth2FAEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  geoEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  labArea?: InputMaybe<Geography_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nurseMaterials?: InputMaybe<Nurse_Material_Bool_Exp>;
  nurseMaterials_aggregate?: InputMaybe<Nurse_Material_Aggregate_Bool_Exp>;
  nurseTests?: InputMaybe<Nurse_Test_Bool_Exp>;
  nurseTests_aggregate?: InputMaybe<Nurse_Test_Aggregate_Bool_Exp>;
  orderArea?: InputMaybe<Geography_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "nurse" */
export enum Nurse_Constraint {
  /** unique or primary key constraint on columns "email" */
  NurseEmailKey = 'nurse_email_key',
  /** unique or primary key constraint on columns "id" */
  NursePkey = 'nurse_pkey'
}

/** input type for incrementing numeric columns in table "nurse" */
export type Nurse_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "nurse" */
export type Nurse_Insert_Input = {
  auth2FAEnabled?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  geoEnabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  labArea?: InputMaybe<Scalars['geography']>;
  name?: InputMaybe<Scalars['String']>;
  nurseMaterials?: InputMaybe<Nurse_Material_Arr_Rel_Insert_Input>;
  nurseTests?: InputMaybe<Nurse_Test_Arr_Rel_Insert_Input>;
  orderArea?: InputMaybe<Scalars['geography']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "nurse_material" */
export type Nurse_Material = {
  __typename?: 'nurse_material';
  /** An object relationship */
  material: Material;
  materialId: Scalars['Int'];
  /** An object relationship */
  nurse: Nurse;
  nurseId: Scalars['Int'];
};

/** aggregated selection of "nurse_material" */
export type Nurse_Material_Aggregate = {
  __typename?: 'nurse_material_aggregate';
  aggregate?: Maybe<Nurse_Material_Aggregate_Fields>;
  nodes: Array<Nurse_Material>;
};

export type Nurse_Material_Aggregate_Bool_Exp = {
  count?: InputMaybe<Nurse_Material_Aggregate_Bool_Exp_Count>;
};

export type Nurse_Material_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Nurse_Material_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Nurse_Material_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "nurse_material" */
export type Nurse_Material_Aggregate_Fields = {
  __typename?: 'nurse_material_aggregate_fields';
  avg?: Maybe<Nurse_Material_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Nurse_Material_Max_Fields>;
  min?: Maybe<Nurse_Material_Min_Fields>;
  stddev?: Maybe<Nurse_Material_Stddev_Fields>;
  stddev_pop?: Maybe<Nurse_Material_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nurse_Material_Stddev_Samp_Fields>;
  sum?: Maybe<Nurse_Material_Sum_Fields>;
  var_pop?: Maybe<Nurse_Material_Var_Pop_Fields>;
  var_samp?: Maybe<Nurse_Material_Var_Samp_Fields>;
  variance?: Maybe<Nurse_Material_Variance_Fields>;
};


/** aggregate fields of "nurse_material" */
export type Nurse_Material_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nurse_Material_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "nurse_material" */
export type Nurse_Material_Aggregate_Order_By = {
  avg?: InputMaybe<Nurse_Material_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Nurse_Material_Max_Order_By>;
  min?: InputMaybe<Nurse_Material_Min_Order_By>;
  stddev?: InputMaybe<Nurse_Material_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Nurse_Material_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Nurse_Material_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Nurse_Material_Sum_Order_By>;
  var_pop?: InputMaybe<Nurse_Material_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Nurse_Material_Var_Samp_Order_By>;
  variance?: InputMaybe<Nurse_Material_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "nurse_material" */
export type Nurse_Material_Arr_Rel_Insert_Input = {
  data: Array<Nurse_Material_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Nurse_Material_On_Conflict>;
};

/** aggregate avg on columns */
export type Nurse_Material_Avg_Fields = {
  __typename?: 'nurse_material_avg_fields';
  materialId?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "nurse_material" */
export type Nurse_Material_Avg_Order_By = {
  materialId?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nurse_material". All fields are combined with a logical 'AND'. */
export type Nurse_Material_Bool_Exp = {
  _and?: InputMaybe<Array<Nurse_Material_Bool_Exp>>;
  _not?: InputMaybe<Nurse_Material_Bool_Exp>;
  _or?: InputMaybe<Array<Nurse_Material_Bool_Exp>>;
  material?: InputMaybe<Material_Bool_Exp>;
  materialId?: InputMaybe<Int_Comparison_Exp>;
  nurse?: InputMaybe<Nurse_Bool_Exp>;
  nurseId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "nurse_material" */
export enum Nurse_Material_Constraint {
  /** unique or primary key constraint on columns "nurse_id", "material_id" */
  NurseMaterialPkey = 'nurse_material_pkey'
}

/** input type for inserting data into table "nurse_material" */
export type Nurse_Material_Insert_Input = {
  material?: InputMaybe<Material_Obj_Rel_Insert_Input>;
  materialId?: InputMaybe<Scalars['Int']>;
  nurse?: InputMaybe<Nurse_Obj_Rel_Insert_Input>;
  nurseId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Nurse_Material_Max_Fields = {
  __typename?: 'nurse_material_max_fields';
  materialId?: Maybe<Scalars['Int']>;
  nurseId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "nurse_material" */
export type Nurse_Material_Max_Order_By = {
  materialId?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Nurse_Material_Min_Fields = {
  __typename?: 'nurse_material_min_fields';
  materialId?: Maybe<Scalars['Int']>;
  nurseId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "nurse_material" */
export type Nurse_Material_Min_Order_By = {
  materialId?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "nurse_material" */
export type Nurse_Material_Mutation_Response = {
  __typename?: 'nurse_material_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nurse_Material>;
};

/** on_conflict condition type for table "nurse_material" */
export type Nurse_Material_On_Conflict = {
  constraint: Nurse_Material_Constraint;
  update_columns?: Array<Nurse_Material_Update_Column>;
  where?: InputMaybe<Nurse_Material_Bool_Exp>;
};

/** Ordering options when selecting data from "nurse_material". */
export type Nurse_Material_Order_By = {
  material?: InputMaybe<Material_Order_By>;
  materialId?: InputMaybe<Order_By>;
  nurse?: InputMaybe<Nurse_Order_By>;
  nurseId?: InputMaybe<Order_By>;
};

/** select columns of table "nurse_material" */
export enum Nurse_Material_Select_Column {
  /** column name */
  MaterialId = 'materialId',
  /** column name */
  NurseId = 'nurseId'
}

/** aggregate stddev on columns */
export type Nurse_Material_Stddev_Fields = {
  __typename?: 'nurse_material_stddev_fields';
  materialId?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "nurse_material" */
export type Nurse_Material_Stddev_Order_By = {
  materialId?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Nurse_Material_Stddev_Pop_Fields = {
  __typename?: 'nurse_material_stddev_pop_fields';
  materialId?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "nurse_material" */
export type Nurse_Material_Stddev_Pop_Order_By = {
  materialId?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Nurse_Material_Stddev_Samp_Fields = {
  __typename?: 'nurse_material_stddev_samp_fields';
  materialId?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "nurse_material" */
export type Nurse_Material_Stddev_Samp_Order_By = {
  materialId?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "nurse_material" */
export type Nurse_Material_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nurse_Material_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nurse_Material_Stream_Cursor_Value_Input = {
  materialId?: InputMaybe<Scalars['Int']>;
  nurseId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Nurse_Material_Sum_Fields = {
  __typename?: 'nurse_material_sum_fields';
  materialId?: Maybe<Scalars['Int']>;
  nurseId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "nurse_material" */
export type Nurse_Material_Sum_Order_By = {
  materialId?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "nurse_material" (current role has no relevant permissions) */
export enum Nurse_Material_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type Nurse_Material_Var_Pop_Fields = {
  __typename?: 'nurse_material_var_pop_fields';
  materialId?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "nurse_material" */
export type Nurse_Material_Var_Pop_Order_By = {
  materialId?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Nurse_Material_Var_Samp_Fields = {
  __typename?: 'nurse_material_var_samp_fields';
  materialId?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "nurse_material" */
export type Nurse_Material_Var_Samp_Order_By = {
  materialId?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Nurse_Material_Variance_Fields = {
  __typename?: 'nurse_material_variance_fields';
  materialId?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "nurse_material" */
export type Nurse_Material_Variance_Order_By = {
  materialId?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Nurse_Max_Fields = {
  __typename?: 'nurse_max_fields';
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Nurse_Min_Fields = {
  __typename?: 'nurse_min_fields';
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "nurse" */
export type Nurse_Mutation_Response = {
  __typename?: 'nurse_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nurse>;
};

/** input type for inserting object relation for remote table "nurse" */
export type Nurse_Obj_Rel_Insert_Input = {
  data: Nurse_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Nurse_On_Conflict>;
};

/** on_conflict condition type for table "nurse" */
export type Nurse_On_Conflict = {
  constraint: Nurse_Constraint;
  update_columns?: Array<Nurse_Update_Column>;
  where?: InputMaybe<Nurse_Bool_Exp>;
};

/** Ordering options when selecting data from "nurse". */
export type Nurse_Order_By = {
  auth2FAEnabled?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  geoEnabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labArea?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nurseMaterials_aggregate?: InputMaybe<Nurse_Material_Aggregate_Order_By>;
  nurseTests_aggregate?: InputMaybe<Nurse_Test_Aggregate_Order_By>;
  orderArea?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
};

/** columns and relationships of "nurse_order_cost" */
export type Nurse_Order_Cost = {
  __typename?: 'nurse_order_cost';
  collectionCostSum?: Maybe<Scalars['numeric']>;
  collectionKitCostSum?: Maybe<Scalars['numeric']>;
  deliveryCostSum?: Maybe<Scalars['numeric']>;
  orderCount?: Maybe<Scalars['bigint']>;
  totalCostSum?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "nurse_order_cost". All fields are combined with a logical 'AND'. */
export type Nurse_Order_Cost_Bool_Exp = {
  _and?: InputMaybe<Array<Nurse_Order_Cost_Bool_Exp>>;
  _not?: InputMaybe<Nurse_Order_Cost_Bool_Exp>;
  _or?: InputMaybe<Array<Nurse_Order_Cost_Bool_Exp>>;
  collectionCostSum?: InputMaybe<Numeric_Comparison_Exp>;
  collectionKitCostSum?: InputMaybe<Numeric_Comparison_Exp>;
  deliveryCostSum?: InputMaybe<Numeric_Comparison_Exp>;
  orderCount?: InputMaybe<Bigint_Comparison_Exp>;
  totalCostSum?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Ordering options when selecting data from "nurse_order_cost". */
export type Nurse_Order_Cost_Order_By = {
  collectionCostSum?: InputMaybe<Order_By>;
  collectionKitCostSum?: InputMaybe<Order_By>;
  deliveryCostSum?: InputMaybe<Order_By>;
  orderCount?: InputMaybe<Order_By>;
  totalCostSum?: InputMaybe<Order_By>;
};

/** select columns of table "nurse_order_cost" */
export enum Nurse_Order_Cost_Select_Column {
  /** column name */
  CollectionCostSum = 'collectionCostSum',
  /** column name */
  CollectionKitCostSum = 'collectionKitCostSum',
  /** column name */
  DeliveryCostSum = 'deliveryCostSum',
  /** column name */
  OrderCount = 'orderCount',
  /** column name */
  TotalCostSum = 'totalCostSum'
}

/** Streaming cursor of the table "nurse_order_cost" */
export type Nurse_Order_Cost_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nurse_Order_Cost_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nurse_Order_Cost_Stream_Cursor_Value_Input = {
  collectionCostSum?: InputMaybe<Scalars['numeric']>;
  collectionKitCostSum?: InputMaybe<Scalars['numeric']>;
  deliveryCostSum?: InputMaybe<Scalars['numeric']>;
  orderCount?: InputMaybe<Scalars['bigint']>;
  totalCostSum?: InputMaybe<Scalars['numeric']>;
};

/** primary key columns input for table: nurse */
export type Nurse_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "nurse" */
export enum Nurse_Select_Column {
  /** column name */
  Auth2FaEnabled = 'auth2FAEnabled',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  GeoEnabled = 'geoEnabled',
  /** column name */
  Id = 'id',
  /** column name */
  LabArea = 'labArea',
  /** column name */
  Name = 'name',
  /** column name */
  OrderArea = 'orderArea',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phoneNumber'
}

/** input type for updating data in table "nurse" */
export type Nurse_Set_Input = {
  auth2FAEnabled?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  geoEnabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  labArea?: InputMaybe<Scalars['geography']>;
  name?: InputMaybe<Scalars['String']>;
  orderArea?: InputMaybe<Scalars['geography']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Nurse_Stddev_Fields = {
  __typename?: 'nurse_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Nurse_Stddev_Pop_Fields = {
  __typename?: 'nurse_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Nurse_Stddev_Samp_Fields = {
  __typename?: 'nurse_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "nurse" */
export type Nurse_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nurse_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nurse_Stream_Cursor_Value_Input = {
  auth2FAEnabled?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  geoEnabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  labArea?: InputMaybe<Scalars['geography']>;
  name?: InputMaybe<Scalars['String']>;
  orderArea?: InputMaybe<Scalars['geography']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Nurse_Sum_Fields = {
  __typename?: 'nurse_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "nurse_test" */
export type Nurse_Test = {
  __typename?: 'nurse_test';
  /** An object relationship */
  nurse: Nurse;
  nurseId: Scalars['Int'];
  /** An object relationship */
  test: Test;
  testId: Scalars['Int'];
};

/** aggregated selection of "nurse_test" */
export type Nurse_Test_Aggregate = {
  __typename?: 'nurse_test_aggregate';
  aggregate?: Maybe<Nurse_Test_Aggregate_Fields>;
  nodes: Array<Nurse_Test>;
};

export type Nurse_Test_Aggregate_Bool_Exp = {
  count?: InputMaybe<Nurse_Test_Aggregate_Bool_Exp_Count>;
};

export type Nurse_Test_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Nurse_Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Nurse_Test_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "nurse_test" */
export type Nurse_Test_Aggregate_Fields = {
  __typename?: 'nurse_test_aggregate_fields';
  avg?: Maybe<Nurse_Test_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Nurse_Test_Max_Fields>;
  min?: Maybe<Nurse_Test_Min_Fields>;
  stddev?: Maybe<Nurse_Test_Stddev_Fields>;
  stddev_pop?: Maybe<Nurse_Test_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nurse_Test_Stddev_Samp_Fields>;
  sum?: Maybe<Nurse_Test_Sum_Fields>;
  var_pop?: Maybe<Nurse_Test_Var_Pop_Fields>;
  var_samp?: Maybe<Nurse_Test_Var_Samp_Fields>;
  variance?: Maybe<Nurse_Test_Variance_Fields>;
};


/** aggregate fields of "nurse_test" */
export type Nurse_Test_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nurse_Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "nurse_test" */
export type Nurse_Test_Aggregate_Order_By = {
  avg?: InputMaybe<Nurse_Test_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Nurse_Test_Max_Order_By>;
  min?: InputMaybe<Nurse_Test_Min_Order_By>;
  stddev?: InputMaybe<Nurse_Test_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Nurse_Test_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Nurse_Test_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Nurse_Test_Sum_Order_By>;
  var_pop?: InputMaybe<Nurse_Test_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Nurse_Test_Var_Samp_Order_By>;
  variance?: InputMaybe<Nurse_Test_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "nurse_test" */
export type Nurse_Test_Arr_Rel_Insert_Input = {
  data: Array<Nurse_Test_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Nurse_Test_On_Conflict>;
};

/** aggregate avg on columns */
export type Nurse_Test_Avg_Fields = {
  __typename?: 'nurse_test_avg_fields';
  nurseId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "nurse_test" */
export type Nurse_Test_Avg_Order_By = {
  nurseId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nurse_test". All fields are combined with a logical 'AND'. */
export type Nurse_Test_Bool_Exp = {
  _and?: InputMaybe<Array<Nurse_Test_Bool_Exp>>;
  _not?: InputMaybe<Nurse_Test_Bool_Exp>;
  _or?: InputMaybe<Array<Nurse_Test_Bool_Exp>>;
  nurse?: InputMaybe<Nurse_Bool_Exp>;
  nurseId?: InputMaybe<Int_Comparison_Exp>;
  test?: InputMaybe<Test_Bool_Exp>;
  testId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "nurse_test" */
export enum Nurse_Test_Constraint {
  /** unique or primary key constraint on columns "nurse_id", "test_id" */
  NurseTestPkey = 'nurse_test_pkey'
}

/** input type for incrementing numeric columns in table "nurse_test" */
export type Nurse_Test_Inc_Input = {
  nurseId?: InputMaybe<Scalars['Int']>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "nurse_test" */
export type Nurse_Test_Insert_Input = {
  nurse?: InputMaybe<Nurse_Obj_Rel_Insert_Input>;
  nurseId?: InputMaybe<Scalars['Int']>;
  test?: InputMaybe<Test_Obj_Rel_Insert_Input>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Nurse_Test_Max_Fields = {
  __typename?: 'nurse_test_max_fields';
  nurseId?: Maybe<Scalars['Int']>;
  testId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "nurse_test" */
export type Nurse_Test_Max_Order_By = {
  nurseId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Nurse_Test_Min_Fields = {
  __typename?: 'nurse_test_min_fields';
  nurseId?: Maybe<Scalars['Int']>;
  testId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "nurse_test" */
export type Nurse_Test_Min_Order_By = {
  nurseId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "nurse_test" */
export type Nurse_Test_Mutation_Response = {
  __typename?: 'nurse_test_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nurse_Test>;
};

/** on_conflict condition type for table "nurse_test" */
export type Nurse_Test_On_Conflict = {
  constraint: Nurse_Test_Constraint;
  update_columns?: Array<Nurse_Test_Update_Column>;
  where?: InputMaybe<Nurse_Test_Bool_Exp>;
};

/** Ordering options when selecting data from "nurse_test". */
export type Nurse_Test_Order_By = {
  nurse?: InputMaybe<Nurse_Order_By>;
  nurseId?: InputMaybe<Order_By>;
  test?: InputMaybe<Test_Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nurse_test */
export type Nurse_Test_Pk_Columns_Input = {
  nurseId: Scalars['Int'];
  testId: Scalars['Int'];
};

/** select columns of table "nurse_test" */
export enum Nurse_Test_Select_Column {
  /** column name */
  NurseId = 'nurseId',
  /** column name */
  TestId = 'testId'
}

/** input type for updating data in table "nurse_test" */
export type Nurse_Test_Set_Input = {
  nurseId?: InputMaybe<Scalars['Int']>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Nurse_Test_Stddev_Fields = {
  __typename?: 'nurse_test_stddev_fields';
  nurseId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "nurse_test" */
export type Nurse_Test_Stddev_Order_By = {
  nurseId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Nurse_Test_Stddev_Pop_Fields = {
  __typename?: 'nurse_test_stddev_pop_fields';
  nurseId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "nurse_test" */
export type Nurse_Test_Stddev_Pop_Order_By = {
  nurseId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Nurse_Test_Stddev_Samp_Fields = {
  __typename?: 'nurse_test_stddev_samp_fields';
  nurseId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "nurse_test" */
export type Nurse_Test_Stddev_Samp_Order_By = {
  nurseId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "nurse_test" */
export type Nurse_Test_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nurse_Test_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nurse_Test_Stream_Cursor_Value_Input = {
  nurseId?: InputMaybe<Scalars['Int']>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Nurse_Test_Sum_Fields = {
  __typename?: 'nurse_test_sum_fields';
  nurseId?: Maybe<Scalars['Int']>;
  testId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "nurse_test" */
export type Nurse_Test_Sum_Order_By = {
  nurseId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** update columns of table "nurse_test" */
export enum Nurse_Test_Update_Column {
  /** column name */
  NurseId = 'nurseId',
  /** column name */
  TestId = 'testId'
}

export type Nurse_Test_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nurse_Test_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nurse_Test_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nurse_Test_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Nurse_Test_Var_Pop_Fields = {
  __typename?: 'nurse_test_var_pop_fields';
  nurseId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "nurse_test" */
export type Nurse_Test_Var_Pop_Order_By = {
  nurseId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Nurse_Test_Var_Samp_Fields = {
  __typename?: 'nurse_test_var_samp_fields';
  nurseId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "nurse_test" */
export type Nurse_Test_Var_Samp_Order_By = {
  nurseId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Nurse_Test_Variance_Fields = {
  __typename?: 'nurse_test_variance_fields';
  nurseId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "nurse_test" */
export type Nurse_Test_Variance_Order_By = {
  nurseId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** update columns of table "nurse" */
export enum Nurse_Update_Column {
  /** column name */
  Auth2FaEnabled = 'auth2FAEnabled',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  GeoEnabled = 'geoEnabled',
  /** column name */
  Id = 'id',
  /** column name */
  LabArea = 'labArea',
  /** column name */
  Name = 'name',
  /** column name */
  OrderArea = 'orderArea',
  /** column name */
  Password = 'password',
  /** column name */
  PhoneNumber = 'phoneNumber'
}

export type Nurse_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nurse_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nurse_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nurse_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Nurse_Var_Pop_Fields = {
  __typename?: 'nurse_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Nurse_Var_Samp_Fields = {
  __typename?: 'nurse_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Nurse_Variance_Fields = {
  __typename?: 'nurse_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "order" */
export type Order = {
  __typename?: 'order';
  /** An object relationship */
  client: Client;
  clientConsent1?: Maybe<Scalars['Boolean']>;
  clientConsent2?: Maybe<Scalars['Boolean']>;
  clientConsent3?: Maybe<Scalars['Boolean']>;
  clientConsent4?: Maybe<Scalars['Boolean']>;
  clientConsent5?: Maybe<Scalars['Boolean']>;
  clientId: Scalars['Int'];
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  currentState?: Maybe<Scalars['String']>;
  /** A computed field, executes function "get_current_order_state_date" */
  currentStateDate?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  documents: Array<Order_Document>;
  /** An aggregate relationship */
  documents_aggregate: Order_Document_Aggregate;
  /** A computed field, executes function "get_first_order_state_date" */
  firstStateDate?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  /** An object relationship */
  nurse?: Maybe<Nurse>;
  /** An array relationship */
  orderCollections: Array<Order_Collection>;
  /** An aggregate relationship */
  orderCollections_aggregate: Order_Collection_Aggregate;
  /** An array relationship */
  orderConsultations: Array<Order_Consultation>;
  /** An aggregate relationship */
  orderConsultations_aggregate: Order_Consultation_Aggregate;
  /** An array relationship */
  orderDiscounts: Array<Order_Discount>;
  /** An array relationship */
  orderShippings: Array<Order_Shipping>;
  /** An array relationship */
  orderStates: Array<Order_State>;
  /** An array relationship */
  orderTests: Array<Order_Test>;
  /** An array relationship */
  orderTrainings: Array<Order_Training>;
  /** An aggregate relationship */
  orderTrainings_aggregate: Order_Training_Aggregate;
  shippingConsent1?: Maybe<Scalars['Boolean']>;
  shippingConsent2?: Maybe<Scalars['Boolean']>;
  shippingConsent3?: Maybe<Scalars['Boolean']>;
  totalCost: Scalars['numeric'];
};


/** columns and relationships of "order" */
export type OrderDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Order_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Document_Order_By>>;
  where?: InputMaybe<Order_Document_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Document_Order_By>>;
  where?: InputMaybe<Order_Document_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrderCollectionsArgs = {
  distinct_on?: InputMaybe<Array<Order_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Collection_Order_By>>;
  where?: InputMaybe<Order_Collection_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrderCollections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Collection_Order_By>>;
  where?: InputMaybe<Order_Collection_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrderConsultationsArgs = {
  distinct_on?: InputMaybe<Array<Order_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Consultation_Order_By>>;
  where?: InputMaybe<Order_Consultation_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrderConsultations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Consultation_Order_By>>;
  where?: InputMaybe<Order_Consultation_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrderDiscountsArgs = {
  distinct_on?: InputMaybe<Array<Order_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Discount_Order_By>>;
  where?: InputMaybe<Order_Discount_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrderShippingsArgs = {
  distinct_on?: InputMaybe<Array<Order_Shipping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Shipping_Order_By>>;
  where?: InputMaybe<Order_Shipping_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrderStatesArgs = {
  distinct_on?: InputMaybe<Array<Order_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_State_Order_By>>;
  where?: InputMaybe<Order_State_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrderTestsArgs = {
  distinct_on?: InputMaybe<Array<Order_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Test_Order_By>>;
  where?: InputMaybe<Order_Test_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrderTrainingsArgs = {
  distinct_on?: InputMaybe<Array<Order_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Training_Order_By>>;
  where?: InputMaybe<Order_Training_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrderTrainings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Training_Order_By>>;
  where?: InputMaybe<Order_Training_Bool_Exp>;
};

export type Order_Aggregate = {
  __typename?: 'order_aggregate';
  aggregate?: Maybe<Order_Aggregate_Fields>;
  nodes: Array<Order>;
};

/** aggregate fields of "order" */
export type Order_Aggregate_Fields = {
  __typename?: 'order_aggregate_fields';
  avg?: Maybe<Order_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Max_Fields>;
  min?: Maybe<Order_Min_Fields>;
  stddev?: Maybe<Order_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Sum_Fields>;
  var_pop?: Maybe<Order_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Var_Samp_Fields>;
  variance?: Maybe<Order_Variance_Fields>;
};


/** aggregate fields of "order" */
export type Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Order_Avg_Fields = {
  __typename?: 'order_avg_fields';
  clientId?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "order". All fields are combined with a logical 'AND'. */
export type Order_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Bool_Exp>>;
  _not?: InputMaybe<Order_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Bool_Exp>>;
  client?: InputMaybe<Client_Bool_Exp>;
  clientConsent1?: InputMaybe<Boolean_Comparison_Exp>;
  clientConsent2?: InputMaybe<Boolean_Comparison_Exp>;
  clientConsent3?: InputMaybe<Boolean_Comparison_Exp>;
  clientConsent4?: InputMaybe<Boolean_Comparison_Exp>;
  clientConsent5?: InputMaybe<Boolean_Comparison_Exp>;
  clientId?: InputMaybe<Int_Comparison_Exp>;
  costBeforeDiscount?: InputMaybe<Numeric_Comparison_Exp>;
  currentState?: InputMaybe<String_Comparison_Exp>;
  currentStateDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  documents?: InputMaybe<Order_Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Order_Document_Aggregate_Bool_Exp>;
  firstStateDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  nurse?: InputMaybe<Nurse_Bool_Exp>;
  orderCollections?: InputMaybe<Order_Collection_Bool_Exp>;
  orderCollections_aggregate?: InputMaybe<Order_Collection_Aggregate_Bool_Exp>;
  orderConsultations?: InputMaybe<Order_Consultation_Bool_Exp>;
  orderConsultations_aggregate?: InputMaybe<Order_Consultation_Aggregate_Bool_Exp>;
  orderDiscounts?: InputMaybe<Order_Discount_Bool_Exp>;
  orderShippings?: InputMaybe<Order_Shipping_Bool_Exp>;
  orderStates?: InputMaybe<Order_State_Bool_Exp>;
  orderTests?: InputMaybe<Order_Test_Bool_Exp>;
  orderTrainings?: InputMaybe<Order_Training_Bool_Exp>;
  orderTrainings_aggregate?: InputMaybe<Order_Training_Aggregate_Bool_Exp>;
  shippingConsent1?: InputMaybe<Boolean_Comparison_Exp>;
  shippingConsent2?: InputMaybe<Boolean_Comparison_Exp>;
  shippingConsent3?: InputMaybe<Boolean_Comparison_Exp>;
  totalCost?: InputMaybe<Numeric_Comparison_Exp>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "order_collection" */
export type Order_Collection = {
  __typename?: 'order_collection';
  address: Scalars['String'];
  city: Scalars['String'];
  clientNotes?: Maybe<Scalars['String']>;
  clientQuarantine?: Maybe<Scalars['Boolean']>;
  collectionCost: Scalars['numeric'];
  collectionCostBeforeDiscount?: Maybe<Scalars['numeric']>;
  collectionDate?: Maybe<Scalars['timestamptz']>;
  collectionKitCost: Scalars['numeric'];
  /** An object relationship */
  collectionPoint?: Maybe<Laboratory_Collection_Point>;
  collectionPointId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  collectionSlot?: Maybe<Collection_Slot>;
  collectionSlotId?: Maybe<Scalars['Int']>;
  deliveryCost: Scalars['numeric'];
  id: Scalars['Int'];
  isVoucher: Scalars['Boolean'];
  location: Scalars['geography'];
  /** An object relationship */
  nurse?: Maybe<Nurse>;
  nurseId?: Maybe<Scalars['Int']>;
  nurseNotes?: Maybe<Scalars['String']>;
  /** An object relationship */
  order: Order;
  orderId: Scalars['Int'];
  phoneNumber: Scalars['String'];
  postalCode: Scalars['String'];
  voucherValidUntil?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "order_collection" */
export type Order_Collection_Aggregate = {
  __typename?: 'order_collection_aggregate';
  aggregate?: Maybe<Order_Collection_Aggregate_Fields>;
  nodes: Array<Order_Collection>;
};

export type Order_Collection_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Order_Collection_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Order_Collection_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Order_Collection_Aggregate_Bool_Exp_Count>;
};

export type Order_Collection_Aggregate_Bool_Exp_Bool_And = {
  arguments: Order_Collection_Select_Column_Order_Collection_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Collection_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Collection_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Order_Collection_Select_Column_Order_Collection_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Collection_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Collection_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Collection_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_collection" */
export type Order_Collection_Aggregate_Fields = {
  __typename?: 'order_collection_aggregate_fields';
  avg?: Maybe<Order_Collection_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Collection_Max_Fields>;
  min?: Maybe<Order_Collection_Min_Fields>;
  stddev?: Maybe<Order_Collection_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Collection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Collection_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Collection_Sum_Fields>;
  var_pop?: Maybe<Order_Collection_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Collection_Var_Samp_Fields>;
  variance?: Maybe<Order_Collection_Variance_Fields>;
};


/** aggregate fields of "order_collection" */
export type Order_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_collection" */
export type Order_Collection_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Collection_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Collection_Max_Order_By>;
  min?: InputMaybe<Order_Collection_Min_Order_By>;
  stddev?: InputMaybe<Order_Collection_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Collection_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Collection_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Collection_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Collection_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Collection_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Collection_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order_collection" */
export type Order_Collection_Arr_Rel_Insert_Input = {
  data: Array<Order_Collection_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Collection_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Collection_Avg_Fields = {
  __typename?: 'order_collection_avg_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCostBeforeDiscount?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  collectionPointId?: Maybe<Scalars['Float']>;
  collectionSlotId?: Maybe<Scalars['Float']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_collection" */
export type Order_Collection_Avg_Order_By = {
  collectionCost?: InputMaybe<Order_By>;
  collectionCostBeforeDiscount?: InputMaybe<Order_By>;
  collectionKitCost?: InputMaybe<Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  collectionSlotId?: InputMaybe<Order_By>;
  deliveryCost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_collection". All fields are combined with a logical 'AND'. */
export type Order_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Collection_Bool_Exp>>;
  _not?: InputMaybe<Order_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Collection_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  clientNotes?: InputMaybe<String_Comparison_Exp>;
  clientQuarantine?: InputMaybe<Boolean_Comparison_Exp>;
  collectionCost?: InputMaybe<Numeric_Comparison_Exp>;
  collectionCostBeforeDiscount?: InputMaybe<Numeric_Comparison_Exp>;
  collectionDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  collectionKitCost?: InputMaybe<Numeric_Comparison_Exp>;
  collectionPoint?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
  collectionPointId?: InputMaybe<Int_Comparison_Exp>;
  collectionSlot?: InputMaybe<Collection_Slot_Bool_Exp>;
  collectionSlotId?: InputMaybe<Int_Comparison_Exp>;
  deliveryCost?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isVoucher?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  nurse?: InputMaybe<Nurse_Bool_Exp>;
  nurseId?: InputMaybe<Int_Comparison_Exp>;
  nurseNotes?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderId?: InputMaybe<Int_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  postalCode?: InputMaybe<String_Comparison_Exp>;
  voucherValidUntil?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_collection" */
export enum Order_Collection_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderCollectionPkey = 'order_collection_pkey',
  /** unique or primary key constraint on columns "collection_slot_id" */
  OrderCollectionSlotUnique = 'order_collection_slot_unique'
}

/** input type for incrementing numeric columns in table "order_collection" */
export type Order_Collection_Inc_Input = {
  collectionPointId?: InputMaybe<Scalars['Int']>;
  collectionSlotId?: InputMaybe<Scalars['Int']>;
  nurseId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "order_collection" */
export type Order_Collection_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  clientNotes?: InputMaybe<Scalars['String']>;
  clientQuarantine?: InputMaybe<Scalars['Boolean']>;
  collectionCost?: InputMaybe<Scalars['numeric']>;
  collectionCostBeforeDiscount?: InputMaybe<Scalars['numeric']>;
  collectionDate?: InputMaybe<Scalars['timestamptz']>;
  collectionKitCost?: InputMaybe<Scalars['numeric']>;
  collectionPoint?: InputMaybe<Laboratory_Collection_Point_Obj_Rel_Insert_Input>;
  collectionPointId?: InputMaybe<Scalars['Int']>;
  collectionSlot?: InputMaybe<Collection_Slot_Obj_Rel_Insert_Input>;
  collectionSlotId?: InputMaybe<Scalars['Int']>;
  deliveryCost?: InputMaybe<Scalars['numeric']>;
  isVoucher?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geography']>;
  nurse?: InputMaybe<Nurse_Obj_Rel_Insert_Input>;
  nurseId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Order_Obj_Rel_Insert_Input>;
  orderId?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  voucherValidUntil?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Order_Collection_Max_Fields = {
  __typename?: 'order_collection_max_fields';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clientNotes?: Maybe<Scalars['String']>;
  collectionCost?: Maybe<Scalars['numeric']>;
  collectionCostBeforeDiscount?: Maybe<Scalars['numeric']>;
  collectionDate?: Maybe<Scalars['timestamptz']>;
  collectionKitCost?: Maybe<Scalars['numeric']>;
  collectionPointId?: Maybe<Scalars['Int']>;
  collectionSlotId?: Maybe<Scalars['Int']>;
  deliveryCost?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  nurseId?: Maybe<Scalars['Int']>;
  nurseNotes?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  voucherValidUntil?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "order_collection" */
export type Order_Collection_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  clientNotes?: InputMaybe<Order_By>;
  collectionCost?: InputMaybe<Order_By>;
  collectionCostBeforeDiscount?: InputMaybe<Order_By>;
  collectionDate?: InputMaybe<Order_By>;
  collectionKitCost?: InputMaybe<Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  collectionSlotId?: InputMaybe<Order_By>;
  deliveryCost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
  nurseNotes?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  voucherValidUntil?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Collection_Min_Fields = {
  __typename?: 'order_collection_min_fields';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clientNotes?: Maybe<Scalars['String']>;
  collectionCost?: Maybe<Scalars['numeric']>;
  collectionCostBeforeDiscount?: Maybe<Scalars['numeric']>;
  collectionDate?: Maybe<Scalars['timestamptz']>;
  collectionKitCost?: Maybe<Scalars['numeric']>;
  collectionPointId?: Maybe<Scalars['Int']>;
  collectionSlotId?: Maybe<Scalars['Int']>;
  deliveryCost?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  nurseId?: Maybe<Scalars['Int']>;
  nurseNotes?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  voucherValidUntil?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "order_collection" */
export type Order_Collection_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  clientNotes?: InputMaybe<Order_By>;
  collectionCost?: InputMaybe<Order_By>;
  collectionCostBeforeDiscount?: InputMaybe<Order_By>;
  collectionDate?: InputMaybe<Order_By>;
  collectionKitCost?: InputMaybe<Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  collectionSlotId?: InputMaybe<Order_By>;
  deliveryCost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
  nurseNotes?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  voucherValidUntil?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_collection" */
export type Order_Collection_Mutation_Response = {
  __typename?: 'order_collection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Collection>;
};

/** input type for inserting object relation for remote table "order_collection" */
export type Order_Collection_Obj_Rel_Insert_Input = {
  data: Order_Collection_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Collection_On_Conflict>;
};

/** on_conflict condition type for table "order_collection" */
export type Order_Collection_On_Conflict = {
  constraint: Order_Collection_Constraint;
  update_columns?: Array<Order_Collection_Update_Column>;
  where?: InputMaybe<Order_Collection_Bool_Exp>;
};

/** Ordering options when selecting data from "order_collection". */
export type Order_Collection_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  clientNotes?: InputMaybe<Order_By>;
  clientQuarantine?: InputMaybe<Order_By>;
  collectionCost?: InputMaybe<Order_By>;
  collectionCostBeforeDiscount?: InputMaybe<Order_By>;
  collectionDate?: InputMaybe<Order_By>;
  collectionKitCost?: InputMaybe<Order_By>;
  collectionPoint?: InputMaybe<Laboratory_Collection_Point_Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  collectionSlot?: InputMaybe<Collection_Slot_Order_By>;
  collectionSlotId?: InputMaybe<Order_By>;
  deliveryCost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isVoucher?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  nurse?: InputMaybe<Nurse_Order_By>;
  nurseId?: InputMaybe<Order_By>;
  nurseNotes?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderId?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  voucherValidUntil?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_collection */
export type Order_Collection_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "order_collection" */
export enum Order_Collection_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  ClientNotes = 'clientNotes',
  /** column name */
  ClientQuarantine = 'clientQuarantine',
  /** column name */
  CollectionCost = 'collectionCost',
  /** column name */
  CollectionCostBeforeDiscount = 'collectionCostBeforeDiscount',
  /** column name */
  CollectionDate = 'collectionDate',
  /** column name */
  CollectionKitCost = 'collectionKitCost',
  /** column name */
  CollectionPointId = 'collectionPointId',
  /** column name */
  CollectionSlotId = 'collectionSlotId',
  /** column name */
  DeliveryCost = 'deliveryCost',
  /** column name */
  Id = 'id',
  /** column name */
  IsVoucher = 'isVoucher',
  /** column name */
  Location = 'location',
  /** column name */
  NurseId = 'nurseId',
  /** column name */
  NurseNotes = 'nurseNotes',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  VoucherValidUntil = 'voucherValidUntil'
}

/** select "order_collection_aggregate_bool_exp_bool_and_arguments_columns" columns of table "order_collection" */
export enum Order_Collection_Select_Column_Order_Collection_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ClientQuarantine = 'clientQuarantine',
  /** column name */
  IsVoucher = 'isVoucher'
}

/** select "order_collection_aggregate_bool_exp_bool_or_arguments_columns" columns of table "order_collection" */
export enum Order_Collection_Select_Column_Order_Collection_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ClientQuarantine = 'clientQuarantine',
  /** column name */
  IsVoucher = 'isVoucher'
}

/** input type for updating data in table "order_collection" */
export type Order_Collection_Set_Input = {
  collectionPointId?: InputMaybe<Scalars['Int']>;
  collectionSlotId?: InputMaybe<Scalars['Int']>;
  nurseId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Order_Collection_Stddev_Fields = {
  __typename?: 'order_collection_stddev_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCostBeforeDiscount?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  collectionPointId?: Maybe<Scalars['Float']>;
  collectionSlotId?: Maybe<Scalars['Float']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_collection" */
export type Order_Collection_Stddev_Order_By = {
  collectionCost?: InputMaybe<Order_By>;
  collectionCostBeforeDiscount?: InputMaybe<Order_By>;
  collectionKitCost?: InputMaybe<Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  collectionSlotId?: InputMaybe<Order_By>;
  deliveryCost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Collection_Stddev_Pop_Fields = {
  __typename?: 'order_collection_stddev_pop_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCostBeforeDiscount?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  collectionPointId?: Maybe<Scalars['Float']>;
  collectionSlotId?: Maybe<Scalars['Float']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_collection" */
export type Order_Collection_Stddev_Pop_Order_By = {
  collectionCost?: InputMaybe<Order_By>;
  collectionCostBeforeDiscount?: InputMaybe<Order_By>;
  collectionKitCost?: InputMaybe<Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  collectionSlotId?: InputMaybe<Order_By>;
  deliveryCost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Collection_Stddev_Samp_Fields = {
  __typename?: 'order_collection_stddev_samp_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCostBeforeDiscount?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  collectionPointId?: Maybe<Scalars['Float']>;
  collectionSlotId?: Maybe<Scalars['Float']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_collection" */
export type Order_Collection_Stddev_Samp_Order_By = {
  collectionCost?: InputMaybe<Order_By>;
  collectionCostBeforeDiscount?: InputMaybe<Order_By>;
  collectionKitCost?: InputMaybe<Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  collectionSlotId?: InputMaybe<Order_By>;
  deliveryCost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_collection" */
export type Order_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Collection_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  clientNotes?: InputMaybe<Scalars['String']>;
  clientQuarantine?: InputMaybe<Scalars['Boolean']>;
  collectionCost?: InputMaybe<Scalars['numeric']>;
  collectionCostBeforeDiscount?: InputMaybe<Scalars['numeric']>;
  collectionDate?: InputMaybe<Scalars['timestamptz']>;
  collectionKitCost?: InputMaybe<Scalars['numeric']>;
  collectionPointId?: InputMaybe<Scalars['Int']>;
  collectionSlotId?: InputMaybe<Scalars['Int']>;
  deliveryCost?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  isVoucher?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geography']>;
  nurseId?: InputMaybe<Scalars['Int']>;
  nurseNotes?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  voucherValidUntil?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Order_Collection_Sum_Fields = {
  __typename?: 'order_collection_sum_fields';
  collectionCost?: Maybe<Scalars['numeric']>;
  collectionCostBeforeDiscount?: Maybe<Scalars['numeric']>;
  collectionKitCost?: Maybe<Scalars['numeric']>;
  collectionPointId?: Maybe<Scalars['Int']>;
  collectionSlotId?: Maybe<Scalars['Int']>;
  deliveryCost?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  nurseId?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_collection" */
export type Order_Collection_Sum_Order_By = {
  collectionCost?: InputMaybe<Order_By>;
  collectionCostBeforeDiscount?: InputMaybe<Order_By>;
  collectionKitCost?: InputMaybe<Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  collectionSlotId?: InputMaybe<Order_By>;
  deliveryCost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** update columns of table "order_collection" */
export enum Order_Collection_Update_Column {
  /** column name */
  CollectionPointId = 'collectionPointId',
  /** column name */
  CollectionSlotId = 'collectionSlotId',
  /** column name */
  NurseId = 'nurseId'
}

export type Order_Collection_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Collection_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Collection_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Collection_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Collection_Var_Pop_Fields = {
  __typename?: 'order_collection_var_pop_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCostBeforeDiscount?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  collectionPointId?: Maybe<Scalars['Float']>;
  collectionSlotId?: Maybe<Scalars['Float']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_collection" */
export type Order_Collection_Var_Pop_Order_By = {
  collectionCost?: InputMaybe<Order_By>;
  collectionCostBeforeDiscount?: InputMaybe<Order_By>;
  collectionKitCost?: InputMaybe<Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  collectionSlotId?: InputMaybe<Order_By>;
  deliveryCost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Collection_Var_Samp_Fields = {
  __typename?: 'order_collection_var_samp_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCostBeforeDiscount?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  collectionPointId?: Maybe<Scalars['Float']>;
  collectionSlotId?: Maybe<Scalars['Float']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_collection" */
export type Order_Collection_Var_Samp_Order_By = {
  collectionCost?: InputMaybe<Order_By>;
  collectionCostBeforeDiscount?: InputMaybe<Order_By>;
  collectionKitCost?: InputMaybe<Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  collectionSlotId?: InputMaybe<Order_By>;
  deliveryCost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Collection_Variance_Fields = {
  __typename?: 'order_collection_variance_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCostBeforeDiscount?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  collectionPointId?: Maybe<Scalars['Float']>;
  collectionSlotId?: Maybe<Scalars['Float']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nurseId?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_collection" */
export type Order_Collection_Variance_Order_By = {
  collectionCost?: InputMaybe<Order_By>;
  collectionCostBeforeDiscount?: InputMaybe<Order_By>;
  collectionKitCost?: InputMaybe<Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  collectionSlotId?: InputMaybe<Order_By>;
  deliveryCost?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nurseId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "order" */
export enum Order_Constraint {
  /** unique or primary key constraint on columns "payment_session_id" */
  OrderPaymentSessionIdIdx = 'order_payment_session_id_idx',
  /** unique or primary key constraint on columns "id" */
  OrderPkey = 'order_pkey'
}

/** columns and relationships of "order_consultation" */
export type Order_Consultation = {
  __typename?: 'order_consultation';
  /** An object relationship */
  consultation: Consultation;
  consultationId: Scalars['Int'];
  consultationSlotId?: Maybe<Scalars['Int']>;
  cost: Scalars['numeric'];
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  finishedOn?: Maybe<Scalars['timestamptz']>;
  firstName: Scalars['String'];
  gender?: Maybe<Gender_Enum>;
  id: Scalars['Int'];
  identity: Scalars['jsonb'];
  lastName: Scalars['String'];
  /** An object relationship */
  order: Order;
  orderId: Scalars['Int'];
  phoneNumber: Scalars['String'];
  preferredDate: Scalars['timestamptz'];
};


/** columns and relationships of "order_consultation" */
export type Order_ConsultationIdentityArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "order_consultation" */
export type Order_Consultation_Aggregate = {
  __typename?: 'order_consultation_aggregate';
  aggregate?: Maybe<Order_Consultation_Aggregate_Fields>;
  nodes: Array<Order_Consultation>;
};

export type Order_Consultation_Aggregate_Bool_Exp = {
  count?: InputMaybe<Order_Consultation_Aggregate_Bool_Exp_Count>;
};

export type Order_Consultation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Consultation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Consultation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_consultation" */
export type Order_Consultation_Aggregate_Fields = {
  __typename?: 'order_consultation_aggregate_fields';
  avg?: Maybe<Order_Consultation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Consultation_Max_Fields>;
  min?: Maybe<Order_Consultation_Min_Fields>;
  stddev?: Maybe<Order_Consultation_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Consultation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Consultation_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Consultation_Sum_Fields>;
  var_pop?: Maybe<Order_Consultation_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Consultation_Var_Samp_Fields>;
  variance?: Maybe<Order_Consultation_Variance_Fields>;
};


/** aggregate fields of "order_consultation" */
export type Order_Consultation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Consultation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_consultation" */
export type Order_Consultation_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Consultation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Consultation_Max_Order_By>;
  min?: InputMaybe<Order_Consultation_Min_Order_By>;
  stddev?: InputMaybe<Order_Consultation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Consultation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Consultation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Consultation_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Consultation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Consultation_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Consultation_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Order_Consultation_Avg_Fields = {
  __typename?: 'order_consultation_avg_fields';
  consultationId?: Maybe<Scalars['Float']>;
  consultationSlotId?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_consultation" */
export type Order_Consultation_Avg_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  consultationSlotId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_consultation". All fields are combined with a logical 'AND'. */
export type Order_Consultation_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Consultation_Bool_Exp>>;
  _not?: InputMaybe<Order_Consultation_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Consultation_Bool_Exp>>;
  consultation?: InputMaybe<Consultation_Bool_Exp>;
  consultationId?: InputMaybe<Int_Comparison_Exp>;
  consultationSlotId?: InputMaybe<Int_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  costBeforeDiscount?: InputMaybe<Numeric_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  finishedOn?: InputMaybe<Timestamptz_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<Gender_Enum_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  identity?: InputMaybe<Jsonb_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderId?: InputMaybe<Int_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  preferredDate?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Order_Consultation_Max_Fields = {
  __typename?: 'order_consultation_max_fields';
  consultationId?: Maybe<Scalars['Int']>;
  consultationSlotId?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['numeric']>;
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  finishedOn?: Maybe<Scalars['timestamptz']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  preferredDate?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "order_consultation" */
export type Order_Consultation_Max_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  consultationSlotId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  finishedOn?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  preferredDate?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Consultation_Min_Fields = {
  __typename?: 'order_consultation_min_fields';
  consultationId?: Maybe<Scalars['Int']>;
  consultationSlotId?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['numeric']>;
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  finishedOn?: Maybe<Scalars['timestamptz']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  preferredDate?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "order_consultation" */
export type Order_Consultation_Min_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  consultationSlotId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  finishedOn?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  preferredDate?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_consultation" */
export type Order_Consultation_Mutation_Response = {
  __typename?: 'order_consultation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Consultation>;
};

/** Ordering options when selecting data from "order_consultation". */
export type Order_Consultation_Order_By = {
  consultation?: InputMaybe<Consultation_Order_By>;
  consultationId?: InputMaybe<Order_By>;
  consultationSlotId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  finishedOn?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderId?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  preferredDate?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_consultation */
export type Order_Consultation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "order_consultation" */
export enum Order_Consultation_Select_Column {
  /** column name */
  ConsultationId = 'consultationId',
  /** column name */
  ConsultationSlotId = 'consultationSlotId',
  /** column name */
  Cost = 'cost',
  /** column name */
  CostBeforeDiscount = 'costBeforeDiscount',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FinishedOn = 'finishedOn',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  Identity = 'identity',
  /** column name */
  LastName = 'lastName',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PreferredDate = 'preferredDate'
}

/** input type for updating data in table "order_consultation" */
export type Order_Consultation_Set_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  finishedOn?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Order_Consultation_Stddev_Fields = {
  __typename?: 'order_consultation_stddev_fields';
  consultationId?: Maybe<Scalars['Float']>;
  consultationSlotId?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_consultation" */
export type Order_Consultation_Stddev_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  consultationSlotId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Consultation_Stddev_Pop_Fields = {
  __typename?: 'order_consultation_stddev_pop_fields';
  consultationId?: Maybe<Scalars['Float']>;
  consultationSlotId?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_consultation" */
export type Order_Consultation_Stddev_Pop_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  consultationSlotId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Consultation_Stddev_Samp_Fields = {
  __typename?: 'order_consultation_stddev_samp_fields';
  consultationId?: Maybe<Scalars['Float']>;
  consultationSlotId?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_consultation" */
export type Order_Consultation_Stddev_Samp_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  consultationSlotId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_consultation" */
export type Order_Consultation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Consultation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Consultation_Stream_Cursor_Value_Input = {
  consultationId?: InputMaybe<Scalars['Int']>;
  consultationSlotId?: InputMaybe<Scalars['Int']>;
  cost?: InputMaybe<Scalars['numeric']>;
  costBeforeDiscount?: InputMaybe<Scalars['numeric']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  finishedOn?: InputMaybe<Scalars['timestamptz']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender_Enum>;
  id?: InputMaybe<Scalars['Int']>;
  identity?: InputMaybe<Scalars['jsonb']>;
  lastName?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  preferredDate?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Order_Consultation_Sum_Fields = {
  __typename?: 'order_consultation_sum_fields';
  consultationId?: Maybe<Scalars['Int']>;
  consultationSlotId?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['numeric']>;
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_consultation" */
export type Order_Consultation_Sum_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  consultationSlotId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

export type Order_Consultation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Consultation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Consultation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Consultation_Var_Pop_Fields = {
  __typename?: 'order_consultation_var_pop_fields';
  consultationId?: Maybe<Scalars['Float']>;
  consultationSlotId?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_consultation" */
export type Order_Consultation_Var_Pop_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  consultationSlotId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Consultation_Var_Samp_Fields = {
  __typename?: 'order_consultation_var_samp_fields';
  consultationId?: Maybe<Scalars['Float']>;
  consultationSlotId?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_consultation" */
export type Order_Consultation_Var_Samp_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  consultationSlotId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Consultation_Variance_Fields = {
  __typename?: 'order_consultation_variance_fields';
  consultationId?: Maybe<Scalars['Float']>;
  consultationSlotId?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_consultation" */
export type Order_Consultation_Variance_Order_By = {
  consultationId?: InputMaybe<Order_By>;
  consultationSlotId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_discount" */
export type Order_Discount = {
  __typename?: 'order_discount';
  /** An object relationship */
  discount: Discount;
  discount_id: Scalars['Int'];
  /** An object relationship */
  order: Order;
  order_id: Scalars['Int'];
};

/** order by aggregate values of table "order_discount" */
export type Order_Discount_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Discount_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Discount_Max_Order_By>;
  min?: InputMaybe<Order_Discount_Min_Order_By>;
  stddev?: InputMaybe<Order_Discount_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Discount_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Discount_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Discount_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Discount_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Discount_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Discount_Variance_Order_By>;
};

/** order by avg() on columns of table "order_discount" */
export type Order_Discount_Avg_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_discount". All fields are combined with a logical 'AND'. */
export type Order_Discount_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Discount_Bool_Exp>>;
  _not?: InputMaybe<Order_Discount_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Discount_Bool_Exp>>;
  discount?: InputMaybe<Discount_Bool_Exp>;
  discount_id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "order_discount" */
export type Order_Discount_Max_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_discount" */
export type Order_Discount_Min_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_discount". */
export type Order_Discount_Order_By = {
  discount?: InputMaybe<Discount_Order_By>;
  discount_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** select columns of table "order_discount" */
export enum Order_Discount_Select_Column {
  /** column name */
  DiscountId = 'discount_id',
  /** column name */
  OrderId = 'order_id'
}

/** order by stddev() on columns of table "order_discount" */
export type Order_Discount_Stddev_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_discount" */
export type Order_Discount_Stddev_Pop_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_discount" */
export type Order_Discount_Stddev_Samp_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_discount" */
export type Order_Discount_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Discount_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Discount_Stream_Cursor_Value_Input = {
  discount_id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_discount" */
export type Order_Discount_Sum_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "order_discount" */
export type Order_Discount_Var_Pop_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_discount" */
export type Order_Discount_Var_Samp_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_discount" */
export type Order_Discount_Variance_Order_By = {
  discount_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_document" */
export type Order_Document = {
  __typename?: 'order_document';
  /** An object relationship */
  file: File;
  fileId: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  order: Order;
  orderId: Scalars['Int'];
};

/** aggregated selection of "order_document" */
export type Order_Document_Aggregate = {
  __typename?: 'order_document_aggregate';
  aggregate?: Maybe<Order_Document_Aggregate_Fields>;
  nodes: Array<Order_Document>;
};

export type Order_Document_Aggregate_Bool_Exp = {
  count?: InputMaybe<Order_Document_Aggregate_Bool_Exp_Count>;
};

export type Order_Document_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_document" */
export type Order_Document_Aggregate_Fields = {
  __typename?: 'order_document_aggregate_fields';
  avg?: Maybe<Order_Document_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Document_Max_Fields>;
  min?: Maybe<Order_Document_Min_Fields>;
  stddev?: Maybe<Order_Document_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Document_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Document_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Document_Sum_Fields>;
  var_pop?: Maybe<Order_Document_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Document_Var_Samp_Fields>;
  variance?: Maybe<Order_Document_Variance_Fields>;
};


/** aggregate fields of "order_document" */
export type Order_Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_document" */
export type Order_Document_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Document_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Document_Max_Order_By>;
  min?: InputMaybe<Order_Document_Min_Order_By>;
  stddev?: InputMaybe<Order_Document_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Document_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Document_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Document_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Document_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Document_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Document_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Order_Document_Avg_Fields = {
  __typename?: 'order_document_avg_fields';
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_document" */
export type Order_Document_Avg_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_document". All fields are combined with a logical 'AND'. */
export type Order_Document_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Document_Bool_Exp>>;
  _not?: InputMaybe<Order_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Document_Bool_Exp>>;
  file?: InputMaybe<File_Bool_Exp>;
  fileId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderId?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Order_Document_Max_Fields = {
  __typename?: 'order_document_max_fields';
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "order_document" */
export type Order_Document_Max_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Document_Min_Fields = {
  __typename?: 'order_document_min_fields';
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "order_document" */
export type Order_Document_Min_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_document". */
export type Order_Document_Order_By = {
  file?: InputMaybe<File_Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** select columns of table "order_document" */
export enum Order_Document_Select_Column {
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'orderId'
}

/** aggregate stddev on columns */
export type Order_Document_Stddev_Fields = {
  __typename?: 'order_document_stddev_fields';
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_document" */
export type Order_Document_Stddev_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Document_Stddev_Pop_Fields = {
  __typename?: 'order_document_stddev_pop_fields';
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_document" */
export type Order_Document_Stddev_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Document_Stddev_Samp_Fields = {
  __typename?: 'order_document_stddev_samp_fields';
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_document" */
export type Order_Document_Stddev_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_document" */
export type Order_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Document_Stream_Cursor_Value_Input = {
  fileId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Order_Document_Sum_Fields = {
  __typename?: 'order_document_sum_fields';
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_document" */
export type Order_Document_Sum_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Order_Document_Var_Pop_Fields = {
  __typename?: 'order_document_var_pop_fields';
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_document" */
export type Order_Document_Var_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Document_Var_Samp_Fields = {
  __typename?: 'order_document_var_samp_fields';
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_document" */
export type Order_Document_Var_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Document_Variance_Fields = {
  __typename?: 'order_document_variance_fields';
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_document" */
export type Order_Document_Variance_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "order" */
export type Order_Inc_Input = {
  costBeforeDiscount?: InputMaybe<Scalars['numeric']>;
  nurseId?: InputMaybe<Scalars['Int']>;
  totalCost?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "order" */
export type Order_Insert_Input = {
  client?: InputMaybe<Client_Obj_Rel_Insert_Input>;
  clientConsent1?: InputMaybe<Scalars['Boolean']>;
  clientConsent2?: InputMaybe<Scalars['Boolean']>;
  clientConsent3?: InputMaybe<Scalars['Boolean']>;
  clientConsent4?: InputMaybe<Scalars['Boolean']>;
  clientConsent5?: InputMaybe<Scalars['Boolean']>;
  clientId?: InputMaybe<Scalars['Int']>;
  costBeforeDiscount?: InputMaybe<Scalars['numeric']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  nurse?: InputMaybe<Nurse_Obj_Rel_Insert_Input>;
  nurseId?: InputMaybe<Scalars['Int']>;
  orderCollections?: InputMaybe<Order_Collection_Arr_Rel_Insert_Input>;
  orderStates?: InputMaybe<Order_State_Arr_Rel_Insert_Input>;
  orderTests?: InputMaybe<Order_Test_Arr_Rel_Insert_Input>;
  shippingConsent1?: InputMaybe<Scalars['Boolean']>;
  shippingConsent2?: InputMaybe<Scalars['Boolean']>;
  shippingConsent3?: InputMaybe<Scalars['Boolean']>;
  totalCost?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Order_Max_Fields = {
  __typename?: 'order_max_fields';
  clientId?: Maybe<Scalars['Int']>;
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  currentState?: Maybe<Scalars['String']>;
  /** A computed field, executes function "get_current_order_state_date" */
  currentStateDate?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "get_first_order_state_date" */
  firstStateDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  totalCost?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Order_Min_Fields = {
  __typename?: 'order_min_fields';
  clientId?: Maybe<Scalars['Int']>;
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  currentState?: Maybe<Scalars['String']>;
  /** A computed field, executes function "get_current_order_state_date" */
  currentStateDate?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "get_first_order_state_date" */
  firstStateDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  totalCost?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "order" */
export type Order_Mutation_Response = {
  __typename?: 'order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order>;
};

/** input type for inserting object relation for remote table "order" */
export type Order_Obj_Rel_Insert_Input = {
  data: Order_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_On_Conflict>;
};

/** on_conflict condition type for table "order" */
export type Order_On_Conflict = {
  constraint: Order_Constraint;
  update_columns?: Array<Order_Update_Column>;
  where?: InputMaybe<Order_Bool_Exp>;
};

/** Ordering options when selecting data from "order". */
export type Order_Order_By = {
  client?: InputMaybe<Client_Order_By>;
  clientConsent1?: InputMaybe<Order_By>;
  clientConsent2?: InputMaybe<Order_By>;
  clientConsent3?: InputMaybe<Order_By>;
  clientConsent4?: InputMaybe<Order_By>;
  clientConsent5?: InputMaybe<Order_By>;
  clientId?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  currentState?: InputMaybe<Order_By>;
  currentStateDate?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Order_Document_Aggregate_Order_By>;
  firstStateDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nurse?: InputMaybe<Nurse_Order_By>;
  orderCollections_aggregate?: InputMaybe<Order_Collection_Aggregate_Order_By>;
  orderConsultations_aggregate?: InputMaybe<Order_Consultation_Aggregate_Order_By>;
  orderDiscounts_aggregate?: InputMaybe<Order_Discount_Aggregate_Order_By>;
  orderShippings_aggregate?: InputMaybe<Order_Shipping_Aggregate_Order_By>;
  orderStates_aggregate?: InputMaybe<Order_State_Aggregate_Order_By>;
  orderTests_aggregate?: InputMaybe<Order_Test_Aggregate_Order_By>;
  orderTrainings_aggregate?: InputMaybe<Order_Training_Aggregate_Order_By>;
  shippingConsent1?: InputMaybe<Order_By>;
  shippingConsent2?: InputMaybe<Order_By>;
  shippingConsent3?: InputMaybe<Order_By>;
  totalCost?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order */
export type Order_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "order" */
export enum Order_Select_Column {
  /** column name */
  ClientConsent1 = 'clientConsent1',
  /** column name */
  ClientConsent2 = 'clientConsent2',
  /** column name */
  ClientConsent3 = 'clientConsent3',
  /** column name */
  ClientConsent4 = 'clientConsent4',
  /** column name */
  ClientConsent5 = 'clientConsent5',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  CostBeforeDiscount = 'costBeforeDiscount',
  /** column name */
  Id = 'id',
  /** column name */
  ShippingConsent1 = 'shippingConsent1',
  /** column name */
  ShippingConsent2 = 'shippingConsent2',
  /** column name */
  ShippingConsent3 = 'shippingConsent3',
  /** column name */
  TotalCost = 'totalCost'
}

/** input type for updating data in table "order" */
export type Order_Set_Input = {
  costBeforeDiscount?: InputMaybe<Scalars['numeric']>;
  nurseId?: InputMaybe<Scalars['Int']>;
  totalCost?: InputMaybe<Scalars['numeric']>;
};

/** columns and relationships of "order_shipping" */
export type Order_Shipping = {
  __typename?: 'order_shipping';
  carrierShipmentId?: Maybe<Scalars['bigint']>;
  carrierTrackingUrl?: Maybe<Scalars['String']>;
  cost: Scalars['numeric'];
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  createdAt: Scalars['timestamptz'];
  deliveredAt?: Maybe<Scalars['timestamptz']>;
  direction: Scalars['shipping_direction'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  /** An object relationship */
  laboratory?: Maybe<Laboratory>;
  laboratoryId?: Maybe<Scalars['Int']>;
  metadata: Scalars['jsonb'];
  /** An object relationship */
  order: Order;
  orderId: Scalars['bigint'];
  phone?: Maybe<Scalars['String']>;
  pointName?: Maybe<Scalars['String']>;
  shippedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  shipping: Shipping;
  shippingId: Scalars['bigint'];
  status: Scalars['String'];
  trackingNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "order_shipping" */
export type Order_ShippingMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "order_shipping" */
export type Order_Shipping_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Shipping_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Shipping_Max_Order_By>;
  min?: InputMaybe<Order_Shipping_Min_Order_By>;
  stddev?: InputMaybe<Order_Shipping_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Shipping_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Shipping_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Shipping_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Shipping_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Shipping_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Shipping_Variance_Order_By>;
};

/** order by avg() on columns of table "order_shipping" */
export type Order_Shipping_Avg_Order_By = {
  carrierShipmentId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_shipping". All fields are combined with a logical 'AND'. */
export type Order_Shipping_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Shipping_Bool_Exp>>;
  _not?: InputMaybe<Order_Shipping_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Shipping_Bool_Exp>>;
  carrierShipmentId?: InputMaybe<Bigint_Comparison_Exp>;
  carrierTrackingUrl?: InputMaybe<String_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  costBeforeDiscount?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deliveredAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  direction?: InputMaybe<Shipping_Direction_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  laboratory?: InputMaybe<Laboratory_Bool_Exp>;
  laboratoryId?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderId?: InputMaybe<Bigint_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  pointName?: InputMaybe<String_Comparison_Exp>;
  shippedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  shipping?: InputMaybe<Shipping_Bool_Exp>;
  shippingId?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trackingNumber?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "order_shipping" */
export type Order_Shipping_Max_Order_By = {
  carrierShipmentId?: InputMaybe<Order_By>;
  carrierTrackingUrl?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deliveredAt?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  pointName?: InputMaybe<Order_By>;
  shippedAt?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trackingNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_shipping" */
export type Order_Shipping_Min_Order_By = {
  carrierShipmentId?: InputMaybe<Order_By>;
  carrierTrackingUrl?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deliveredAt?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  pointName?: InputMaybe<Order_By>;
  shippedAt?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trackingNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_shipping". */
export type Order_Shipping_Order_By = {
  carrierShipmentId?: InputMaybe<Order_By>;
  carrierTrackingUrl?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deliveredAt?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory?: InputMaybe<Laboratory_Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  pointName?: InputMaybe<Order_By>;
  shippedAt?: InputMaybe<Order_By>;
  shipping?: InputMaybe<Shipping_Order_By>;
  shippingId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trackingNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "order_shipping" */
export enum Order_Shipping_Select_Column {
  /** column name */
  CarrierShipmentId = 'carrierShipmentId',
  /** column name */
  CarrierTrackingUrl = 'carrierTrackingUrl',
  /** column name */
  Cost = 'cost',
  /** column name */
  CostBeforeDiscount = 'costBeforeDiscount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeliveredAt = 'deliveredAt',
  /** column name */
  Direction = 'direction',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  LaboratoryId = 'laboratoryId',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  Phone = 'phone',
  /** column name */
  PointName = 'pointName',
  /** column name */
  ShippedAt = 'shippedAt',
  /** column name */
  ShippingId = 'shippingId',
  /** column name */
  Status = 'status',
  /** column name */
  TrackingNumber = 'trackingNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "order_shipping" */
export type Order_Shipping_Stddev_Order_By = {
  carrierShipmentId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_shipping" */
export type Order_Shipping_Stddev_Pop_Order_By = {
  carrierShipmentId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_shipping" */
export type Order_Shipping_Stddev_Samp_Order_By = {
  carrierShipmentId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_shipping" */
export type Order_Shipping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Shipping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Shipping_Stream_Cursor_Value_Input = {
  carrierShipmentId?: InputMaybe<Scalars['bigint']>;
  carrierTrackingUrl?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['numeric']>;
  costBeforeDiscount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deliveredAt?: InputMaybe<Scalars['timestamptz']>;
  direction?: InputMaybe<Scalars['shipping_direction']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  laboratoryId?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  orderId?: InputMaybe<Scalars['bigint']>;
  phone?: InputMaybe<Scalars['String']>;
  pointName?: InputMaybe<Scalars['String']>;
  shippedAt?: InputMaybe<Scalars['timestamptz']>;
  shippingId?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "order_shipping" */
export type Order_Shipping_Sum_Order_By = {
  carrierShipmentId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "order_shipping" */
export type Order_Shipping_Var_Pop_Order_By = {
  carrierShipmentId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_shipping" */
export type Order_Shipping_Var_Samp_Order_By = {
  carrierShipmentId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_shipping" */
export type Order_Shipping_Variance_Order_By = {
  carrierShipmentId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryId?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  shippingId?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_state" */
export type Order_State = {
  __typename?: 'order_state';
  date: Scalars['timestamptz'];
  extra?: Maybe<Scalars['jsonb']>;
  id: Scalars['Int'];
  /** An object relationship */
  order: Order;
  orderId: Scalars['Int'];
  state: Order_State_Enum_Enum;
};


/** columns and relationships of "order_state" */
export type Order_StateExtraArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "order_state" */
export type Order_State_Aggregate_Order_By = {
  avg?: InputMaybe<Order_State_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_State_Max_Order_By>;
  min?: InputMaybe<Order_State_Min_Order_By>;
  stddev?: InputMaybe<Order_State_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_State_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_State_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_State_Sum_Order_By>;
  var_pop?: InputMaybe<Order_State_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_State_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_State_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order_state" */
export type Order_State_Arr_Rel_Insert_Input = {
  data: Array<Order_State_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_State_On_Conflict>;
};

/** order by avg() on columns of table "order_state" */
export type Order_State_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_state". All fields are combined with a logical 'AND'. */
export type Order_State_Bool_Exp = {
  _and?: InputMaybe<Array<Order_State_Bool_Exp>>;
  _not?: InputMaybe<Order_State_Bool_Exp>;
  _or?: InputMaybe<Array<Order_State_Bool_Exp>>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderId?: InputMaybe<Int_Comparison_Exp>;
  state?: InputMaybe<Order_State_Enum_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_state" */
export enum Order_State_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderStatePkey = 'order_state_pkey'
}

export enum Order_State_Enum_Enum {
  AwaitingClientConfirmation = 'AwaitingClientConfirmation',
  AwaitingConfirmation = 'AwaitingConfirmation',
  Cancelled = 'Cancelled',
  CollectingSamples = 'CollectingSamples',
  Confirmed = 'Confirmed',
  DifferentDateAccepted = 'DifferentDateAccepted',
  DifferentDateProposed = 'DifferentDateProposed',
  DifferentDateRejected = 'DifferentDateRejected',
  ExaminingSamples = 'ExaminingSamples',
  Finished = 'Finished',
  FinishedExternal = 'FinishedExternal',
  OnTheWayToClient = 'OnTheWayToClient',
  OnTheWayToLab = 'OnTheWayToLab',
  Unpaid = 'Unpaid'
}

/** Boolean expression to compare columns of type "order_state_enum_enum". All fields are combined with logical 'AND'. */
export type Order_State_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Order_State_Enum_Enum>;
  _in?: InputMaybe<Array<Order_State_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Order_State_Enum_Enum>;
  _nin?: InputMaybe<Array<Order_State_Enum_Enum>>;
};

/** input type for inserting data into table "order_state" */
export type Order_State_Insert_Input = {
  date?: InputMaybe<Scalars['timestamptz']>;
  extra?: InputMaybe<Scalars['jsonb']>;
  order?: InputMaybe<Order_Obj_Rel_Insert_Input>;
  orderId?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Order_State_Enum_Enum>;
};

/** order by max() on columns of table "order_state" */
export type Order_State_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_state" */
export type Order_State_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_state" */
export type Order_State_Mutation_Response = {
  __typename?: 'order_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_State>;
};

/** on_conflict condition type for table "order_state" */
export type Order_State_On_Conflict = {
  constraint: Order_State_Constraint;
  update_columns?: Array<Order_State_Update_Column>;
  where?: InputMaybe<Order_State_Bool_Exp>;
};

/** Ordering options when selecting data from "order_state". */
export type Order_State_Order_By = {
  date?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderId?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** select columns of table "order_state" */
export enum Order_State_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Extra = 'extra',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  State = 'state'
}

/** order by stddev() on columns of table "order_state" */
export type Order_State_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_state" */
export type Order_State_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_state" */
export type Order_State_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_state" */
export type Order_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_State_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['timestamptz']>;
  extra?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Order_State_Enum_Enum>;
};

/** order by sum() on columns of table "order_state" */
export type Order_State_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "order_state" (current role has no relevant permissions) */
export enum Order_State_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "order_state" */
export type Order_State_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_state" */
export type Order_State_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_state" */
export type Order_State_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Order_Stddev_Fields = {
  __typename?: 'order_stddev_fields';
  clientId?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Order_Stddev_Pop_Fields = {
  __typename?: 'order_stddev_pop_fields';
  clientId?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Order_Stddev_Samp_Fields = {
  __typename?: 'order_stddev_samp_fields';
  clientId?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "order" */
export type Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Stream_Cursor_Value_Input = {
  clientConsent1?: InputMaybe<Scalars['Boolean']>;
  clientConsent2?: InputMaybe<Scalars['Boolean']>;
  clientConsent3?: InputMaybe<Scalars['Boolean']>;
  clientConsent4?: InputMaybe<Scalars['Boolean']>;
  clientConsent5?: InputMaybe<Scalars['Boolean']>;
  clientId?: InputMaybe<Scalars['Int']>;
  costBeforeDiscount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  shippingConsent1?: InputMaybe<Scalars['Boolean']>;
  shippingConsent2?: InputMaybe<Scalars['Boolean']>;
  shippingConsent3?: InputMaybe<Scalars['Boolean']>;
  totalCost?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Order_Sum_Fields = {
  __typename?: 'order_sum_fields';
  clientId?: Maybe<Scalars['Int']>;
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  totalCost?: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "order_test" */
export type Order_Test = {
  __typename?: 'order_test';
  collectedOn?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  collectionPoint?: Maybe<Laboratory_Collection_Point>;
  collectionPointId?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['numeric']>;
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  deliveryOrder: Scalars['Int'];
  finishedOn?: Maybe<Scalars['timestamptz']>;
  firstName: Scalars['String'];
  gender?: Maybe<Gender_Enum>;
  id: Scalars['Int'];
  identity?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "order_test_laboratory" */
  laboratory?: Maybe<Array<Laboratory>>;
  laboratoryCode?: Maybe<Scalars['String']>;
  /** A computed field, executes function "order_test_laboratory_test" */
  laboratoryTest?: Maybe<Array<Laboratory_Test>>;
  lastName: Scalars['String'];
  /** An object relationship */
  order: Order;
  orderId: Scalars['Int'];
  retrievedOn?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  test: Test;
  testId: Scalars['Int'];
  /** An array relationship */
  testResults: Array<Order_Test_Result>;
  /** A computed field, executes function "get_order_test_results_count" */
  testResultsCount?: Maybe<Scalars['bigint']>;
  /** An aggregate relationship */
  testResults_aggregate: Order_Test_Result_Aggregate;
  tubeCode?: Maybe<Scalars['String']>;
};


/** columns and relationships of "order_test" */
export type Order_TestIdentityArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "order_test" */
export type Order_TestLaboratoryArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


/** columns and relationships of "order_test" */
export type Order_TestLaboratoryTestArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Test_Order_By>>;
  where?: InputMaybe<Laboratory_Test_Bool_Exp>;
};


/** columns and relationships of "order_test" */
export type Order_TestTestResultsArgs = {
  distinct_on?: InputMaybe<Array<Order_Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Test_Result_Order_By>>;
  where?: InputMaybe<Order_Test_Result_Bool_Exp>;
};


/** columns and relationships of "order_test" */
export type Order_TestTestResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Test_Result_Order_By>>;
  where?: InputMaybe<Order_Test_Result_Bool_Exp>;
};

/** order by aggregate values of table "order_test" */
export type Order_Test_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Test_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Test_Max_Order_By>;
  min?: InputMaybe<Order_Test_Min_Order_By>;
  stddev?: InputMaybe<Order_Test_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Test_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Test_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Test_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Test_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Test_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Test_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Order_Test_Append_Input = {
  identity?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "order_test" */
export type Order_Test_Arr_Rel_Insert_Input = {
  data: Array<Order_Test_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Test_On_Conflict>;
};

/** order by avg() on columns of table "order_test" */
export type Order_Test_Avg_Order_By = {
  collectionPointId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deliveryOrder?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_test". All fields are combined with a logical 'AND'. */
export type Order_Test_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Test_Bool_Exp>>;
  _not?: InputMaybe<Order_Test_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Test_Bool_Exp>>;
  collectedOn?: InputMaybe<Timestamptz_Comparison_Exp>;
  collectionPoint?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
  collectionPointId?: InputMaybe<Int_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  costBeforeDiscount?: InputMaybe<Numeric_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deliveryOrder?: InputMaybe<Int_Comparison_Exp>;
  finishedOn?: InputMaybe<Timestamptz_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<Gender_Enum_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  identity?: InputMaybe<Jsonb_Comparison_Exp>;
  laboratory?: InputMaybe<Laboratory_Bool_Exp>;
  laboratoryCode?: InputMaybe<String_Comparison_Exp>;
  laboratoryTest?: InputMaybe<Laboratory_Test_Bool_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderId?: InputMaybe<Int_Comparison_Exp>;
  retrievedOn?: InputMaybe<Timestamptz_Comparison_Exp>;
  test?: InputMaybe<Test_Bool_Exp>;
  testId?: InputMaybe<Int_Comparison_Exp>;
  testResults?: InputMaybe<Order_Test_Result_Bool_Exp>;
  testResultsCount?: InputMaybe<Bigint_Comparison_Exp>;
  testResults_aggregate?: InputMaybe<Order_Test_Result_Aggregate_Bool_Exp>;
  tubeCode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_test" */
export enum Order_Test_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderTestPkey = 'order_test_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Order_Test_Delete_At_Path_Input = {
  identity?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Order_Test_Delete_Elem_Input = {
  identity?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Order_Test_Delete_Key_Input = {
  identity?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "order_test" */
export type Order_Test_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "order_test" */
export type Order_Test_Insert_Input = {
  collectedOn?: InputMaybe<Scalars['timestamptz']>;
  collectionPoint?: InputMaybe<Laboratory_Collection_Point_Obj_Rel_Insert_Input>;
  collectionPointId?: InputMaybe<Scalars['Int']>;
  cost?: InputMaybe<Scalars['numeric']>;
  costBeforeDiscount?: InputMaybe<Scalars['numeric']>;
  deliveryOrder?: InputMaybe<Scalars['Int']>;
  finishedOn?: InputMaybe<Scalars['timestamptz']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender_Enum>;
  identity?: InputMaybe<Scalars['jsonb']>;
  laboratoryCode?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Order_Obj_Rel_Insert_Input>;
  orderId?: InputMaybe<Scalars['Int']>;
  retrievedOn?: InputMaybe<Scalars['timestamptz']>;
  test?: InputMaybe<Test_Obj_Rel_Insert_Input>;
  testId?: InputMaybe<Scalars['Int']>;
  testResults?: InputMaybe<Order_Test_Result_Arr_Rel_Insert_Input>;
  tubeCode?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "order_test" */
export type Order_Test_Max_Order_By = {
  collectedOn?: InputMaybe<Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  deliveryOrder?: InputMaybe<Order_By>;
  finishedOn?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryCode?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  retrievedOn?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
  tubeCode?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_test" */
export type Order_Test_Min_Order_By = {
  collectedOn?: InputMaybe<Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  deliveryOrder?: InputMaybe<Order_By>;
  finishedOn?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratoryCode?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  retrievedOn?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
  tubeCode?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_test" */
export type Order_Test_Mutation_Response = {
  __typename?: 'order_test_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Test>;
};

/** input type for inserting object relation for remote table "order_test" */
export type Order_Test_Obj_Rel_Insert_Input = {
  data: Order_Test_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Test_On_Conflict>;
};

/** on_conflict condition type for table "order_test" */
export type Order_Test_On_Conflict = {
  constraint: Order_Test_Constraint;
  update_columns?: Array<Order_Test_Update_Column>;
  where?: InputMaybe<Order_Test_Bool_Exp>;
};

/** Ordering options when selecting data from "order_test". */
export type Order_Test_Order_By = {
  collectedOn?: InputMaybe<Order_By>;
  collectionPoint?: InputMaybe<Laboratory_Collection_Point_Order_By>;
  collectionPointId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  deliveryOrder?: InputMaybe<Order_By>;
  finishedOn?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity?: InputMaybe<Order_By>;
  laboratoryCode?: InputMaybe<Order_By>;
  laboratoryTest_aggregate?: InputMaybe<Laboratory_Test_Aggregate_Order_By>;
  laboratory_aggregate?: InputMaybe<Laboratory_Aggregate_Order_By>;
  lastName?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderId?: InputMaybe<Order_By>;
  retrievedOn?: InputMaybe<Order_By>;
  test?: InputMaybe<Test_Order_By>;
  testId?: InputMaybe<Order_By>;
  testResultsCount?: InputMaybe<Order_By>;
  testResults_aggregate?: InputMaybe<Order_Test_Result_Aggregate_Order_By>;
  tubeCode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_test */
export type Order_Test_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Order_Test_Prepend_Input = {
  identity?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "order_test_result" */
export type Order_Test_Result = {
  __typename?: 'order_test_result';
  criticalParameter: Scalars['Boolean'];
  date?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  file: File;
  fileId: Scalars['Int'];
  /** An object relationship */
  orderTest: Order_Test;
  orderTestId: Scalars['Int'];
  originalFilename: Scalars['String'];
};

/** aggregated selection of "order_test_result" */
export type Order_Test_Result_Aggregate = {
  __typename?: 'order_test_result_aggregate';
  aggregate?: Maybe<Order_Test_Result_Aggregate_Fields>;
  nodes: Array<Order_Test_Result>;
};

export type Order_Test_Result_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Order_Test_Result_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Order_Test_Result_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Order_Test_Result_Aggregate_Bool_Exp_Count>;
};

export type Order_Test_Result_Aggregate_Bool_Exp_Bool_And = {
  arguments: Order_Test_Result_Select_Column_Order_Test_Result_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Test_Result_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Test_Result_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Order_Test_Result_Select_Column_Order_Test_Result_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Test_Result_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Test_Result_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Test_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Test_Result_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_test_result" */
export type Order_Test_Result_Aggregate_Fields = {
  __typename?: 'order_test_result_aggregate_fields';
  avg?: Maybe<Order_Test_Result_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Test_Result_Max_Fields>;
  min?: Maybe<Order_Test_Result_Min_Fields>;
  stddev?: Maybe<Order_Test_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Test_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Test_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Test_Result_Sum_Fields>;
  var_pop?: Maybe<Order_Test_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Test_Result_Var_Samp_Fields>;
  variance?: Maybe<Order_Test_Result_Variance_Fields>;
};


/** aggregate fields of "order_test_result" */
export type Order_Test_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Test_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_test_result" */
export type Order_Test_Result_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Test_Result_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Test_Result_Max_Order_By>;
  min?: InputMaybe<Order_Test_Result_Min_Order_By>;
  stddev?: InputMaybe<Order_Test_Result_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Test_Result_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Test_Result_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Test_Result_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Test_Result_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Test_Result_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Test_Result_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order_test_result" */
export type Order_Test_Result_Arr_Rel_Insert_Input = {
  data: Array<Order_Test_Result_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Test_Result_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Test_Result_Avg_Fields = {
  __typename?: 'order_test_result_avg_fields';
  fileId?: Maybe<Scalars['Float']>;
  orderTestId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_test_result" */
export type Order_Test_Result_Avg_Order_By = {
  fileId?: InputMaybe<Order_By>;
  orderTestId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_test_result". All fields are combined with a logical 'AND'. */
export type Order_Test_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Test_Result_Bool_Exp>>;
  _not?: InputMaybe<Order_Test_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Test_Result_Bool_Exp>>;
  criticalParameter?: InputMaybe<Boolean_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  fileId?: InputMaybe<Int_Comparison_Exp>;
  orderTest?: InputMaybe<Order_Test_Bool_Exp>;
  orderTestId?: InputMaybe<Int_Comparison_Exp>;
  originalFilename?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_test_result" */
export enum Order_Test_Result_Constraint {
  /** unique or primary key constraint on columns "order_test_id", "file_id" */
  OrderTestResultPkey = 'order_test_result_pkey'
}

/** input type for inserting data into table "order_test_result" */
export type Order_Test_Result_Insert_Input = {
  criticalParameter?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  file?: InputMaybe<File_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['Int']>;
  orderTest?: InputMaybe<Order_Test_Obj_Rel_Insert_Input>;
  orderTestId?: InputMaybe<Scalars['Int']>;
  originalFilename?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Order_Test_Result_Max_Fields = {
  __typename?: 'order_test_result_max_fields';
  date?: Maybe<Scalars['timestamptz']>;
  fileId?: Maybe<Scalars['Int']>;
  orderTestId?: Maybe<Scalars['Int']>;
  originalFilename?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "order_test_result" */
export type Order_Test_Result_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  orderTestId?: InputMaybe<Order_By>;
  originalFilename?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Test_Result_Min_Fields = {
  __typename?: 'order_test_result_min_fields';
  date?: Maybe<Scalars['timestamptz']>;
  fileId?: Maybe<Scalars['Int']>;
  orderTestId?: Maybe<Scalars['Int']>;
  originalFilename?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "order_test_result" */
export type Order_Test_Result_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  orderTestId?: InputMaybe<Order_By>;
  originalFilename?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_test_result" */
export type Order_Test_Result_Mutation_Response = {
  __typename?: 'order_test_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Test_Result>;
};

/** on_conflict condition type for table "order_test_result" */
export type Order_Test_Result_On_Conflict = {
  constraint: Order_Test_Result_Constraint;
  update_columns?: Array<Order_Test_Result_Update_Column>;
  where?: InputMaybe<Order_Test_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "order_test_result". */
export type Order_Test_Result_Order_By = {
  criticalParameter?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  fileId?: InputMaybe<Order_By>;
  orderTest?: InputMaybe<Order_Test_Order_By>;
  orderTestId?: InputMaybe<Order_By>;
  originalFilename?: InputMaybe<Order_By>;
};

/** select columns of table "order_test_result" */
export enum Order_Test_Result_Select_Column {
  /** column name */
  CriticalParameter = 'criticalParameter',
  /** column name */
  Date = 'date',
  /** column name */
  FileId = 'fileId',
  /** column name */
  OrderTestId = 'orderTestId',
  /** column name */
  OriginalFilename = 'originalFilename'
}

/** select "order_test_result_aggregate_bool_exp_bool_and_arguments_columns" columns of table "order_test_result" */
export enum Order_Test_Result_Select_Column_Order_Test_Result_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CriticalParameter = 'criticalParameter'
}

/** select "order_test_result_aggregate_bool_exp_bool_or_arguments_columns" columns of table "order_test_result" */
export enum Order_Test_Result_Select_Column_Order_Test_Result_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CriticalParameter = 'criticalParameter'
}

/** aggregate stddev on columns */
export type Order_Test_Result_Stddev_Fields = {
  __typename?: 'order_test_result_stddev_fields';
  fileId?: Maybe<Scalars['Float']>;
  orderTestId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_test_result" */
export type Order_Test_Result_Stddev_Order_By = {
  fileId?: InputMaybe<Order_By>;
  orderTestId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Test_Result_Stddev_Pop_Fields = {
  __typename?: 'order_test_result_stddev_pop_fields';
  fileId?: Maybe<Scalars['Float']>;
  orderTestId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_test_result" */
export type Order_Test_Result_Stddev_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  orderTestId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Test_Result_Stddev_Samp_Fields = {
  __typename?: 'order_test_result_stddev_samp_fields';
  fileId?: Maybe<Scalars['Float']>;
  orderTestId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_test_result" */
export type Order_Test_Result_Stddev_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  orderTestId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_test_result" */
export type Order_Test_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Test_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Test_Result_Stream_Cursor_Value_Input = {
  criticalParameter?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  fileId?: InputMaybe<Scalars['Int']>;
  orderTestId?: InputMaybe<Scalars['Int']>;
  originalFilename?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Order_Test_Result_Sum_Fields = {
  __typename?: 'order_test_result_sum_fields';
  fileId?: Maybe<Scalars['Int']>;
  orderTestId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_test_result" */
export type Order_Test_Result_Sum_Order_By = {
  fileId?: InputMaybe<Order_By>;
  orderTestId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "order_test_result" (current role has no relevant permissions) */
export enum Order_Test_Result_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type Order_Test_Result_Var_Pop_Fields = {
  __typename?: 'order_test_result_var_pop_fields';
  fileId?: Maybe<Scalars['Float']>;
  orderTestId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_test_result" */
export type Order_Test_Result_Var_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  orderTestId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Test_Result_Var_Samp_Fields = {
  __typename?: 'order_test_result_var_samp_fields';
  fileId?: Maybe<Scalars['Float']>;
  orderTestId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_test_result" */
export type Order_Test_Result_Var_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  orderTestId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Test_Result_Variance_Fields = {
  __typename?: 'order_test_result_variance_fields';
  fileId?: Maybe<Scalars['Float']>;
  orderTestId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_test_result" */
export type Order_Test_Result_Variance_Order_By = {
  fileId?: InputMaybe<Order_By>;
  orderTestId?: InputMaybe<Order_By>;
};

/** select columns of table "order_test" */
export enum Order_Test_Select_Column {
  /** column name */
  CollectedOn = 'collectedOn',
  /** column name */
  CollectionPointId = 'collectionPointId',
  /** column name */
  Cost = 'cost',
  /** column name */
  CostBeforeDiscount = 'costBeforeDiscount',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DeliveryOrder = 'deliveryOrder',
  /** column name */
  FinishedOn = 'finishedOn',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  Identity = 'identity',
  /** column name */
  LaboratoryCode = 'laboratoryCode',
  /** column name */
  LastName = 'lastName',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  RetrievedOn = 'retrievedOn',
  /** column name */
  TestId = 'testId',
  /** column name */
  TubeCode = 'tubeCode'
}

/** input type for updating data in table "order_test" */
export type Order_Test_Set_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  finishedOn?: InputMaybe<Scalars['timestamptz']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender_Enum>;
  id?: InputMaybe<Scalars['Int']>;
  identity?: InputMaybe<Scalars['jsonb']>;
  lastName?: InputMaybe<Scalars['String']>;
  retrievedOn?: InputMaybe<Scalars['timestamptz']>;
  tubeCode?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "order_test" */
export type Order_Test_Stddev_Order_By = {
  collectionPointId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deliveryOrder?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_test" */
export type Order_Test_Stddev_Pop_Order_By = {
  collectionPointId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deliveryOrder?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_test" */
export type Order_Test_Stddev_Samp_Order_By = {
  collectionPointId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deliveryOrder?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_test" */
export type Order_Test_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Test_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Test_Stream_Cursor_Value_Input = {
  collectedOn?: InputMaybe<Scalars['timestamptz']>;
  collectionPointId?: InputMaybe<Scalars['Int']>;
  cost?: InputMaybe<Scalars['numeric']>;
  costBeforeDiscount?: InputMaybe<Scalars['numeric']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  deliveryOrder?: InputMaybe<Scalars['Int']>;
  finishedOn?: InputMaybe<Scalars['timestamptz']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender_Enum>;
  id?: InputMaybe<Scalars['Int']>;
  identity?: InputMaybe<Scalars['jsonb']>;
  laboratoryCode?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['Int']>;
  retrievedOn?: InputMaybe<Scalars['timestamptz']>;
  testId?: InputMaybe<Scalars['Int']>;
  tubeCode?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "order_test" */
export type Order_Test_Sum_Order_By = {
  collectionPointId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deliveryOrder?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** update columns of table "order_test" */
export enum Order_Test_Update_Column {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  FinishedOn = 'finishedOn',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  Identity = 'identity',
  /** column name */
  LastName = 'lastName',
  /** column name */
  RetrievedOn = 'retrievedOn',
  /** column name */
  TubeCode = 'tubeCode'
}

export type Order_Test_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Order_Test_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Order_Test_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Order_Test_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Order_Test_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Test_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Order_Test_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Test_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Test_Bool_Exp;
};

/** order by var_pop() on columns of table "order_test" */
export type Order_Test_Var_Pop_Order_By = {
  collectionPointId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deliveryOrder?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_test" */
export type Order_Test_Var_Samp_Order_By = {
  collectionPointId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deliveryOrder?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_test" */
export type Order_Test_Variance_Order_By = {
  collectionPointId?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deliveryOrder?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_training" */
export type Order_Training = {
  __typename?: 'order_training';
  cost: Scalars['numeric'];
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  /** An object relationship */
  order: Order;
  orderId: Scalars['Int'];
  /** An object relationship */
  training: Training;
  trainingId: Scalars['Int'];
};

/** aggregated selection of "order_training" */
export type Order_Training_Aggregate = {
  __typename?: 'order_training_aggregate';
  aggregate?: Maybe<Order_Training_Aggregate_Fields>;
  nodes: Array<Order_Training>;
};

export type Order_Training_Aggregate_Bool_Exp = {
  count?: InputMaybe<Order_Training_Aggregate_Bool_Exp_Count>;
};

export type Order_Training_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Training_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Training_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_training" */
export type Order_Training_Aggregate_Fields = {
  __typename?: 'order_training_aggregate_fields';
  avg?: Maybe<Order_Training_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Training_Max_Fields>;
  min?: Maybe<Order_Training_Min_Fields>;
  stddev?: Maybe<Order_Training_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Training_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Training_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Training_Sum_Fields>;
  var_pop?: Maybe<Order_Training_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Training_Var_Samp_Fields>;
  variance?: Maybe<Order_Training_Variance_Fields>;
};


/** aggregate fields of "order_training" */
export type Order_Training_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Training_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_training" */
export type Order_Training_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Training_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Training_Max_Order_By>;
  min?: InputMaybe<Order_Training_Min_Order_By>;
  stddev?: InputMaybe<Order_Training_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Training_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Training_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Training_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Training_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Training_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Training_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Order_Training_Avg_Fields = {
  __typename?: 'order_training_avg_fields';
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_training" */
export type Order_Training_Avg_Order_By = {
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_training". All fields are combined with a logical 'AND'. */
export type Order_Training_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Training_Bool_Exp>>;
  _not?: InputMaybe<Order_Training_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Training_Bool_Exp>>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  costBeforeDiscount?: InputMaybe<Numeric_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderId?: InputMaybe<Int_Comparison_Exp>;
  training?: InputMaybe<Training_Bool_Exp>;
  trainingId?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Order_Training_Max_Fields = {
  __typename?: 'order_training_max_fields';
  cost?: Maybe<Scalars['numeric']>;
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['Int']>;
  trainingId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "order_training" */
export type Order_Training_Max_Order_By = {
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Training_Min_Fields = {
  __typename?: 'order_training_min_fields';
  cost?: Maybe<Scalars['numeric']>;
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['Int']>;
  trainingId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "order_training" */
export type Order_Training_Min_Order_By = {
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_training" */
export type Order_Training_Mutation_Response = {
  __typename?: 'order_training_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Training>;
};

/** Ordering options when selecting data from "order_training". */
export type Order_Training_Order_By = {
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderId?: InputMaybe<Order_By>;
  training?: InputMaybe<Training_Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_training */
export type Order_Training_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "order_training" */
export enum Order_Training_Select_Column {
  /** column name */
  Cost = 'cost',
  /** column name */
  CostBeforeDiscount = 'costBeforeDiscount',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  TrainingId = 'trainingId'
}

/** input type for updating data in table "order_training" */
export type Order_Training_Set_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Order_Training_Stddev_Fields = {
  __typename?: 'order_training_stddev_fields';
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_training" */
export type Order_Training_Stddev_Order_By = {
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Training_Stddev_Pop_Fields = {
  __typename?: 'order_training_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_training" */
export type Order_Training_Stddev_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Training_Stddev_Samp_Fields = {
  __typename?: 'order_training_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_training" */
export type Order_Training_Stddev_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_training" */
export type Order_Training_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Training_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Training_Stream_Cursor_Value_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  costBeforeDiscount?: InputMaybe<Scalars['numeric']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['Int']>;
  trainingId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Order_Training_Sum_Fields = {
  __typename?: 'order_training_sum_fields';
  cost?: Maybe<Scalars['numeric']>;
  costBeforeDiscount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['Int']>;
  trainingId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_training" */
export type Order_Training_Sum_Order_By = {
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

export type Order_Training_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Training_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Training_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Training_Var_Pop_Fields = {
  __typename?: 'order_training_var_pop_fields';
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_training" */
export type Order_Training_Var_Pop_Order_By = {
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Training_Var_Samp_Fields = {
  __typename?: 'order_training_var_samp_fields';
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_training" */
export type Order_Training_Var_Samp_Order_By = {
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Training_Variance_Fields = {
  __typename?: 'order_training_variance_fields';
  cost?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['Float']>;
  trainingId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_training" */
export type Order_Training_Variance_Order_By = {
  cost?: InputMaybe<Order_By>;
  costBeforeDiscount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  trainingId?: InputMaybe<Order_By>;
};

/** update columns of table "order" */
export enum Order_Update_Column {
  /** column name */
  CostBeforeDiscount = 'costBeforeDiscount',
  /** column name */
  NurseId = 'nurseId',
  /** column name */
  TotalCost = 'totalCost'
}

export type Order_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Var_Pop_Fields = {
  __typename?: 'order_var_pop_fields';
  clientId?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Order_Var_Samp_Fields = {
  __typename?: 'order_var_samp_fields';
  clientId?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Order_Variance_Fields = {
  __typename?: 'order_variance_fields';
  clientId?: Maybe<Scalars['Float']>;
  costBeforeDiscount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "push_notification" */
export type Push_Notification = {
  __typename?: 'push_notification';
  content_i18n: Scalars['jsonb'];
  heading_i18n: Scalars['jsonb'];
  id: Scalars['Int'];
  notificationId?: Maybe<Scalars['String']>;
  /** An array relationship */
  pushNotificationClients: Array<Push_Notification_Client>;
  /** An aggregate relationship */
  pushNotificationClients_aggregate: Push_Notification_Client_Aggregate;
  response?: Maybe<Scalars['jsonb']>;
  url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "push_notification" */
export type Push_NotificationContent_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "push_notification" */
export type Push_NotificationHeading_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "push_notification" */
export type Push_NotificationPushNotificationClientsArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Push_Notification_Client_Order_By>>;
  where?: InputMaybe<Push_Notification_Client_Bool_Exp>;
};


/** columns and relationships of "push_notification" */
export type Push_NotificationPushNotificationClients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Push_Notification_Client_Order_By>>;
  where?: InputMaybe<Push_Notification_Client_Bool_Exp>;
};


/** columns and relationships of "push_notification" */
export type Push_NotificationResponseArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "push_notification" */
export type Push_Notification_Aggregate = {
  __typename?: 'push_notification_aggregate';
  aggregate?: Maybe<Push_Notification_Aggregate_Fields>;
  nodes: Array<Push_Notification>;
};

/** aggregate fields of "push_notification" */
export type Push_Notification_Aggregate_Fields = {
  __typename?: 'push_notification_aggregate_fields';
  avg?: Maybe<Push_Notification_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Push_Notification_Max_Fields>;
  min?: Maybe<Push_Notification_Min_Fields>;
  stddev?: Maybe<Push_Notification_Stddev_Fields>;
  stddev_pop?: Maybe<Push_Notification_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Push_Notification_Stddev_Samp_Fields>;
  sum?: Maybe<Push_Notification_Sum_Fields>;
  var_pop?: Maybe<Push_Notification_Var_Pop_Fields>;
  var_samp?: Maybe<Push_Notification_Var_Samp_Fields>;
  variance?: Maybe<Push_Notification_Variance_Fields>;
};


/** aggregate fields of "push_notification" */
export type Push_Notification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Push_Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Push_Notification_Avg_Fields = {
  __typename?: 'push_notification_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "push_notification". All fields are combined with a logical 'AND'. */
export type Push_Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Push_Notification_Bool_Exp>>;
  _not?: InputMaybe<Push_Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Push_Notification_Bool_Exp>>;
  content_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  heading_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  notificationId?: InputMaybe<String_Comparison_Exp>;
  pushNotificationClients?: InputMaybe<Push_Notification_Client_Bool_Exp>;
  pushNotificationClients_aggregate?: InputMaybe<Push_Notification_Client_Aggregate_Bool_Exp>;
  response?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "push_notification_client" */
export type Push_Notification_Client = {
  __typename?: 'push_notification_client';
  /** An object relationship */
  client: Client;
  clientId: Scalars['Int'];
  /** An object relationship */
  pushNotification: Push_Notification;
  pushNotificationId: Scalars['Int'];
};

/** aggregated selection of "push_notification_client" */
export type Push_Notification_Client_Aggregate = {
  __typename?: 'push_notification_client_aggregate';
  aggregate?: Maybe<Push_Notification_Client_Aggregate_Fields>;
  nodes: Array<Push_Notification_Client>;
};

export type Push_Notification_Client_Aggregate_Bool_Exp = {
  count?: InputMaybe<Push_Notification_Client_Aggregate_Bool_Exp_Count>;
};

export type Push_Notification_Client_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Push_Notification_Client_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Push_Notification_Client_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "push_notification_client" */
export type Push_Notification_Client_Aggregate_Fields = {
  __typename?: 'push_notification_client_aggregate_fields';
  avg?: Maybe<Push_Notification_Client_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Push_Notification_Client_Max_Fields>;
  min?: Maybe<Push_Notification_Client_Min_Fields>;
  stddev?: Maybe<Push_Notification_Client_Stddev_Fields>;
  stddev_pop?: Maybe<Push_Notification_Client_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Push_Notification_Client_Stddev_Samp_Fields>;
  sum?: Maybe<Push_Notification_Client_Sum_Fields>;
  var_pop?: Maybe<Push_Notification_Client_Var_Pop_Fields>;
  var_samp?: Maybe<Push_Notification_Client_Var_Samp_Fields>;
  variance?: Maybe<Push_Notification_Client_Variance_Fields>;
};


/** aggregate fields of "push_notification_client" */
export type Push_Notification_Client_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Push_Notification_Client_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "push_notification_client" */
export type Push_Notification_Client_Aggregate_Order_By = {
  avg?: InputMaybe<Push_Notification_Client_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Push_Notification_Client_Max_Order_By>;
  min?: InputMaybe<Push_Notification_Client_Min_Order_By>;
  stddev?: InputMaybe<Push_Notification_Client_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Push_Notification_Client_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Push_Notification_Client_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Push_Notification_Client_Sum_Order_By>;
  var_pop?: InputMaybe<Push_Notification_Client_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Push_Notification_Client_Var_Samp_Order_By>;
  variance?: InputMaybe<Push_Notification_Client_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "push_notification_client" */
export type Push_Notification_Client_Arr_Rel_Insert_Input = {
  data: Array<Push_Notification_Client_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Push_Notification_Client_On_Conflict>;
};

/** aggregate avg on columns */
export type Push_Notification_Client_Avg_Fields = {
  __typename?: 'push_notification_client_avg_fields';
  clientId?: Maybe<Scalars['Float']>;
  pushNotificationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "push_notification_client" */
export type Push_Notification_Client_Avg_Order_By = {
  clientId?: InputMaybe<Order_By>;
  pushNotificationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "push_notification_client". All fields are combined with a logical 'AND'. */
export type Push_Notification_Client_Bool_Exp = {
  _and?: InputMaybe<Array<Push_Notification_Client_Bool_Exp>>;
  _not?: InputMaybe<Push_Notification_Client_Bool_Exp>;
  _or?: InputMaybe<Array<Push_Notification_Client_Bool_Exp>>;
  client?: InputMaybe<Client_Bool_Exp>;
  clientId?: InputMaybe<Int_Comparison_Exp>;
  pushNotification?: InputMaybe<Push_Notification_Bool_Exp>;
  pushNotificationId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "push_notification_client" */
export enum Push_Notification_Client_Constraint {
  /** unique or primary key constraint on columns "push_notification_id", "client_id" */
  PushNotificationClientPkey = 'push_notification_client_pkey'
}

/** input type for inserting data into table "push_notification_client" */
export type Push_Notification_Client_Insert_Input = {
  client?: InputMaybe<Client_Obj_Rel_Insert_Input>;
  clientId?: InputMaybe<Scalars['Int']>;
  pushNotification?: InputMaybe<Push_Notification_Obj_Rel_Insert_Input>;
  pushNotificationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Push_Notification_Client_Max_Fields = {
  __typename?: 'push_notification_client_max_fields';
  clientId?: Maybe<Scalars['Int']>;
  pushNotificationId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "push_notification_client" */
export type Push_Notification_Client_Max_Order_By = {
  clientId?: InputMaybe<Order_By>;
  pushNotificationId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Push_Notification_Client_Min_Fields = {
  __typename?: 'push_notification_client_min_fields';
  clientId?: Maybe<Scalars['Int']>;
  pushNotificationId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "push_notification_client" */
export type Push_Notification_Client_Min_Order_By = {
  clientId?: InputMaybe<Order_By>;
  pushNotificationId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "push_notification_client" */
export type Push_Notification_Client_Mutation_Response = {
  __typename?: 'push_notification_client_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Push_Notification_Client>;
};

/** on_conflict condition type for table "push_notification_client" */
export type Push_Notification_Client_On_Conflict = {
  constraint: Push_Notification_Client_Constraint;
  update_columns?: Array<Push_Notification_Client_Update_Column>;
  where?: InputMaybe<Push_Notification_Client_Bool_Exp>;
};

/** Ordering options when selecting data from "push_notification_client". */
export type Push_Notification_Client_Order_By = {
  client?: InputMaybe<Client_Order_By>;
  clientId?: InputMaybe<Order_By>;
  pushNotification?: InputMaybe<Push_Notification_Order_By>;
  pushNotificationId?: InputMaybe<Order_By>;
};

/** select columns of table "push_notification_client" */
export enum Push_Notification_Client_Select_Column {
  /** column name */
  ClientId = 'clientId',
  /** column name */
  PushNotificationId = 'pushNotificationId'
}

/** aggregate stddev on columns */
export type Push_Notification_Client_Stddev_Fields = {
  __typename?: 'push_notification_client_stddev_fields';
  clientId?: Maybe<Scalars['Float']>;
  pushNotificationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "push_notification_client" */
export type Push_Notification_Client_Stddev_Order_By = {
  clientId?: InputMaybe<Order_By>;
  pushNotificationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Push_Notification_Client_Stddev_Pop_Fields = {
  __typename?: 'push_notification_client_stddev_pop_fields';
  clientId?: Maybe<Scalars['Float']>;
  pushNotificationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "push_notification_client" */
export type Push_Notification_Client_Stddev_Pop_Order_By = {
  clientId?: InputMaybe<Order_By>;
  pushNotificationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Push_Notification_Client_Stddev_Samp_Fields = {
  __typename?: 'push_notification_client_stddev_samp_fields';
  clientId?: Maybe<Scalars['Float']>;
  pushNotificationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "push_notification_client" */
export type Push_Notification_Client_Stddev_Samp_Order_By = {
  clientId?: InputMaybe<Order_By>;
  pushNotificationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "push_notification_client" */
export type Push_Notification_Client_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Push_Notification_Client_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Push_Notification_Client_Stream_Cursor_Value_Input = {
  clientId?: InputMaybe<Scalars['Int']>;
  pushNotificationId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Push_Notification_Client_Sum_Fields = {
  __typename?: 'push_notification_client_sum_fields';
  clientId?: Maybe<Scalars['Int']>;
  pushNotificationId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "push_notification_client" */
export type Push_Notification_Client_Sum_Order_By = {
  clientId?: InputMaybe<Order_By>;
  pushNotificationId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "push_notification_client" (current role has no relevant permissions) */
export enum Push_Notification_Client_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type Push_Notification_Client_Var_Pop_Fields = {
  __typename?: 'push_notification_client_var_pop_fields';
  clientId?: Maybe<Scalars['Float']>;
  pushNotificationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "push_notification_client" */
export type Push_Notification_Client_Var_Pop_Order_By = {
  clientId?: InputMaybe<Order_By>;
  pushNotificationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Push_Notification_Client_Var_Samp_Fields = {
  __typename?: 'push_notification_client_var_samp_fields';
  clientId?: Maybe<Scalars['Float']>;
  pushNotificationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "push_notification_client" */
export type Push_Notification_Client_Var_Samp_Order_By = {
  clientId?: InputMaybe<Order_By>;
  pushNotificationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Push_Notification_Client_Variance_Fields = {
  __typename?: 'push_notification_client_variance_fields';
  clientId?: Maybe<Scalars['Float']>;
  pushNotificationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "push_notification_client" */
export type Push_Notification_Client_Variance_Order_By = {
  clientId?: InputMaybe<Order_By>;
  pushNotificationId?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "push_notification" */
export enum Push_Notification_Constraint {
  /** unique or primary key constraint on columns "notification_id" */
  PushNotificationNotificationIdKey = 'push_notification_notification_id_key',
  /** unique or primary key constraint on columns "id" */
  PushNotificationPkey = 'push_notification_pkey'
}

/** input type for inserting data into table "push_notification" */
export type Push_Notification_Insert_Input = {
  content_i18n?: InputMaybe<Scalars['jsonb']>;
  heading_i18n?: InputMaybe<Scalars['jsonb']>;
  pushNotificationClients?: InputMaybe<Push_Notification_Client_Arr_Rel_Insert_Input>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Push_Notification_Max_Fields = {
  __typename?: 'push_notification_max_fields';
  id?: Maybe<Scalars['Int']>;
  notificationId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Push_Notification_Min_Fields = {
  __typename?: 'push_notification_min_fields';
  id?: Maybe<Scalars['Int']>;
  notificationId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "push_notification" */
export type Push_Notification_Mutation_Response = {
  __typename?: 'push_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Push_Notification>;
};

/** input type for inserting object relation for remote table "push_notification" */
export type Push_Notification_Obj_Rel_Insert_Input = {
  data: Push_Notification_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Push_Notification_On_Conflict>;
};

/** on_conflict condition type for table "push_notification" */
export type Push_Notification_On_Conflict = {
  constraint: Push_Notification_Constraint;
  update_columns?: Array<Push_Notification_Update_Column>;
  where?: InputMaybe<Push_Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "push_notification". */
export type Push_Notification_Order_By = {
  content_i18n?: InputMaybe<Order_By>;
  heading_i18n?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationId?: InputMaybe<Order_By>;
  pushNotificationClients_aggregate?: InputMaybe<Push_Notification_Client_Aggregate_Order_By>;
  response?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** select columns of table "push_notification" */
export enum Push_Notification_Select_Column {
  /** column name */
  ContentI18n = 'content_i18n',
  /** column name */
  HeadingI18n = 'heading_i18n',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notificationId',
  /** column name */
  Response = 'response',
  /** column name */
  Url = 'url'
}

/** aggregate stddev on columns */
export type Push_Notification_Stddev_Fields = {
  __typename?: 'push_notification_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Push_Notification_Stddev_Pop_Fields = {
  __typename?: 'push_notification_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Push_Notification_Stddev_Samp_Fields = {
  __typename?: 'push_notification_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "push_notification" */
export type Push_Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Push_Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Push_Notification_Stream_Cursor_Value_Input = {
  content_i18n?: InputMaybe<Scalars['jsonb']>;
  heading_i18n?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  notificationId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Scalars['jsonb']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Push_Notification_Sum_Fields = {
  __typename?: 'push_notification_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** placeholder for update columns of table "push_notification" (current role has no relevant permissions) */
export enum Push_Notification_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type Push_Notification_Var_Pop_Fields = {
  __typename?: 'push_notification_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Push_Notification_Var_Samp_Fields = {
  __typename?: 'push_notification_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Push_Notification_Variance_Fields = {
  __typename?: 'push_notification_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "administrator" */
  administrator: Array<Administrator>;
  /** fetch aggregated fields from the table: "administrator" */
  administrator_aggregate: Administrator_Aggregate;
  /** fetch data from the table: "administrator" using primary key columns */
  administrator_by_pk?: Maybe<Administrator>;
  administrator_logs: Array<AdministratorLog>;
  /** fetch data from the table: "administrator_notification" */
  administrator_notification: Array<Administrator_Notification>;
  /** fetch aggregated fields from the table: "administrator_notification" */
  administrator_notification_aggregate: Administrator_Notification_Aggregate;
  /** fetch data from the table: "administrator_notification" using primary key columns */
  administrator_notification_by_pk?: Maybe<Administrator_Notification>;
  administrator_order_shipment_label: AdministratorOrderShipmentLabelOutput;
  /** execute function "available_laboratory" which returns "laboratory" */
  available_laboratory: Array<Laboratory>;
  /** execute function "available_laboratory" and query aggregates on result of table type "laboratory" */
  available_laboratory_aggregate: Laboratory_Aggregate;
  /** execute function "available_shipping_test_tag" which returns "test_tag" */
  available_shipping_test_tag: Array<Test_Tag>;
  /** execute function "available_shipping_test_tag" and query aggregates on result of table type "test_tag" */
  available_shipping_test_tag_aggregate: Test_Tag_Aggregate;
  /** execute function "available_test_tag" which returns "test_tag" */
  available_test_tag: Array<Test_Tag>;
  /** execute function "available_test_tag" and query aggregates on result of table type "test_tag" */
  available_test_tag_aggregate: Test_Tag_Aggregate;
  /** fetch data from the table: "client" */
  client: Array<Client>;
  /** fetch aggregated fields from the table: "client" */
  client_aggregate: Client_Aggregate;
  /** fetch data from the table: "client" using primary key columns */
  client_by_pk?: Maybe<Client>;
  /** fetch data from the table: "client_favourite_test" */
  client_favourite_test: Array<Client_Favourite_Test>;
  /** fetch data from the table: "client_favourite_test" using primary key columns */
  client_favourite_test_by_pk?: Maybe<Client_Favourite_Test>;
  /** fetch data from the table: "client_profile" */
  client_profile: Array<Client_Profile>;
  /** fetch data from the table: "client_profile" using primary key columns */
  client_profile_by_pk?: Maybe<Client_Profile>;
  /** fetch data from the table: "collection_slot" */
  collection_slot: Array<Collection_Slot>;
  /** fetch aggregated fields from the table: "collection_slot" */
  collection_slot_aggregate: Collection_Slot_Aggregate;
  /** fetch data from the table: "collection_slot" using primary key columns */
  collection_slot_by_pk?: Maybe<Collection_Slot>;
  /** fetch data from the table: "consultation" */
  consultation: Array<Consultation>;
  /** fetch aggregated fields from the table: "consultation" */
  consultation_aggregate: Consultation_Aggregate;
  /** fetch data from the table: "consultation" using primary key columns */
  consultation_by_pk?: Maybe<Consultation>;
  /** fetch data from the table: "consultation_slot" */
  consultation_slot: Array<Consultation_Slot>;
  /** fetch aggregated fields from the table: "consultation_slot" */
  consultation_slot_aggregate: Consultation_Slot_Aggregate;
  /** fetch data from the table: "consultation_slot" using primary key columns */
  consultation_slot_by_pk?: Maybe<Consultation_Slot>;
  /** fetch data from the table: "discount" */
  discount: Array<Discount>;
  /** fetch aggregated fields from the table: "discount" */
  discount_aggregate: Discount_Aggregate;
  /** fetch data from the table: "discount" using primary key columns */
  discount_by_pk?: Maybe<Discount>;
  /** fetch data from the table: "discount_consultation" */
  discount_consultation: Array<Discount_Consultation>;
  /** fetch aggregated fields from the table: "discount_consultation" */
  discount_consultation_aggregate: Discount_Consultation_Aggregate;
  /** fetch data from the table: "discount_consultation" using primary key columns */
  discount_consultation_by_pk?: Maybe<Discount_Consultation>;
  /** fetch data from the table: "discount_test" */
  discount_test: Array<Discount_Test>;
  /** fetch aggregated fields from the table: "discount_test" */
  discount_test_aggregate: Discount_Test_Aggregate;
  /** fetch data from the table: "discount_test" using primary key columns */
  discount_test_by_pk?: Maybe<Discount_Test>;
  /** fetch data from the table: "discount_training" */
  discount_training: Array<Discount_Training>;
  /** fetch aggregated fields from the table: "discount_training" */
  discount_training_aggregate: Discount_Training_Aggregate;
  /** fetch data from the table: "discount_training" using primary key columns */
  discount_training_by_pk?: Maybe<Discount_Training>;
  /** fetch data from the table: "discount_type_enum" */
  discount_type_enum: Array<Discount_Type_Enum>;
  /** fetch data from the table: "discount_type_enum" using primary key columns */
  discount_type_enum_by_pk?: Maybe<Discount_Type_Enum>;
  /** fetch data from the table: "feature_flags" */
  feature_flags: Array<Feature_Flags>;
  /** fetch data from the table: "feature_flags" using primary key columns */
  feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk?: Maybe<File>;
  /** fetch data from the table: "gender" */
  gender: Array<Gender>;
  /** fetch data from the table: "gender" using primary key columns */
  gender_by_pk?: Maybe<Gender>;
  /** fetch data from the table: "lab_user" */
  lab_user: Array<Lab_User>;
  /** fetch aggregated fields from the table: "lab_user" */
  lab_user_aggregate: Lab_User_Aggregate;
  /** fetch data from the table: "lab_user" using primary key columns */
  lab_user_by_pk?: Maybe<Lab_User>;
  /** fetch data from the table: "laboratory" */
  laboratory: Array<Laboratory>;
  /** fetch aggregated fields from the table: "laboratory" */
  laboratory_aggregate: Laboratory_Aggregate;
  /** fetch data from the table: "laboratory" using primary key columns */
  laboratory_by_pk?: Maybe<Laboratory>;
  /** fetch data from the table: "laboratory_collection_point" */
  laboratory_collection_point: Array<Laboratory_Collection_Point>;
  /** fetch aggregated fields from the table: "laboratory_collection_point" */
  laboratory_collection_point_aggregate: Laboratory_Collection_Point_Aggregate;
  /** fetch data from the table: "laboratory_collection_point" using primary key columns */
  laboratory_collection_point_by_pk?: Maybe<Laboratory_Collection_Point>;
  /** fetch data from the table: "laboratory_shipping" */
  laboratory_shipping: Array<Laboratory_Shipping>;
  /** fetch data from the table: "laboratory_shipping" using primary key columns */
  laboratory_shipping_by_pk?: Maybe<Laboratory_Shipping>;
  /** fetch data from the table: "laboratory_summary" */
  laboratory_summary: Array<Laboratory_Summary>;
  /** fetch data from the table: "laboratory_test" */
  laboratory_test: Array<Laboratory_Test>;
  /** fetch aggregated fields from the table: "laboratory_test" */
  laboratory_test_aggregate: Laboratory_Test_Aggregate;
  /** fetch data from the table: "laboratory_test" using primary key columns */
  laboratory_test_by_pk?: Maybe<Laboratory_Test>;
  /** fetch data from the table: "material" */
  material: Array<Material>;
  /** fetch aggregated fields from the table: "material" */
  material_aggregate: Material_Aggregate;
  /** fetch data from the table: "material" using primary key columns */
  material_by_pk?: Maybe<Material>;
  /** execute function "nearby_unconfirmed_order" which returns "order" */
  nearby_unconfirmed_order: Array<Order>;
  /** execute function "nearby_unconfirmed_order" and query aggregates on result of table type "order" */
  nearby_unconfirmed_order_aggregate: Order_Aggregate;
  /** fetch data from the table: "nurse" */
  nurse: Array<Nurse>;
  /** fetch aggregated fields from the table: "nurse" */
  nurse_aggregate: Nurse_Aggregate;
  /** fetch data from the table: "nurse" using primary key columns */
  nurse_by_pk?: Maybe<Nurse>;
  /** fetch data from the table: "nurse_material" */
  nurse_material: Array<Nurse_Material>;
  /** fetch aggregated fields from the table: "nurse_material" */
  nurse_material_aggregate: Nurse_Material_Aggregate;
  /** fetch data from the table: "nurse_material" using primary key columns */
  nurse_material_by_pk?: Maybe<Nurse_Material>;
  /** fetch data from the table: "nurse_order_cost" */
  nurse_order_cost: Array<Nurse_Order_Cost>;
  /** fetch data from the table: "nurse_test" */
  nurse_test: Array<Nurse_Test>;
  /** fetch aggregated fields from the table: "nurse_test" */
  nurse_test_aggregate: Nurse_Test_Aggregate;
  /** fetch data from the table: "nurse_test" using primary key columns */
  nurse_test_by_pk?: Maybe<Nurse_Test>;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** fetch data from the table: "order_collection" */
  order_collection: Array<Order_Collection>;
  /** fetch aggregated fields from the table: "order_collection" */
  order_collection_aggregate: Order_Collection_Aggregate;
  /** fetch data from the table: "order_collection" using primary key columns */
  order_collection_by_pk?: Maybe<Order_Collection>;
  /** fetch data from the table: "order_consultation" */
  order_consultation: Array<Order_Consultation>;
  /** fetch aggregated fields from the table: "order_consultation" */
  order_consultation_aggregate: Order_Consultation_Aggregate;
  /** fetch data from the table: "order_consultation" using primary key columns */
  order_consultation_by_pk?: Maybe<Order_Consultation>;
  /** fetch data from the table: "order_discount" */
  order_discount: Array<Order_Discount>;
  /** fetch data from the table: "order_discount" using primary key columns */
  order_discount_by_pk?: Maybe<Order_Discount>;
  /** fetch data from the table: "order_document" */
  order_document: Array<Order_Document>;
  /** fetch aggregated fields from the table: "order_document" */
  order_document_aggregate: Order_Document_Aggregate;
  /** fetch data from the table: "order_document" using primary key columns */
  order_document_by_pk?: Maybe<Order_Document>;
  /** fetch data from the table: "order_shipping" */
  order_shipping: Array<Order_Shipping>;
  /** fetch data from the table: "order_shipping" using primary key columns */
  order_shipping_by_pk?: Maybe<Order_Shipping>;
  /** fetch data from the table: "order_state" */
  order_state: Array<Order_State>;
  /** fetch data from the table: "order_state" using primary key columns */
  order_state_by_pk?: Maybe<Order_State>;
  /** fetch data from the table: "order_test" */
  order_test: Array<Order_Test>;
  /** fetch data from the table: "order_test" using primary key columns */
  order_test_by_pk?: Maybe<Order_Test>;
  /** fetch data from the table: "order_test_result" */
  order_test_result: Array<Order_Test_Result>;
  /** fetch aggregated fields from the table: "order_test_result" */
  order_test_result_aggregate: Order_Test_Result_Aggregate;
  /** fetch data from the table: "order_test_result" using primary key columns */
  order_test_result_by_pk?: Maybe<Order_Test_Result>;
  /** fetch data from the table: "order_training" */
  order_training: Array<Order_Training>;
  /** fetch aggregated fields from the table: "order_training" */
  order_training_aggregate: Order_Training_Aggregate;
  /** fetch data from the table: "order_training" using primary key columns */
  order_training_by_pk?: Maybe<Order_Training>;
  /** fetch data from the table: "push_notification" */
  push_notification: Array<Push_Notification>;
  /** fetch aggregated fields from the table: "push_notification" */
  push_notification_aggregate: Push_Notification_Aggregate;
  /** fetch data from the table: "push_notification" using primary key columns */
  push_notification_by_pk?: Maybe<Push_Notification>;
  /** fetch data from the table: "push_notification_client" */
  push_notification_client: Array<Push_Notification_Client>;
  /** fetch aggregated fields from the table: "push_notification_client" */
  push_notification_client_aggregate: Push_Notification_Client_Aggregate;
  /** fetch data from the table: "push_notification_client" using primary key columns */
  push_notification_client_by_pk?: Maybe<Push_Notification_Client>;
  /** fetch data from the table: "rate" */
  rate: Array<Rate>;
  /** fetch aggregated fields from the table: "rate" */
  rate_aggregate: Rate_Aggregate;
  /** fetch data from the table: "rate" using primary key columns */
  rate_by_pk?: Maybe<Rate>;
  /** execute function "search_consultation" which returns "consultation" */
  search_consultation: Array<Consultation>;
  /** execute function "search_consultation" and query aggregates on result of table type "consultation" */
  search_consultation_aggregate: Consultation_Aggregate;
  /** execute function "search_test" which returns "test" */
  search_test: Array<Test>;
  /** execute function "search_test" and query aggregates on result of table type "test" */
  search_test_aggregate: Test_Aggregate;
  /** execute function "search_test_most_popular" which returns "test" */
  search_test_most_popular: Array<Test>;
  /** execute function "search_test_most_popular" and query aggregates on result of table type "test" */
  search_test_most_popular_aggregate: Test_Aggregate;
  /** execute function "search_test_shipping" which returns "test" */
  search_test_shipping: Array<Test>;
  /** execute function "search_test_shipping" and query aggregates on result of table type "test" */
  search_test_shipping_aggregate: Test_Aggregate;
  /** execute function "search_test_shipping_tag" which returns "test" */
  search_test_shipping_tag: Array<Test>;
  /** execute function "search_test_shipping_tag" and query aggregates on result of table type "test" */
  search_test_shipping_tag_aggregate: Test_Aggregate;
  /** execute function "search_test_tag" which returns "test" */
  search_test_tag: Array<Test>;
  /** execute function "search_test_tag" and query aggregates on result of table type "test" */
  search_test_tag_aggregate: Test_Aggregate;
  /** execute function "search_training" which returns "training" */
  search_training: Array<Training>;
  /** execute function "search_training" and query aggregates on result of table type "training" */
  search_training_aggregate: Training_Aggregate;
  /** fetch data from the table: "shipping" */
  shipping: Array<Shipping>;
  /** fetch data from the table: "shipping" using primary key columns */
  shipping_by_pk?: Maybe<Shipping>;
  /** fetch data from the table: "tag" */
  tag: Array<Tag>;
  /** fetch aggregated fields from the table: "tag" */
  tag_aggregate: Tag_Aggregate;
  /** fetch data from the table: "tag" using primary key columns */
  tag_by_pk?: Maybe<Tag>;
  /** fetch data from the table: "test" */
  test: Array<Test>;
  /** fetch aggregated fields from the table: "test" */
  test_aggregate: Test_Aggregate;
  /** fetch data from the table: "test" using primary key columns */
  test_by_pk?: Maybe<Test>;
  /** execute function "test_laboratories" which returns "laboratory" */
  test_laboratories: Array<Laboratory>;
  /** execute function "test_laboratories" and query aggregates on result of table type "laboratory" */
  test_laboratories_aggregate: Laboratory_Aggregate;
  /** fetch data from the table: "test_material" */
  test_material: Array<Test_Material>;
  /** fetch aggregated fields from the table: "test_material" */
  test_material_aggregate: Test_Material_Aggregate;
  /** fetch data from the table: "test_material" using primary key columns */
  test_material_by_pk?: Maybe<Test_Material>;
  /** fetch data from the table: "test_tag" */
  test_tag: Array<Test_Tag>;
  /** fetch aggregated fields from the table: "test_tag" */
  test_tag_aggregate: Test_Tag_Aggregate;
  /** fetch data from the table: "test_tag" using primary key columns */
  test_tag_by_pk?: Maybe<Test_Tag>;
  /** execute function "tests_by_collection_point_and_nurse" which returns "test" */
  tests_by_collection_point_and_nurse: Array<Test>;
  /** execute function "tests_by_collection_point_and_nurse" and query aggregates on result of table type "test" */
  tests_by_collection_point_and_nurse_aggregate: Test_Aggregate;
  /** fetch data from the table: "training" */
  training: Array<Training>;
  /** fetch aggregated fields from the table: "training" */
  training_aggregate: Training_Aggregate;
  /** fetch data from the table: "training" using primary key columns */
  training_by_pk?: Maybe<Training>;
};


export type Query_RootAdministratorArgs = {
  distinct_on?: InputMaybe<Array<Administrator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Administrator_Order_By>>;
  where?: InputMaybe<Administrator_Bool_Exp>;
};


export type Query_RootAdministrator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Administrator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Administrator_Order_By>>;
  where?: InputMaybe<Administrator_Bool_Exp>;
};


export type Query_RootAdministrator_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAdministrator_LogsArgs = {
  from?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAdministrator_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Administrator_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Administrator_Notification_Order_By>>;
  where?: InputMaybe<Administrator_Notification_Bool_Exp>;
};


export type Query_RootAdministrator_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Administrator_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Administrator_Notification_Order_By>>;
  where?: InputMaybe<Administrator_Notification_Bool_Exp>;
};


export type Query_RootAdministrator_Notification_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAdministrator_Order_Shipment_LabelArgs = {
  shipmentId: Scalars['bigint'];
};


export type Query_RootAvailable_LaboratoryArgs = {
  args: Available_Laboratory_Args;
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Query_RootAvailable_Laboratory_AggregateArgs = {
  args: Available_Laboratory_Args;
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Query_RootAvailable_Shipping_Test_TagArgs = {
  args?: InputMaybe<Available_Shipping_Test_Tag_Args>;
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


export type Query_RootAvailable_Shipping_Test_Tag_AggregateArgs = {
  args?: InputMaybe<Available_Shipping_Test_Tag_Args>;
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


export type Query_RootAvailable_Test_TagArgs = {
  args: Available_Test_Tag_Args;
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


export type Query_RootAvailable_Test_Tag_AggregateArgs = {
  args: Available_Test_Tag_Args;
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


export type Query_RootClientArgs = {
  distinct_on?: InputMaybe<Array<Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Order_By>>;
  where?: InputMaybe<Client_Bool_Exp>;
};


export type Query_RootClient_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Order_By>>;
  where?: InputMaybe<Client_Bool_Exp>;
};


export type Query_RootClient_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootClient_Favourite_TestArgs = {
  distinct_on?: InputMaybe<Array<Client_Favourite_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Favourite_Test_Order_By>>;
  where?: InputMaybe<Client_Favourite_Test_Bool_Exp>;
};


export type Query_RootClient_Favourite_Test_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootClient_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Client_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Profile_Order_By>>;
  where?: InputMaybe<Client_Profile_Bool_Exp>;
};


export type Query_RootClient_Profile_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCollection_SlotArgs = {
  distinct_on?: InputMaybe<Array<Collection_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Slot_Order_By>>;
  where?: InputMaybe<Collection_Slot_Bool_Exp>;
};


export type Query_RootCollection_Slot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collection_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Slot_Order_By>>;
  where?: InputMaybe<Collection_Slot_Bool_Exp>;
};


export type Query_RootCollection_Slot_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootConsultationArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Order_By>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Query_RootConsultation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Order_By>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Query_RootConsultation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootConsultation_SlotArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Slot_Order_By>>;
  where?: InputMaybe<Consultation_Slot_Bool_Exp>;
};


export type Query_RootConsultation_Slot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Slot_Order_By>>;
  where?: InputMaybe<Consultation_Slot_Bool_Exp>;
};


export type Query_RootConsultation_Slot_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDiscountArgs = {
  distinct_on?: InputMaybe<Array<Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Order_By>>;
  where?: InputMaybe<Discount_Bool_Exp>;
};


export type Query_RootDiscount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Order_By>>;
  where?: InputMaybe<Discount_Bool_Exp>;
};


export type Query_RootDiscount_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDiscount_ConsultationArgs = {
  distinct_on?: InputMaybe<Array<Discount_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Consultation_Order_By>>;
  where?: InputMaybe<Discount_Consultation_Bool_Exp>;
};


export type Query_RootDiscount_Consultation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Consultation_Order_By>>;
  where?: InputMaybe<Discount_Consultation_Bool_Exp>;
};


export type Query_RootDiscount_Consultation_By_PkArgs = {
  consultationId: Scalars['Int'];
  discountId: Scalars['Int'];
};


export type Query_RootDiscount_TestArgs = {
  distinct_on?: InputMaybe<Array<Discount_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Test_Order_By>>;
  where?: InputMaybe<Discount_Test_Bool_Exp>;
};


export type Query_RootDiscount_Test_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Test_Order_By>>;
  where?: InputMaybe<Discount_Test_Bool_Exp>;
};


export type Query_RootDiscount_Test_By_PkArgs = {
  discountId: Scalars['Int'];
  testId: Scalars['Int'];
};


export type Query_RootDiscount_TrainingArgs = {
  distinct_on?: InputMaybe<Array<Discount_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Training_Order_By>>;
  where?: InputMaybe<Discount_Training_Bool_Exp>;
};


export type Query_RootDiscount_Training_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Training_Order_By>>;
  where?: InputMaybe<Discount_Training_Bool_Exp>;
};


export type Query_RootDiscount_Training_By_PkArgs = {
  discountId: Scalars['Int'];
  trainingId: Scalars['Int'];
};


export type Query_RootDiscount_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Discount_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Type_Enum_Order_By>>;
  where?: InputMaybe<Discount_Type_Enum_Bool_Exp>;
};


export type Query_RootDiscount_Type_Enum_By_PkArgs = {
  type: Scalars['String'];
};


export type Query_RootFeature_FlagsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Query_RootFeature_Flags_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootFileArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Query_RootFile_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGenderArgs = {
  distinct_on?: InputMaybe<Array<Gender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gender_Order_By>>;
  where?: InputMaybe<Gender_Bool_Exp>;
};


export type Query_RootGender_By_PkArgs = {
  gender: Scalars['String'];
};


export type Query_RootLab_UserArgs = {
  distinct_on?: InputMaybe<Array<Lab_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lab_User_Order_By>>;
  where?: InputMaybe<Lab_User_Bool_Exp>;
};


export type Query_RootLab_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lab_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lab_User_Order_By>>;
  where?: InputMaybe<Lab_User_Bool_Exp>;
};


export type Query_RootLab_User_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLaboratoryArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Query_RootLaboratory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Query_RootLaboratory_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLaboratory_Collection_PointArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Collection_Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Collection_Point_Order_By>>;
  where?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
};


export type Query_RootLaboratory_Collection_Point_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Collection_Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Collection_Point_Order_By>>;
  where?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
};


export type Query_RootLaboratory_Collection_Point_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLaboratory_ShippingArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Shipping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Shipping_Order_By>>;
  where?: InputMaybe<Laboratory_Shipping_Bool_Exp>;
};


export type Query_RootLaboratory_Shipping_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootLaboratory_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Summary_Order_By>>;
  where?: InputMaybe<Laboratory_Summary_Bool_Exp>;
};


export type Query_RootLaboratory_TestArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Test_Order_By>>;
  where?: InputMaybe<Laboratory_Test_Bool_Exp>;
};


export type Query_RootLaboratory_Test_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Test_Order_By>>;
  where?: InputMaybe<Laboratory_Test_Bool_Exp>;
};


export type Query_RootLaboratory_Test_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMaterialArgs = {
  distinct_on?: InputMaybe<Array<Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Material_Order_By>>;
  where?: InputMaybe<Material_Bool_Exp>;
};


export type Query_RootMaterial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Material_Order_By>>;
  where?: InputMaybe<Material_Bool_Exp>;
};


export type Query_RootMaterial_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootNearby_Unconfirmed_OrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootNearby_Unconfirmed_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootNurseArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Order_By>>;
  where?: InputMaybe<Nurse_Bool_Exp>;
};


export type Query_RootNurse_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Order_By>>;
  where?: InputMaybe<Nurse_Bool_Exp>;
};


export type Query_RootNurse_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootNurse_MaterialArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Material_Order_By>>;
  where?: InputMaybe<Nurse_Material_Bool_Exp>;
};


export type Query_RootNurse_Material_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Material_Order_By>>;
  where?: InputMaybe<Nurse_Material_Bool_Exp>;
};


export type Query_RootNurse_Material_By_PkArgs = {
  materialId: Scalars['Int'];
  nurseId: Scalars['Int'];
};


export type Query_RootNurse_Order_CostArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Order_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Order_Cost_Order_By>>;
  where?: InputMaybe<Nurse_Order_Cost_Bool_Exp>;
};


export type Query_RootNurse_TestArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Test_Order_By>>;
  where?: InputMaybe<Nurse_Test_Bool_Exp>;
};


export type Query_RootNurse_Test_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Test_Order_By>>;
  where?: InputMaybe<Nurse_Test_Bool_Exp>;
};


export type Query_RootNurse_Test_By_PkArgs = {
  nurseId: Scalars['Int'];
  testId: Scalars['Int'];
};


export type Query_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrder_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Order_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Collection_Order_By>>;
  where?: InputMaybe<Order_Collection_Bool_Exp>;
};


export type Query_RootOrder_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Collection_Order_By>>;
  where?: InputMaybe<Order_Collection_Bool_Exp>;
};


export type Query_RootOrder_Collection_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrder_ConsultationArgs = {
  distinct_on?: InputMaybe<Array<Order_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Consultation_Order_By>>;
  where?: InputMaybe<Order_Consultation_Bool_Exp>;
};


export type Query_RootOrder_Consultation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Consultation_Order_By>>;
  where?: InputMaybe<Order_Consultation_Bool_Exp>;
};


export type Query_RootOrder_Consultation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrder_DiscountArgs = {
  distinct_on?: InputMaybe<Array<Order_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Discount_Order_By>>;
  where?: InputMaybe<Order_Discount_Bool_Exp>;
};


export type Query_RootOrder_Discount_By_PkArgs = {
  discount_id: Scalars['Int'];
  order_id: Scalars['Int'];
};


export type Query_RootOrder_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Order_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Document_Order_By>>;
  where?: InputMaybe<Order_Document_Bool_Exp>;
};


export type Query_RootOrder_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Document_Order_By>>;
  where?: InputMaybe<Order_Document_Bool_Exp>;
};


export type Query_RootOrder_Document_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrder_ShippingArgs = {
  distinct_on?: InputMaybe<Array<Order_Shipping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Shipping_Order_By>>;
  where?: InputMaybe<Order_Shipping_Bool_Exp>;
};


export type Query_RootOrder_Shipping_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOrder_StateArgs = {
  distinct_on?: InputMaybe<Array<Order_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_State_Order_By>>;
  where?: InputMaybe<Order_State_Bool_Exp>;
};


export type Query_RootOrder_State_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrder_TestArgs = {
  distinct_on?: InputMaybe<Array<Order_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Test_Order_By>>;
  where?: InputMaybe<Order_Test_Bool_Exp>;
};


export type Query_RootOrder_Test_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrder_Test_ResultArgs = {
  distinct_on?: InputMaybe<Array<Order_Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Test_Result_Order_By>>;
  where?: InputMaybe<Order_Test_Result_Bool_Exp>;
};


export type Query_RootOrder_Test_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Test_Result_Order_By>>;
  where?: InputMaybe<Order_Test_Result_Bool_Exp>;
};


export type Query_RootOrder_Test_Result_By_PkArgs = {
  fileId: Scalars['Int'];
  orderTestId: Scalars['Int'];
};


export type Query_RootOrder_TrainingArgs = {
  distinct_on?: InputMaybe<Array<Order_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Training_Order_By>>;
  where?: InputMaybe<Order_Training_Bool_Exp>;
};


export type Query_RootOrder_Training_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Training_Order_By>>;
  where?: InputMaybe<Order_Training_Bool_Exp>;
};


export type Query_RootOrder_Training_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPush_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Push_Notification_Order_By>>;
  where?: InputMaybe<Push_Notification_Bool_Exp>;
};


export type Query_RootPush_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Push_Notification_Order_By>>;
  where?: InputMaybe<Push_Notification_Bool_Exp>;
};


export type Query_RootPush_Notification_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPush_Notification_ClientArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Push_Notification_Client_Order_By>>;
  where?: InputMaybe<Push_Notification_Client_Bool_Exp>;
};


export type Query_RootPush_Notification_Client_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Push_Notification_Client_Order_By>>;
  where?: InputMaybe<Push_Notification_Client_Bool_Exp>;
};


export type Query_RootPush_Notification_Client_By_PkArgs = {
  clientId: Scalars['Int'];
  pushNotificationId: Scalars['Int'];
};


export type Query_RootRateArgs = {
  distinct_on?: InputMaybe<Array<Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rate_Order_By>>;
  where?: InputMaybe<Rate_Bool_Exp>;
};


export type Query_RootRate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rate_Order_By>>;
  where?: InputMaybe<Rate_Bool_Exp>;
};


export type Query_RootRate_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSearch_ConsultationArgs = {
  args: Search_Consultation_Args;
  distinct_on?: InputMaybe<Array<Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Order_By>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Query_RootSearch_Consultation_AggregateArgs = {
  args: Search_Consultation_Args;
  distinct_on?: InputMaybe<Array<Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Order_By>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Query_RootSearch_TestArgs = {
  args: Search_Test_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootSearch_Test_AggregateArgs = {
  args: Search_Test_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootSearch_Test_Most_PopularArgs = {
  args: Search_Test_Most_Popular_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootSearch_Test_Most_Popular_AggregateArgs = {
  args: Search_Test_Most_Popular_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootSearch_Test_ShippingArgs = {
  args: Search_Test_Shipping_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootSearch_Test_Shipping_AggregateArgs = {
  args: Search_Test_Shipping_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootSearch_Test_Shipping_TagArgs = {
  args: Search_Test_Shipping_Tag_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootSearch_Test_Shipping_Tag_AggregateArgs = {
  args: Search_Test_Shipping_Tag_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootSearch_Test_TagArgs = {
  args: Search_Test_Tag_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootSearch_Test_Tag_AggregateArgs = {
  args: Search_Test_Tag_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootSearch_TrainingArgs = {
  args: Search_Training_Args;
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


export type Query_RootSearch_Training_AggregateArgs = {
  args: Search_Training_Args;
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


export type Query_RootShippingArgs = {
  distinct_on?: InputMaybe<Array<Shipping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipping_Order_By>>;
  where?: InputMaybe<Shipping_Bool_Exp>;
};


export type Query_RootShipping_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTagArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Query_RootTag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Query_RootTag_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootTestArgs = {
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootTest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootTest_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTest_LaboratoriesArgs = {
  args: Test_Laboratories_Args;
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Query_RootTest_Laboratories_AggregateArgs = {
  args: Test_Laboratories_Args;
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Query_RootTest_MaterialArgs = {
  distinct_on?: InputMaybe<Array<Test_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Material_Order_By>>;
  where?: InputMaybe<Test_Material_Bool_Exp>;
};


export type Query_RootTest_Material_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Material_Order_By>>;
  where?: InputMaybe<Test_Material_Bool_Exp>;
};


export type Query_RootTest_Material_By_PkArgs = {
  materialId: Scalars['Int'];
  testId: Scalars['Int'];
};


export type Query_RootTest_TagArgs = {
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


export type Query_RootTest_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


export type Query_RootTest_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTests_By_Collection_Point_And_NurseArgs = {
  args: Tests_By_Collection_Point_And_Nurse_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootTests_By_Collection_Point_And_Nurse_AggregateArgs = {
  args: Tests_By_Collection_Point_And_Nurse_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Query_RootTrainingArgs = {
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


export type Query_RootTraining_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


export type Query_RootTraining_By_PkArgs = {
  id: Scalars['Int'];
};

/** columns and relationships of "rate" */
export type Rate = {
  __typename?: 'rate';
  area?: Maybe<Scalars['geography']>;
  collectionCost: Scalars['numeric'];
  collectionCost3Plus: Scalars['numeric'];
  collectionKitCost: Scalars['numeric'];
  default: Scalars['Boolean'];
  deliveryCostPerKm: Scalars['numeric'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** aggregated selection of "rate" */
export type Rate_Aggregate = {
  __typename?: 'rate_aggregate';
  aggregate?: Maybe<Rate_Aggregate_Fields>;
  nodes: Array<Rate>;
};

/** aggregate fields of "rate" */
export type Rate_Aggregate_Fields = {
  __typename?: 'rate_aggregate_fields';
  avg?: Maybe<Rate_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Rate_Max_Fields>;
  min?: Maybe<Rate_Min_Fields>;
  stddev?: Maybe<Rate_Stddev_Fields>;
  stddev_pop?: Maybe<Rate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rate_Stddev_Samp_Fields>;
  sum?: Maybe<Rate_Sum_Fields>;
  var_pop?: Maybe<Rate_Var_Pop_Fields>;
  var_samp?: Maybe<Rate_Var_Samp_Fields>;
  variance?: Maybe<Rate_Variance_Fields>;
};


/** aggregate fields of "rate" */
export type Rate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Rate_Avg_Fields = {
  __typename?: 'rate_avg_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCost3Plus?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  deliveryCostPerKm?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "rate". All fields are combined with a logical 'AND'. */
export type Rate_Bool_Exp = {
  _and?: InputMaybe<Array<Rate_Bool_Exp>>;
  _not?: InputMaybe<Rate_Bool_Exp>;
  _or?: InputMaybe<Array<Rate_Bool_Exp>>;
  area?: InputMaybe<Geography_Comparison_Exp>;
  collectionCost?: InputMaybe<Numeric_Comparison_Exp>;
  collectionCost3Plus?: InputMaybe<Numeric_Comparison_Exp>;
  collectionKitCost?: InputMaybe<Numeric_Comparison_Exp>;
  default?: InputMaybe<Boolean_Comparison_Exp>;
  deliveryCostPerKm?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "rate" */
export enum Rate_Constraint {
  /** unique or primary key constraint on columns "default" */
  RateDefaultIdx = 'rate_default_idx',
  /** unique or primary key constraint on columns "name" */
  RateNameKey = 'rate_name_key',
  /** unique or primary key constraint on columns "id" */
  RatePkey = 'rate_pkey'
}

/** input type for incrementing numeric columns in table "rate" */
export type Rate_Inc_Input = {
  collectionCost?: InputMaybe<Scalars['numeric']>;
  collectionCost3Plus?: InputMaybe<Scalars['numeric']>;
  collectionKitCost?: InputMaybe<Scalars['numeric']>;
  deliveryCostPerKm?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "rate" */
export type Rate_Insert_Input = {
  area?: InputMaybe<Scalars['geography']>;
  collectionCost?: InputMaybe<Scalars['numeric']>;
  collectionCost3Plus?: InputMaybe<Scalars['numeric']>;
  collectionKitCost?: InputMaybe<Scalars['numeric']>;
  default?: InputMaybe<Scalars['Boolean']>;
  deliveryCostPerKm?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Rate_Max_Fields = {
  __typename?: 'rate_max_fields';
  collectionCost?: Maybe<Scalars['numeric']>;
  collectionCost3Plus?: Maybe<Scalars['numeric']>;
  collectionKitCost?: Maybe<Scalars['numeric']>;
  deliveryCostPerKm?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Rate_Min_Fields = {
  __typename?: 'rate_min_fields';
  collectionCost?: Maybe<Scalars['numeric']>;
  collectionCost3Plus?: Maybe<Scalars['numeric']>;
  collectionKitCost?: Maybe<Scalars['numeric']>;
  deliveryCostPerKm?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "rate" */
export type Rate_Mutation_Response = {
  __typename?: 'rate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Rate>;
};

/** on_conflict condition type for table "rate" */
export type Rate_On_Conflict = {
  constraint: Rate_Constraint;
  update_columns?: Array<Rate_Update_Column>;
  where?: InputMaybe<Rate_Bool_Exp>;
};

/** Ordering options when selecting data from "rate". */
export type Rate_Order_By = {
  area?: InputMaybe<Order_By>;
  collectionCost?: InputMaybe<Order_By>;
  collectionCost3Plus?: InputMaybe<Order_By>;
  collectionKitCost?: InputMaybe<Order_By>;
  default?: InputMaybe<Order_By>;
  deliveryCostPerKm?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rate */
export type Rate_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "rate" */
export enum Rate_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  CollectionCost = 'collectionCost',
  /** column name */
  CollectionCost3Plus = 'collectionCost3Plus',
  /** column name */
  CollectionKitCost = 'collectionKitCost',
  /** column name */
  Default = 'default',
  /** column name */
  DeliveryCostPerKm = 'deliveryCostPerKm',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "rate" */
export type Rate_Set_Input = {
  area?: InputMaybe<Scalars['geography']>;
  collectionCost?: InputMaybe<Scalars['numeric']>;
  collectionCost3Plus?: InputMaybe<Scalars['numeric']>;
  collectionKitCost?: InputMaybe<Scalars['numeric']>;
  default?: InputMaybe<Scalars['Boolean']>;
  deliveryCostPerKm?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Rate_Stddev_Fields = {
  __typename?: 'rate_stddev_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCost3Plus?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  deliveryCostPerKm?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Rate_Stddev_Pop_Fields = {
  __typename?: 'rate_stddev_pop_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCost3Plus?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  deliveryCostPerKm?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Rate_Stddev_Samp_Fields = {
  __typename?: 'rate_stddev_samp_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCost3Plus?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  deliveryCostPerKm?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "rate" */
export type Rate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rate_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['geography']>;
  collectionCost?: InputMaybe<Scalars['numeric']>;
  collectionCost3Plus?: InputMaybe<Scalars['numeric']>;
  collectionKitCost?: InputMaybe<Scalars['numeric']>;
  default?: InputMaybe<Scalars['Boolean']>;
  deliveryCostPerKm?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Rate_Sum_Fields = {
  __typename?: 'rate_sum_fields';
  collectionCost?: Maybe<Scalars['numeric']>;
  collectionCost3Plus?: Maybe<Scalars['numeric']>;
  collectionKitCost?: Maybe<Scalars['numeric']>;
  deliveryCostPerKm?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "rate" */
export enum Rate_Update_Column {
  /** column name */
  Area = 'area',
  /** column name */
  CollectionCost = 'collectionCost',
  /** column name */
  CollectionCost3Plus = 'collectionCost3Plus',
  /** column name */
  CollectionKitCost = 'collectionKitCost',
  /** column name */
  Default = 'default',
  /** column name */
  DeliveryCostPerKm = 'deliveryCostPerKm',
  /** column name */
  Name = 'name'
}

export type Rate_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rate_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rate_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rate_Var_Pop_Fields = {
  __typename?: 'rate_var_pop_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCost3Plus?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  deliveryCostPerKm?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Rate_Var_Samp_Fields = {
  __typename?: 'rate_var_samp_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCost3Plus?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  deliveryCostPerKm?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Rate_Variance_Fields = {
  __typename?: 'rate_variance_fields';
  collectionCost?: Maybe<Scalars['Float']>;
  collectionCost3Plus?: Maybe<Scalars['Float']>;
  collectionKitCost?: Maybe<Scalars['Float']>;
  deliveryCostPerKm?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type Search_Consultation_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

export type Search_Test_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  point?: InputMaybe<Scalars['geography']>;
  query?: InputMaybe<Scalars['String']>;
};

export type Search_Test_Most_Popular_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  point?: InputMaybe<Scalars['geography']>;
};

export type Search_Test_Shipping_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

export type Search_Test_Shipping_Tag_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _tag?: InputMaybe<Scalars['String']>;
};

export type Search_Test_Tag_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _tag?: InputMaybe<Scalars['String']>;
  point?: InputMaybe<Scalars['geography']>;
};

export type Search_Training_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "shipping" */
export type Shipping = {
  __typename?: 'shipping';
  carrier: Scalars['String'];
  codSupported: Scalars['Boolean'];
  code: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['bigint'];
  isActive: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  price: Scalars['numeric'];
  service: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "shipping" */
export type ShippingMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "shipping". All fields are combined with a logical 'AND'. */
export type Shipping_Bool_Exp = {
  _and?: InputMaybe<Array<Shipping_Bool_Exp>>;
  _not?: InputMaybe<Shipping_Bool_Exp>;
  _or?: InputMaybe<Array<Shipping_Bool_Exp>>;
  carrier?: InputMaybe<String_Comparison_Exp>;
  codSupported?: InputMaybe<Boolean_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  service?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "shipping_direction". All fields are combined with logical 'AND'. */
export type Shipping_Direction_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['shipping_direction']>;
  _gt?: InputMaybe<Scalars['shipping_direction']>;
  _gte?: InputMaybe<Scalars['shipping_direction']>;
  _in?: InputMaybe<Array<Scalars['shipping_direction']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['shipping_direction']>;
  _lte?: InputMaybe<Scalars['shipping_direction']>;
  _neq?: InputMaybe<Scalars['shipping_direction']>;
  _nin?: InputMaybe<Array<Scalars['shipping_direction']>>;
};

/** Ordering options when selecting data from "shipping". */
export type Shipping_Order_By = {
  carrier?: InputMaybe<Order_By>;
  codSupported?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "shipping" */
export enum Shipping_Select_Column {
  /** column name */
  Carrier = 'carrier',
  /** column name */
  CodSupported = 'codSupported',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  Service = 'service',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "shipping" */
export type Shipping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shipping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shipping_Stream_Cursor_Value_Input = {
  carrier?: InputMaybe<Scalars['String']>;
  codSupported?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  service?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: InputMaybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "administrator" */
  administrator: Array<Administrator>;
  /** fetch aggregated fields from the table: "administrator" */
  administrator_aggregate: Administrator_Aggregate;
  /** fetch data from the table: "administrator" using primary key columns */
  administrator_by_pk?: Maybe<Administrator>;
  /** fetch data from the table: "administrator_notification" */
  administrator_notification: Array<Administrator_Notification>;
  /** fetch aggregated fields from the table: "administrator_notification" */
  administrator_notification_aggregate: Administrator_Notification_Aggregate;
  /** fetch data from the table: "administrator_notification" using primary key columns */
  administrator_notification_by_pk?: Maybe<Administrator_Notification>;
  /** fetch data from the table in a streaming manner: "administrator_notification" */
  administrator_notification_stream: Array<Administrator_Notification>;
  /** fetch data from the table in a streaming manner: "administrator" */
  administrator_stream: Array<Administrator>;
  /** execute function "available_laboratory" which returns "laboratory" */
  available_laboratory: Array<Laboratory>;
  /** execute function "available_laboratory" and query aggregates on result of table type "laboratory" */
  available_laboratory_aggregate: Laboratory_Aggregate;
  /** execute function "available_shipping_test_tag" which returns "test_tag" */
  available_shipping_test_tag: Array<Test_Tag>;
  /** execute function "available_shipping_test_tag" and query aggregates on result of table type "test_tag" */
  available_shipping_test_tag_aggregate: Test_Tag_Aggregate;
  /** execute function "available_test_tag" which returns "test_tag" */
  available_test_tag: Array<Test_Tag>;
  /** execute function "available_test_tag" and query aggregates on result of table type "test_tag" */
  available_test_tag_aggregate: Test_Tag_Aggregate;
  /** fetch data from the table: "client" */
  client: Array<Client>;
  /** fetch aggregated fields from the table: "client" */
  client_aggregate: Client_Aggregate;
  /** fetch data from the table: "client" using primary key columns */
  client_by_pk?: Maybe<Client>;
  /** fetch data from the table: "client_favourite_test" */
  client_favourite_test: Array<Client_Favourite_Test>;
  /** fetch data from the table: "client_favourite_test" using primary key columns */
  client_favourite_test_by_pk?: Maybe<Client_Favourite_Test>;
  /** fetch data from the table in a streaming manner: "client_favourite_test" */
  client_favourite_test_stream: Array<Client_Favourite_Test>;
  /** fetch data from the table: "client_profile" */
  client_profile: Array<Client_Profile>;
  /** fetch data from the table: "client_profile" using primary key columns */
  client_profile_by_pk?: Maybe<Client_Profile>;
  /** fetch data from the table in a streaming manner: "client_profile" */
  client_profile_stream: Array<Client_Profile>;
  /** fetch data from the table in a streaming manner: "client" */
  client_stream: Array<Client>;
  /** fetch data from the table: "collection_slot" */
  collection_slot: Array<Collection_Slot>;
  /** fetch aggregated fields from the table: "collection_slot" */
  collection_slot_aggregate: Collection_Slot_Aggregate;
  /** fetch data from the table: "collection_slot" using primary key columns */
  collection_slot_by_pk?: Maybe<Collection_Slot>;
  /** fetch data from the table in a streaming manner: "collection_slot" */
  collection_slot_stream: Array<Collection_Slot>;
  /** fetch data from the table: "consultation" */
  consultation: Array<Consultation>;
  /** fetch aggregated fields from the table: "consultation" */
  consultation_aggregate: Consultation_Aggregate;
  /** fetch data from the table: "consultation" using primary key columns */
  consultation_by_pk?: Maybe<Consultation>;
  /** fetch data from the table: "consultation_slot" */
  consultation_slot: Array<Consultation_Slot>;
  /** fetch aggregated fields from the table: "consultation_slot" */
  consultation_slot_aggregate: Consultation_Slot_Aggregate;
  /** fetch data from the table: "consultation_slot" using primary key columns */
  consultation_slot_by_pk?: Maybe<Consultation_Slot>;
  /** fetch data from the table in a streaming manner: "consultation_slot" */
  consultation_slot_stream: Array<Consultation_Slot>;
  /** fetch data from the table in a streaming manner: "consultation" */
  consultation_stream: Array<Consultation>;
  /** fetch data from the table: "discount" */
  discount: Array<Discount>;
  /** fetch aggregated fields from the table: "discount" */
  discount_aggregate: Discount_Aggregate;
  /** fetch data from the table: "discount" using primary key columns */
  discount_by_pk?: Maybe<Discount>;
  /** fetch data from the table: "discount_consultation" */
  discount_consultation: Array<Discount_Consultation>;
  /** fetch aggregated fields from the table: "discount_consultation" */
  discount_consultation_aggregate: Discount_Consultation_Aggregate;
  /** fetch data from the table: "discount_consultation" using primary key columns */
  discount_consultation_by_pk?: Maybe<Discount_Consultation>;
  /** fetch data from the table in a streaming manner: "discount_consultation" */
  discount_consultation_stream: Array<Discount_Consultation>;
  /** fetch data from the table in a streaming manner: "discount" */
  discount_stream: Array<Discount>;
  /** fetch data from the table: "discount_test" */
  discount_test: Array<Discount_Test>;
  /** fetch aggregated fields from the table: "discount_test" */
  discount_test_aggregate: Discount_Test_Aggregate;
  /** fetch data from the table: "discount_test" using primary key columns */
  discount_test_by_pk?: Maybe<Discount_Test>;
  /** fetch data from the table in a streaming manner: "discount_test" */
  discount_test_stream: Array<Discount_Test>;
  /** fetch data from the table: "discount_training" */
  discount_training: Array<Discount_Training>;
  /** fetch aggregated fields from the table: "discount_training" */
  discount_training_aggregate: Discount_Training_Aggregate;
  /** fetch data from the table: "discount_training" using primary key columns */
  discount_training_by_pk?: Maybe<Discount_Training>;
  /** fetch data from the table in a streaming manner: "discount_training" */
  discount_training_stream: Array<Discount_Training>;
  /** fetch data from the table: "discount_type_enum" */
  discount_type_enum: Array<Discount_Type_Enum>;
  /** fetch data from the table: "discount_type_enum" using primary key columns */
  discount_type_enum_by_pk?: Maybe<Discount_Type_Enum>;
  /** fetch data from the table in a streaming manner: "discount_type_enum" */
  discount_type_enum_stream: Array<Discount_Type_Enum>;
  /** fetch data from the table: "feature_flags" */
  feature_flags: Array<Feature_Flags>;
  /** fetch data from the table: "feature_flags" using primary key columns */
  feature_flags_by_pk?: Maybe<Feature_Flags>;
  /** fetch data from the table in a streaming manner: "feature_flags" */
  feature_flags_stream: Array<Feature_Flags>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk?: Maybe<File>;
  /** fetch data from the table in a streaming manner: "file" */
  file_stream: Array<File>;
  /** fetch data from the table: "gender" */
  gender: Array<Gender>;
  /** fetch data from the table: "gender" using primary key columns */
  gender_by_pk?: Maybe<Gender>;
  /** fetch data from the table in a streaming manner: "gender" */
  gender_stream: Array<Gender>;
  /** fetch data from the table: "lab_user" */
  lab_user: Array<Lab_User>;
  /** fetch aggregated fields from the table: "lab_user" */
  lab_user_aggregate: Lab_User_Aggregate;
  /** fetch data from the table: "lab_user" using primary key columns */
  lab_user_by_pk?: Maybe<Lab_User>;
  /** fetch data from the table in a streaming manner: "lab_user" */
  lab_user_stream: Array<Lab_User>;
  /** fetch data from the table: "laboratory" */
  laboratory: Array<Laboratory>;
  /** fetch aggregated fields from the table: "laboratory" */
  laboratory_aggregate: Laboratory_Aggregate;
  /** fetch data from the table: "laboratory" using primary key columns */
  laboratory_by_pk?: Maybe<Laboratory>;
  /** fetch data from the table: "laboratory_collection_point" */
  laboratory_collection_point: Array<Laboratory_Collection_Point>;
  /** fetch aggregated fields from the table: "laboratory_collection_point" */
  laboratory_collection_point_aggregate: Laboratory_Collection_Point_Aggregate;
  /** fetch data from the table: "laboratory_collection_point" using primary key columns */
  laboratory_collection_point_by_pk?: Maybe<Laboratory_Collection_Point>;
  /** fetch data from the table in a streaming manner: "laboratory_collection_point" */
  laboratory_collection_point_stream: Array<Laboratory_Collection_Point>;
  /** fetch data from the table: "laboratory_shipping" */
  laboratory_shipping: Array<Laboratory_Shipping>;
  /** fetch data from the table: "laboratory_shipping" using primary key columns */
  laboratory_shipping_by_pk?: Maybe<Laboratory_Shipping>;
  /** fetch data from the table in a streaming manner: "laboratory_shipping" */
  laboratory_shipping_stream: Array<Laboratory_Shipping>;
  /** fetch data from the table in a streaming manner: "laboratory" */
  laboratory_stream: Array<Laboratory>;
  /** fetch data from the table: "laboratory_summary" */
  laboratory_summary: Array<Laboratory_Summary>;
  /** fetch data from the table in a streaming manner: "laboratory_summary" */
  laboratory_summary_stream: Array<Laboratory_Summary>;
  /** fetch data from the table: "laboratory_test" */
  laboratory_test: Array<Laboratory_Test>;
  /** fetch aggregated fields from the table: "laboratory_test" */
  laboratory_test_aggregate: Laboratory_Test_Aggregate;
  /** fetch data from the table: "laboratory_test" using primary key columns */
  laboratory_test_by_pk?: Maybe<Laboratory_Test>;
  /** fetch data from the table in a streaming manner: "laboratory_test" */
  laboratory_test_stream: Array<Laboratory_Test>;
  /** fetch data from the table: "material" */
  material: Array<Material>;
  /** fetch aggregated fields from the table: "material" */
  material_aggregate: Material_Aggregate;
  /** fetch data from the table: "material" using primary key columns */
  material_by_pk?: Maybe<Material>;
  /** fetch data from the table in a streaming manner: "material" */
  material_stream: Array<Material>;
  /** execute function "nearby_unconfirmed_order" which returns "order" */
  nearby_unconfirmed_order: Array<Order>;
  /** execute function "nearby_unconfirmed_order" and query aggregates on result of table type "order" */
  nearby_unconfirmed_order_aggregate: Order_Aggregate;
  /** fetch data from the table: "nurse" */
  nurse: Array<Nurse>;
  /** fetch aggregated fields from the table: "nurse" */
  nurse_aggregate: Nurse_Aggregate;
  /** fetch data from the table: "nurse" using primary key columns */
  nurse_by_pk?: Maybe<Nurse>;
  /** fetch data from the table: "nurse_material" */
  nurse_material: Array<Nurse_Material>;
  /** fetch aggregated fields from the table: "nurse_material" */
  nurse_material_aggregate: Nurse_Material_Aggregate;
  /** fetch data from the table: "nurse_material" using primary key columns */
  nurse_material_by_pk?: Maybe<Nurse_Material>;
  /** fetch data from the table in a streaming manner: "nurse_material" */
  nurse_material_stream: Array<Nurse_Material>;
  /** fetch data from the table: "nurse_order_cost" */
  nurse_order_cost: Array<Nurse_Order_Cost>;
  /** fetch data from the table in a streaming manner: "nurse_order_cost" */
  nurse_order_cost_stream: Array<Nurse_Order_Cost>;
  /** fetch data from the table in a streaming manner: "nurse" */
  nurse_stream: Array<Nurse>;
  /** fetch data from the table: "nurse_test" */
  nurse_test: Array<Nurse_Test>;
  /** fetch aggregated fields from the table: "nurse_test" */
  nurse_test_aggregate: Nurse_Test_Aggregate;
  /** fetch data from the table: "nurse_test" using primary key columns */
  nurse_test_by_pk?: Maybe<Nurse_Test>;
  /** fetch data from the table in a streaming manner: "nurse_test" */
  nurse_test_stream: Array<Nurse_Test>;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** fetch data from the table: "order_collection" */
  order_collection: Array<Order_Collection>;
  /** fetch aggregated fields from the table: "order_collection" */
  order_collection_aggregate: Order_Collection_Aggregate;
  /** fetch data from the table: "order_collection" using primary key columns */
  order_collection_by_pk?: Maybe<Order_Collection>;
  /** fetch data from the table in a streaming manner: "order_collection" */
  order_collection_stream: Array<Order_Collection>;
  /** fetch data from the table: "order_consultation" */
  order_consultation: Array<Order_Consultation>;
  /** fetch aggregated fields from the table: "order_consultation" */
  order_consultation_aggregate: Order_Consultation_Aggregate;
  /** fetch data from the table: "order_consultation" using primary key columns */
  order_consultation_by_pk?: Maybe<Order_Consultation>;
  /** fetch data from the table in a streaming manner: "order_consultation" */
  order_consultation_stream: Array<Order_Consultation>;
  /** fetch data from the table: "order_discount" */
  order_discount: Array<Order_Discount>;
  /** fetch data from the table: "order_discount" using primary key columns */
  order_discount_by_pk?: Maybe<Order_Discount>;
  /** fetch data from the table in a streaming manner: "order_discount" */
  order_discount_stream: Array<Order_Discount>;
  /** fetch data from the table: "order_document" */
  order_document: Array<Order_Document>;
  /** fetch aggregated fields from the table: "order_document" */
  order_document_aggregate: Order_Document_Aggregate;
  /** fetch data from the table: "order_document" using primary key columns */
  order_document_by_pk?: Maybe<Order_Document>;
  /** fetch data from the table in a streaming manner: "order_document" */
  order_document_stream: Array<Order_Document>;
  /** fetch data from the table: "order_shipping" */
  order_shipping: Array<Order_Shipping>;
  /** fetch data from the table: "order_shipping" using primary key columns */
  order_shipping_by_pk?: Maybe<Order_Shipping>;
  /** fetch data from the table in a streaming manner: "order_shipping" */
  order_shipping_stream: Array<Order_Shipping>;
  /** fetch data from the table: "order_state" */
  order_state: Array<Order_State>;
  /** fetch data from the table: "order_state" using primary key columns */
  order_state_by_pk?: Maybe<Order_State>;
  /** fetch data from the table in a streaming manner: "order_state" */
  order_state_stream: Array<Order_State>;
  /** fetch data from the table in a streaming manner: "order" */
  order_stream: Array<Order>;
  /** fetch data from the table: "order_test" */
  order_test: Array<Order_Test>;
  /** fetch data from the table: "order_test" using primary key columns */
  order_test_by_pk?: Maybe<Order_Test>;
  /** fetch data from the table: "order_test_result" */
  order_test_result: Array<Order_Test_Result>;
  /** fetch aggregated fields from the table: "order_test_result" */
  order_test_result_aggregate: Order_Test_Result_Aggregate;
  /** fetch data from the table: "order_test_result" using primary key columns */
  order_test_result_by_pk?: Maybe<Order_Test_Result>;
  /** fetch data from the table in a streaming manner: "order_test_result" */
  order_test_result_stream: Array<Order_Test_Result>;
  /** fetch data from the table in a streaming manner: "order_test" */
  order_test_stream: Array<Order_Test>;
  /** fetch data from the table: "order_training" */
  order_training: Array<Order_Training>;
  /** fetch aggregated fields from the table: "order_training" */
  order_training_aggregate: Order_Training_Aggregate;
  /** fetch data from the table: "order_training" using primary key columns */
  order_training_by_pk?: Maybe<Order_Training>;
  /** fetch data from the table in a streaming manner: "order_training" */
  order_training_stream: Array<Order_Training>;
  /** fetch data from the table: "push_notification" */
  push_notification: Array<Push_Notification>;
  /** fetch aggregated fields from the table: "push_notification" */
  push_notification_aggregate: Push_Notification_Aggregate;
  /** fetch data from the table: "push_notification" using primary key columns */
  push_notification_by_pk?: Maybe<Push_Notification>;
  /** fetch data from the table: "push_notification_client" */
  push_notification_client: Array<Push_Notification_Client>;
  /** fetch aggregated fields from the table: "push_notification_client" */
  push_notification_client_aggregate: Push_Notification_Client_Aggregate;
  /** fetch data from the table: "push_notification_client" using primary key columns */
  push_notification_client_by_pk?: Maybe<Push_Notification_Client>;
  /** fetch data from the table in a streaming manner: "push_notification_client" */
  push_notification_client_stream: Array<Push_Notification_Client>;
  /** fetch data from the table in a streaming manner: "push_notification" */
  push_notification_stream: Array<Push_Notification>;
  /** fetch data from the table: "rate" */
  rate: Array<Rate>;
  /** fetch aggregated fields from the table: "rate" */
  rate_aggregate: Rate_Aggregate;
  /** fetch data from the table: "rate" using primary key columns */
  rate_by_pk?: Maybe<Rate>;
  /** fetch data from the table in a streaming manner: "rate" */
  rate_stream: Array<Rate>;
  /** execute function "search_consultation" which returns "consultation" */
  search_consultation: Array<Consultation>;
  /** execute function "search_consultation" and query aggregates on result of table type "consultation" */
  search_consultation_aggregate: Consultation_Aggregate;
  /** execute function "search_test" which returns "test" */
  search_test: Array<Test>;
  /** execute function "search_test" and query aggregates on result of table type "test" */
  search_test_aggregate: Test_Aggregate;
  /** execute function "search_test_most_popular" which returns "test" */
  search_test_most_popular: Array<Test>;
  /** execute function "search_test_most_popular" and query aggregates on result of table type "test" */
  search_test_most_popular_aggregate: Test_Aggregate;
  /** execute function "search_test_shipping" which returns "test" */
  search_test_shipping: Array<Test>;
  /** execute function "search_test_shipping" and query aggregates on result of table type "test" */
  search_test_shipping_aggregate: Test_Aggregate;
  /** execute function "search_test_shipping_tag" which returns "test" */
  search_test_shipping_tag: Array<Test>;
  /** execute function "search_test_shipping_tag" and query aggregates on result of table type "test" */
  search_test_shipping_tag_aggregate: Test_Aggregate;
  /** execute function "search_test_tag" which returns "test" */
  search_test_tag: Array<Test>;
  /** execute function "search_test_tag" and query aggregates on result of table type "test" */
  search_test_tag_aggregate: Test_Aggregate;
  /** execute function "search_training" which returns "training" */
  search_training: Array<Training>;
  /** execute function "search_training" and query aggregates on result of table type "training" */
  search_training_aggregate: Training_Aggregate;
  /** fetch data from the table: "shipping" */
  shipping: Array<Shipping>;
  /** fetch data from the table: "shipping" using primary key columns */
  shipping_by_pk?: Maybe<Shipping>;
  /** fetch data from the table in a streaming manner: "shipping" */
  shipping_stream: Array<Shipping>;
  /** fetch data from the table: "tag" */
  tag: Array<Tag>;
  /** fetch aggregated fields from the table: "tag" */
  tag_aggregate: Tag_Aggregate;
  /** fetch data from the table: "tag" using primary key columns */
  tag_by_pk?: Maybe<Tag>;
  /** fetch data from the table in a streaming manner: "tag" */
  tag_stream: Array<Tag>;
  /** fetch data from the table: "test" */
  test: Array<Test>;
  /** fetch aggregated fields from the table: "test" */
  test_aggregate: Test_Aggregate;
  /** fetch data from the table: "test" using primary key columns */
  test_by_pk?: Maybe<Test>;
  /** execute function "test_laboratories" which returns "laboratory" */
  test_laboratories: Array<Laboratory>;
  /** execute function "test_laboratories" and query aggregates on result of table type "laboratory" */
  test_laboratories_aggregate: Laboratory_Aggregate;
  /** fetch data from the table: "test_material" */
  test_material: Array<Test_Material>;
  /** fetch aggregated fields from the table: "test_material" */
  test_material_aggregate: Test_Material_Aggregate;
  /** fetch data from the table: "test_material" using primary key columns */
  test_material_by_pk?: Maybe<Test_Material>;
  /** fetch data from the table in a streaming manner: "test_material" */
  test_material_stream: Array<Test_Material>;
  /** fetch data from the table in a streaming manner: "test" */
  test_stream: Array<Test>;
  /** fetch data from the table: "test_tag" */
  test_tag: Array<Test_Tag>;
  /** fetch aggregated fields from the table: "test_tag" */
  test_tag_aggregate: Test_Tag_Aggregate;
  /** fetch data from the table: "test_tag" using primary key columns */
  test_tag_by_pk?: Maybe<Test_Tag>;
  /** fetch data from the table in a streaming manner: "test_tag" */
  test_tag_stream: Array<Test_Tag>;
  /** execute function "tests_by_collection_point_and_nurse" which returns "test" */
  tests_by_collection_point_and_nurse: Array<Test>;
  /** execute function "tests_by_collection_point_and_nurse" and query aggregates on result of table type "test" */
  tests_by_collection_point_and_nurse_aggregate: Test_Aggregate;
  /** fetch data from the table: "training" */
  training: Array<Training>;
  /** fetch aggregated fields from the table: "training" */
  training_aggregate: Training_Aggregate;
  /** fetch data from the table: "training" using primary key columns */
  training_by_pk?: Maybe<Training>;
  /** fetch data from the table in a streaming manner: "training" */
  training_stream: Array<Training>;
};


export type Subscription_RootAdministratorArgs = {
  distinct_on?: InputMaybe<Array<Administrator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Administrator_Order_By>>;
  where?: InputMaybe<Administrator_Bool_Exp>;
};


export type Subscription_RootAdministrator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Administrator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Administrator_Order_By>>;
  where?: InputMaybe<Administrator_Bool_Exp>;
};


export type Subscription_RootAdministrator_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAdministrator_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Administrator_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Administrator_Notification_Order_By>>;
  where?: InputMaybe<Administrator_Notification_Bool_Exp>;
};


export type Subscription_RootAdministrator_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Administrator_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Administrator_Notification_Order_By>>;
  where?: InputMaybe<Administrator_Notification_Bool_Exp>;
};


export type Subscription_RootAdministrator_Notification_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAdministrator_Notification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Administrator_Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Administrator_Notification_Bool_Exp>;
};


export type Subscription_RootAdministrator_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Administrator_Stream_Cursor_Input>>;
  where?: InputMaybe<Administrator_Bool_Exp>;
};


export type Subscription_RootAvailable_LaboratoryArgs = {
  args: Available_Laboratory_Args;
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Subscription_RootAvailable_Laboratory_AggregateArgs = {
  args: Available_Laboratory_Args;
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Subscription_RootAvailable_Shipping_Test_TagArgs = {
  args?: InputMaybe<Available_Shipping_Test_Tag_Args>;
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


export type Subscription_RootAvailable_Shipping_Test_Tag_AggregateArgs = {
  args?: InputMaybe<Available_Shipping_Test_Tag_Args>;
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


export type Subscription_RootAvailable_Test_TagArgs = {
  args: Available_Test_Tag_Args;
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


export type Subscription_RootAvailable_Test_Tag_AggregateArgs = {
  args: Available_Test_Tag_Args;
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


export type Subscription_RootClientArgs = {
  distinct_on?: InputMaybe<Array<Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Order_By>>;
  where?: InputMaybe<Client_Bool_Exp>;
};


export type Subscription_RootClient_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Order_By>>;
  where?: InputMaybe<Client_Bool_Exp>;
};


export type Subscription_RootClient_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootClient_Favourite_TestArgs = {
  distinct_on?: InputMaybe<Array<Client_Favourite_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Favourite_Test_Order_By>>;
  where?: InputMaybe<Client_Favourite_Test_Bool_Exp>;
};


export type Subscription_RootClient_Favourite_Test_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootClient_Favourite_Test_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Client_Favourite_Test_Stream_Cursor_Input>>;
  where?: InputMaybe<Client_Favourite_Test_Bool_Exp>;
};


export type Subscription_RootClient_ProfileArgs = {
  distinct_on?: InputMaybe<Array<Client_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Profile_Order_By>>;
  where?: InputMaybe<Client_Profile_Bool_Exp>;
};


export type Subscription_RootClient_Profile_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootClient_Profile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Client_Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<Client_Profile_Bool_Exp>;
};


export type Subscription_RootClient_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Client_Stream_Cursor_Input>>;
  where?: InputMaybe<Client_Bool_Exp>;
};


export type Subscription_RootCollection_SlotArgs = {
  distinct_on?: InputMaybe<Array<Collection_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Slot_Order_By>>;
  where?: InputMaybe<Collection_Slot_Bool_Exp>;
};


export type Subscription_RootCollection_Slot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collection_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Slot_Order_By>>;
  where?: InputMaybe<Collection_Slot_Bool_Exp>;
};


export type Subscription_RootCollection_Slot_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCollection_Slot_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Collection_Slot_Stream_Cursor_Input>>;
  where?: InputMaybe<Collection_Slot_Bool_Exp>;
};


export type Subscription_RootConsultationArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Order_By>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Subscription_RootConsultation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Order_By>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Subscription_RootConsultation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootConsultation_SlotArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Slot_Order_By>>;
  where?: InputMaybe<Consultation_Slot_Bool_Exp>;
};


export type Subscription_RootConsultation_Slot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Slot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Slot_Order_By>>;
  where?: InputMaybe<Consultation_Slot_Bool_Exp>;
};


export type Subscription_RootConsultation_Slot_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootConsultation_Slot_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Consultation_Slot_Stream_Cursor_Input>>;
  where?: InputMaybe<Consultation_Slot_Bool_Exp>;
};


export type Subscription_RootConsultation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Consultation_Stream_Cursor_Input>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Subscription_RootDiscountArgs = {
  distinct_on?: InputMaybe<Array<Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Order_By>>;
  where?: InputMaybe<Discount_Bool_Exp>;
};


export type Subscription_RootDiscount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Order_By>>;
  where?: InputMaybe<Discount_Bool_Exp>;
};


export type Subscription_RootDiscount_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDiscount_ConsultationArgs = {
  distinct_on?: InputMaybe<Array<Discount_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Consultation_Order_By>>;
  where?: InputMaybe<Discount_Consultation_Bool_Exp>;
};


export type Subscription_RootDiscount_Consultation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Consultation_Order_By>>;
  where?: InputMaybe<Discount_Consultation_Bool_Exp>;
};


export type Subscription_RootDiscount_Consultation_By_PkArgs = {
  consultationId: Scalars['Int'];
  discountId: Scalars['Int'];
};


export type Subscription_RootDiscount_Consultation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Discount_Consultation_Stream_Cursor_Input>>;
  where?: InputMaybe<Discount_Consultation_Bool_Exp>;
};


export type Subscription_RootDiscount_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Discount_Stream_Cursor_Input>>;
  where?: InputMaybe<Discount_Bool_Exp>;
};


export type Subscription_RootDiscount_TestArgs = {
  distinct_on?: InputMaybe<Array<Discount_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Test_Order_By>>;
  where?: InputMaybe<Discount_Test_Bool_Exp>;
};


export type Subscription_RootDiscount_Test_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Test_Order_By>>;
  where?: InputMaybe<Discount_Test_Bool_Exp>;
};


export type Subscription_RootDiscount_Test_By_PkArgs = {
  discountId: Scalars['Int'];
  testId: Scalars['Int'];
};


export type Subscription_RootDiscount_Test_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Discount_Test_Stream_Cursor_Input>>;
  where?: InputMaybe<Discount_Test_Bool_Exp>;
};


export type Subscription_RootDiscount_TrainingArgs = {
  distinct_on?: InputMaybe<Array<Discount_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Training_Order_By>>;
  where?: InputMaybe<Discount_Training_Bool_Exp>;
};


export type Subscription_RootDiscount_Training_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Training_Order_By>>;
  where?: InputMaybe<Discount_Training_Bool_Exp>;
};


export type Subscription_RootDiscount_Training_By_PkArgs = {
  discountId: Scalars['Int'];
  trainingId: Scalars['Int'];
};


export type Subscription_RootDiscount_Training_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Discount_Training_Stream_Cursor_Input>>;
  where?: InputMaybe<Discount_Training_Bool_Exp>;
};


export type Subscription_RootDiscount_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Discount_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Type_Enum_Order_By>>;
  where?: InputMaybe<Discount_Type_Enum_Bool_Exp>;
};


export type Subscription_RootDiscount_Type_Enum_By_PkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootDiscount_Type_Enum_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Discount_Type_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Discount_Type_Enum_Bool_Exp>;
};


export type Subscription_RootFeature_FlagsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Flags_Order_By>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootFeature_Flags_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootFeature_Flags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feature_Flags_Stream_Cursor_Input>>;
  where?: InputMaybe<Feature_Flags_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFile_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<File_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootGenderArgs = {
  distinct_on?: InputMaybe<Array<Gender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gender_Order_By>>;
  where?: InputMaybe<Gender_Bool_Exp>;
};


export type Subscription_RootGender_By_PkArgs = {
  gender: Scalars['String'];
};


export type Subscription_RootGender_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Gender_Stream_Cursor_Input>>;
  where?: InputMaybe<Gender_Bool_Exp>;
};


export type Subscription_RootLab_UserArgs = {
  distinct_on?: InputMaybe<Array<Lab_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lab_User_Order_By>>;
  where?: InputMaybe<Lab_User_Bool_Exp>;
};


export type Subscription_RootLab_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lab_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lab_User_Order_By>>;
  where?: InputMaybe<Lab_User_Bool_Exp>;
};


export type Subscription_RootLab_User_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLab_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Lab_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Lab_User_Bool_Exp>;
};


export type Subscription_RootLaboratoryArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Subscription_RootLaboratory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Subscription_RootLaboratory_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLaboratory_Collection_PointArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Collection_Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Collection_Point_Order_By>>;
  where?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
};


export type Subscription_RootLaboratory_Collection_Point_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Collection_Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Collection_Point_Order_By>>;
  where?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
};


export type Subscription_RootLaboratory_Collection_Point_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLaboratory_Collection_Point_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Laboratory_Collection_Point_Stream_Cursor_Input>>;
  where?: InputMaybe<Laboratory_Collection_Point_Bool_Exp>;
};


export type Subscription_RootLaboratory_ShippingArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Shipping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Shipping_Order_By>>;
  where?: InputMaybe<Laboratory_Shipping_Bool_Exp>;
};


export type Subscription_RootLaboratory_Shipping_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootLaboratory_Shipping_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Laboratory_Shipping_Stream_Cursor_Input>>;
  where?: InputMaybe<Laboratory_Shipping_Bool_Exp>;
};


export type Subscription_RootLaboratory_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Laboratory_Stream_Cursor_Input>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Subscription_RootLaboratory_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Summary_Order_By>>;
  where?: InputMaybe<Laboratory_Summary_Bool_Exp>;
};


export type Subscription_RootLaboratory_Summary_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Laboratory_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Laboratory_Summary_Bool_Exp>;
};


export type Subscription_RootLaboratory_TestArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Test_Order_By>>;
  where?: InputMaybe<Laboratory_Test_Bool_Exp>;
};


export type Subscription_RootLaboratory_Test_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Test_Order_By>>;
  where?: InputMaybe<Laboratory_Test_Bool_Exp>;
};


export type Subscription_RootLaboratory_Test_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLaboratory_Test_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Laboratory_Test_Stream_Cursor_Input>>;
  where?: InputMaybe<Laboratory_Test_Bool_Exp>;
};


export type Subscription_RootMaterialArgs = {
  distinct_on?: InputMaybe<Array<Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Material_Order_By>>;
  where?: InputMaybe<Material_Bool_Exp>;
};


export type Subscription_RootMaterial_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Material_Order_By>>;
  where?: InputMaybe<Material_Bool_Exp>;
};


export type Subscription_RootMaterial_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMaterial_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Material_Stream_Cursor_Input>>;
  where?: InputMaybe<Material_Bool_Exp>;
};


export type Subscription_RootNearby_Unconfirmed_OrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootNearby_Unconfirmed_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootNurseArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Order_By>>;
  where?: InputMaybe<Nurse_Bool_Exp>;
};


export type Subscription_RootNurse_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Order_By>>;
  where?: InputMaybe<Nurse_Bool_Exp>;
};


export type Subscription_RootNurse_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootNurse_MaterialArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Material_Order_By>>;
  where?: InputMaybe<Nurse_Material_Bool_Exp>;
};


export type Subscription_RootNurse_Material_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Material_Order_By>>;
  where?: InputMaybe<Nurse_Material_Bool_Exp>;
};


export type Subscription_RootNurse_Material_By_PkArgs = {
  materialId: Scalars['Int'];
  nurseId: Scalars['Int'];
};


export type Subscription_RootNurse_Material_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nurse_Material_Stream_Cursor_Input>>;
  where?: InputMaybe<Nurse_Material_Bool_Exp>;
};


export type Subscription_RootNurse_Order_CostArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Order_Cost_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Order_Cost_Order_By>>;
  where?: InputMaybe<Nurse_Order_Cost_Bool_Exp>;
};


export type Subscription_RootNurse_Order_Cost_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nurse_Order_Cost_Stream_Cursor_Input>>;
  where?: InputMaybe<Nurse_Order_Cost_Bool_Exp>;
};


export type Subscription_RootNurse_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nurse_Stream_Cursor_Input>>;
  where?: InputMaybe<Nurse_Bool_Exp>;
};


export type Subscription_RootNurse_TestArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Test_Order_By>>;
  where?: InputMaybe<Nurse_Test_Bool_Exp>;
};


export type Subscription_RootNurse_Test_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Test_Order_By>>;
  where?: InputMaybe<Nurse_Test_Bool_Exp>;
};


export type Subscription_RootNurse_Test_By_PkArgs = {
  nurseId: Scalars['Int'];
  testId: Scalars['Int'];
};


export type Subscription_RootNurse_Test_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nurse_Test_Stream_Cursor_Input>>;
  where?: InputMaybe<Nurse_Test_Bool_Exp>;
};


export type Subscription_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrder_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Order_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Collection_Order_By>>;
  where?: InputMaybe<Order_Collection_Bool_Exp>;
};


export type Subscription_RootOrder_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Collection_Order_By>>;
  where?: InputMaybe<Order_Collection_Bool_Exp>;
};


export type Subscription_RootOrder_Collection_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrder_Collection_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Collection_Bool_Exp>;
};


export type Subscription_RootOrder_ConsultationArgs = {
  distinct_on?: InputMaybe<Array<Order_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Consultation_Order_By>>;
  where?: InputMaybe<Order_Consultation_Bool_Exp>;
};


export type Subscription_RootOrder_Consultation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Consultation_Order_By>>;
  where?: InputMaybe<Order_Consultation_Bool_Exp>;
};


export type Subscription_RootOrder_Consultation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrder_Consultation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Consultation_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Consultation_Bool_Exp>;
};


export type Subscription_RootOrder_DiscountArgs = {
  distinct_on?: InputMaybe<Array<Order_Discount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Discount_Order_By>>;
  where?: InputMaybe<Order_Discount_Bool_Exp>;
};


export type Subscription_RootOrder_Discount_By_PkArgs = {
  discount_id: Scalars['Int'];
  order_id: Scalars['Int'];
};


export type Subscription_RootOrder_Discount_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Discount_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Discount_Bool_Exp>;
};


export type Subscription_RootOrder_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Order_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Document_Order_By>>;
  where?: InputMaybe<Order_Document_Bool_Exp>;
};


export type Subscription_RootOrder_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Document_Order_By>>;
  where?: InputMaybe<Order_Document_Bool_Exp>;
};


export type Subscription_RootOrder_Document_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrder_Document_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Document_Bool_Exp>;
};


export type Subscription_RootOrder_ShippingArgs = {
  distinct_on?: InputMaybe<Array<Order_Shipping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Shipping_Order_By>>;
  where?: InputMaybe<Order_Shipping_Bool_Exp>;
};


export type Subscription_RootOrder_Shipping_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOrder_Shipping_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Shipping_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Shipping_Bool_Exp>;
};


export type Subscription_RootOrder_StateArgs = {
  distinct_on?: InputMaybe<Array<Order_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_State_Order_By>>;
  where?: InputMaybe<Order_State_Bool_Exp>;
};


export type Subscription_RootOrder_State_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrder_State_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_State_Bool_Exp>;
};


export type Subscription_RootOrder_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_TestArgs = {
  distinct_on?: InputMaybe<Array<Order_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Test_Order_By>>;
  where?: InputMaybe<Order_Test_Bool_Exp>;
};


export type Subscription_RootOrder_Test_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrder_Test_ResultArgs = {
  distinct_on?: InputMaybe<Array<Order_Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Test_Result_Order_By>>;
  where?: InputMaybe<Order_Test_Result_Bool_Exp>;
};


export type Subscription_RootOrder_Test_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Test_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Test_Result_Order_By>>;
  where?: InputMaybe<Order_Test_Result_Bool_Exp>;
};


export type Subscription_RootOrder_Test_Result_By_PkArgs = {
  fileId: Scalars['Int'];
  orderTestId: Scalars['Int'];
};


export type Subscription_RootOrder_Test_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Test_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Test_Result_Bool_Exp>;
};


export type Subscription_RootOrder_Test_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Test_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Test_Bool_Exp>;
};


export type Subscription_RootOrder_TrainingArgs = {
  distinct_on?: InputMaybe<Array<Order_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Training_Order_By>>;
  where?: InputMaybe<Order_Training_Bool_Exp>;
};


export type Subscription_RootOrder_Training_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Training_Order_By>>;
  where?: InputMaybe<Order_Training_Bool_Exp>;
};


export type Subscription_RootOrder_Training_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrder_Training_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Training_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Training_Bool_Exp>;
};


export type Subscription_RootPush_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Push_Notification_Order_By>>;
  where?: InputMaybe<Push_Notification_Bool_Exp>;
};


export type Subscription_RootPush_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Push_Notification_Order_By>>;
  where?: InputMaybe<Push_Notification_Bool_Exp>;
};


export type Subscription_RootPush_Notification_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPush_Notification_ClientArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Push_Notification_Client_Order_By>>;
  where?: InputMaybe<Push_Notification_Client_Bool_Exp>;
};


export type Subscription_RootPush_Notification_Client_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Push_Notification_Client_Order_By>>;
  where?: InputMaybe<Push_Notification_Client_Bool_Exp>;
};


export type Subscription_RootPush_Notification_Client_By_PkArgs = {
  clientId: Scalars['Int'];
  pushNotificationId: Scalars['Int'];
};


export type Subscription_RootPush_Notification_Client_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Push_Notification_Client_Stream_Cursor_Input>>;
  where?: InputMaybe<Push_Notification_Client_Bool_Exp>;
};


export type Subscription_RootPush_Notification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Push_Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Push_Notification_Bool_Exp>;
};


export type Subscription_RootRateArgs = {
  distinct_on?: InputMaybe<Array<Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rate_Order_By>>;
  where?: InputMaybe<Rate_Bool_Exp>;
};


export type Subscription_RootRate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rate_Order_By>>;
  where?: InputMaybe<Rate_Bool_Exp>;
};


export type Subscription_RootRate_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Rate_Stream_Cursor_Input>>;
  where?: InputMaybe<Rate_Bool_Exp>;
};


export type Subscription_RootSearch_ConsultationArgs = {
  args: Search_Consultation_Args;
  distinct_on?: InputMaybe<Array<Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Order_By>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Subscription_RootSearch_Consultation_AggregateArgs = {
  args: Search_Consultation_Args;
  distinct_on?: InputMaybe<Array<Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consultation_Order_By>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Subscription_RootSearch_TestArgs = {
  args: Search_Test_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootSearch_Test_AggregateArgs = {
  args: Search_Test_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootSearch_Test_Most_PopularArgs = {
  args: Search_Test_Most_Popular_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootSearch_Test_Most_Popular_AggregateArgs = {
  args: Search_Test_Most_Popular_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootSearch_Test_ShippingArgs = {
  args: Search_Test_Shipping_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootSearch_Test_Shipping_AggregateArgs = {
  args: Search_Test_Shipping_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootSearch_Test_Shipping_TagArgs = {
  args: Search_Test_Shipping_Tag_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootSearch_Test_Shipping_Tag_AggregateArgs = {
  args: Search_Test_Shipping_Tag_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootSearch_Test_TagArgs = {
  args: Search_Test_Tag_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootSearch_Test_Tag_AggregateArgs = {
  args: Search_Test_Tag_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootSearch_TrainingArgs = {
  args: Search_Training_Args;
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


export type Subscription_RootSearch_Training_AggregateArgs = {
  args: Search_Training_Args;
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


export type Subscription_RootShippingArgs = {
  distinct_on?: InputMaybe<Array<Shipping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipping_Order_By>>;
  where?: InputMaybe<Shipping_Bool_Exp>;
};


export type Subscription_RootShipping_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootShipping_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shipping_Stream_Cursor_Input>>;
  where?: InputMaybe<Shipping_Bool_Exp>;
};


export type Subscription_RootTagArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Subscription_RootTag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Order_By>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Subscription_RootTag_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootTag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Bool_Exp>;
};


export type Subscription_RootTestArgs = {
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootTest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootTest_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTest_LaboratoriesArgs = {
  args: Test_Laboratories_Args;
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Subscription_RootTest_Laboratories_AggregateArgs = {
  args: Test_Laboratories_Args;
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Subscription_RootTest_MaterialArgs = {
  distinct_on?: InputMaybe<Array<Test_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Material_Order_By>>;
  where?: InputMaybe<Test_Material_Bool_Exp>;
};


export type Subscription_RootTest_Material_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Material_Order_By>>;
  where?: InputMaybe<Test_Material_Bool_Exp>;
};


export type Subscription_RootTest_Material_By_PkArgs = {
  materialId: Scalars['Int'];
  testId: Scalars['Int'];
};


export type Subscription_RootTest_Material_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Test_Material_Stream_Cursor_Input>>;
  where?: InputMaybe<Test_Material_Bool_Exp>;
};


export type Subscription_RootTest_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Test_Stream_Cursor_Input>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootTest_TagArgs = {
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


export type Subscription_RootTest_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


export type Subscription_RootTest_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTest_Tag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Test_Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


export type Subscription_RootTests_By_Collection_Point_And_NurseArgs = {
  args: Tests_By_Collection_Point_And_Nurse_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootTests_By_Collection_Point_And_Nurse_AggregateArgs = {
  args: Tests_By_Collection_Point_And_Nurse_Args;
  distinct_on?: InputMaybe<Array<Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Order_By>>;
  where?: InputMaybe<Test_Bool_Exp>;
};


export type Subscription_RootTrainingArgs = {
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


export type Subscription_RootTraining_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


export type Subscription_RootTraining_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTraining_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Training_Stream_Cursor_Input>>;
  where?: InputMaybe<Training_Bool_Exp>;
};

/** columns and relationships of "tag" */
export type Tag = {
  __typename?: 'tag';
  id: Scalars['String'];
  /** A computed field, executes function "tag_tag_i18n" */
  tag?: Maybe<Scalars['String']>;
  tag_i18n: Scalars['jsonb'];
  /** An array relationship */
  testTags: Array<Test_Tag>;
  /** An aggregate relationship */
  testTags_aggregate: Test_Tag_Aggregate;
};


/** columns and relationships of "tag" */
export type TagTag_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "tag" */
export type TagTestTagsArgs = {
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagTestTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};

/** aggregated selection of "tag" */
export type Tag_Aggregate = {
  __typename?: 'tag_aggregate';
  aggregate?: Maybe<Tag_Aggregate_Fields>;
  nodes: Array<Tag>;
};

/** aggregate fields of "tag" */
export type Tag_Aggregate_Fields = {
  __typename?: 'tag_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tag_Max_Fields>;
  min?: Maybe<Tag_Min_Fields>;
};


/** aggregate fields of "tag" */
export type Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tag_Append_Input = {
  tag_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "tag". All fields are combined with a logical 'AND'. */
export type Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Tag_Bool_Exp>>;
  _not?: InputMaybe<Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  tag_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  testTags?: InputMaybe<Test_Tag_Bool_Exp>;
  testTags_aggregate?: InputMaybe<Test_Tag_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tag" */
export enum Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  TagPkey = 'tag_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tag_Delete_At_Path_Input = {
  tag_i18n?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tag_Delete_Elem_Input = {
  tag_i18n?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tag_Delete_Key_Input = {
  tag_i18n?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "tag" */
export type Tag_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  tag_i18n?: InputMaybe<Scalars['jsonb']>;
  testTags?: InputMaybe<Test_Tag_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tag_Max_Fields = {
  __typename?: 'tag_max_fields';
  id?: Maybe<Scalars['String']>;
  /** A computed field, executes function "tag_tag_i18n" */
  tag?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Tag_Min_Fields = {
  __typename?: 'tag_min_fields';
  id?: Maybe<Scalars['String']>;
  /** A computed field, executes function "tag_tag_i18n" */
  tag?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "tag" */
export type Tag_Mutation_Response = {
  __typename?: 'tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag>;
};

/** input type for inserting object relation for remote table "tag" */
export type Tag_Obj_Rel_Insert_Input = {
  data: Tag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_On_Conflict>;
};

/** on_conflict condition type for table "tag" */
export type Tag_On_Conflict = {
  constraint: Tag_Constraint;
  update_columns?: Array<Tag_Update_Column>;
  where?: InputMaybe<Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "tag". */
export type Tag_Order_By = {
  id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  tag_i18n?: InputMaybe<Order_By>;
  testTags_aggregate?: InputMaybe<Test_Tag_Aggregate_Order_By>;
};

/** primary key columns input for table: tag */
export type Tag_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tag_Prepend_Input = {
  tag_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "tag" */
export enum Tag_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TagI18n = 'tag_i18n'
}

/** input type for updating data in table "tag" */
export type Tag_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
  tag_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "tag" */
export type Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  tag_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "tag" */
export enum Tag_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TagI18n = 'tag_i18n'
}

export type Tag_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tag_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tag_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tag_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tag_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tag_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Bool_Exp;
};

/** columns and relationships of "test" */
export type Test = {
  __typename?: 'test';
  /** A computed field, executes function "test_laboratory_tests" */
  availableLaboratoryTests?: Maybe<Array<Laboratory_Test>>;
  bloodlabEligible: Scalars['Boolean'];
  /** An array relationship */
  clientFavouriteTests: Array<Client_Favourite_Test>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "test_description_i18n" */
  description?: Maybe<Scalars['String']>;
  description_i18n: Scalars['jsonb'];
  /** An array relationship */
  discountTests: Array<Discount_Test>;
  /** An aggregate relationship */
  discountTests_aggregate: Discount_Test_Aggregate;
  fulfillment: Scalars['fulfillment_type'];
  id: Scalars['Int'];
  /** A computed field, executes function "test_instructions_i18n" */
  instructions?: Maybe<Scalars['String']>;
  instructions_i18n: Scalars['jsonb'];
  /** A computed field, executes function "test_available" */
  isAvailable?: Maybe<Scalars['Boolean']>;
  /** A computed field, executes function "test_has_nurse_available" */
  isNurseAvailable?: Maybe<Scalars['Boolean']>;
  labInstructions_i18n: Scalars['jsonb'];
  /** An array relationship */
  laboratoryTests: Array<Laboratory_Test>;
  /** An aggregate relationship */
  laboratoryTests_aggregate: Laboratory_Test_Aggregate;
  mostPopular: Scalars['Boolean'];
  /** A computed field, executes function "test_name_i18n" */
  name?: Maybe<Scalars['String']>;
  name_i18n: Scalars['jsonb'];
  /** An array relationship */
  nurseTests: Array<Nurse_Test>;
  /** An aggregate relationship */
  nurseTests_aggregate: Nurse_Test_Aggregate;
  /** An array relationship */
  orderTests: Array<Order_Test>;
  /** A computed field, executes function "test_preparation_i18n" */
  preparation?: Maybe<Scalars['String']>;
  preparation_i18n: Scalars['jsonb'];
  /** A computed field, executes function "test_short_name_i18n" */
  shortName?: Maybe<Scalars['String']>;
  shortName_i18n: Scalars['jsonb'];
  svgIcon?: Maybe<Scalars['String']>;
  /** An array relationship */
  testMaterials: Array<Test_Material>;
  /** An aggregate relationship */
  testMaterials_aggregate: Test_Material_Aggregate;
  /** An array relationship */
  testTags: Array<Test_Tag>;
  /** An aggregate relationship */
  testTags_aggregate: Test_Tag_Aggregate;
  ts__en_GB?: Maybe<Scalars['tsvector']>;
  ts__pl_PL?: Maybe<Scalars['tsvector']>;
  ts__uk_UA?: Maybe<Scalars['tsvector']>;
};


/** columns and relationships of "test" */
export type TestAvailableLaboratoryTestsArgs = {
  args: AvailableLaboratoryTests_Test_Args;
  distinct_on?: InputMaybe<Array<Laboratory_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Test_Order_By>>;
  where?: InputMaybe<Laboratory_Test_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestClientFavouriteTestsArgs = {
  distinct_on?: InputMaybe<Array<Client_Favourite_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Client_Favourite_Test_Order_By>>;
  where?: InputMaybe<Client_Favourite_Test_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestDescription_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "test" */
export type TestDiscountTestsArgs = {
  distinct_on?: InputMaybe<Array<Discount_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Test_Order_By>>;
  where?: InputMaybe<Discount_Test_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestDiscountTests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discount_Test_Order_By>>;
  where?: InputMaybe<Discount_Test_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestInstructions_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "test" */
export type TestIsAvailableArgs = {
  args: IsAvailable_Test_Args;
};


/** columns and relationships of "test" */
export type TestIsNurseAvailableArgs = {
  args: IsNurseAvailable_Test_Args;
};


/** columns and relationships of "test" */
export type TestLabInstructions_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "test" */
export type TestLaboratoryTestsArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Test_Order_By>>;
  where?: InputMaybe<Laboratory_Test_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestLaboratoryTests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Test_Order_By>>;
  where?: InputMaybe<Laboratory_Test_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestName_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "test" */
export type TestNurseTestsArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Test_Order_By>>;
  where?: InputMaybe<Nurse_Test_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestNurseTests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nurse_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nurse_Test_Order_By>>;
  where?: InputMaybe<Nurse_Test_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestOrderTestsArgs = {
  distinct_on?: InputMaybe<Array<Order_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Test_Order_By>>;
  where?: InputMaybe<Order_Test_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestPreparation_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "test" */
export type TestShortName_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "test" */
export type TestTestMaterialsArgs = {
  distinct_on?: InputMaybe<Array<Test_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Material_Order_By>>;
  where?: InputMaybe<Test_Material_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestTestMaterials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Material_Order_By>>;
  where?: InputMaybe<Test_Material_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestTestTagsArgs = {
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};


/** columns and relationships of "test" */
export type TestTestTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Tag_Order_By>>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};

export type Test_Aggregate = {
  __typename?: 'test_aggregate';
  aggregate?: Maybe<Test_Aggregate_Fields>;
  nodes: Array<Test>;
};

/** aggregate fields of "test" */
export type Test_Aggregate_Fields = {
  __typename?: 'test_aggregate_fields';
  avg?: Maybe<Test_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Test_Max_Fields>;
  min?: Maybe<Test_Min_Fields>;
  stddev?: Maybe<Test_Stddev_Fields>;
  stddev_pop?: Maybe<Test_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Test_Stddev_Samp_Fields>;
  sum?: Maybe<Test_Sum_Fields>;
  var_pop?: Maybe<Test_Var_Pop_Fields>;
  var_samp?: Maybe<Test_Var_Samp_Fields>;
  variance?: Maybe<Test_Variance_Fields>;
};


/** aggregate fields of "test" */
export type Test_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Test_Append_Input = {
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  instructions_i18n?: InputMaybe<Scalars['jsonb']>;
  labInstructions_i18n?: InputMaybe<Scalars['jsonb']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
  preparation_i18n?: InputMaybe<Scalars['jsonb']>;
  shortName_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Test_Avg_Fields = {
  __typename?: 'test_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "test". All fields are combined with a logical 'AND'. */
export type Test_Bool_Exp = {
  _and?: InputMaybe<Array<Test_Bool_Exp>>;
  _not?: InputMaybe<Test_Bool_Exp>;
  _or?: InputMaybe<Array<Test_Bool_Exp>>;
  bloodlabEligible?: InputMaybe<Boolean_Comparison_Exp>;
  clientFavouriteTests?: InputMaybe<Client_Favourite_Test_Bool_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  description_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  discountTests?: InputMaybe<Discount_Test_Bool_Exp>;
  discountTests_aggregate?: InputMaybe<Discount_Test_Aggregate_Bool_Exp>;
  fulfillment?: InputMaybe<Fulfillment_Type_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  instructions?: InputMaybe<String_Comparison_Exp>;
  instructions_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  labInstructions_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  laboratoryTests?: InputMaybe<Laboratory_Test_Bool_Exp>;
  laboratoryTests_aggregate?: InputMaybe<Laboratory_Test_Aggregate_Bool_Exp>;
  mostPopular?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  nurseTests?: InputMaybe<Nurse_Test_Bool_Exp>;
  nurseTests_aggregate?: InputMaybe<Nurse_Test_Aggregate_Bool_Exp>;
  orderTests?: InputMaybe<Order_Test_Bool_Exp>;
  preparation?: InputMaybe<String_Comparison_Exp>;
  preparation_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  shortName?: InputMaybe<String_Comparison_Exp>;
  shortName_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  svgIcon?: InputMaybe<String_Comparison_Exp>;
  testMaterials?: InputMaybe<Test_Material_Bool_Exp>;
  testMaterials_aggregate?: InputMaybe<Test_Material_Aggregate_Bool_Exp>;
  testTags?: InputMaybe<Test_Tag_Bool_Exp>;
  testTags_aggregate?: InputMaybe<Test_Tag_Aggregate_Bool_Exp>;
  ts__en_GB?: InputMaybe<Tsvector_Comparison_Exp>;
  ts__pl_PL?: InputMaybe<Tsvector_Comparison_Exp>;
  ts__uk_UA?: InputMaybe<Tsvector_Comparison_Exp>;
};

/** unique or primary key constraints on table "test" */
export enum Test_Constraint {
  /** unique or primary key constraint on columns "id" */
  TestPkey = 'test_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Test_Delete_At_Path_Input = {
  description_i18n?: InputMaybe<Array<Scalars['String']>>;
  instructions_i18n?: InputMaybe<Array<Scalars['String']>>;
  labInstructions_i18n?: InputMaybe<Array<Scalars['String']>>;
  name_i18n?: InputMaybe<Array<Scalars['String']>>;
  preparation_i18n?: InputMaybe<Array<Scalars['String']>>;
  shortName_i18n?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Test_Delete_Elem_Input = {
  description_i18n?: InputMaybe<Scalars['Int']>;
  instructions_i18n?: InputMaybe<Scalars['Int']>;
  labInstructions_i18n?: InputMaybe<Scalars['Int']>;
  name_i18n?: InputMaybe<Scalars['Int']>;
  preparation_i18n?: InputMaybe<Scalars['Int']>;
  shortName_i18n?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Test_Delete_Key_Input = {
  description_i18n?: InputMaybe<Scalars['String']>;
  instructions_i18n?: InputMaybe<Scalars['String']>;
  labInstructions_i18n?: InputMaybe<Scalars['String']>;
  name_i18n?: InputMaybe<Scalars['String']>;
  preparation_i18n?: InputMaybe<Scalars['String']>;
  shortName_i18n?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "test" */
export type Test_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "test" */
export type Test_Insert_Input = {
  bloodlabEligible?: InputMaybe<Scalars['Boolean']>;
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  discountTests?: InputMaybe<Discount_Test_Arr_Rel_Insert_Input>;
  fulfillment?: InputMaybe<Scalars['fulfillment_type']>;
  id?: InputMaybe<Scalars['Int']>;
  instructions_i18n?: InputMaybe<Scalars['jsonb']>;
  labInstructions_i18n?: InputMaybe<Scalars['jsonb']>;
  laboratoryTests?: InputMaybe<Laboratory_Test_Arr_Rel_Insert_Input>;
  mostPopular?: InputMaybe<Scalars['Boolean']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
  nurseTests?: InputMaybe<Nurse_Test_Arr_Rel_Insert_Input>;
  orderTests?: InputMaybe<Order_Test_Arr_Rel_Insert_Input>;
  preparation_i18n?: InputMaybe<Scalars['jsonb']>;
  shortName_i18n?: InputMaybe<Scalars['jsonb']>;
  svgIcon?: InputMaybe<Scalars['String']>;
  testMaterials?: InputMaybe<Test_Material_Arr_Rel_Insert_Input>;
  testTags?: InputMaybe<Test_Tag_Arr_Rel_Insert_Input>;
};

export type Test_Laboratories_Args = {
  _test_id?: InputMaybe<Scalars['Int']>;
  point?: InputMaybe<Scalars['geography']>;
};

/** columns and relationships of "test_material" */
export type Test_Material = {
  __typename?: 'test_material';
  /** An object relationship */
  material: Material;
  materialId: Scalars['Int'];
  /** An object relationship */
  test: Test;
  testId: Scalars['Int'];
};

/** aggregated selection of "test_material" */
export type Test_Material_Aggregate = {
  __typename?: 'test_material_aggregate';
  aggregate?: Maybe<Test_Material_Aggregate_Fields>;
  nodes: Array<Test_Material>;
};

export type Test_Material_Aggregate_Bool_Exp = {
  count?: InputMaybe<Test_Material_Aggregate_Bool_Exp_Count>;
};

export type Test_Material_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Test_Material_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Test_Material_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "test_material" */
export type Test_Material_Aggregate_Fields = {
  __typename?: 'test_material_aggregate_fields';
  avg?: Maybe<Test_Material_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Test_Material_Max_Fields>;
  min?: Maybe<Test_Material_Min_Fields>;
  stddev?: Maybe<Test_Material_Stddev_Fields>;
  stddev_pop?: Maybe<Test_Material_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Test_Material_Stddev_Samp_Fields>;
  sum?: Maybe<Test_Material_Sum_Fields>;
  var_pop?: Maybe<Test_Material_Var_Pop_Fields>;
  var_samp?: Maybe<Test_Material_Var_Samp_Fields>;
  variance?: Maybe<Test_Material_Variance_Fields>;
};


/** aggregate fields of "test_material" */
export type Test_Material_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Test_Material_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "test_material" */
export type Test_Material_Aggregate_Order_By = {
  avg?: InputMaybe<Test_Material_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Test_Material_Max_Order_By>;
  min?: InputMaybe<Test_Material_Min_Order_By>;
  stddev?: InputMaybe<Test_Material_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Test_Material_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Test_Material_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Test_Material_Sum_Order_By>;
  var_pop?: InputMaybe<Test_Material_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Test_Material_Var_Samp_Order_By>;
  variance?: InputMaybe<Test_Material_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "test_material" */
export type Test_Material_Arr_Rel_Insert_Input = {
  data: Array<Test_Material_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Test_Material_On_Conflict>;
};

/** aggregate avg on columns */
export type Test_Material_Avg_Fields = {
  __typename?: 'test_material_avg_fields';
  materialId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "test_material" */
export type Test_Material_Avg_Order_By = {
  materialId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "test_material". All fields are combined with a logical 'AND'. */
export type Test_Material_Bool_Exp = {
  _and?: InputMaybe<Array<Test_Material_Bool_Exp>>;
  _not?: InputMaybe<Test_Material_Bool_Exp>;
  _or?: InputMaybe<Array<Test_Material_Bool_Exp>>;
  material?: InputMaybe<Material_Bool_Exp>;
  materialId?: InputMaybe<Int_Comparison_Exp>;
  test?: InputMaybe<Test_Bool_Exp>;
  testId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "test_material" */
export enum Test_Material_Constraint {
  /** unique or primary key constraint on columns "material_id", "test_id" */
  TestMaterialPkey = 'test_material_pkey'
}

/** input type for inserting data into table "test_material" */
export type Test_Material_Insert_Input = {
  material?: InputMaybe<Material_Obj_Rel_Insert_Input>;
  materialId?: InputMaybe<Scalars['Int']>;
  test?: InputMaybe<Test_Obj_Rel_Insert_Input>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Test_Material_Max_Fields = {
  __typename?: 'test_material_max_fields';
  materialId?: Maybe<Scalars['Int']>;
  testId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "test_material" */
export type Test_Material_Max_Order_By = {
  materialId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Test_Material_Min_Fields = {
  __typename?: 'test_material_min_fields';
  materialId?: Maybe<Scalars['Int']>;
  testId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "test_material" */
export type Test_Material_Min_Order_By = {
  materialId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "test_material" */
export type Test_Material_Mutation_Response = {
  __typename?: 'test_material_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Test_Material>;
};

/** on_conflict condition type for table "test_material" */
export type Test_Material_On_Conflict = {
  constraint: Test_Material_Constraint;
  update_columns?: Array<Test_Material_Update_Column>;
  where?: InputMaybe<Test_Material_Bool_Exp>;
};

/** Ordering options when selecting data from "test_material". */
export type Test_Material_Order_By = {
  material?: InputMaybe<Material_Order_By>;
  materialId?: InputMaybe<Order_By>;
  test?: InputMaybe<Test_Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** select columns of table "test_material" */
export enum Test_Material_Select_Column {
  /** column name */
  MaterialId = 'materialId',
  /** column name */
  TestId = 'testId'
}

/** aggregate stddev on columns */
export type Test_Material_Stddev_Fields = {
  __typename?: 'test_material_stddev_fields';
  materialId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "test_material" */
export type Test_Material_Stddev_Order_By = {
  materialId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Test_Material_Stddev_Pop_Fields = {
  __typename?: 'test_material_stddev_pop_fields';
  materialId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "test_material" */
export type Test_Material_Stddev_Pop_Order_By = {
  materialId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Test_Material_Stddev_Samp_Fields = {
  __typename?: 'test_material_stddev_samp_fields';
  materialId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "test_material" */
export type Test_Material_Stddev_Samp_Order_By = {
  materialId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "test_material" */
export type Test_Material_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test_Material_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test_Material_Stream_Cursor_Value_Input = {
  materialId?: InputMaybe<Scalars['Int']>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Test_Material_Sum_Fields = {
  __typename?: 'test_material_sum_fields';
  materialId?: Maybe<Scalars['Int']>;
  testId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "test_material" */
export type Test_Material_Sum_Order_By = {
  materialId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "test_material" (current role has no relevant permissions) */
export enum Test_Material_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type Test_Material_Var_Pop_Fields = {
  __typename?: 'test_material_var_pop_fields';
  materialId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "test_material" */
export type Test_Material_Var_Pop_Order_By = {
  materialId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Test_Material_Var_Samp_Fields = {
  __typename?: 'test_material_var_samp_fields';
  materialId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "test_material" */
export type Test_Material_Var_Samp_Order_By = {
  materialId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Test_Material_Variance_Fields = {
  __typename?: 'test_material_variance_fields';
  materialId?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "test_material" */
export type Test_Material_Variance_Order_By = {
  materialId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Test_Max_Fields = {
  __typename?: 'test_max_fields';
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "test_description_i18n" */
  description?: Maybe<Scalars['String']>;
  fulfillment?: Maybe<Scalars['fulfillment_type']>;
  id?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "test_instructions_i18n" */
  instructions?: Maybe<Scalars['String']>;
  /** A computed field, executes function "test_name_i18n" */
  name?: Maybe<Scalars['String']>;
  /** A computed field, executes function "test_preparation_i18n" */
  preparation?: Maybe<Scalars['String']>;
  /** A computed field, executes function "test_short_name_i18n" */
  shortName?: Maybe<Scalars['String']>;
  svgIcon?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Test_Min_Fields = {
  __typename?: 'test_min_fields';
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "test_description_i18n" */
  description?: Maybe<Scalars['String']>;
  fulfillment?: Maybe<Scalars['fulfillment_type']>;
  id?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "test_instructions_i18n" */
  instructions?: Maybe<Scalars['String']>;
  /** A computed field, executes function "test_name_i18n" */
  name?: Maybe<Scalars['String']>;
  /** A computed field, executes function "test_preparation_i18n" */
  preparation?: Maybe<Scalars['String']>;
  /** A computed field, executes function "test_short_name_i18n" */
  shortName?: Maybe<Scalars['String']>;
  svgIcon?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "test" */
export type Test_Mutation_Response = {
  __typename?: 'test_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Test>;
};

/** input type for inserting object relation for remote table "test" */
export type Test_Obj_Rel_Insert_Input = {
  data: Test_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Test_On_Conflict>;
};

/** on_conflict condition type for table "test" */
export type Test_On_Conflict = {
  constraint: Test_Constraint;
  update_columns?: Array<Test_Update_Column>;
  where?: InputMaybe<Test_Bool_Exp>;
};

/** Ordering options when selecting data from "test". */
export type Test_Order_By = {
  bloodlabEligible?: InputMaybe<Order_By>;
  clientFavouriteTests_aggregate?: InputMaybe<Client_Favourite_Test_Aggregate_Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_i18n?: InputMaybe<Order_By>;
  discountTests_aggregate?: InputMaybe<Discount_Test_Aggregate_Order_By>;
  fulfillment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructions?: InputMaybe<Order_By>;
  instructions_i18n?: InputMaybe<Order_By>;
  labInstructions_i18n?: InputMaybe<Order_By>;
  laboratoryTests_aggregate?: InputMaybe<Laboratory_Test_Aggregate_Order_By>;
  mostPopular?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_i18n?: InputMaybe<Order_By>;
  nurseTests_aggregate?: InputMaybe<Nurse_Test_Aggregate_Order_By>;
  orderTests_aggregate?: InputMaybe<Order_Test_Aggregate_Order_By>;
  preparation?: InputMaybe<Order_By>;
  preparation_i18n?: InputMaybe<Order_By>;
  shortName?: InputMaybe<Order_By>;
  shortName_i18n?: InputMaybe<Order_By>;
  svgIcon?: InputMaybe<Order_By>;
  testMaterials_aggregate?: InputMaybe<Test_Material_Aggregate_Order_By>;
  testTags_aggregate?: InputMaybe<Test_Tag_Aggregate_Order_By>;
  ts__en_GB?: InputMaybe<Order_By>;
  ts__pl_PL?: InputMaybe<Order_By>;
  ts__uk_UA?: InputMaybe<Order_By>;
};

/** primary key columns input for table: test */
export type Test_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Test_Prepend_Input = {
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  instructions_i18n?: InputMaybe<Scalars['jsonb']>;
  labInstructions_i18n?: InputMaybe<Scalars['jsonb']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
  preparation_i18n?: InputMaybe<Scalars['jsonb']>;
  shortName_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "test" */
export enum Test_Select_Column {
  /** column name */
  BloodlabEligible = 'bloodlabEligible',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DescriptionI18n = 'description_i18n',
  /** column name */
  Fulfillment = 'fulfillment',
  /** column name */
  Id = 'id',
  /** column name */
  InstructionsI18n = 'instructions_i18n',
  /** column name */
  LabInstructionsI18n = 'labInstructions_i18n',
  /** column name */
  MostPopular = 'mostPopular',
  /** column name */
  NameI18n = 'name_i18n',
  /** column name */
  PreparationI18n = 'preparation_i18n',
  /** column name */
  ShortNameI18n = 'shortName_i18n',
  /** column name */
  SvgIcon = 'svgIcon',
  /** column name */
  TsEnGb = 'ts__en_GB',
  /** column name */
  TsPlPl = 'ts__pl_PL',
  /** column name */
  TsUkUa = 'ts__uk_UA'
}

/** input type for updating data in table "test" */
export type Test_Set_Input = {
  bloodlabEligible?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  fulfillment?: InputMaybe<Scalars['fulfillment_type']>;
  id?: InputMaybe<Scalars['Int']>;
  instructions_i18n?: InputMaybe<Scalars['jsonb']>;
  labInstructions_i18n?: InputMaybe<Scalars['jsonb']>;
  mostPopular?: InputMaybe<Scalars['Boolean']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
  preparation_i18n?: InputMaybe<Scalars['jsonb']>;
  shortName_i18n?: InputMaybe<Scalars['jsonb']>;
  svgIcon?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Test_Stddev_Fields = {
  __typename?: 'test_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Test_Stddev_Pop_Fields = {
  __typename?: 'test_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Test_Stddev_Samp_Fields = {
  __typename?: 'test_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "test" */
export type Test_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test_Stream_Cursor_Value_Input = {
  bloodlabEligible?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  fulfillment?: InputMaybe<Scalars['fulfillment_type']>;
  id?: InputMaybe<Scalars['Int']>;
  instructions_i18n?: InputMaybe<Scalars['jsonb']>;
  labInstructions_i18n?: InputMaybe<Scalars['jsonb']>;
  mostPopular?: InputMaybe<Scalars['Boolean']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
  preparation_i18n?: InputMaybe<Scalars['jsonb']>;
  shortName_i18n?: InputMaybe<Scalars['jsonb']>;
  svgIcon?: InputMaybe<Scalars['String']>;
  ts__en_GB?: InputMaybe<Scalars['tsvector']>;
  ts__pl_PL?: InputMaybe<Scalars['tsvector']>;
  ts__uk_UA?: InputMaybe<Scalars['tsvector']>;
};

/** aggregate sum on columns */
export type Test_Sum_Fields = {
  __typename?: 'test_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "test_tag" */
export type Test_Tag = {
  __typename?: 'test_tag';
  /** An object relationship */
  Tag: Tag;
  id: Scalars['Int'];
  tag?: Maybe<Scalars['String']>;
  tagId: Scalars['String'];
  /** An object relationship */
  test: Test;
  testId: Scalars['Int'];
};

/** aggregated selection of "test_tag" */
export type Test_Tag_Aggregate = {
  __typename?: 'test_tag_aggregate';
  aggregate?: Maybe<Test_Tag_Aggregate_Fields>;
  nodes: Array<Test_Tag>;
};

export type Test_Tag_Aggregate_Bool_Exp = {
  count?: InputMaybe<Test_Tag_Aggregate_Bool_Exp_Count>;
};

export type Test_Tag_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Test_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Test_Tag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "test_tag" */
export type Test_Tag_Aggregate_Fields = {
  __typename?: 'test_tag_aggregate_fields';
  avg?: Maybe<Test_Tag_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Test_Tag_Max_Fields>;
  min?: Maybe<Test_Tag_Min_Fields>;
  stddev?: Maybe<Test_Tag_Stddev_Fields>;
  stddev_pop?: Maybe<Test_Tag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Test_Tag_Stddev_Samp_Fields>;
  sum?: Maybe<Test_Tag_Sum_Fields>;
  var_pop?: Maybe<Test_Tag_Var_Pop_Fields>;
  var_samp?: Maybe<Test_Tag_Var_Samp_Fields>;
  variance?: Maybe<Test_Tag_Variance_Fields>;
};


/** aggregate fields of "test_tag" */
export type Test_Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Test_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "test_tag" */
export type Test_Tag_Aggregate_Order_By = {
  avg?: InputMaybe<Test_Tag_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Test_Tag_Max_Order_By>;
  min?: InputMaybe<Test_Tag_Min_Order_By>;
  stddev?: InputMaybe<Test_Tag_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Test_Tag_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Test_Tag_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Test_Tag_Sum_Order_By>;
  var_pop?: InputMaybe<Test_Tag_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Test_Tag_Var_Samp_Order_By>;
  variance?: InputMaybe<Test_Tag_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "test_tag" */
export type Test_Tag_Arr_Rel_Insert_Input = {
  data: Array<Test_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Test_Tag_On_Conflict>;
};

/** aggregate avg on columns */
export type Test_Tag_Avg_Fields = {
  __typename?: 'test_tag_avg_fields';
  id?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "test_tag" */
export type Test_Tag_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "test_tag". All fields are combined with a logical 'AND'. */
export type Test_Tag_Bool_Exp = {
  Tag?: InputMaybe<Tag_Bool_Exp>;
  _and?: InputMaybe<Array<Test_Tag_Bool_Exp>>;
  _not?: InputMaybe<Test_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Test_Tag_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  tagId?: InputMaybe<String_Comparison_Exp>;
  test?: InputMaybe<Test_Bool_Exp>;
  testId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "test_tag" */
export enum Test_Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  TestTagPkey = 'test_tag_pkey'
}

/** input type for inserting data into table "test_tag" */
export type Test_Tag_Insert_Input = {
  Tag?: InputMaybe<Tag_Obj_Rel_Insert_Input>;
  tagId?: InputMaybe<Scalars['String']>;
  test?: InputMaybe<Test_Obj_Rel_Insert_Input>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Test_Tag_Max_Fields = {
  __typename?: 'test_tag_max_fields';
  id?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['String']>;
  testId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "test_tag" */
export type Test_Tag_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Test_Tag_Min_Fields = {
  __typename?: 'test_tag_min_fields';
  id?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
  tagId?: Maybe<Scalars['String']>;
  testId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "test_tag" */
export type Test_Tag_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "test_tag" */
export type Test_Tag_Mutation_Response = {
  __typename?: 'test_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Test_Tag>;
};

/** on_conflict condition type for table "test_tag" */
export type Test_Tag_On_Conflict = {
  constraint: Test_Tag_Constraint;
  update_columns?: Array<Test_Tag_Update_Column>;
  where?: InputMaybe<Test_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "test_tag". */
export type Test_Tag_Order_By = {
  Tag?: InputMaybe<Tag_Order_By>;
  id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  tagId?: InputMaybe<Order_By>;
  test?: InputMaybe<Test_Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** select columns of table "test_tag" */
export enum Test_Tag_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Tag = 'tag',
  /** column name */
  TagId = 'tagId',
  /** column name */
  TestId = 'testId'
}

/** aggregate stddev on columns */
export type Test_Tag_Stddev_Fields = {
  __typename?: 'test_tag_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "test_tag" */
export type Test_Tag_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Test_Tag_Stddev_Pop_Fields = {
  __typename?: 'test_tag_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "test_tag" */
export type Test_Tag_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Test_Tag_Stddev_Samp_Fields = {
  __typename?: 'test_tag_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "test_tag" */
export type Test_Tag_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "test_tag" */
export type Test_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test_Tag_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
  tagId?: InputMaybe<Scalars['String']>;
  testId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Test_Tag_Sum_Fields = {
  __typename?: 'test_tag_sum_fields';
  id?: Maybe<Scalars['Int']>;
  testId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "test_tag" */
export type Test_Tag_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "test_tag" (current role has no relevant permissions) */
export enum Test_Tag_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type Test_Tag_Var_Pop_Fields = {
  __typename?: 'test_tag_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "test_tag" */
export type Test_Tag_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Test_Tag_Var_Samp_Fields = {
  __typename?: 'test_tag_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "test_tag" */
export type Test_Tag_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Test_Tag_Variance_Fields = {
  __typename?: 'test_tag_variance_fields';
  id?: Maybe<Scalars['Float']>;
  testId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "test_tag" */
export type Test_Tag_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  testId?: InputMaybe<Order_By>;
};

/** update columns of table "test" */
export enum Test_Update_Column {
  /** column name */
  BloodlabEligible = 'bloodlabEligible',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DescriptionI18n = 'description_i18n',
  /** column name */
  Fulfillment = 'fulfillment',
  /** column name */
  Id = 'id',
  /** column name */
  InstructionsI18n = 'instructions_i18n',
  /** column name */
  LabInstructionsI18n = 'labInstructions_i18n',
  /** column name */
  MostPopular = 'mostPopular',
  /** column name */
  NameI18n = 'name_i18n',
  /** column name */
  PreparationI18n = 'preparation_i18n',
  /** column name */
  ShortNameI18n = 'shortName_i18n',
  /** column name */
  SvgIcon = 'svgIcon'
}

export type Test_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Test_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Test_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Test_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Test_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Test_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Test_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Test_Set_Input>;
  /** filter the rows which have to be updated */
  where: Test_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Test_Var_Pop_Fields = {
  __typename?: 'test_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Test_Var_Samp_Fields = {
  __typename?: 'test_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Test_Variance_Fields = {
  __typename?: 'test_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Tests_By_Collection_Point_And_Nurse_Args = {
  collectionpointid?: InputMaybe<Scalars['Int']>;
  nurseid?: InputMaybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "training" */
export type Training = {
  __typename?: 'training';
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "training_description_i18n" */
  description?: Maybe<Scalars['String']>;
  description_i18n: Scalars['jsonb'];
  id: Scalars['Int'];
  /** A computed field, executes function "training_name_i18n" */
  name?: Maybe<Scalars['String']>;
  name_i18n: Scalars['jsonb'];
  /** An array relationship */
  orderTrainings: Array<Order_Training>;
  /** An aggregate relationship */
  orderTrainings_aggregate: Order_Training_Aggregate;
  /** An object relationship */
  previewFile: File;
  previewFileId: Scalars['Int'];
  price: Scalars['numeric'];
  /** An object relationship */
  videoFile: File;
  videoFileId: Scalars['Int'];
};


/** columns and relationships of "training" */
export type TrainingDescription_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "training" */
export type TrainingName_I18nArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "training" */
export type TrainingOrderTrainingsArgs = {
  distinct_on?: InputMaybe<Array<Order_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Training_Order_By>>;
  where?: InputMaybe<Order_Training_Bool_Exp>;
};


/** columns and relationships of "training" */
export type TrainingOrderTrainings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Training_Order_By>>;
  where?: InputMaybe<Order_Training_Bool_Exp>;
};

/** aggregated selection of "training" */
export type Training_Aggregate = {
  __typename?: 'training_aggregate';
  aggregate?: Maybe<Training_Aggregate_Fields>;
  nodes: Array<Training>;
};

export type Training_Aggregate_Bool_Exp = {
  count?: InputMaybe<Training_Aggregate_Bool_Exp_Count>;
};

export type Training_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Training_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Training_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "training" */
export type Training_Aggregate_Fields = {
  __typename?: 'training_aggregate_fields';
  avg?: Maybe<Training_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Training_Max_Fields>;
  min?: Maybe<Training_Min_Fields>;
  stddev?: Maybe<Training_Stddev_Fields>;
  stddev_pop?: Maybe<Training_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Training_Stddev_Samp_Fields>;
  sum?: Maybe<Training_Sum_Fields>;
  var_pop?: Maybe<Training_Var_Pop_Fields>;
  var_samp?: Maybe<Training_Var_Samp_Fields>;
  variance?: Maybe<Training_Variance_Fields>;
};


/** aggregate fields of "training" */
export type Training_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Training_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "training" */
export type Training_Aggregate_Order_By = {
  avg?: InputMaybe<Training_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Training_Max_Order_By>;
  min?: InputMaybe<Training_Min_Order_By>;
  stddev?: InputMaybe<Training_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Training_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Training_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Training_Sum_Order_By>;
  var_pop?: InputMaybe<Training_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Training_Var_Samp_Order_By>;
  variance?: InputMaybe<Training_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Training_Append_Input = {
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "training" */
export type Training_Arr_Rel_Insert_Input = {
  data: Array<Training_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Training_On_Conflict>;
};

/** aggregate avg on columns */
export type Training_Avg_Fields = {
  __typename?: 'training_avg_fields';
  id?: Maybe<Scalars['Float']>;
  previewFileId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  videoFileId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "training" */
export type Training_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  previewFileId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "training". All fields are combined with a logical 'AND'. */
export type Training_Bool_Exp = {
  _and?: InputMaybe<Array<Training_Bool_Exp>>;
  _not?: InputMaybe<Training_Bool_Exp>;
  _or?: InputMaybe<Array<Training_Bool_Exp>>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  description_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_i18n?: InputMaybe<Jsonb_Comparison_Exp>;
  orderTrainings?: InputMaybe<Order_Training_Bool_Exp>;
  orderTrainings_aggregate?: InputMaybe<Order_Training_Aggregate_Bool_Exp>;
  previewFile?: InputMaybe<File_Bool_Exp>;
  previewFileId?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  videoFile?: InputMaybe<File_Bool_Exp>;
  videoFileId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "training" */
export enum Training_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrainingPkey = 'training_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Training_Delete_At_Path_Input = {
  description_i18n?: InputMaybe<Array<Scalars['String']>>;
  name_i18n?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Training_Delete_Elem_Input = {
  description_i18n?: InputMaybe<Scalars['Int']>;
  name_i18n?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Training_Delete_Key_Input = {
  description_i18n?: InputMaybe<Scalars['String']>;
  name_i18n?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "training" */
export type Training_Inc_Input = {
  previewFileId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  videoFileId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "training" */
export type Training_Insert_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
  previewFile?: InputMaybe<File_Obj_Rel_Insert_Input>;
  previewFileId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  videoFile?: InputMaybe<File_Obj_Rel_Insert_Input>;
  videoFileId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Training_Max_Fields = {
  __typename?: 'training_max_fields';
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "training_description_i18n" */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "training_name_i18n" */
  name?: Maybe<Scalars['String']>;
  previewFileId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  videoFileId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "training" */
export type Training_Max_Order_By = {
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  previewFileId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Training_Min_Fields = {
  __typename?: 'training_min_fields';
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "training_description_i18n" */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "training_name_i18n" */
  name?: Maybe<Scalars['String']>;
  previewFileId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  videoFileId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "training" */
export type Training_Min_Order_By = {
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  previewFileId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "training" */
export type Training_Mutation_Response = {
  __typename?: 'training_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Training>;
};

/** input type for inserting object relation for remote table "training" */
export type Training_Obj_Rel_Insert_Input = {
  data: Training_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Training_On_Conflict>;
};

/** on_conflict condition type for table "training" */
export type Training_On_Conflict = {
  constraint: Training_Constraint;
  update_columns?: Array<Training_Update_Column>;
  where?: InputMaybe<Training_Bool_Exp>;
};

/** Ordering options when selecting data from "training". */
export type Training_Order_By = {
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_i18n?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_i18n?: InputMaybe<Order_By>;
  orderTrainings_aggregate?: InputMaybe<Order_Training_Aggregate_Order_By>;
  previewFile?: InputMaybe<File_Order_By>;
  previewFileId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  videoFile?: InputMaybe<File_Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: training */
export type Training_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Training_Prepend_Input = {
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "training" */
export enum Training_Select_Column {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DescriptionI18n = 'description_i18n',
  /** column name */
  Id = 'id',
  /** column name */
  NameI18n = 'name_i18n',
  /** column name */
  PreviewFileId = 'previewFileId',
  /** column name */
  Price = 'price',
  /** column name */
  VideoFileId = 'videoFileId'
}

/** input type for updating data in table "training" */
export type Training_Set_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
  previewFileId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  videoFileId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Training_Stddev_Fields = {
  __typename?: 'training_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  previewFileId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  videoFileId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "training" */
export type Training_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  previewFileId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Training_Stddev_Pop_Fields = {
  __typename?: 'training_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  previewFileId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  videoFileId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "training" */
export type Training_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  previewFileId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Training_Stddev_Samp_Fields = {
  __typename?: 'training_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  previewFileId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  videoFileId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "training" */
export type Training_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  previewFileId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "training" */
export type Training_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Training_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Training_Stream_Cursor_Value_Input = {
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description_i18n?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  name_i18n?: InputMaybe<Scalars['jsonb']>;
  previewFileId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  videoFileId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Training_Sum_Fields = {
  __typename?: 'training_sum_fields';
  id?: Maybe<Scalars['Int']>;
  previewFileId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  videoFileId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "training" */
export type Training_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  previewFileId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** update columns of table "training" */
export enum Training_Update_Column {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DescriptionI18n = 'description_i18n',
  /** column name */
  NameI18n = 'name_i18n',
  /** column name */
  PreviewFileId = 'previewFileId',
  /** column name */
  Price = 'price',
  /** column name */
  VideoFileId = 'videoFileId'
}

export type Training_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Training_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Training_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Training_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Training_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Training_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Training_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Training_Set_Input>;
  /** filter the rows which have to be updated */
  where: Training_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Training_Var_Pop_Fields = {
  __typename?: 'training_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  previewFileId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  videoFileId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "training" */
export type Training_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  previewFileId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Training_Var_Samp_Fields = {
  __typename?: 'training_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  previewFileId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  videoFileId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "training" */
export type Training_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  previewFileId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Training_Variance_Fields = {
  __typename?: 'training_variance_fields';
  id?: Maybe<Scalars['Float']>;
  previewFileId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  videoFileId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "training" */
export type Training_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  previewFileId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  videoFileId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "tsvector". All fields are combined with logical 'AND'. */
export type Tsvector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tsvector']>;
  _gt?: InputMaybe<Scalars['tsvector']>;
  _gte?: InputMaybe<Scalars['tsvector']>;
  _in?: InputMaybe<Array<Scalars['tsvector']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['tsvector']>;
  _lte?: InputMaybe<Scalars['tsvector']>;
  _neq?: InputMaybe<Scalars['tsvector']>;
  _nin?: InputMaybe<Array<Scalars['tsvector']>>;
};

export type DeleteAdministratorNotificationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAdministratorNotificationMutation = { __typename?: 'mutation_root', delete_administrator_notification_by_pk?: { __typename?: 'administrator_notification', id: number } | null };

export type DeleteCollectionSlotMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCollectionSlotMutation = { __typename?: 'mutation_root', delete_collection_slot_by_pk?: { __typename?: 'collection_slot', id: number } | null };

export type DeleteConsultationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteConsultationMutation = { __typename?: 'mutation_root', update_consultation_by_pk?: { __typename?: 'consultation', id: number } | null };

export type DeleteConsultationSlotMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteConsultationSlotMutation = { __typename?: 'mutation_root', delete_consultation_slot_by_pk?: { __typename?: 'consultation_slot', id: number } | null };

export type DeleteDiscountMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteDiscountMutation = { __typename?: 'mutation_root', update_discount_by_pk?: { __typename?: 'discount', id: number } | null };

export type DeleteDiscountConsultationMutationVariables = Exact<{
  discountId: Scalars['Int'];
  consultationId: Scalars['Int'];
}>;


export type DeleteDiscountConsultationMutation = { __typename?: 'mutation_root', delete_discount_consultation_by_pk?: { __typename?: 'discount_consultation', discountId: number, consultationId: number } | null };

export type DeleteDiscountTestMutationVariables = Exact<{
  discountId: Scalars['Int'];
  testId: Scalars['Int'];
}>;


export type DeleteDiscountTestMutation = { __typename?: 'mutation_root', delete_discount_test_by_pk?: { __typename?: 'discount_test', discountId: number, testId: number } | null };

export type DeleteDiscountTrainingMutationVariables = Exact<{
  discountId: Scalars['Int'];
  trainingId: Scalars['Int'];
}>;


export type DeleteDiscountTrainingMutation = { __typename?: 'mutation_root', delete_discount_training_by_pk?: { __typename?: 'discount_training', discountId: number, trainingId: number } | null };

export type DeleteLabUserMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLabUserMutation = { __typename?: 'mutation_root', delete_lab_user_by_pk?: { __typename?: 'lab_user', id: number } | null };

export type DeleteLaboratoryTestMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLaboratoryTestMutation = { __typename?: 'mutation_root', delete_laboratory_test_by_pk?: { __typename?: 'laboratory_test', id: number } | null };

export type DeleteNurseMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteNurseMutation = { __typename?: 'mutation_root', update_nurse_by_pk?: { __typename?: 'nurse', id: number } | null };

export type DeleteOrderTestResultMutationVariables = Exact<{
  fileId: Scalars['Int'];
  orderTestId: Scalars['Int'];
}>;


export type DeleteOrderTestResultMutation = { __typename?: 'mutation_root', delete_order_test_result_by_pk?: { __typename?: 'order_test_result', orderTestId: number, fileId: number } | null };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTagMutation = { __typename?: 'mutation_root', delete_tag_by_pk?: { __typename?: 'tag', id: string } | null };

export type DeleteTestMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteTestMutation = { __typename?: 'mutation_root', update_test_by_pk?: { __typename?: 'test', id: number } | null, delete_client_favourite_test?: { __typename?: 'client_favourite_test_mutation_response', affected_rows: number } | null, delete_laboratory_test?: { __typename?: 'laboratory_test_mutation_response', affected_rows: number } | null, delete_nurse_test?: { __typename?: 'nurse_test_mutation_response', affected_rows: number } | null, delete_test_material?: { __typename?: 'test_material_mutation_response', affected_rows: number } | null, delete_test_tag?: { __typename?: 'test_tag_mutation_response', affected_rows: number } | null };

export type DeleteTrainingMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteTrainingMutation = { __typename?: 'mutation_root', update_training_by_pk?: { __typename?: 'training', id: number } | null };

export type GetAdministratorNotificationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetAdministratorNotificationQuery = { __typename?: 'query_root', administrator_notification_by_pk?: { __typename?: 'administrator_notification', id: number, administratorId: number, scope: string, email: boolean, sms: boolean } | null };

export type GetAdministratorNotificationsQueryVariables = Exact<{
  administratorId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Administrator_Notification_Order_By> | Administrator_Notification_Order_By>;
}>;


export type GetAdministratorNotificationsQuery = { __typename?: 'query_root', administrator_notification: Array<{ __typename?: 'administrator_notification', id: number, administratorId: number, scope: string, email: boolean, sms: boolean }>, administrator_notification_aggregate: { __typename?: 'administrator_notification_aggregate', aggregate?: { __typename?: 'administrator_notification_aggregate_fields', count: number } | null } };

export type GetAdministratorsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Administrator_Order_By> | Administrator_Order_By>;
}>;


export type GetAdministratorsQuery = { __typename?: 'query_root', administrator: Array<{ __typename?: 'administrator', id: number, email: string, phoneNumber?: string | null, name: string }>, administrator_aggregate: { __typename?: 'administrator_aggregate', aggregate?: { __typename?: 'administrator_aggregate_fields', count: number } | null } };

export type GetAllCollectionSlotsQueryVariables = Exact<{
  collectionPointId: Scalars['Int'];
  minDate: Scalars['timestamptz'];
  orderBy: Array<Collection_Slot_Order_By> | Collection_Slot_Order_By;
}>;


export type GetAllCollectionSlotsQuery = { __typename?: 'query_root', collection_slot: Array<{ __typename?: 'collection_slot', id: number, collectionPointId: number, dateFrom: any, dateTo: any }> };

export type GetAllConsultationSlotsQueryVariables = Exact<{
  consultationId: Scalars['Int'];
  minDate: Scalars['timestamptz'];
  orderBy?: InputMaybe<Array<Consultation_Slot_Order_By> | Consultation_Slot_Order_By>;
}>;


export type GetAllConsultationSlotsQuery = { __typename?: 'query_root', consultation_slot: Array<{ __typename?: 'consultation_slot', id: number, consultationId: number, dateFrom: any, dateTo: any }> };

export type GetAvailableTestsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetAvailableTestsQuery = { __typename?: 'query_root', test: Array<{ __typename?: 'test', id: number, name?: string | null, laboratoryTests_aggregate: { __typename?: 'laboratory_test_aggregate', aggregate?: { __typename?: 'laboratory_test_aggregate_fields', min?: { __typename?: 'laboratory_test_min_fields', price?: number | null } | null, max?: { __typename?: 'laboratory_test_max_fields', price?: number | null } | null } | null } }> };

export type GetClientQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetClientQuery = { __typename?: 'query_root', client_by_pk?: { __typename?: 'client', id: number, email: string, newsletterConsent: boolean, pushConsent: boolean, auth2FAEnabled: boolean, confirmedOn?: any | null } | null };

export type GetClientProfilesQueryVariables = Exact<{
  clientId: Scalars['Int'];
}>;


export type GetClientProfilesQuery = { __typename?: 'query_root', client_profile: Array<{ __typename?: 'client_profile', id: number, firstName: string, lastName: string, phoneNumber: string, identity: any }> };

export type GetClientsQueryVariables = Exact<{
  where?: InputMaybe<Client_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Client_Order_By> | Client_Order_By>;
}>;


export type GetClientsQuery = { __typename?: 'query_root', client: Array<{ __typename?: 'client', id: number, email: string, newsletterConsent: boolean, pushConsent: boolean, auth2FAEnabled: boolean, confirmedOn?: any | null }>, client_aggregate: { __typename?: 'client_aggregate', aggregate?: { __typename?: 'client_aggregate_fields', count: number } | null } };

export type GetClientsWithPushNotificationConsentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientsWithPushNotificationConsentQuery = { __typename?: 'query_root', client: Array<{ __typename?: 'client', id: number, email: string }> };

export type GetCollectionSlotQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetCollectionSlotQuery = { __typename?: 'query_root', collection_slot_by_pk?: { __typename?: 'collection_slot', id: number, collectionPointId: number, dateFrom: any, dateTo: any } | null };

export type GetConsultationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetConsultationQuery = { __typename?: 'query_root', consultation_by_pk?: { __typename?: 'consultation', id: number, name?: string | null, name_i18n: any, description_i18n: any, svgIcon?: string | null, price: number, deletedAt?: any | null } | null };

export type GetConsultationSlotQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetConsultationSlotQuery = { __typename?: 'query_root', consultation_slot_by_pk?: { __typename?: 'consultation_slot', id: number, consultationId: number, dateFrom: any, dateTo: any } | null };

export type GetConsultationSlotsQueryVariables = Exact<{
  consultationId: Scalars['Int'];
  limit?: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Consultation_Slot_Order_By> | Consultation_Slot_Order_By>;
}>;


export type GetConsultationSlotsQuery = { __typename?: 'query_root', consultation_slot: Array<{ __typename?: 'consultation_slot', id: number, consultationId: number, dateFrom: any, dateTo: any }>, consultation_slot_aggregate: { __typename?: 'consultation_slot_aggregate', aggregate?: { __typename?: 'consultation_slot_aggregate_fields', count: number } | null } };

export type GetConsultationsQueryVariables = Exact<{
  limit?: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Consultation_Order_By> | Consultation_Order_By>;
}>;


export type GetConsultationsQuery = { __typename?: 'query_root', consultation: Array<{ __typename?: 'consultation', id: number, name?: string | null, name_i18n: any, description_i18n: any, svgIcon?: string | null, price: number, deletedAt?: any | null }>, consultation_aggregate: { __typename?: 'consultation_aggregate', aggregate?: { __typename?: 'consultation_aggregate_fields', count: number } | null } };

export type GetDiscountQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetDiscountQuery = { __typename?: 'query_root', discount_by_pk?: { __typename?: 'discount', id: number, code: string, dateFrom?: any | null, dateTo?: any | null, percent: number, type: Discount_Type_Enum_Enum, deletedAt?: any | null } | null };

export type GetDiscountConsultationQueryVariables = Exact<{
  discountId: Scalars['Int'];
  consultationId: Scalars['Int'];
}>;


export type GetDiscountConsultationQuery = { __typename?: 'query_root', discount_consultation_by_pk?: { __typename?: 'discount_consultation', discountId: number, consultationId: number, maxCount?: number | null, consultation: { __typename?: 'consultation', id: number, name?: string | null } } | null };

export type GetDiscountConsultationsQueryVariables = Exact<{
  discountId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Discount_Consultation_Order_By> | Discount_Consultation_Order_By>;
}>;


export type GetDiscountConsultationsQuery = { __typename?: 'query_root', discount_consultation: Array<{ __typename?: 'discount_consultation', consultationId: number, maxCount?: number | null, consultation: { __typename?: 'consultation', id: number, name?: string | null } }>, discount_consultation_aggregate: { __typename?: 'discount_consultation_aggregate', aggregate?: { __typename?: 'discount_consultation_aggregate_fields', count: number } | null } };

export type GetDiscountTestQueryVariables = Exact<{
  discountId: Scalars['Int'];
  testId: Scalars['Int'];
}>;


export type GetDiscountTestQuery = { __typename?: 'query_root', discount_test_by_pk?: { __typename?: 'discount_test', discountId: number, testId: number, maxCount?: number | null, test: { __typename?: 'test', id: number, name?: string | null, shortName?: string | null } } | null };

export type GetDiscountTestsQueryVariables = Exact<{
  discountId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Discount_Test_Order_By> | Discount_Test_Order_By>;
}>;


export type GetDiscountTestsQuery = { __typename?: 'query_root', discount_test: Array<{ __typename?: 'discount_test', testId: number, maxCount?: number | null, test: { __typename?: 'test', id: number, shortName?: string | null, name?: string | null } }>, discount_test_aggregate: { __typename?: 'discount_test_aggregate', aggregate?: { __typename?: 'discount_test_aggregate_fields', count: number } | null } };

export type GetDiscountTrainingQueryVariables = Exact<{
  discountId: Scalars['Int'];
  trainingId: Scalars['Int'];
}>;


export type GetDiscountTrainingQuery = { __typename?: 'query_root', discount_training_by_pk?: { __typename?: 'discount_training', discountId: number, trainingId: number, maxCount?: number | null, training: { __typename?: 'training', id: number, name?: string | null } } | null };

export type GetDiscountTrainingsQueryVariables = Exact<{
  discountId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Discount_Training_Order_By> | Discount_Training_Order_By>;
}>;


export type GetDiscountTrainingsQuery = { __typename?: 'query_root', discount_training: Array<{ __typename?: 'discount_training', trainingId: number, maxCount?: number | null, training: { __typename?: 'training', id: number, name?: string | null } }>, discount_training_aggregate: { __typename?: 'discount_training_aggregate', aggregate?: { __typename?: 'discount_training_aggregate_fields', count: number } | null } };

export type GetDiscountsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Discount_Order_By> | Discount_Order_By>;
}>;


export type GetDiscountsQuery = { __typename?: 'query_root', discount: Array<{ __typename?: 'discount', id: number, code: string, dateFrom?: any | null, dateTo?: any | null, percent: number, type: Discount_Type_Enum_Enum, discountTests_aggregate: { __typename?: 'discount_test_aggregate', aggregate?: { __typename?: 'discount_test_aggregate_fields', count: number } | null }, discountConsultations_aggregate: { __typename?: 'discount_consultation_aggregate', aggregate?: { __typename?: 'discount_consultation_aggregate_fields', count: number } | null }, discountTrainings_aggregate: { __typename?: 'discount_training_aggregate', aggregate?: { __typename?: 'discount_training_aggregate_fields', count: number } | null } }>, discount_aggregate: { __typename?: 'discount_aggregate', aggregate?: { __typename?: 'discount_aggregate_fields', count: number } | null } };

export type GetFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeatureFlagsQuery = { __typename?: 'query_root', feature_flags: Array<{ __typename?: 'feature_flags', id: number, key: string, enabled: boolean, description?: string | null, payload?: any | null, project: string }> };

export type GetLabUserQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetLabUserQuery = { __typename?: 'query_root', lab_user_by_pk?: { __typename?: 'lab_user', id: number, email: string, name: string, laboratoryId: number } | null };

export type GetLabUsersQueryVariables = Exact<{
  laboratoryId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Lab_User_Order_By> | Lab_User_Order_By>;
}>;


export type GetLabUsersQuery = { __typename?: 'query_root', lab_user: Array<{ __typename?: 'lab_user', id: number, email: string, name: string, laboratoryId: number }>, lab_user_aggregate: { __typename?: 'lab_user_aggregate', aggregate?: { __typename?: 'lab_user_aggregate_fields', count: number } | null } };

export type GetLaboratoriesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Laboratory_Order_By> | Laboratory_Order_By>;
}>;


export type GetLaboratoriesQuery = { __typename?: 'query_root', laboratory: Array<{ __typename?: 'laboratory', id: number, name: string, shortName?: string | null, url?: string | null, enabled: boolean, useHL7: boolean, logoFileId?: number | null, laboratoryTests: Array<{ __typename?: 'laboratory_test', id: number, laboratoryId: number, testId: number, externalId?: string | null }>, collectionPoints: Array<{ __typename?: 'laboratory_collection_point', id: number, address: string, city: string, postalCode: string, location: import('../lib/geography').Geography, openingHours: any }> }>, laboratory_aggregate: { __typename?: 'laboratory_aggregate', aggregate?: { __typename?: 'laboratory_aggregate_fields', count: number } | null } };

export type GetLaboratoriesByAreaQueryVariables = Exact<{
  area: Scalars['geography'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Laboratory_Order_By> | Laboratory_Order_By>;
}>;


export type GetLaboratoriesByAreaQuery = { __typename?: 'query_root', laboratory: Array<{ __typename?: 'laboratory', id: number, name: string, shortName?: string | null, url?: string | null, enabled: boolean, useHL7: boolean, logoFileId?: number | null, laboratoryTests: Array<{ __typename?: 'laboratory_test', id: number, laboratoryId: number, testId: number, externalId?: string | null }>, collectionPoints: Array<{ __typename?: 'laboratory_collection_point', id: number, address: string, city: string, postalCode: string, location: import('../lib/geography').Geography, openingHours: any }> }>, laboratory_aggregate: { __typename?: 'laboratory_aggregate', aggregate?: { __typename?: 'laboratory_aggregate_fields', count: number } | null } };

export type GetLaboratoryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetLaboratoryQuery = { __typename?: 'query_root', laboratory_by_pk?: { __typename?: 'laboratory', id: number, name: string, shortName?: string | null, url?: string | null, enabled: boolean, useHL7: boolean, logoFileId?: number | null, laboratoryTests: Array<{ __typename?: 'laboratory_test', id: number, laboratoryId: number, testId: number, externalId?: string | null }>, collectionPoints: Array<{ __typename?: 'laboratory_collection_point', id: number, address: string, city: string, postalCode: string, location: import('../lib/geography').Geography, openingHours: any }> } | null };

export type GetLaboratoryCollectionPointQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetLaboratoryCollectionPointQuery = { __typename?: 'query_root', laboratory_collection_point_by_pk?: { __typename?: 'laboratory_collection_point', id: number, name: string, address: string, city: string, postalCode: string, location: import('../lib/geography').Geography, openingHours: any, isVoucherEnabled: boolean, isExternalResults: boolean, email?: string | null, deletedAt?: any | null } | null };

export type GetLaboratoryCollectionPointsByLaboratoryIdQueryVariables = Exact<{
  laboratoryId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Laboratory_Collection_Point_Order_By> | Laboratory_Collection_Point_Order_By>;
}>;


export type GetLaboratoryCollectionPointsByLaboratoryIdQuery = { __typename?: 'query_root', laboratory_collection_point: Array<{ __typename?: 'laboratory_collection_point', id: number, name: string, address: string, city: string, postalCode: string, location: import('../lib/geography').Geography, openingHours: any, isVoucherEnabled: boolean, isExternalResults: boolean, email?: string | null, deletedAt?: any | null }>, laboratory_collection_point_aggregate: { __typename?: 'laboratory_collection_point_aggregate', aggregate?: { __typename?: 'laboratory_collection_point_aggregate_fields', count: number } | null } };

export type GetLaboratoryCostSummaryQueryVariables = Exact<{
  dateFrom: Scalars['timestamptz'];
  dateTo: Scalars['timestamptz'];
  orderBy?: InputMaybe<Array<Laboratory_Order_By> | Laboratory_Order_By>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetLaboratoryCostSummaryQuery = { __typename?: 'query_root', laboratory: Array<{ __typename?: 'laboratory', id: number, name: string, costSummary?: Array<{ __typename?: 'laboratory_summary', costSum?: number | null, orderCount?: number | null, testCount?: number | null }> | null }>, laboratory_aggregate: { __typename?: 'laboratory_aggregate', aggregate?: { __typename?: 'laboratory_aggregate_fields', count: number } | null } };

export type GetLaboratoryShippingByLaboratoryIdQueryVariables = Exact<{
  laboratoryId: Scalars['Int'];
}>;


export type GetLaboratoryShippingByLaboratoryIdQuery = { __typename?: 'query_root', laboratory_shipping: Array<{ __typename?: 'laboratory_shipping', id: number, email: string, phone: string, pointName: string }> };

export type GetLaboratoryTestQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetLaboratoryTestQuery = { __typename?: 'query_root', laboratory_test_by_pk?: { __typename?: 'laboratory_test', id: number, testId: number, laboratoryId: number, price: number, externalId?: string | null, waitingTime_i18n: any } | null };

export type GetLaboratoryTestsQueryVariables = Exact<{
  laboratoryId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Laboratory_Test_Order_By> | Laboratory_Test_Order_By>;
}>;


export type GetLaboratoryTestsQuery = { __typename?: 'query_root', laboratory_test: Array<{ __typename?: 'laboratory_test', id: number, testId: number, price: number, waitingTime?: string | null, test: { __typename?: 'test', name?: string | null } }>, laboratory_test_aggregate: { __typename?: 'laboratory_test_aggregate', aggregate?: { __typename?: 'laboratory_test_aggregate_fields', count: number } | null } };

export type GetLogsQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetLogsQuery = { __typename?: 'query_root', administrator_logs: Array<{ __typename?: 'AdministratorLog', timestamp: any, data?: any | null, prevData?: any | null, type: string, client?: { __typename?: 'client', id: number, email: string } | null, nurse?: { __typename?: 'nurse', id: number, email: string, name?: string | null } | null, orderTest?: { __typename?: 'order_test', id: number, test: { __typename?: 'test', shortName?: string | null } } | null, file?: { __typename?: 'file', id: number, name: string } | null, order?: { __typename?: 'order', id: number, clientId: number, orderCollections: Array<{ __typename?: 'order_collection', nurseId?: number | null }> } | null, orderState?: { __typename?: 'order_state', state: Order_State_Enum_Enum } | null, orderTestResult?: { __typename?: 'order_test_result', originalFilename: string } | null, test?: { __typename?: 'test', id: number, shortName?: string | null } | null, sessionClient?: { __typename?: 'client', id: number, email: string } | null, sessionNurse?: { __typename?: 'nurse', id: number, email: string, name?: string | null } | null, sessionAdministrator?: { __typename?: 'administrator', id: number, email: string, name: string } | null, sessionLabUser?: { __typename?: 'lab_user', id: number, name: string, email: string, laboratoryId: number } | null }> };

export type GetMaterialQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetMaterialQuery = { __typename?: 'query_root', material_by_pk?: { __typename?: 'material', id: number, name: string } | null };

export type GetMaterialsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Material_Order_By> | Material_Order_By>;
}>;


export type GetMaterialsQuery = { __typename?: 'query_root', material: Array<{ __typename?: 'material', id: number, name: string }>, material_aggregate: { __typename?: 'material_aggregate', aggregate?: { __typename?: 'material_aggregate_fields', count: number } | null } };

export type GetNurseQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetNurseQuery = { __typename?: 'query_root', nurse_by_pk?: { __typename?: 'nurse', id: number, email: string, labArea?: import('../lib/geography').Geography | null, name?: string | null, orderArea?: import('../lib/geography').Geography | null, password?: string | null, phoneNumber: string, enabled: boolean, geoEnabled: boolean, auth2FAEnabled: boolean, nurseTests: Array<{ __typename?: 'nurse_test', testId: number }>, nurseMaterials: Array<{ __typename?: 'nurse_material', materialId: number }> } | null };

export type GetNursesByOrderLocationQueryVariables = Exact<{
  location: Scalars['geography'];
}>;


export type GetNursesByOrderLocationQuery = { __typename?: 'query_root', nurse: Array<{ __typename?: 'nurse', id: number, name?: string | null, labArea?: import('../lib/geography').Geography | null }> };

export type GetNurseCostSummaryQueryVariables = Exact<{
  dateFrom: Scalars['timestamptz'];
  dateTo: Scalars['timestamptz'];
  orderBy?: InputMaybe<Array<Nurse_Order_By> | Nurse_Order_By>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetNurseCostSummaryQuery = { __typename?: 'query_root', nurse: Array<{ __typename?: 'nurse', id: number, name?: string | null, costSummary?: Array<{ __typename?: 'nurse_order_cost', collectionCostSum?: number | null, collectionKitCostSum?: number | null, deliveryCostSum?: number | null, orderCount?: number | null, totalCostSum?: number | null }> | null }>, nurse_aggregate: { __typename?: 'nurse_aggregate', aggregate?: { __typename?: 'nurse_aggregate_fields', count: number } | null } };

export type GetNursesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Nurse_Order_By> | Nurse_Order_By>;
}>;


export type GetNursesQuery = { __typename?: 'query_root', nurse: Array<{ __typename?: 'nurse', id: number, email: string, labArea?: import('../lib/geography').Geography | null, name?: string | null, orderArea?: import('../lib/geography').Geography | null, password?: string | null, phoneNumber: string, enabled: boolean, geoEnabled: boolean, auth2FAEnabled: boolean, nurseTests: Array<{ __typename?: 'nurse_test', testId: number }>, nurseMaterials: Array<{ __typename?: 'nurse_material', materialId: number }> }>, nurse_aggregate: { __typename?: 'nurse_aggregate', aggregate?: { __typename?: 'nurse_aggregate_fields', count: number } | null } };

export type GetOrderQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetOrderQuery = { __typename?: 'query_root', order_by_pk?: { __typename?: 'order', id: number, currentState?: string | null, firstStateDate?: any | null, totalCost: number, costBeforeDiscount?: number | null, clientConsent1?: boolean | null, clientConsent3?: boolean | null, clientConsent4?: boolean | null, shippingConsent1?: boolean | null, shippingConsent2?: boolean | null, shippingConsent3?: boolean | null, orderCollections: Array<{ __typename?: 'order_collection', collectionDate?: any | null, isVoucher: boolean, voucherValidUntil?: any | null, nurseNotes?: string | null, address: string, postalCode: string, city: string, phoneNumber: string, collectionCost: number, collectionCostBeforeDiscount?: number | null, collectionKitCost: number, deliveryCost: number, nurse?: { __typename?: 'nurse', id: number, name?: string | null, deletedAt?: any | null } | null, collectionPoint?: { __typename?: 'laboratory_collection_point', isExternalResults: boolean } | null }>, client: { __typename?: 'client', id: number, email: string, regulationsAcceptedAt?: any | null, medicalDocumentationAcceptedAt?: any | null, clientProfiles: Array<{ __typename?: 'client_profile', firstName: string, lastName: string, identity: any }> }, documents: Array<{ __typename?: 'order_document', id: number, fileId: number }>, profiles: Array<{ __typename?: 'order_test', firstName: string, lastName: string, identity?: any | null }>, orderDiscounts: Array<{ __typename?: 'order_discount', discount: { __typename?: 'discount', code: string, type: Discount_Type_Enum_Enum, percent: number, deletedAt?: any | null } }>, orderStates: Array<{ __typename?: 'order_state', id: number, date: any, state: Order_State_Enum_Enum, extra?: any | null }>, orderTests: Array<{ __typename?: 'order_test', id: number, deletedAt?: any | null, tubeCode?: string | null, laboratoryCode?: string | null, firstName: string, lastName: string, identity?: any | null, gender?: Gender_Enum | null, cost?: number | null, costBeforeDiscount?: number | null, testResultsCount?: number | null, finishedOn?: any | null, collectedOn?: any | null, retrievedOn?: any | null, test: { __typename?: 'test', id: number, name?: string | null, fulfillment: 'nurse' | 'shipping', deletedAt?: any | null }, collectionPoint?: { __typename?: 'laboratory_collection_point', id: number, name: string, address: string, city: string, postalCode: string, laboratory: { __typename?: 'laboratory', id: number, name: string, shortName?: string | null } } | null, testResults: Array<{ __typename?: 'order_test_result', date?: any | null, originalFilename: string, file: { __typename?: 'file', id: number, name: string } }> }>, orderConsultations: Array<{ __typename?: 'order_consultation', id: number, deletedAt?: any | null, firstName: string, lastName: string, phoneNumber: string, identity: any, gender?: Gender_Enum | null, preferredDate: any, finishedOn?: any | null, cost: number, consultation: { __typename?: 'consultation', id: number, name?: string | null, description?: string | null, deletedAt?: any | null } }>, orderTrainings: Array<{ __typename?: 'order_training', id: number, deletedAt?: any | null, cost: number, training: { __typename?: 'training', id: number, name?: string | null, description?: string | null, deletedAt?: any | null, videoFile: { __typename?: 'file', id: number } } }>, orderShippings: Array<{ __typename?: 'order_shipping', id: number, direction: 'to_client' | 'to_lab', cost: number, costBeforeDiscount?: number | null, email?: string | null, phone?: string | null, pointName?: string | null, status: string, trackingNumber?: string | null }> } | null };

export type GetOrderShipmentLabelQueryVariables = Exact<{
  shipmentId: Scalars['bigint'];
}>;


export type GetOrderShipmentLabelQuery = { __typename?: 'query_root', administrator_order_shipment_label: { __typename?: 'AdministratorOrderShipmentLabelOutput', fileType?: string | null, fileBase64?: string | null } };

export type GetOrdersQueryVariables = Exact<{
  where?: InputMaybe<Order_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Order_Order_By> | Order_Order_By>;
}>;


export type GetOrdersQuery = { __typename?: 'query_root', order: Array<{ __typename?: 'order', id: number, currentState?: string | null, firstStateDate?: any | null, totalCost: number, costBeforeDiscount?: number | null, clientConsent1?: boolean | null, clientConsent3?: boolean | null, clientConsent4?: boolean | null, shippingConsent1?: boolean | null, shippingConsent2?: boolean | null, shippingConsent3?: boolean | null, orderTestLaboratories: Array<{ __typename?: 'order_test', collectionPoint?: { __typename?: 'laboratory_collection_point', id: number, name: string, laboratory: { __typename?: 'laboratory', id: number, name: string, shortName?: string | null } } | null }>, orderShippingLaboratory: Array<{ __typename?: 'order_shipping', laboratory?: { __typename?: 'laboratory', id: number, name: string, shortName?: string | null } | null }>, orderCollections: Array<{ __typename?: 'order_collection', collectionDate?: any | null, isVoucher: boolean, voucherValidUntil?: any | null, nurseNotes?: string | null, address: string, postalCode: string, city: string, phoneNumber: string, collectionCost: number, collectionCostBeforeDiscount?: number | null, collectionKitCost: number, deliveryCost: number, nurse?: { __typename?: 'nurse', id: number, name?: string | null, deletedAt?: any | null } | null, collectionPoint?: { __typename?: 'laboratory_collection_point', isExternalResults: boolean } | null }>, client: { __typename?: 'client', id: number, email: string, regulationsAcceptedAt?: any | null, medicalDocumentationAcceptedAt?: any | null, clientProfiles: Array<{ __typename?: 'client_profile', firstName: string, lastName: string, identity: any }> }, documents: Array<{ __typename?: 'order_document', id: number, fileId: number }>, profiles: Array<{ __typename?: 'order_test', firstName: string, lastName: string, identity?: any | null }>, orderDiscounts: Array<{ __typename?: 'order_discount', discount: { __typename?: 'discount', code: string, type: Discount_Type_Enum_Enum, percent: number, deletedAt?: any | null } }>, orderStates: Array<{ __typename?: 'order_state', id: number, date: any, state: Order_State_Enum_Enum, extra?: any | null }>, orderTests: Array<{ __typename?: 'order_test', id: number, deletedAt?: any | null, tubeCode?: string | null, laboratoryCode?: string | null, firstName: string, lastName: string, identity?: any | null, gender?: Gender_Enum | null, cost?: number | null, costBeforeDiscount?: number | null, testResultsCount?: number | null, finishedOn?: any | null, collectedOn?: any | null, retrievedOn?: any | null, test: { __typename?: 'test', id: number, name?: string | null, fulfillment: 'nurse' | 'shipping', deletedAt?: any | null }, collectionPoint?: { __typename?: 'laboratory_collection_point', id: number, name: string, address: string, city: string, postalCode: string, laboratory: { __typename?: 'laboratory', id: number, name: string, shortName?: string | null } } | null, testResults: Array<{ __typename?: 'order_test_result', date?: any | null, originalFilename: string, file: { __typename?: 'file', id: number, name: string } }> }>, orderConsultations: Array<{ __typename?: 'order_consultation', id: number, deletedAt?: any | null, firstName: string, lastName: string, phoneNumber: string, identity: any, gender?: Gender_Enum | null, preferredDate: any, finishedOn?: any | null, cost: number, consultation: { __typename?: 'consultation', id: number, name?: string | null, description?: string | null, deletedAt?: any | null } }>, orderTrainings: Array<{ __typename?: 'order_training', id: number, deletedAt?: any | null, cost: number, training: { __typename?: 'training', id: number, name?: string | null, description?: string | null, deletedAt?: any | null, videoFile: { __typename?: 'file', id: number } } }>, orderShippings: Array<{ __typename?: 'order_shipping', id: number, direction: 'to_client' | 'to_lab', cost: number, costBeforeDiscount?: number | null, email?: string | null, phone?: string | null, pointName?: string | null, status: string, trackingNumber?: string | null }> }>, order_aggregate: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null } };

export type GetOrdersByLaboratoryQueryVariables = Exact<{
  laboratoryId: Scalars['Int'];
  dateFrom: Scalars['timestamptz'];
  dateTo: Scalars['timestamptz'];
  orderBy?: InputMaybe<Array<Order_Order_By> | Order_Order_By>;
}>;


export type GetOrdersByLaboratoryQuery = { __typename?: 'query_root', order: Array<{ __typename?: 'order', id: number, currentStateDate?: any | null, totalCost: number, orderTests: Array<{ __typename?: 'order_test', cost?: number | null, test: { __typename?: 'test', id: number, name?: string | null } }>, orderCollections: Array<{ __typename?: 'order_collection', collectionCost: number, deliveryCost: number }> }> };

export type GetOrdersByNurseQueryVariables = Exact<{
  nurseId: Scalars['Int'];
  dateFrom: Scalars['timestamptz'];
  dateTo: Scalars['timestamptz'];
  orderBy?: InputMaybe<Array<Order_Order_By> | Order_Order_By>;
}>;


export type GetOrdersByNurseQuery = { __typename?: 'query_root', order: Array<{ __typename?: 'order', id: number, currentStateDate?: any | null, totalCost: number, orderTests: Array<{ __typename?: 'order_test', test: { __typename?: 'test', id: number, name?: string | null } }>, orderCollections: Array<{ __typename?: 'order_collection', collectionCost: number, collectionKitCost: number, deliveryCost: number }> }> };

export type GetPushNotificationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetPushNotificationQuery = { __typename?: 'query_root', push_notification_by_pk?: { __typename?: 'push_notification', id: number, notificationId?: string | null, heading_i18n: any, content_i18n: any, url?: string | null, pushNotificationClients: Array<{ __typename?: 'push_notification_client', clientId: number }> } | null };

export type GetPushNotificationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Push_Notification_Order_By> | Push_Notification_Order_By>;
}>;


export type GetPushNotificationsQuery = { __typename?: 'query_root', push_notification: Array<{ __typename?: 'push_notification', id: number, notificationId?: string | null, heading_i18n: any, content_i18n: any, url?: string | null, pushNotificationClients_aggregate: { __typename?: 'push_notification_client_aggregate', aggregate?: { __typename?: 'push_notification_client_aggregate_fields', count: number } | null } }>, push_notification_aggregate: { __typename?: 'push_notification_aggregate', aggregate?: { __typename?: 'push_notification_aggregate_fields', count: number } | null } };

export type GetRateQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetRateQuery = { __typename?: 'query_root', rate_by_pk?: { __typename?: 'rate', id: number, name: string, default: boolean, area?: import('../lib/geography').Geography | null, collectionCost: number, collectionCost3Plus: number, collectionKitCost: number, deliveryCostPerKm: number } | null };

export type GetRatesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Rate_Order_By> | Rate_Order_By>;
}>;


export type GetRatesQuery = { __typename?: 'query_root', rate: Array<{ __typename?: 'rate', id: number, name: string, default: boolean, area?: import('../lib/geography').Geography | null, collectionCost: number, collectionCost3Plus: number, collectionKitCost: number, deliveryCostPerKm: number }>, rate_aggregate: { __typename?: 'rate_aggregate', aggregate?: { __typename?: 'rate_aggregate_fields', count: number } | null } };

export type GetShippingByCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetShippingByCodeQuery = { __typename?: 'query_root', shipping: Array<{ __typename?: 'shipping', id: number }> };

export type GetTagQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTagQuery = { __typename?: 'query_root', tag_by_pk?: { __typename?: 'tag', id: string, tag_i18n: any } | null };

export type GetTagsQueryVariables = Exact<{
  limit?: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Tag_Order_By> | Tag_Order_By>;
}>;


export type GetTagsQuery = { __typename?: 'query_root', tag: Array<{ __typename?: 'tag', id: string, tag_i18n: any, testTags_aggregate: { __typename?: 'test_tag_aggregate', aggregate?: { __typename?: 'test_tag_aggregate_fields', count: number } | null } }>, tag_aggregate: { __typename?: 'tag_aggregate', aggregate?: { __typename?: 'tag_aggregate_fields', count: number } | null } };

export type GetTestQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetTestQuery = { __typename?: 'query_root', test_by_pk?: { __typename?: 'test', id: number, shortName?: string | null, shortName_i18n: any, name?: string | null, name_i18n: any, description_i18n: any, preparation_i18n: any, instructions_i18n: any, labInstructions_i18n: any, svgIcon?: string | null, mostPopular: boolean, bloodlabEligible: boolean, deletedAt?: any | null, fulfillment: 'nurse' | 'shipping', testTags: Array<{ __typename?: 'test_tag', tagId: string, testId: number }>, testMaterials: Array<{ __typename?: 'test_material', materialId: number, material: { __typename?: 'material', id: number, name: string } }>, laboratoryTests: Array<{ __typename?: 'laboratory_test', laboratoryId: number, testId: number, price: number, externalId?: string | null, waitingTime_i18n: any, laboratory: { __typename?: 'laboratory', id: number, name: string, shortName?: string | null } }>, laboratoryTests_aggregate: { __typename?: 'laboratory_test_aggregate', aggregate?: { __typename?: 'laboratory_test_aggregate_fields', min?: { __typename?: 'laboratory_test_min_fields', price?: number | null } | null, max?: { __typename?: 'laboratory_test_max_fields', price?: number | null } | null } | null } } | null };

export type GetTestLaboratoriesQueryVariables = Exact<{
  testId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Laboratory_Test_Order_By> | Laboratory_Test_Order_By>;
}>;


export type GetTestLaboratoriesQuery = { __typename?: 'query_root', laboratory_test: Array<{ __typename?: 'laboratory_test', id: number, testId: number, laboratoryId: number, price: number, waitingTime?: string | null, test: { __typename?: 'test', name?: string | null }, laboratory: { __typename?: 'laboratory', name: string, shortName?: string | null } }>, laboratory_test_aggregate: { __typename?: 'laboratory_test_aggregate', aggregate?: { __typename?: 'laboratory_test_aggregate_fields', count: number } | null } };

export type GetTestsQueryVariables = Exact<{
  limit?: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Test_Order_By> | Test_Order_By>;
}>;


export type GetTestsQuery = { __typename?: 'query_root', test: Array<{ __typename?: 'test', id: number, shortName?: string | null, shortName_i18n: any, name?: string | null, name_i18n: any, description_i18n: any, preparation_i18n: any, instructions_i18n: any, labInstructions_i18n: any, svgIcon?: string | null, mostPopular: boolean, bloodlabEligible: boolean, deletedAt?: any | null, fulfillment: 'nurse' | 'shipping', testTags: Array<{ __typename?: 'test_tag', tagId: string, testId: number }>, testMaterials: Array<{ __typename?: 'test_material', materialId: number, material: { __typename?: 'material', id: number, name: string } }>, laboratoryTests: Array<{ __typename?: 'laboratory_test', laboratoryId: number, testId: number, price: number, externalId?: string | null, waitingTime_i18n: any, laboratory: { __typename?: 'laboratory', id: number, name: string, shortName?: string | null } }>, laboratoryTests_aggregate: { __typename?: 'laboratory_test_aggregate', aggregate?: { __typename?: 'laboratory_test_aggregate_fields', min?: { __typename?: 'laboratory_test_min_fields', price?: number | null } | null, max?: { __typename?: 'laboratory_test_max_fields', price?: number | null } | null } | null } }>, test_aggregate: { __typename?: 'test_aggregate', aggregate?: { __typename?: 'test_aggregate_fields', count: number } | null } };

export type GetTrainingQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetTrainingQuery = { __typename?: 'query_root', training_by_pk?: { __typename?: 'training', id: number, name?: string | null, name_i18n: any, description_i18n: any, previewFileId: number, videoFileId: number, price: number, deletedAt?: any | null } | null };

export type GetTrainingsQueryVariables = Exact<{
  limit?: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Training_Order_By> | Training_Order_By>;
}>;


export type GetTrainingsQuery = { __typename?: 'query_root', training: Array<{ __typename?: 'training', id: number, name?: string | null, name_i18n: any, description_i18n: any, previewFileId: number, videoFileId: number, price: number, deletedAt?: any | null }>, training_aggregate: { __typename?: 'training_aggregate', aggregate?: { __typename?: 'training_aggregate_fields', count: number } | null } };

export type InsertAdministratorNotificationMutationVariables = Exact<{
  administratorId: Scalars['Int'];
  scope: Scalars['String'];
  email: Scalars['Boolean'];
  sms: Scalars['Boolean'];
}>;


export type InsertAdministratorNotificationMutation = { __typename?: 'mutation_root', insert_administrator_notification_one?: { __typename?: 'administrator_notification', id: number } | null };

export type InsertCollectionSlotMutationVariables = Exact<{
  collectionPointId: Scalars['Int'];
  dateFrom: Scalars['timestamptz'];
  dateTo: Scalars['timestamptz'];
}>;


export type InsertCollectionSlotMutation = { __typename?: 'mutation_root', insert_collection_slot_one?: { __typename?: 'collection_slot', id: number, collectionPointId: number, dateFrom: any, dateTo: any } | null };

export type InsertCollectionSlotsMutationVariables = Exact<{
  objects: Array<Collection_Slot_Insert_Input> | Collection_Slot_Insert_Input;
}>;


export type InsertCollectionSlotsMutation = { __typename?: 'mutation_root', insert_collection_slot?: { __typename?: 'collection_slot_mutation_response', affected_rows: number } | null };

export type InsertConsultationMutationVariables = Exact<{
  name_i18n: Scalars['jsonb'];
  description_i18n: Scalars['jsonb'];
  svgIcon?: InputMaybe<Scalars['String']>;
  price: Scalars['numeric'];
}>;


export type InsertConsultationMutation = { __typename?: 'mutation_root', insert_consultation_one?: { __typename?: 'consultation', id: number, name?: string | null, name_i18n: any, description_i18n: any, svgIcon?: string | null, price: number, deletedAt?: any | null } | null };

export type InsertConsultationSlotMutationVariables = Exact<{
  consultationId: Scalars['Int'];
  dateFrom: Scalars['timestamptz'];
  dateTo: Scalars['timestamptz'];
}>;


export type InsertConsultationSlotMutation = { __typename?: 'mutation_root', insert_consultation_slot_one?: { __typename?: 'consultation_slot', id: number, consultationId: number, dateFrom: any, dateTo: any } | null };

export type InsertConsultationSlotsMutationVariables = Exact<{
  objects: Array<Consultation_Slot_Insert_Input> | Consultation_Slot_Insert_Input;
}>;


export type InsertConsultationSlotsMutation = { __typename?: 'mutation_root', insert_consultation_slot?: { __typename?: 'consultation_slot_mutation_response', affected_rows: number } | null };

export type InsertDiscountMutationVariables = Exact<{
  code: Scalars['String'];
  dateFrom?: InputMaybe<Scalars['timestamptz']>;
  dateTo?: InputMaybe<Scalars['timestamptz']>;
  percent: Scalars['numeric'];
  type: Discount_Type_Enum_Enum;
}>;


export type InsertDiscountMutation = { __typename?: 'mutation_root', insert_discount_one?: { __typename?: 'discount', id: number } | null };

export type UpsertDiscountConsultationMutationVariables = Exact<{
  discountId: Scalars['Int'];
  consultationId: Scalars['Int'];
  maxCount?: InputMaybe<Scalars['Int']>;
}>;


export type UpsertDiscountConsultationMutation = { __typename?: 'mutation_root', insert_discount_consultation_one?: { __typename?: 'discount_consultation', discountId: number, consultationId: number, maxCount?: number | null } | null };

export type UpsertDiscountTestMutationVariables = Exact<{
  discountId: Scalars['Int'];
  testId: Scalars['Int'];
  maxCount?: InputMaybe<Scalars['Int']>;
}>;


export type UpsertDiscountTestMutation = { __typename?: 'mutation_root', insert_discount_test_one?: { __typename?: 'discount_test', discountId: number, testId: number, maxCount?: number | null } | null };

export type UpsertDiscountTrainingMutationVariables = Exact<{
  discountId: Scalars['Int'];
  trainingId: Scalars['Int'];
  maxCount?: InputMaybe<Scalars['Int']>;
}>;


export type UpsertDiscountTrainingMutation = { __typename?: 'mutation_root', insert_discount_training_one?: { __typename?: 'discount_training', discountId: number, trainingId: number, maxCount?: number | null } | null };

export type InsertLabUserMutationVariables = Exact<{
  email: Scalars['String'];
  name: Scalars['String'];
  laboratoryId: Scalars['Int'];
}>;


export type InsertLabUserMutation = { __typename?: 'mutation_root', insert_lab_user_one?: { __typename?: 'lab_user', id: number } | null };

export type InsertLaboratoryMutationVariables = Exact<{
  name: Scalars['String'];
  shortName?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  useHL7: Scalars['Boolean'];
  logoFileId?: InputMaybe<Scalars['Int']>;
}>;


export type InsertLaboratoryMutation = { __typename?: 'mutation_root', insert_laboratory_one?: { __typename?: 'laboratory', id: number } | null };

export type InsertLaboratoryCollectionPointMutationVariables = Exact<{
  laboratoryId: Scalars['Int'];
  name: Scalars['String'];
  address: Scalars['String'];
  postalCode: Scalars['String'];
  city: Scalars['String'];
  location: Scalars['geography'];
  openingHours: Scalars['jsonb'];
  isVoucherEnabled: Scalars['Boolean'];
  isExternalResults: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
}>;


export type InsertLaboratoryCollectionPointMutation = { __typename?: 'mutation_root', insert_laboratory_collection_point_one?: { __typename?: 'laboratory_collection_point', id: number } | null };

export type InsertLaboratoryShippingMutationVariables = Exact<{
  email: Scalars['String'];
  phone: Scalars['String'];
  pointName: Scalars['String'];
  laboratoryId: Scalars['Int'];
  shippingId: Scalars['bigint'];
}>;


export type InsertLaboratoryShippingMutation = { __typename?: 'mutation_root', insert_laboratory_shipping_one?: { __typename?: 'laboratory_shipping', id: number } | null };

export type InsertLaboratoryTestMutationVariables = Exact<{
  testId: Scalars['Int'];
  price: Scalars['numeric'];
  waitingTime_i18n: Scalars['jsonb'];
  laboratoryId: Scalars['Int'];
  externalId?: InputMaybe<Scalars['String']>;
}>;


export type InsertLaboratoryTestMutation = { __typename?: 'mutation_root', insert_laboratory_test_one?: { __typename?: 'laboratory_test', id: number } | null };

export type InsertMaterialMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type InsertMaterialMutation = { __typename?: 'mutation_root', insert_material_one?: { __typename?: 'material', id: number } | null };

export type InsertNurseMutationVariables = Exact<{
  email: Scalars['String'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  enabled: Scalars['Boolean'];
  geoEnabled: Scalars['Boolean'];
  auth2FAEnabled: Scalars['Boolean'];
  nurseTests: Array<Nurse_Test_Insert_Input> | Nurse_Test_Insert_Input;
  nurseMaterials: Array<Nurse_Material_Insert_Input> | Nurse_Material_Insert_Input;
  orderArea: Scalars['geography'];
  labArea: Scalars['geography'];
}>;


export type InsertNurseMutation = { __typename?: 'mutation_root', insert_nurse_one?: { __typename?: 'nurse', id: number } | null };

export type InsertOrderStateMutationVariables = Exact<{
  orderId: Scalars['Int'];
  state: Order_State_Enum_Enum;
}>;


export type InsertOrderStateMutation = { __typename?: 'mutation_root', insert_order_state_one?: { __typename?: 'order_state', id: number } | null };

export type InsertOrdersMutationVariables = Exact<{
  orders: Array<Order_Insert_Input> | Order_Insert_Input;
  clientProfiles?: Array<Client_Profile_Insert_Input> | Client_Profile_Insert_Input;
}>;


export type InsertOrdersMutation = { __typename?: 'mutation_root', insert_order?: { __typename?: 'order_mutation_response', returning: Array<{ __typename?: 'order', id: number }> } | null, insert_client_profile?: { __typename?: 'client_profile_mutation_response', returning: Array<{ __typename?: 'client_profile', id: number }> } | null };

export type InsertPushNotificationMutationVariables = Exact<{
  heading_i18n: Scalars['jsonb'];
  content_i18n: Scalars['jsonb'];
  url?: InputMaybe<Scalars['String']>;
  pushNotificationClients: Array<Push_Notification_Client_Insert_Input> | Push_Notification_Client_Insert_Input;
}>;


export type InsertPushNotificationMutation = { __typename?: 'mutation_root', insert_push_notification_one?: { __typename?: 'push_notification', id: number } | null };

export type InsertRateMutationVariables = Exact<{
  name: Scalars['String'];
  default: Scalars['Boolean'];
  area?: InputMaybe<Scalars['geography']>;
  collectionCost: Scalars['numeric'];
  collectionCost3Plus: Scalars['numeric'];
  collectionKitCost: Scalars['numeric'];
  deliveryCostPerKm: Scalars['numeric'];
}>;


export type InsertRateMutation = { __typename?: 'mutation_root', insert_rate_one?: { __typename?: 'rate', id: number } | null };

export type InsertTagMutationVariables = Exact<{
  id: Scalars['String'];
  tag_i18n: Scalars['jsonb'];
}>;


export type InsertTagMutation = { __typename?: 'mutation_root', insert_tag_one?: { __typename?: 'tag', id: string } | null };

export type InsertTestMutationVariables = Exact<{
  shortName_i18n: Scalars['jsonb'];
  name_i18n: Scalars['jsonb'];
  description_i18n: Scalars['jsonb'];
  preparation_i18n: Scalars['jsonb'];
  instructions_i18n: Scalars['jsonb'];
  labInstructions_i18n: Scalars['jsonb'];
  svgIcon?: InputMaybe<Scalars['String']>;
  testTags: Array<Test_Tag_Insert_Input> | Test_Tag_Insert_Input;
  testMaterials: Array<Test_Material_Insert_Input> | Test_Material_Insert_Input;
  mostPopular: Scalars['Boolean'];
  bloodlabEligible: Scalars['Boolean'];
  fulfillment: Scalars['fulfillment_type'];
}>;


export type InsertTestMutation = { __typename?: 'mutation_root', insert_test_one?: { __typename?: 'test', id: number } | null };

export type InsertTestsMutationVariables = Exact<{
  tests: Array<Test_Insert_Input> | Test_Insert_Input;
}>;


export type InsertTestsMutation = { __typename?: 'mutation_root', insert_test?: { __typename?: 'test_mutation_response', returning: Array<{ __typename?: 'test', id: number }> } | null };

export type InsertTrainingMutationVariables = Exact<{
  name_i18n: Scalars['jsonb'];
  description_i18n: Scalars['jsonb'];
  previewFileId: Scalars['Int'];
  videoFileId: Scalars['Int'];
  price: Scalars['numeric'];
}>;


export type InsertTrainingMutation = { __typename?: 'mutation_root', insert_training_one?: { __typename?: 'training', id: number, name?: string | null, name_i18n: any, description_i18n: any, previewFileId: number, videoFileId: number, price: number, deletedAt?: any | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'mutation_root', administrator_logout?: { __typename?: 'AdministratorLogoutOutput', result: string } | null };

export type PingMutationVariables = Exact<{ [key: string]: never; }>;


export type PingMutation = { __typename?: 'mutation_root', ping?: { __typename?: 'PingOutput', pong: boolean } | null };

export type RestoreOrderConsultationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RestoreOrderConsultationMutation = { __typename?: 'mutation_root', update_order_consultation_by_pk?: { __typename?: 'order_consultation', id: number, cost: number, costBeforeDiscount?: number | null } | null };

export type RestoreOrderTestMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RestoreOrderTestMutation = { __typename?: 'mutation_root', update_order_test_by_pk?: { __typename?: 'order_test', id: number, cost?: number | null, costBeforeDiscount?: number | null } | null };

export type RestoreOrderTrainingMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RestoreOrderTrainingMutation = { __typename?: 'mutation_root', update_order_training_by_pk?: { __typename?: 'order_training', id: number, cost: number, costBeforeDiscount?: number | null } | null };

export type SendOrderTestMutationVariables = Exact<{
  id: Scalars['Int'];
  now: Scalars['timestamptz'];
}>;


export type SendOrderTestMutation = { __typename?: 'mutation_root', update_order_test_by_pk?: { __typename?: 'order_test', id: number } | null };

export type SoftDeleteLaboratoryCollectionPointMutationVariables = Exact<{
  id: Scalars['Int'];
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type SoftDeleteLaboratoryCollectionPointMutation = { __typename?: 'mutation_root', update_laboratory_collection_point?: { __typename?: 'laboratory_collection_point_mutation_response', affected_rows: number } | null };

export type SoftDeleteOrderConsultationMutationVariables = Exact<{
  id: Scalars['Int'];
  deletedAt: Scalars['timestamptz'];
}>;


export type SoftDeleteOrderConsultationMutation = { __typename?: 'mutation_root', update_order_consultation_by_pk?: { __typename?: 'order_consultation', id: number, cost: number, costBeforeDiscount?: number | null } | null };

export type SoftDeleteOrderTestMutationVariables = Exact<{
  id: Scalars['Int'];
  deletedAt: Scalars['timestamptz'];
}>;


export type SoftDeleteOrderTestMutation = { __typename?: 'mutation_root', update_order_test_by_pk?: { __typename?: 'order_test', id: number, cost?: number | null, costBeforeDiscount?: number | null } | null };

export type SoftDeleteOrderTrainingMutationVariables = Exact<{
  id: Scalars['Int'];
  deletedAt: Scalars['timestamptz'];
}>;


export type SoftDeleteOrderTrainingMutation = { __typename?: 'mutation_root', update_order_training_by_pk?: { __typename?: 'order_training', id: number, cost: number, costBeforeDiscount?: number | null } | null };

export type GetTestsByCollectionPointAndNurseQueryVariables = Exact<{
  collectionPointId: Scalars['Int'];
  nurseId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Test_Order_By> | Test_Order_By>;
}>;


export type GetTestsByCollectionPointAndNurseQuery = { __typename?: 'query_root', tests_by_collection_point_and_nurse: Array<{ __typename?: 'test', id: number, shortName?: string | null, shortName_i18n: any, name?: string | null, name_i18n: any, description_i18n: any, preparation_i18n: any, instructions_i18n: any, labInstructions_i18n: any, svgIcon?: string | null, mostPopular: boolean, bloodlabEligible: boolean, deletedAt?: any | null, fulfillment: 'nurse' | 'shipping', testTags: Array<{ __typename?: 'test_tag', tagId: string, testId: number }>, testMaterials: Array<{ __typename?: 'test_material', materialId: number, material: { __typename?: 'material', id: number, name: string } }>, laboratoryTests: Array<{ __typename?: 'laboratory_test', laboratoryId: number, testId: number, price: number, externalId?: string | null, waitingTime_i18n: any, laboratory: { __typename?: 'laboratory', id: number, name: string, shortName?: string | null } }>, laboratoryTests_aggregate: { __typename?: 'laboratory_test_aggregate', aggregate?: { __typename?: 'laboratory_test_aggregate_fields', min?: { __typename?: 'laboratory_test_min_fields', price?: number | null } | null, max?: { __typename?: 'laboratory_test_max_fields', price?: number | null } | null } | null } }> };

export type UpdateAdministratorNotificationMutationVariables = Exact<{
  id: Scalars['Int'];
  scope: Scalars['String'];
  email: Scalars['Boolean'];
  sms: Scalars['Boolean'];
}>;


export type UpdateAdministratorNotificationMutation = { __typename?: 'mutation_root', update_administrator_notification_by_pk?: { __typename?: 'administrator_notification', id: number } | null };

export type UpdateAdministratorPhoneNumberMutationVariables = Exact<{
  id: Scalars['Int'];
  phoneNumber: Scalars['String'];
}>;


export type UpdateAdministratorPhoneNumberMutation = { __typename?: 'mutation_root', update_administrator_by_pk?: { __typename?: 'administrator', id: number, phoneNumber?: string | null } | null };

export type UpdateClientMutationVariables = Exact<{
  id: Scalars['Int'];
  email: Scalars['String'];
  auth2FAEnabled: Scalars['Boolean'];
}>;


export type UpdateClientMutation = { __typename?: 'mutation_root', update_client_by_pk?: { __typename?: 'client', id: number } | null };

export type UpdateCollectionSlotMutationVariables = Exact<{
  id: Scalars['Int'];
  collectionPointId: Scalars['Int'];
  dateFrom: Scalars['timestamptz'];
  dateTo: Scalars['timestamptz'];
}>;


export type UpdateCollectionSlotMutation = { __typename?: 'mutation_root', update_collection_slot_by_pk?: { __typename?: 'collection_slot', id: number } | null };

export type UpdateConsultationMutationVariables = Exact<{
  id: Scalars['Int'];
  name_i18n: Scalars['jsonb'];
  description_i18n: Scalars['jsonb'];
  svgIcon?: InputMaybe<Scalars['String']>;
  price: Scalars['numeric'];
}>;


export type UpdateConsultationMutation = { __typename?: 'mutation_root', update_consultation_by_pk?: { __typename?: 'consultation', id: number } | null };

export type UpdateConsultationSlotMutationVariables = Exact<{
  id: Scalars['Int'];
  consultationId: Scalars['Int'];
  dateFrom: Scalars['timestamptz'];
  dateTo: Scalars['timestamptz'];
}>;


export type UpdateConsultationSlotMutation = { __typename?: 'mutation_root', update_consultation_slot_by_pk?: { __typename?: 'consultation_slot', id: number } | null };

export type UpdateDiscountMutationVariables = Exact<{
  id: Scalars['Int'];
  code: Scalars['String'];
  dateFrom?: InputMaybe<Scalars['timestamptz']>;
  dateTo?: InputMaybe<Scalars['timestamptz']>;
  percent: Scalars['numeric'];
  type: Discount_Type_Enum_Enum;
}>;


export type UpdateDiscountMutation = { __typename?: 'mutation_root', update_discount_by_pk?: { __typename?: 'discount', id: number } | null };

export type UpdateFeatureFlagMutationVariables = Exact<{
  id: Scalars['bigint'];
  isEnabled: Scalars['Boolean'];
}>;


export type UpdateFeatureFlagMutation = { __typename?: 'mutation_root', update_feature_flags_by_pk?: { __typename?: 'feature_flags', enabled: boolean } | null };

export type UpdateLabUserMutationVariables = Exact<{
  email: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
}>;


export type UpdateLabUserMutation = { __typename?: 'mutation_root', update_lab_user_by_pk?: { __typename?: 'lab_user', id: number } | null };

export type UpdateLabUserPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type UpdateLabUserPasswordMutation = { __typename?: 'mutation_root', lab_user_password_update?: { __typename?: 'LabUserPasswordUpdateOutput', result: string } | null };

export type UpdateLaboratoryMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
  shortName?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  useHL7: Scalars['Boolean'];
  logoFileId?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateLaboratoryMutation = { __typename?: 'mutation_root', update_laboratory_by_pk?: { __typename?: 'laboratory', id: number } | null };

export type UpdateLaboratoryCollectionPointMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
  address: Scalars['String'];
  postalCode: Scalars['String'];
  city: Scalars['String'];
  location: Scalars['geography'];
  openingHours?: InputMaybe<Scalars['jsonb']>;
  isVoucherEnabled?: InputMaybe<Scalars['Boolean']>;
  isExternalResults?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
}>;


export type UpdateLaboratoryCollectionPointMutation = { __typename?: 'mutation_root', update_laboratory_collection_point?: { __typename?: 'laboratory_collection_point_mutation_response', affected_rows: number } | null };

export type UpdateLaboratoryShippingMutationVariables = Exact<{
  id: Scalars['bigint'];
  email: Scalars['String'];
  phone: Scalars['String'];
  pointName: Scalars['String'];
}>;


export type UpdateLaboratoryShippingMutation = { __typename?: 'mutation_root', update_laboratory_shipping_by_pk?: { __typename?: 'laboratory_shipping', id: number } | null };

export type UpdateLaboratoryTestMutationVariables = Exact<{
  id: Scalars['Int'];
  testId: Scalars['Int'];
  laboratoryId: Scalars['Int'];
  price: Scalars['numeric'];
  waitingTime_i18n: Scalars['jsonb'];
  externalId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateLaboratoryTestMutation = { __typename?: 'mutation_root', update_laboratory_test_by_pk?: { __typename?: 'laboratory_test', id: number } | null };

export type UpdateMaterialMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
}>;


export type UpdateMaterialMutation = { __typename?: 'mutation_root', update_material_by_pk?: { __typename?: 'material', id: number } | null };

export type UpdateNurseMutationVariables = Exact<{
  email: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  enabled: Scalars['Boolean'];
  geoEnabled: Scalars['Boolean'];
  auth2FAEnabled: Scalars['Boolean'];
  nurseTests: Array<Nurse_Test_Insert_Input> | Nurse_Test_Insert_Input;
  nurseMaterials: Array<Nurse_Material_Insert_Input> | Nurse_Material_Insert_Input;
  orderArea: Scalars['geography'];
  labArea: Scalars['geography'];
}>;


export type UpdateNurseMutation = { __typename?: 'mutation_root', delete_nurse_test?: { __typename?: 'nurse_test_mutation_response', affected_rows: number } | null, delete_nurse_material?: { __typename?: 'nurse_material_mutation_response', affected_rows: number } | null, update_nurse_by_pk?: { __typename?: 'nurse', id: number } | null, insert_nurse_test?: { __typename?: 'nurse_test_mutation_response', affected_rows: number } | null, insert_nurse_material?: { __typename?: 'nurse_material_mutation_response', affected_rows: number } | null };

export type UpdateNursePasswordMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type UpdateNursePasswordMutation = { __typename?: 'mutation_root', nurse_password_update?: { __typename?: 'NursePasswordUpdateOutput', result: string } | null };

export type UpdateOrderCollectionNurseMutationVariables = Exact<{
  orderId: Scalars['Int'];
  nurseId: Scalars['Int'];
}>;


export type UpdateOrderCollectionNurseMutation = { __typename?: 'mutation_root', update_order_by_pk?: { __typename?: 'order', id: number } | null, update_order_collection?: { __typename?: 'order_collection_mutation_response', returning: Array<{ __typename?: 'order_collection', id: number }> } | null };

export type UpdateOrderConsultationFinishedOnMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateOrderConsultationFinishedOnMutation = { __typename?: 'mutation_root', update_order_consultation_by_pk?: { __typename?: 'order_consultation', id: number } | null };

export type UpdateOrderTestMutationVariables = Exact<{
  id: Scalars['Int'];
  tubeCode: Scalars['String'];
  retrievedOn: Scalars['timestamptz'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  identity?: InputMaybe<Scalars['jsonb']>;
  gender?: InputMaybe<Gender_Enum>;
}>;


export type UpdateOrderTestMutation = { __typename?: 'mutation_root', update_order_test_by_pk?: { __typename?: 'order_test', id: number, tubeCode?: string | null, retrievedOn?: any | null, firstName: string, lastName: string, identity?: any | null, gender?: Gender_Enum | null } | null };

export type UpdateOrderTotalCostMutationVariables = Exact<{
  id: Scalars['Int'];
  totalCost: Scalars['numeric'];
  costBeforeDiscount?: InputMaybe<Scalars['numeric']>;
}>;


export type UpdateOrderTotalCostMutation = { __typename?: 'mutation_root', update_order_by_pk?: { __typename?: 'order', id: number, totalCost: number, costBeforeDiscount?: number | null } | null };

export type UpdateRateMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
  default: Scalars['Boolean'];
  area?: InputMaybe<Scalars['geography']>;
  collectionCost: Scalars['numeric'];
  collectionCost3Plus: Scalars['numeric'];
  collectionKitCost: Scalars['numeric'];
  deliveryCostPerKm: Scalars['numeric'];
}>;


export type UpdateRateMutation = { __typename?: 'mutation_root', update_rate_by_pk?: { __typename?: 'rate', id: number } | null };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['String'];
  tag_i18n: Scalars['jsonb'];
}>;


export type UpdateTagMutation = { __typename?: 'mutation_root', update_tag_by_pk?: { __typename?: 'tag', id: string, tag_i18n: any } | null };

export type UpdateTestMutationVariables = Exact<{
  id: Scalars['Int'];
  shortName_i18n: Scalars['jsonb'];
  name_i18n: Scalars['jsonb'];
  description_i18n: Scalars['jsonb'];
  preparation_i18n: Scalars['jsonb'];
  instructions_i18n: Scalars['jsonb'];
  labInstructions_i18n: Scalars['jsonb'];
  svgIcon?: InputMaybe<Scalars['String']>;
  testTags: Array<Test_Tag_Insert_Input> | Test_Tag_Insert_Input;
  testMaterials: Array<Test_Material_Insert_Input> | Test_Material_Insert_Input;
  mostPopular: Scalars['Boolean'];
  bloodlabEligible: Scalars['Boolean'];
  fulfillment: Scalars['fulfillment_type'];
}>;


export type UpdateTestMutation = { __typename?: 'mutation_root', delete_test_tag?: { __typename?: 'test_tag_mutation_response', affected_rows: number } | null, delete_test_material?: { __typename?: 'test_material_mutation_response', affected_rows: number } | null, update_test_by_pk?: { __typename?: 'test', id: number } | null, insert_test_tag?: { __typename?: 'test_tag_mutation_response', affected_rows: number } | null, insert_test_material?: { __typename?: 'test_material_mutation_response', affected_rows: number } | null };

export type UpdateTrainingMutationVariables = Exact<{
  id: Scalars['Int'];
  name_i18n: Scalars['jsonb'];
  description_i18n: Scalars['jsonb'];
  previewFileId: Scalars['Int'];
  videoFileId: Scalars['Int'];
  price: Scalars['numeric'];
}>;


export type UpdateTrainingMutation = { __typename?: 'mutation_root', update_training_by_pk?: { __typename?: 'training', id: number } | null };

export type UpsertTestsMutationVariables = Exact<{
  testInserts: Array<Test_Insert_Input> | Test_Insert_Input;
  testUpdates: Array<Test_Updates> | Test_Updates;
  testIds: Array<Scalars['Int']> | Scalars['Int'];
  testTags: Array<Test_Tag_Insert_Input> | Test_Tag_Insert_Input;
  testMaterials: Array<Test_Material_Insert_Input> | Test_Material_Insert_Input;
  laboratoryTests: Array<Laboratory_Test_Insert_Input> | Laboratory_Test_Insert_Input;
}>;


export type UpsertTestsMutation = { __typename?: 'mutation_root', insert_test?: { __typename?: 'test_mutation_response', returning: Array<{ __typename?: 'test', id: number }> } | null, delete_test_tag?: { __typename?: 'test_tag_mutation_response', affected_rows: number } | null, delete_test_material?: { __typename?: 'test_material_mutation_response', affected_rows: number } | null, delete_laboratory_test?: { __typename?: 'laboratory_test_mutation_response', affected_rows: number } | null, update_test_many?: Array<{ __typename?: 'test_mutation_response', affected_rows: number } | null> | null, insert_test_tag?: { __typename?: 'test_tag_mutation_response', affected_rows: number } | null, insert_test_material?: { __typename?: 'test_material_mutation_response', affected_rows: number } | null, insert_laboratory_test?: { __typename?: 'laboratory_test_mutation_response', affected_rows: number } | null };

export type AdministratorFragment = { __typename?: 'administrator', id: number, email: string, phoneNumber?: string | null, name: string };

export type AdministratorNotificationFragment = { __typename?: 'administrator_notification', id: number, administratorId: number, scope: string, email: boolean, sms: boolean };

export type ClientFragment = { __typename?: 'client', id: number, email: string, newsletterConsent: boolean, pushConsent: boolean, auth2FAEnabled: boolean, confirmedOn?: any | null };

export type CollectionSlotFragment = { __typename?: 'collection_slot', id: number, collectionPointId: number, dateFrom: any, dateTo: any };

export type ConsultationFragment = { __typename?: 'consultation', id: number, name?: string | null, name_i18n: any, description_i18n: any, svgIcon?: string | null, price: number, deletedAt?: any | null };

export type ConsultationSlotFragment = { __typename?: 'consultation_slot', id: number, consultationId: number, dateFrom: any, dateTo: any };

export type LabUserFragment = { __typename?: 'lab_user', id: number, email: string, name: string, laboratoryId: number };

export type LaboratoryFragment = { __typename?: 'laboratory', id: number, name: string, shortName?: string | null, url?: string | null, enabled: boolean, useHL7: boolean, logoFileId?: number | null, laboratoryTests: Array<{ __typename?: 'laboratory_test', id: number, laboratoryId: number, testId: number, externalId?: string | null }>, collectionPoints: Array<{ __typename?: 'laboratory_collection_point', id: number, address: string, city: string, postalCode: string, location: import('../lib/geography').Geography, openingHours: any }> };

export type LaboratoryCollectionPointFragment = { __typename?: 'laboratory_collection_point', id: number, name: string, address: string, city: string, postalCode: string, location: import('../lib/geography').Geography, openingHours: any, isVoucherEnabled: boolean, isExternalResults: boolean, email?: string | null, deletedAt?: any | null };

export type LaboratoryTestFragment = { __typename?: 'laboratory_test', id: number, testId: number, laboratoryId: number, price: number, externalId?: string | null, waitingTime_i18n: any };

export type MaterialFragment = { __typename?: 'material', id: number, name: string };

export type NurseFragment = { __typename?: 'nurse', id: number, email: string, labArea?: import('../lib/geography').Geography | null, name?: string | null, orderArea?: import('../lib/geography').Geography | null, password?: string | null, phoneNumber: string, enabled: boolean, geoEnabled: boolean, auth2FAEnabled: boolean, nurseTests: Array<{ __typename?: 'nurse_test', testId: number }>, nurseMaterials: Array<{ __typename?: 'nurse_material', materialId: number }> };

export type OrderFragment = { __typename?: 'order', id: number, currentState?: string | null, firstStateDate?: any | null, totalCost: number, costBeforeDiscount?: number | null, clientConsent1?: boolean | null, clientConsent3?: boolean | null, clientConsent4?: boolean | null, shippingConsent1?: boolean | null, shippingConsent2?: boolean | null, shippingConsent3?: boolean | null, orderCollections: Array<{ __typename?: 'order_collection', collectionDate?: any | null, isVoucher: boolean, voucherValidUntil?: any | null, nurseNotes?: string | null, address: string, postalCode: string, city: string, phoneNumber: string, collectionCost: number, collectionCostBeforeDiscount?: number | null, collectionKitCost: number, deliveryCost: number, nurse?: { __typename?: 'nurse', id: number, name?: string | null, deletedAt?: any | null } | null, collectionPoint?: { __typename?: 'laboratory_collection_point', isExternalResults: boolean } | null }>, client: { __typename?: 'client', id: number, email: string, regulationsAcceptedAt?: any | null, medicalDocumentationAcceptedAt?: any | null, clientProfiles: Array<{ __typename?: 'client_profile', firstName: string, lastName: string, identity: any }> }, documents: Array<{ __typename?: 'order_document', id: number, fileId: number }>, profiles: Array<{ __typename?: 'order_test', firstName: string, lastName: string, identity?: any | null }>, orderDiscounts: Array<{ __typename?: 'order_discount', discount: { __typename?: 'discount', code: string, type: Discount_Type_Enum_Enum, percent: number, deletedAt?: any | null } }>, orderStates: Array<{ __typename?: 'order_state', id: number, date: any, state: Order_State_Enum_Enum, extra?: any | null }>, orderTests: Array<{ __typename?: 'order_test', id: number, deletedAt?: any | null, tubeCode?: string | null, laboratoryCode?: string | null, firstName: string, lastName: string, identity?: any | null, gender?: Gender_Enum | null, cost?: number | null, costBeforeDiscount?: number | null, testResultsCount?: number | null, finishedOn?: any | null, collectedOn?: any | null, retrievedOn?: any | null, test: { __typename?: 'test', id: number, name?: string | null, fulfillment: 'nurse' | 'shipping', deletedAt?: any | null }, collectionPoint?: { __typename?: 'laboratory_collection_point', id: number, name: string, address: string, city: string, postalCode: string, laboratory: { __typename?: 'laboratory', id: number, name: string, shortName?: string | null } } | null, testResults: Array<{ __typename?: 'order_test_result', date?: any | null, originalFilename: string, file: { __typename?: 'file', id: number, name: string } }> }>, orderConsultations: Array<{ __typename?: 'order_consultation', id: number, deletedAt?: any | null, firstName: string, lastName: string, phoneNumber: string, identity: any, gender?: Gender_Enum | null, preferredDate: any, finishedOn?: any | null, cost: number, consultation: { __typename?: 'consultation', id: number, name?: string | null, description?: string | null, deletedAt?: any | null } }>, orderTrainings: Array<{ __typename?: 'order_training', id: number, deletedAt?: any | null, cost: number, training: { __typename?: 'training', id: number, name?: string | null, description?: string | null, deletedAt?: any | null, videoFile: { __typename?: 'file', id: number } } }>, orderShippings: Array<{ __typename?: 'order_shipping', id: number, direction: 'to_client' | 'to_lab', cost: number, costBeforeDiscount?: number | null, email?: string | null, phone?: string | null, pointName?: string | null, status: string, trackingNumber?: string | null }> };

export type RateFragment = { __typename?: 'rate', id: number, name: string, default: boolean, area?: import('../lib/geography').Geography | null, collectionCost: number, collectionCost3Plus: number, collectionKitCost: number, deliveryCostPerKm: number };

export type TestFragment = { __typename?: 'test', id: number, shortName?: string | null, shortName_i18n: any, name?: string | null, name_i18n: any, description_i18n: any, preparation_i18n: any, instructions_i18n: any, labInstructions_i18n: any, svgIcon?: string | null, mostPopular: boolean, bloodlabEligible: boolean, deletedAt?: any | null, fulfillment: 'nurse' | 'shipping', testTags: Array<{ __typename?: 'test_tag', tagId: string, testId: number }>, testMaterials: Array<{ __typename?: 'test_material', materialId: number, material: { __typename?: 'material', id: number, name: string } }>, laboratoryTests: Array<{ __typename?: 'laboratory_test', laboratoryId: number, testId: number, price: number, externalId?: string | null, waitingTime_i18n: any, laboratory: { __typename?: 'laboratory', id: number, name: string, shortName?: string | null } }>, laboratoryTests_aggregate: { __typename?: 'laboratory_test_aggregate', aggregate?: { __typename?: 'laboratory_test_aggregate_fields', min?: { __typename?: 'laboratory_test_min_fields', price?: number | null } | null, max?: { __typename?: 'laboratory_test_max_fields', price?: number | null } | null } | null } };

export type TrainingFragment = { __typename?: 'training', id: number, name?: string | null, name_i18n: any, description_i18n: any, previewFileId: number, videoFileId: number, price: number, deletedAt?: any | null };

export const AdministratorFragmentDoc = gql`
    fragment administrator on administrator {
  id
  email
  phoneNumber
  name
}
    `;
export const AdministratorNotificationFragmentDoc = gql`
    fragment administratorNotification on administrator_notification {
  id
  administratorId
  scope
  email
  sms
}
    `;
export const ClientFragmentDoc = gql`
    fragment client on client {
  id
  email
  newsletterConsent
  pushConsent
  auth2FAEnabled
  confirmedOn
}
    `;
export const CollectionSlotFragmentDoc = gql`
    fragment collectionSlot on collection_slot {
  id
  collectionPointId
  dateFrom
  dateTo
}
    `;
export const ConsultationFragmentDoc = gql`
    fragment consultation on consultation {
  id
  name
  name_i18n
  description_i18n
  svgIcon
  price
  deletedAt
}
    `;
export const ConsultationSlotFragmentDoc = gql`
    fragment consultationSlot on consultation_slot {
  id
  consultationId
  dateFrom
  dateTo
}
    `;
export const LabUserFragmentDoc = gql`
    fragment labUser on lab_user {
  id
  email
  name
  laboratoryId
}
    `;
export const LaboratoryFragmentDoc = gql`
    fragment laboratory on laboratory {
  id
  name
  shortName
  url
  enabled
  useHL7
  logoFileId
  laboratoryTests(order_by: {test: {name: asc}}) {
    id
    laboratoryId
    testId
    externalId
  }
  collectionPoints {
    id
    address
    city
    postalCode
    location
    openingHours
  }
}
    `;
export const LaboratoryCollectionPointFragmentDoc = gql`
    fragment laboratoryCollectionPoint on laboratory_collection_point {
  id
  name
  address
  city
  postalCode
  location
  openingHours
  isVoucherEnabled
  isExternalResults
  email
  deletedAt
}
    `;
export const LaboratoryTestFragmentDoc = gql`
    fragment laboratoryTest on laboratory_test {
  id
  testId
  laboratoryId
  price
  externalId
  waitingTime_i18n
}
    `;
export const MaterialFragmentDoc = gql`
    fragment material on material {
  id
  name
}
    `;
export const NurseFragmentDoc = gql`
    fragment nurse on nurse {
  id
  email
  labArea
  name
  orderArea
  password
  phoneNumber
  enabled
  geoEnabled
  auth2FAEnabled
  nurseTests(order_by: {test: {name: asc}}) {
    testId
  }
  nurseMaterials(order_by: {material: {name: asc}}) {
    materialId
  }
}
    `;
export const OrderFragmentDoc = gql`
    fragment order on order {
  id
  currentState
  firstStateDate
  totalCost
  costBeforeDiscount
  orderCollections {
    collectionDate
    isVoucher
    voucherValidUntil
    nurseNotes
    address
    postalCode
    city
    phoneNumber
    nurse {
      id
      name
      deletedAt
    }
    collectionPoint {
      isExternalResults
    }
    collectionCost
    collectionCostBeforeDiscount
    collectionKitCost
    deliveryCost
  }
  clientConsent1
  clientConsent3
  clientConsent4
  shippingConsent1
  shippingConsent2
  shippingConsent3
  client {
    id
    email
    regulationsAcceptedAt
    medicalDocumentationAcceptedAt
    clientProfiles(where: {isMain: {_eq: true}}) {
      firstName
      lastName
      identity
    }
  }
  documents {
    id
    fileId
  }
  profiles: orderTests(distinct_on: [firstName, lastName, identity]) {
    firstName
    lastName
    identity
  }
  orderDiscounts {
    discount {
      code
      type
      percent
      deletedAt
    }
  }
  orderStates(order_by: {date: desc, id: desc}) {
    id
    date
    state
    extra
  }
  orderTests(order_by: {id: asc}) {
    id
    deletedAt
    test {
      id
      name
      fulfillment
      deletedAt
    }
    tubeCode
    laboratoryCode
    collectionPoint {
      id
      name
      address
      city
      postalCode
      laboratory {
        id
        name
        shortName
      }
    }
    firstName
    lastName
    identity
    gender
    cost
    costBeforeDiscount
    testResultsCount
    testResults {
      date
      originalFilename
      file {
        id
        name
      }
    }
    finishedOn
    collectedOn
    retrievedOn
  }
  orderConsultations {
    id
    deletedAt
    firstName
    lastName
    phoneNumber
    identity
    gender
    preferredDate
    finishedOn
    cost
    consultation {
      id
      name
      description
      deletedAt
    }
  }
  orderTrainings {
    id
    deletedAt
    cost
    training {
      id
      name
      description
      deletedAt
      videoFile {
        id
      }
    }
  }
  orderShippings {
    id
    direction
    cost
    costBeforeDiscount
    email
    phone
    pointName
    status
    trackingNumber
  }
}
    `;
export const RateFragmentDoc = gql`
    fragment rate on rate {
  id
  name
  default
  area
  collectionCost
  collectionCost3Plus
  collectionKitCost
  deliveryCostPerKm
}
    `;
export const TestFragmentDoc = gql`
    fragment test on test {
  id
  shortName
  shortName_i18n
  name
  name_i18n
  description_i18n
  preparation_i18n
  instructions_i18n
  labInstructions_i18n
  svgIcon
  mostPopular
  bloodlabEligible
  deletedAt
  fulfillment
  testTags {
    tagId
    testId
  }
  testMaterials {
    materialId
    material {
      id
      name
    }
  }
  laboratoryTests {
    laboratoryId
    testId
    price
    externalId
    waitingTime_i18n
    laboratory {
      id
      name
      shortName
    }
  }
  laboratoryTests_aggregate {
    aggregate {
      min {
        price
      }
      max {
        price
      }
    }
  }
}
    `;
export const TrainingFragmentDoc = gql`
    fragment training on training {
  id
  name
  name_i18n
  description_i18n
  previewFileId
  videoFileId
  price
  deletedAt
}
    `;
export const DeleteAdministratorNotificationDocument = gql`
    mutation DeleteAdministratorNotification($id: Int!) {
  delete_administrator_notification_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteAdministratorNotificationMutation() {
  return Urql.useMutation<DeleteAdministratorNotificationMutation, DeleteAdministratorNotificationMutationVariables>(DeleteAdministratorNotificationDocument);
};
export const DeleteCollectionSlotDocument = gql`
    mutation DeleteCollectionSlot($id: Int!) {
  delete_collection_slot_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteCollectionSlotMutation() {
  return Urql.useMutation<DeleteCollectionSlotMutation, DeleteCollectionSlotMutationVariables>(DeleteCollectionSlotDocument);
};
export const DeleteConsultationDocument = gql`
    mutation DeleteConsultation($id: Int!) {
  update_consultation_by_pk(pk_columns: {id: $id}, _set: {deletedAt: now}) {
    id
  }
}
    `;

export function useDeleteConsultationMutation() {
  return Urql.useMutation<DeleteConsultationMutation, DeleteConsultationMutationVariables>(DeleteConsultationDocument);
};
export const DeleteConsultationSlotDocument = gql`
    mutation DeleteConsultationSlot($id: Int!) {
  delete_consultation_slot_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteConsultationSlotMutation() {
  return Urql.useMutation<DeleteConsultationSlotMutation, DeleteConsultationSlotMutationVariables>(DeleteConsultationSlotDocument);
};
export const DeleteDiscountDocument = gql`
    mutation DeleteDiscount($id: Int!) {
  update_discount_by_pk(pk_columns: {id: $id}, _set: {deletedAt: now}) {
    id
  }
}
    `;

export function useDeleteDiscountMutation() {
  return Urql.useMutation<DeleteDiscountMutation, DeleteDiscountMutationVariables>(DeleteDiscountDocument);
};
export const DeleteDiscountConsultationDocument = gql`
    mutation DeleteDiscountConsultation($discountId: Int!, $consultationId: Int!) {
  delete_discount_consultation_by_pk(
    discountId: $discountId
    consultationId: $consultationId
  ) {
    discountId
    consultationId
  }
}
    `;

export function useDeleteDiscountConsultationMutation() {
  return Urql.useMutation<DeleteDiscountConsultationMutation, DeleteDiscountConsultationMutationVariables>(DeleteDiscountConsultationDocument);
};
export const DeleteDiscountTestDocument = gql`
    mutation DeleteDiscountTest($discountId: Int!, $testId: Int!) {
  delete_discount_test_by_pk(discountId: $discountId, testId: $testId) {
    discountId
    testId
  }
}
    `;

export function useDeleteDiscountTestMutation() {
  return Urql.useMutation<DeleteDiscountTestMutation, DeleteDiscountTestMutationVariables>(DeleteDiscountTestDocument);
};
export const DeleteDiscountTrainingDocument = gql`
    mutation DeleteDiscountTraining($discountId: Int!, $trainingId: Int!) {
  delete_discount_training_by_pk(discountId: $discountId, trainingId: $trainingId) {
    discountId
    trainingId
  }
}
    `;

export function useDeleteDiscountTrainingMutation() {
  return Urql.useMutation<DeleteDiscountTrainingMutation, DeleteDiscountTrainingMutationVariables>(DeleteDiscountTrainingDocument);
};
export const DeleteLabUserDocument = gql`
    mutation DeleteLabUser($id: Int!) {
  delete_lab_user_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteLabUserMutation() {
  return Urql.useMutation<DeleteLabUserMutation, DeleteLabUserMutationVariables>(DeleteLabUserDocument);
};
export const DeleteLaboratoryTestDocument = gql`
    mutation DeleteLaboratoryTest($id: Int!) {
  delete_laboratory_test_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteLaboratoryTestMutation() {
  return Urql.useMutation<DeleteLaboratoryTestMutation, DeleteLaboratoryTestMutationVariables>(DeleteLaboratoryTestDocument);
};
export const DeleteNurseDocument = gql`
    mutation DeleteNurse($id: Int!) {
  update_nurse_by_pk(pk_columns: {id: $id}, _set: {deletedAt: "now()"}) {
    id
  }
}
    `;

export function useDeleteNurseMutation() {
  return Urql.useMutation<DeleteNurseMutation, DeleteNurseMutationVariables>(DeleteNurseDocument);
};
export const DeleteOrderTestResultDocument = gql`
    mutation DeleteOrderTestResult($fileId: Int!, $orderTestId: Int!) {
  delete_order_test_result_by_pk(fileId: $fileId, orderTestId: $orderTestId) {
    orderTestId
    fileId
  }
}
    `;

export function useDeleteOrderTestResultMutation() {
  return Urql.useMutation<DeleteOrderTestResultMutation, DeleteOrderTestResultMutationVariables>(DeleteOrderTestResultDocument);
};
export const DeleteTagDocument = gql`
    mutation DeleteTag($id: String!) {
  delete_tag_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteTagMutation() {
  return Urql.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument);
};
export const DeleteTestDocument = gql`
    mutation DeleteTest($id: Int!) {
  update_test_by_pk(pk_columns: {id: $id}, _set: {deletedAt: now}) {
    id
  }
  delete_client_favourite_test(where: {testId: {_eq: $id}}) {
    affected_rows
  }
  delete_laboratory_test(where: {testId: {_eq: $id}}) {
    affected_rows
  }
  delete_nurse_test(where: {testId: {_eq: $id}}) {
    affected_rows
  }
  delete_test_material(where: {testId: {_eq: $id}}) {
    affected_rows
  }
  delete_test_tag(where: {testId: {_eq: $id}}) {
    affected_rows
  }
}
    `;

export function useDeleteTestMutation() {
  return Urql.useMutation<DeleteTestMutation, DeleteTestMutationVariables>(DeleteTestDocument);
};
export const DeleteTrainingDocument = gql`
    mutation DeleteTraining($id: Int!) {
  update_training_by_pk(pk_columns: {id: $id}, _set: {deletedAt: now}) {
    id
  }
}
    `;

export function useDeleteTrainingMutation() {
  return Urql.useMutation<DeleteTrainingMutation, DeleteTrainingMutationVariables>(DeleteTrainingDocument);
};
export const GetAdministratorNotificationDocument = gql`
    query GetAdministratorNotification($id: Int!) {
  administrator_notification_by_pk(id: $id) {
    ...administratorNotification
  }
}
    ${AdministratorNotificationFragmentDoc}`;

export function useGetAdministratorNotificationQuery(options: Omit<Urql.UseQueryArgs<GetAdministratorNotificationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAdministratorNotificationQuery, GetAdministratorNotificationQueryVariables>({ query: GetAdministratorNotificationDocument, ...options });
};
export const GetAdministratorNotificationsDocument = gql`
    query GetAdministratorNotifications($administratorId: Int!, $limit: Int = 100, $offset: Int = 0, $orderBy: [administrator_notification_order_by!] = [{id: asc}]) {
  administrator_notification(
    where: {administratorId: {_eq: $administratorId}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    ...administratorNotification
  }
  administrator_notification_aggregate {
    aggregate {
      count
    }
  }
}
    ${AdministratorNotificationFragmentDoc}`;

export function useGetAdministratorNotificationsQuery(options: Omit<Urql.UseQueryArgs<GetAdministratorNotificationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAdministratorNotificationsQuery, GetAdministratorNotificationsQueryVariables>({ query: GetAdministratorNotificationsDocument, ...options });
};
export const GetAdministratorsDocument = gql`
    query GetAdministrators($limit: Int = 100, $offset: Int = 0, $orderBy: [administrator_order_by!] = [{id: asc}]) {
  administrator(limit: $limit, offset: $offset, order_by: $orderBy) {
    ...administrator
  }
  administrator_aggregate {
    aggregate {
      count
    }
  }
}
    ${AdministratorFragmentDoc}`;

export function useGetAdministratorsQuery(options?: Omit<Urql.UseQueryArgs<GetAdministratorsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAdministratorsQuery, GetAdministratorsQueryVariables>({ query: GetAdministratorsDocument, ...options });
};
export const GetAllCollectionSlotsDocument = gql`
    query GetAllCollectionSlots($collectionPointId: Int!, $minDate: timestamptz!, $orderBy: [collection_slot_order_by!]!) {
  collection_slot(
    where: {collectionPointId: {_eq: $collectionPointId}, dateFrom: {_gte: $minDate}}
    order_by: $orderBy
  ) {
    ...collectionSlot
  }
}
    ${CollectionSlotFragmentDoc}`;

export function useGetAllCollectionSlotsQuery(options: Omit<Urql.UseQueryArgs<GetAllCollectionSlotsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAllCollectionSlotsQuery, GetAllCollectionSlotsQueryVariables>({ query: GetAllCollectionSlotsDocument, ...options });
};
export const GetAllConsultationSlotsDocument = gql`
    query GetAllConsultationSlots($consultationId: Int!, $minDate: timestamptz!, $orderBy: [consultation_slot_order_by!] = [{id: asc}]) {
  consultation_slot(
    where: {consultationId: {_eq: $consultationId}, dateFrom: {_gt: $minDate}}
    order_by: $orderBy
  ) {
    ...consultationSlot
  }
}
    ${ConsultationSlotFragmentDoc}`;

export function useGetAllConsultationSlotsQuery(options: Omit<Urql.UseQueryArgs<GetAllConsultationSlotsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAllConsultationSlotsQuery, GetAllConsultationSlotsQueryVariables>({ query: GetAllConsultationSlotsDocument, ...options });
};
export const GetAvailableTestsDocument = gql`
    query GetAvailableTests($limit: Int!, $offset: Int = 0) {
  test(
    where: {deletedAt: {_is_null: true}}
    limit: $limit
    offset: $offset
    order_by: {name: asc}
  ) {
    id
    name
    laboratoryTests_aggregate {
      aggregate {
        min {
          price
        }
        max {
          price
        }
      }
    }
  }
}
    `;

export function useGetAvailableTestsQuery(options: Omit<Urql.UseQueryArgs<GetAvailableTestsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAvailableTestsQuery, GetAvailableTestsQueryVariables>({ query: GetAvailableTestsDocument, ...options });
};
export const GetClientDocument = gql`
    query GetClient($id: Int!) {
  client_by_pk(id: $id) {
    ...client
  }
}
    ${ClientFragmentDoc}`;

export function useGetClientQuery(options: Omit<Urql.UseQueryArgs<GetClientQueryVariables>, 'query'>) {
  return Urql.useQuery<GetClientQuery, GetClientQueryVariables>({ query: GetClientDocument, ...options });
};
export const GetClientProfilesDocument = gql`
    query GetClientProfiles($clientId: Int!) {
  client_profile(where: {clientId: {_eq: $clientId}}) {
    id
    firstName
    lastName
    phoneNumber
    identity
  }
}
    `;

export function useGetClientProfilesQuery(options: Omit<Urql.UseQueryArgs<GetClientProfilesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetClientProfilesQuery, GetClientProfilesQueryVariables>({ query: GetClientProfilesDocument, ...options });
};
export const GetClientsDocument = gql`
    query GetClients($where: client_bool_exp = {}, $limit: Int = 100, $offset: Int = 0, $orderBy: [client_order_by!] = [{id: asc}]) {
  client(where: $where, limit: $limit, offset: $offset, order_by: $orderBy) {
    ...client
  }
  client_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${ClientFragmentDoc}`;

export function useGetClientsQuery(options?: Omit<Urql.UseQueryArgs<GetClientsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetClientsQuery, GetClientsQueryVariables>({ query: GetClientsDocument, ...options });
};
export const GetClientsWithPushNotificationConsentDocument = gql`
    query GetClientsWithPushNotificationConsent {
  client(where: {pushConsent: {_eq: true}}) {
    id
    email
  }
}
    `;

export function useGetClientsWithPushNotificationConsentQuery(options?: Omit<Urql.UseQueryArgs<GetClientsWithPushNotificationConsentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetClientsWithPushNotificationConsentQuery, GetClientsWithPushNotificationConsentQueryVariables>({ query: GetClientsWithPushNotificationConsentDocument, ...options });
};
export const GetCollectionSlotDocument = gql`
    query GetCollectionSlot($id: Int!) {
  collection_slot_by_pk(id: $id) {
    ...collectionSlot
  }
}
    ${CollectionSlotFragmentDoc}`;

export function useGetCollectionSlotQuery(options: Omit<Urql.UseQueryArgs<GetCollectionSlotQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCollectionSlotQuery, GetCollectionSlotQueryVariables>({ query: GetCollectionSlotDocument, ...options });
};
export const GetConsultationDocument = gql`
    query GetConsultation($id: Int!) {
  consultation_by_pk(id: $id) {
    ...consultation
  }
}
    ${ConsultationFragmentDoc}`;

export function useGetConsultationQuery(options: Omit<Urql.UseQueryArgs<GetConsultationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetConsultationQuery, GetConsultationQueryVariables>({ query: GetConsultationDocument, ...options });
};
export const GetConsultationSlotDocument = gql`
    query GetConsultationSlot($id: Int!) {
  consultation_slot_by_pk(id: $id) {
    ...consultationSlot
  }
}
    ${ConsultationSlotFragmentDoc}`;

export function useGetConsultationSlotQuery(options: Omit<Urql.UseQueryArgs<GetConsultationSlotQueryVariables>, 'query'>) {
  return Urql.useQuery<GetConsultationSlotQuery, GetConsultationSlotQueryVariables>({ query: GetConsultationSlotDocument, ...options });
};
export const GetConsultationSlotsDocument = gql`
    query GetConsultationSlots($consultationId: Int!, $limit: Int! = 20, $offset: Int = 0, $orderBy: [consultation_slot_order_by!] = [{id: asc}]) {
  consultation_slot(
    where: {consultationId: {_eq: $consultationId}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    ...consultationSlot
  }
  consultation_slot_aggregate(where: {consultationId: {_eq: $consultationId}}) {
    aggregate {
      count
    }
  }
}
    ${ConsultationSlotFragmentDoc}`;

export function useGetConsultationSlotsQuery(options: Omit<Urql.UseQueryArgs<GetConsultationSlotsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetConsultationSlotsQuery, GetConsultationSlotsQueryVariables>({ query: GetConsultationSlotsDocument, ...options });
};
export const GetConsultationsDocument = gql`
    query GetConsultations($limit: Int! = 20, $offset: Int = 0, $orderBy: [consultation_order_by!] = [{id: asc}]) {
  consultation(
    where: {deletedAt: {_is_null: true}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    ...consultation
  }
  consultation_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
}
    ${ConsultationFragmentDoc}`;

export function useGetConsultationsQuery(options?: Omit<Urql.UseQueryArgs<GetConsultationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetConsultationsQuery, GetConsultationsQueryVariables>({ query: GetConsultationsDocument, ...options });
};
export const GetDiscountDocument = gql`
    query GetDiscount($id: Int!) {
  discount_by_pk(id: $id) {
    id
    code
    dateFrom
    dateTo
    percent
    type
    deletedAt
  }
}
    `;

export function useGetDiscountQuery(options: Omit<Urql.UseQueryArgs<GetDiscountQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDiscountQuery, GetDiscountQueryVariables>({ query: GetDiscountDocument, ...options });
};
export const GetDiscountConsultationDocument = gql`
    query GetDiscountConsultation($discountId: Int!, $consultationId: Int!) {
  discount_consultation_by_pk(
    discountId: $discountId
    consultationId: $consultationId
  ) {
    discountId
    consultationId
    maxCount
    consultation {
      id
      name
    }
  }
}
    `;

export function useGetDiscountConsultationQuery(options: Omit<Urql.UseQueryArgs<GetDiscountConsultationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDiscountConsultationQuery, GetDiscountConsultationQueryVariables>({ query: GetDiscountConsultationDocument, ...options });
};
export const GetDiscountConsultationsDocument = gql`
    query GetDiscountConsultations($discountId: Int!, $limit: Int = 100, $offset: Int = 0, $orderBy: [discount_consultation_order_by!] = [{consultationId: asc}]) {
  discount_consultation(
    where: {discountId: {_eq: $discountId}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    consultationId
    consultation {
      id
      name
    }
    maxCount
  }
  discount_consultation_aggregate(where: {discountId: {_eq: $discountId}}) {
    aggregate {
      count
    }
  }
}
    `;

export function useGetDiscountConsultationsQuery(options: Omit<Urql.UseQueryArgs<GetDiscountConsultationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDiscountConsultationsQuery, GetDiscountConsultationsQueryVariables>({ query: GetDiscountConsultationsDocument, ...options });
};
export const GetDiscountTestDocument = gql`
    query GetDiscountTest($discountId: Int!, $testId: Int!) {
  discount_test_by_pk(discountId: $discountId, testId: $testId) {
    discountId
    testId
    maxCount
    test {
      id
      name
      shortName
    }
  }
}
    `;

export function useGetDiscountTestQuery(options: Omit<Urql.UseQueryArgs<GetDiscountTestQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDiscountTestQuery, GetDiscountTestQueryVariables>({ query: GetDiscountTestDocument, ...options });
};
export const GetDiscountTestsDocument = gql`
    query GetDiscountTests($discountId: Int!, $limit: Int = 100, $offset: Int = 0, $orderBy: [discount_test_order_by!] = [{testId: asc}]) {
  discount_test(
    where: {discountId: {_eq: $discountId}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    testId
    test {
      id
      shortName
      name
    }
    maxCount
  }
  discount_test_aggregate(where: {discountId: {_eq: $discountId}}) {
    aggregate {
      count
    }
  }
}
    `;

export function useGetDiscountTestsQuery(options: Omit<Urql.UseQueryArgs<GetDiscountTestsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDiscountTestsQuery, GetDiscountTestsQueryVariables>({ query: GetDiscountTestsDocument, ...options });
};
export const GetDiscountTrainingDocument = gql`
    query GetDiscountTraining($discountId: Int!, $trainingId: Int!) {
  discount_training_by_pk(discountId: $discountId, trainingId: $trainingId) {
    discountId
    trainingId
    maxCount
    training {
      id
      name
    }
  }
}
    `;

export function useGetDiscountTrainingQuery(options: Omit<Urql.UseQueryArgs<GetDiscountTrainingQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDiscountTrainingQuery, GetDiscountTrainingQueryVariables>({ query: GetDiscountTrainingDocument, ...options });
};
export const GetDiscountTrainingsDocument = gql`
    query GetDiscountTrainings($discountId: Int!, $limit: Int = 100, $offset: Int = 0, $orderBy: [discount_training_order_by!] = [{trainingId: asc}]) {
  discount_training(
    where: {discountId: {_eq: $discountId}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    trainingId
    training {
      id
      name
    }
    maxCount
  }
  discount_training_aggregate(where: {discountId: {_eq: $discountId}}) {
    aggregate {
      count
    }
  }
}
    `;

export function useGetDiscountTrainingsQuery(options: Omit<Urql.UseQueryArgs<GetDiscountTrainingsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDiscountTrainingsQuery, GetDiscountTrainingsQueryVariables>({ query: GetDiscountTrainingsDocument, ...options });
};
export const GetDiscountsDocument = gql`
    query GetDiscounts($limit: Int!, $offset: Int = 0, $orderBy: [discount_order_by!] = [{dateTo: desc, id: desc}]) {
  discount(
    where: {deletedAt: {_is_null: true}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    id
    code
    dateFrom
    dateTo
    percent
    type
    discountTests_aggregate {
      aggregate {
        count
      }
    }
    discountConsultations_aggregate {
      aggregate {
        count
      }
    }
    discountTrainings_aggregate {
      aggregate {
        count
      }
    }
  }
  discount_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
}
    `;

export function useGetDiscountsQuery(options: Omit<Urql.UseQueryArgs<GetDiscountsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDiscountsQuery, GetDiscountsQueryVariables>({ query: GetDiscountsDocument, ...options });
};
export const GetFeatureFlagsDocument = gql`
    query GetFeatureFlags {
  feature_flags {
    id
    key
    enabled
    description
    payload
    project
  }
}
    `;

export function useGetFeatureFlagsQuery(options?: Omit<Urql.UseQueryArgs<GetFeatureFlagsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>({ query: GetFeatureFlagsDocument, ...options });
};
export const GetLabUserDocument = gql`
    query GetLabUser($id: Int!) {
  lab_user_by_pk(id: $id) {
    ...labUser
  }
}
    ${LabUserFragmentDoc}`;

export function useGetLabUserQuery(options: Omit<Urql.UseQueryArgs<GetLabUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLabUserQuery, GetLabUserQueryVariables>({ query: GetLabUserDocument, ...options });
};
export const GetLabUsersDocument = gql`
    query GetLabUsers($laboratoryId: Int!, $limit: Int = 100, $offset: Int = 0, $orderBy: [lab_user_order_by!] = [{id: asc}]) {
  lab_user(
    where: {laboratoryId: {_eq: $laboratoryId}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    ...labUser
  }
  lab_user_aggregate(where: {laboratoryId: {_eq: $laboratoryId}}) {
    aggregate {
      count
    }
  }
}
    ${LabUserFragmentDoc}`;

export function useGetLabUsersQuery(options: Omit<Urql.UseQueryArgs<GetLabUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLabUsersQuery, GetLabUsersQueryVariables>({ query: GetLabUsersDocument, ...options });
};
export const GetLaboratoriesDocument = gql`
    query GetLaboratories($limit: Int = 100, $offset: Int = 0, $orderBy: [laboratory_order_by!] = [{id: asc}]) {
  laboratory(limit: $limit, offset: $offset, order_by: $orderBy) {
    ...laboratory
  }
  laboratory_aggregate {
    aggregate {
      count
    }
  }
}
    ${LaboratoryFragmentDoc}`;

export function useGetLaboratoriesQuery(options?: Omit<Urql.UseQueryArgs<GetLaboratoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLaboratoriesQuery, GetLaboratoriesQueryVariables>({ query: GetLaboratoriesDocument, ...options });
};
export const GetLaboratoriesByAreaDocument = gql`
    query GetLaboratoriesByArea($area: geography!, $limit: Int = 100, $offset: Int = 0, $orderBy: [laboratory_order_by!] = [{id: asc}]) {
  laboratory(
    where: {collectionPoints: {location: {_st_intersects: $area}}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    ...laboratory
  }
  laboratory_aggregate(
    where: {collectionPoints: {location: {_st_intersects: $area}}}
  ) {
    aggregate {
      count
    }
  }
}
    ${LaboratoryFragmentDoc}`;

export function useGetLaboratoriesByAreaQuery(options: Omit<Urql.UseQueryArgs<GetLaboratoriesByAreaQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLaboratoriesByAreaQuery, GetLaboratoriesByAreaQueryVariables>({ query: GetLaboratoriesByAreaDocument, ...options });
};
export const GetLaboratoryDocument = gql`
    query GetLaboratory($id: Int!) {
  laboratory_by_pk(id: $id) {
    ...laboratory
  }
}
    ${LaboratoryFragmentDoc}`;

export function useGetLaboratoryQuery(options: Omit<Urql.UseQueryArgs<GetLaboratoryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLaboratoryQuery, GetLaboratoryQueryVariables>({ query: GetLaboratoryDocument, ...options });
};
export const GetLaboratoryCollectionPointDocument = gql`
    query GetLaboratoryCollectionPoint($id: Int!) {
  laboratory_collection_point_by_pk(id: $id) {
    ...laboratoryCollectionPoint
  }
}
    ${LaboratoryCollectionPointFragmentDoc}`;

export function useGetLaboratoryCollectionPointQuery(options: Omit<Urql.UseQueryArgs<GetLaboratoryCollectionPointQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLaboratoryCollectionPointQuery, GetLaboratoryCollectionPointQueryVariables>({ query: GetLaboratoryCollectionPointDocument, ...options });
};
export const GetLaboratoryCollectionPointsByLaboratoryIdDocument = gql`
    query GetLaboratoryCollectionPointsByLaboratoryId($laboratoryId: Int!, $limit: Int = 100, $offset: Int = 0, $orderBy: [laboratory_collection_point_order_by!] = [{id: asc}]) {
  laboratory_collection_point(
    where: {laboratoryId: {_eq: $laboratoryId}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    ...laboratoryCollectionPoint
  }
  laboratory_collection_point_aggregate(
    where: {laboratoryId: {_eq: $laboratoryId}}
  ) {
    aggregate {
      count
    }
  }
}
    ${LaboratoryCollectionPointFragmentDoc}`;

export function useGetLaboratoryCollectionPointsByLaboratoryIdQuery(options: Omit<Urql.UseQueryArgs<GetLaboratoryCollectionPointsByLaboratoryIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLaboratoryCollectionPointsByLaboratoryIdQuery, GetLaboratoryCollectionPointsByLaboratoryIdQueryVariables>({ query: GetLaboratoryCollectionPointsByLaboratoryIdDocument, ...options });
};
export const GetLaboratoryCostSummaryDocument = gql`
    query GetLaboratoryCostSummary($dateFrom: timestamptz!, $dateTo: timestamptz!, $orderBy: [laboratory_order_by!] = [], $offset: Int = 0, $limit: Int = 20) {
  laboratory(order_by: $orderBy, offset: $offset, limit: $limit) {
    id
    name
    costSummary(args: {date_from: $dateFrom, date_to: $dateTo}) {
      costSum
      orderCount
      testCount
    }
  }
  laboratory_aggregate {
    aggregate {
      count
    }
  }
}
    `;

export function useGetLaboratoryCostSummaryQuery(options: Omit<Urql.UseQueryArgs<GetLaboratoryCostSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLaboratoryCostSummaryQuery, GetLaboratoryCostSummaryQueryVariables>({ query: GetLaboratoryCostSummaryDocument, ...options });
};
export const GetLaboratoryShippingByLaboratoryIdDocument = gql`
    query GetLaboratoryShippingByLaboratoryId($laboratoryId: Int!) {
  laboratory_shipping(where: {laboratoryId: {_eq: $laboratoryId}}, limit: 1) {
    id
    email
    phone
    pointName
  }
}
    `;

export function useGetLaboratoryShippingByLaboratoryIdQuery(options: Omit<Urql.UseQueryArgs<GetLaboratoryShippingByLaboratoryIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLaboratoryShippingByLaboratoryIdQuery, GetLaboratoryShippingByLaboratoryIdQueryVariables>({ query: GetLaboratoryShippingByLaboratoryIdDocument, ...options });
};
export const GetLaboratoryTestDocument = gql`
    query GetLaboratoryTest($id: Int!) {
  laboratory_test_by_pk(id: $id) {
    ...laboratoryTest
  }
}
    ${LaboratoryTestFragmentDoc}`;

export function useGetLaboratoryTestQuery(options: Omit<Urql.UseQueryArgs<GetLaboratoryTestQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLaboratoryTestQuery, GetLaboratoryTestQueryVariables>({ query: GetLaboratoryTestDocument, ...options });
};
export const GetLaboratoryTestsDocument = gql`
    query GetLaboratoryTests($laboratoryId: Int!, $limit: Int = 100, $offset: Int = 0, $orderBy: [laboratory_test_order_by!] = [{id: asc}]) {
  laboratory_test(
    where: {laboratoryId: {_eq: $laboratoryId}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    id
    testId
    price
    waitingTime
    test {
      name
    }
  }
  laboratory_test_aggregate(where: {laboratoryId: {_eq: $laboratoryId}}) {
    aggregate {
      count
    }
  }
}
    `;

export function useGetLaboratoryTestsQuery(options: Omit<Urql.UseQueryArgs<GetLaboratoryTestsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLaboratoryTestsQuery, GetLaboratoryTestsQueryVariables>({ query: GetLaboratoryTestsDocument, ...options });
};
export const GetLogsDocument = gql`
    query GetLogs($q: String, $from: Int = 0, $size: Int = 100) {
  administrator_logs(q: $q, size: $size, from: $from) {
    timestamp
    client {
      id
      email
    }
    nurse {
      id
      email
      name
    }
    orderTest {
      id
      test {
        shortName
      }
    }
    file {
      id
      name
    }
    order {
      id
      clientId
      orderCollections {
        nurseId
      }
    }
    orderState {
      state
    }
    orderTestResult {
      originalFilename
    }
    test {
      id
      shortName
    }
    data
    prevData
    type
    sessionClient {
      id
      email
    }
    sessionNurse {
      id
      email
      name
    }
    sessionAdministrator {
      id
      email
      name
    }
    sessionLabUser {
      id
      name
      email
      laboratoryId
    }
  }
}
    `;

export function useGetLogsQuery(options?: Omit<Urql.UseQueryArgs<GetLogsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLogsQuery, GetLogsQueryVariables>({ query: GetLogsDocument, ...options });
};
export const GetMaterialDocument = gql`
    query GetMaterial($id: Int!) {
  material_by_pk(id: $id) {
    ...material
  }
}
    ${MaterialFragmentDoc}`;

export function useGetMaterialQuery(options: Omit<Urql.UseQueryArgs<GetMaterialQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMaterialQuery, GetMaterialQueryVariables>({ query: GetMaterialDocument, ...options });
};
export const GetMaterialsDocument = gql`
    query GetMaterials($limit: Int = 100, $offset: Int = 0, $orderBy: [material_order_by!] = [{id: asc}]) {
  material(limit: $limit, offset: $offset, order_by: $orderBy) {
    ...material
  }
  material_aggregate {
    aggregate {
      count
    }
  }
}
    ${MaterialFragmentDoc}`;

export function useGetMaterialsQuery(options?: Omit<Urql.UseQueryArgs<GetMaterialsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMaterialsQuery, GetMaterialsQueryVariables>({ query: GetMaterialsDocument, ...options });
};
export const GetNurseDocument = gql`
    query GetNurse($id: Int!) {
  nurse_by_pk(id: $id) {
    ...nurse
  }
}
    ${NurseFragmentDoc}`;

export function useGetNurseQuery(options: Omit<Urql.UseQueryArgs<GetNurseQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNurseQuery, GetNurseQueryVariables>({ query: GetNurseDocument, ...options });
};
export const GetNursesByOrderLocationDocument = gql`
    query GetNursesByOrderLocation($location: geography!) {
  nurse(
    where: {orderArea: {_st_intersects: $location}, deletedAt: {_is_null: true}}
  ) {
    id
    name
    labArea
  }
}
    `;

export function useGetNursesByOrderLocationQuery(options: Omit<Urql.UseQueryArgs<GetNursesByOrderLocationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNursesByOrderLocationQuery, GetNursesByOrderLocationQueryVariables>({ query: GetNursesByOrderLocationDocument, ...options });
};
export const GetNurseCostSummaryDocument = gql`
    query GetNurseCostSummary($dateFrom: timestamptz!, $dateTo: timestamptz!, $orderBy: [nurse_order_by!] = [], $offset: Int = 0, $limit: Int = 20) {
  nurse(order_by: $orderBy, offset: $offset, limit: $limit) {
    id
    name
    costSummary(args: {date_from: $dateFrom, date_to: $dateTo}) {
      collectionCostSum
      collectionKitCostSum
      deliveryCostSum
      orderCount
      totalCostSum
    }
  }
  nurse_aggregate {
    aggregate {
      count
    }
  }
}
    `;

export function useGetNurseCostSummaryQuery(options: Omit<Urql.UseQueryArgs<GetNurseCostSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNurseCostSummaryQuery, GetNurseCostSummaryQueryVariables>({ query: GetNurseCostSummaryDocument, ...options });
};
export const GetNursesDocument = gql`
    query GetNurses($limit: Int = 100, $offset: Int = 0, $orderBy: [nurse_order_by!] = [{id: asc}]) {
  nurse(
    where: {deletedAt: {_is_null: true}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    ...nurse
  }
  nurse_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
}
    ${NurseFragmentDoc}`;

export function useGetNursesQuery(options?: Omit<Urql.UseQueryArgs<GetNursesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNursesQuery, GetNursesQueryVariables>({ query: GetNursesDocument, ...options });
};
export const GetOrderDocument = gql`
    query GetOrder($id: Int!) {
  order_by_pk(id: $id) {
    ...order
  }
}
    ${OrderFragmentDoc}`;

export function useGetOrderQuery(options: Omit<Urql.UseQueryArgs<GetOrderQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrderQuery, GetOrderQueryVariables>({ query: GetOrderDocument, ...options });
};
export const GetOrderShipmentLabelDocument = gql`
    query GetOrderShipmentLabel($shipmentId: bigint!) {
  administrator_order_shipment_label(shipmentId: $shipmentId) {
    fileType
    fileBase64
  }
}
    `;

export function useGetOrderShipmentLabelQuery(options: Omit<Urql.UseQueryArgs<GetOrderShipmentLabelQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrderShipmentLabelQuery, GetOrderShipmentLabelQueryVariables>({ query: GetOrderShipmentLabelDocument, ...options });
};
export const GetOrdersDocument = gql`
    query GetOrders($where: order_bool_exp = {}, $limit: Int = 100, $offset: Int = 0, $orderBy: [order_order_by!] = []) {
  order(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
    ...order
    orderTestLaboratories: orderTests(distinct_on: [collectionPointId]) {
      collectionPoint {
        id
        name
        laboratory {
          id
          name
          shortName
        }
      }
    }
    orderShippingLaboratory: orderShippings(
      where: {laboratoryId: {_is_null: false}}
      limit: 1
    ) {
      laboratory {
        id
        name
        shortName
      }
    }
  }
  order_aggregate {
    aggregate {
      count
    }
  }
}
    ${OrderFragmentDoc}`;

export function useGetOrdersQuery(options?: Omit<Urql.UseQueryArgs<GetOrdersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrdersQuery, GetOrdersQueryVariables>({ query: GetOrdersDocument, ...options });
};
export const GetOrdersByLaboratoryDocument = gql`
    query GetOrdersByLaboratory($laboratoryId: Int!, $dateFrom: timestamptz!, $dateTo: timestamptz!, $orderBy: [order_order_by!] = []) {
  order(
    where: {_and: [{orderTests: {collectionPoint: {laboratoryId: {_eq: $laboratoryId}}}}, {currentStateDate: {_gt: $dateFrom}}, {currentStateDate: {_lt: $dateTo}}, {currentState: {_eq: "Finished"}}]}
    order_by: $orderBy
  ) {
    id
    orderTests {
      test {
        id
        name
      }
      cost
    }
    orderCollections {
      collectionCost
      deliveryCost
    }
    currentStateDate
    totalCost
  }
}
    `;

export function useGetOrdersByLaboratoryQuery(options: Omit<Urql.UseQueryArgs<GetOrdersByLaboratoryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrdersByLaboratoryQuery, GetOrdersByLaboratoryQueryVariables>({ query: GetOrdersByLaboratoryDocument, ...options });
};
export const GetOrdersByNurseDocument = gql`
    query GetOrdersByNurse($nurseId: Int!, $dateFrom: timestamptz!, $dateTo: timestamptz!, $orderBy: [order_order_by!] = []) {
  order(
    where: {_and: [{orderCollections: {nurseId: {_eq: $nurseId}}}, {currentStateDate: {_gt: $dateFrom}}, {currentStateDate: {_lt: $dateTo}}, {currentState: {_eq: "Finished"}}]}
    order_by: $orderBy
  ) {
    id
    orderTests {
      test {
        id
        name
      }
    }
    orderCollections {
      collectionCost
      collectionKitCost
      deliveryCost
    }
    currentStateDate
    totalCost
  }
}
    `;

export function useGetOrdersByNurseQuery(options: Omit<Urql.UseQueryArgs<GetOrdersByNurseQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrdersByNurseQuery, GetOrdersByNurseQueryVariables>({ query: GetOrdersByNurseDocument, ...options });
};
export const GetPushNotificationDocument = gql`
    query GetPushNotification($id: Int!) {
  push_notification_by_pk(id: $id) {
    id
    notificationId
    heading_i18n
    content_i18n
    url
    pushNotificationClients {
      clientId
    }
  }
}
    `;

export function useGetPushNotificationQuery(options: Omit<Urql.UseQueryArgs<GetPushNotificationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPushNotificationQuery, GetPushNotificationQueryVariables>({ query: GetPushNotificationDocument, ...options });
};
export const GetPushNotificationsDocument = gql`
    query GetPushNotifications($limit: Int = 100, $offset: Int = 0, $orderBy: [push_notification_order_by!] = [{id: asc}]) {
  push_notification(limit: $limit, offset: $offset, order_by: $orderBy) {
    id
    notificationId
    heading_i18n
    content_i18n
    url
    pushNotificationClients_aggregate {
      aggregate {
        count
      }
    }
  }
  push_notification_aggregate {
    aggregate {
      count
    }
  }
}
    `;

export function useGetPushNotificationsQuery(options?: Omit<Urql.UseQueryArgs<GetPushNotificationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPushNotificationsQuery, GetPushNotificationsQueryVariables>({ query: GetPushNotificationsDocument, ...options });
};
export const GetRateDocument = gql`
    query GetRate($id: Int!) {
  rate_by_pk(id: $id) {
    ...rate
  }
}
    ${RateFragmentDoc}`;

export function useGetRateQuery(options: Omit<Urql.UseQueryArgs<GetRateQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRateQuery, GetRateQueryVariables>({ query: GetRateDocument, ...options });
};
export const GetRatesDocument = gql`
    query GetRates($limit: Int = 100, $offset: Int = 0, $orderBy: [rate_order_by!] = [{id: asc}]) {
  rate(limit: $limit, offset: $offset, order_by: $orderBy) {
    ...rate
  }
  rate_aggregate {
    aggregate {
      count
    }
  }
}
    ${RateFragmentDoc}`;

export function useGetRatesQuery(options?: Omit<Urql.UseQueryArgs<GetRatesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRatesQuery, GetRatesQueryVariables>({ query: GetRatesDocument, ...options });
};
export const GetShippingByCodeDocument = gql`
    query GetShippingByCode($code: String!) {
  shipping(where: {code: {_eq: $code}}, limit: 1) {
    id
  }
}
    `;

export function useGetShippingByCodeQuery(options: Omit<Urql.UseQueryArgs<GetShippingByCodeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetShippingByCodeQuery, GetShippingByCodeQueryVariables>({ query: GetShippingByCodeDocument, ...options });
};
export const GetTagDocument = gql`
    query GetTag($id: String!) {
  tag_by_pk(id: $id) {
    id
    tag_i18n
  }
}
    `;

export function useGetTagQuery(options: Omit<Urql.UseQueryArgs<GetTagQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTagQuery, GetTagQueryVariables>({ query: GetTagDocument, ...options });
};
export const GetTagsDocument = gql`
    query GetTags($limit: Int! = 20, $offset: Int = 0, $orderBy: [tag_order_by!] = [{id: asc}]) {
  tag(limit: $limit, offset: $offset, order_by: $orderBy) {
    id
    tag_i18n
    testTags_aggregate {
      aggregate {
        count
      }
    }
  }
  tag_aggregate {
    aggregate {
      count
    }
  }
}
    `;

export function useGetTagsQuery(options?: Omit<Urql.UseQueryArgs<GetTagsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTagsQuery, GetTagsQueryVariables>({ query: GetTagsDocument, ...options });
};
export const GetTestDocument = gql`
    query GetTest($id: Int!) {
  test_by_pk(id: $id) {
    ...test
  }
}
    ${TestFragmentDoc}`;

export function useGetTestQuery(options: Omit<Urql.UseQueryArgs<GetTestQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTestQuery, GetTestQueryVariables>({ query: GetTestDocument, ...options });
};
export const GetTestLaboratoriesDocument = gql`
    query GetTestLaboratories($testId: Int!, $limit: Int = 100, $offset: Int = 0, $orderBy: [laboratory_test_order_by!] = [{id: asc}]) {
  laboratory_test(
    where: {testId: {_eq: $testId}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    id
    testId
    laboratoryId
    price
    waitingTime
    test {
      name
    }
    laboratory {
      name
      shortName
    }
  }
  laboratory_test_aggregate(where: {testId: {_eq: $testId}}) {
    aggregate {
      count
    }
  }
}
    `;

export function useGetTestLaboratoriesQuery(options: Omit<Urql.UseQueryArgs<GetTestLaboratoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTestLaboratoriesQuery, GetTestLaboratoriesQueryVariables>({ query: GetTestLaboratoriesDocument, ...options });
};
export const GetTestsDocument = gql`
    query GetTests($limit: Int! = 20, $offset: Int = 0, $orderBy: [test_order_by!] = [{id: asc}]) {
  test(
    where: {deletedAt: {_is_null: true}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    ...test
  }
  test_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
}
    ${TestFragmentDoc}`;

export function useGetTestsQuery(options?: Omit<Urql.UseQueryArgs<GetTestsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTestsQuery, GetTestsQueryVariables>({ query: GetTestsDocument, ...options });
};
export const GetTrainingDocument = gql`
    query GetTraining($id: Int!) {
  training_by_pk(id: $id) {
    ...training
  }
}
    ${TrainingFragmentDoc}`;

export function useGetTrainingQuery(options: Omit<Urql.UseQueryArgs<GetTrainingQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTrainingQuery, GetTrainingQueryVariables>({ query: GetTrainingDocument, ...options });
};
export const GetTrainingsDocument = gql`
    query GetTrainings($limit: Int! = 20, $offset: Int = 0, $orderBy: [training_order_by!] = [{id: asc}]) {
  training(
    where: {deletedAt: {_is_null: true}}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    ...training
  }
  training_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
}
    ${TrainingFragmentDoc}`;

export function useGetTrainingsQuery(options?: Omit<Urql.UseQueryArgs<GetTrainingsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTrainingsQuery, GetTrainingsQueryVariables>({ query: GetTrainingsDocument, ...options });
};
export const InsertAdministratorNotificationDocument = gql`
    mutation InsertAdministratorNotification($administratorId: Int!, $scope: String!, $email: Boolean!, $sms: Boolean!) {
  insert_administrator_notification_one(
    object: {administratorId: $administratorId, scope: $scope, email: $email, sms: $sms}
  ) {
    id
  }
}
    `;

export function useInsertAdministratorNotificationMutation() {
  return Urql.useMutation<InsertAdministratorNotificationMutation, InsertAdministratorNotificationMutationVariables>(InsertAdministratorNotificationDocument);
};
export const InsertCollectionSlotDocument = gql`
    mutation InsertCollectionSlot($collectionPointId: Int!, $dateFrom: timestamptz!, $dateTo: timestamptz!) {
  insert_collection_slot_one(
    object: {collectionPointId: $collectionPointId, dateFrom: $dateFrom, dateTo: $dateTo}
  ) {
    ...collectionSlot
  }
}
    ${CollectionSlotFragmentDoc}`;

export function useInsertCollectionSlotMutation() {
  return Urql.useMutation<InsertCollectionSlotMutation, InsertCollectionSlotMutationVariables>(InsertCollectionSlotDocument);
};
export const InsertCollectionSlotsDocument = gql`
    mutation InsertCollectionSlots($objects: [collection_slot_insert_input!]!) {
  insert_collection_slot(objects: $objects) {
    affected_rows
  }
}
    `;

export function useInsertCollectionSlotsMutation() {
  return Urql.useMutation<InsertCollectionSlotsMutation, InsertCollectionSlotsMutationVariables>(InsertCollectionSlotsDocument);
};
export const InsertConsultationDocument = gql`
    mutation InsertConsultation($name_i18n: jsonb!, $description_i18n: jsonb!, $svgIcon: String, $price: numeric!) {
  insert_consultation_one(
    object: {name_i18n: $name_i18n, description_i18n: $description_i18n, svgIcon: $svgIcon, price: $price}
  ) {
    ...consultation
  }
}
    ${ConsultationFragmentDoc}`;

export function useInsertConsultationMutation() {
  return Urql.useMutation<InsertConsultationMutation, InsertConsultationMutationVariables>(InsertConsultationDocument);
};
export const InsertConsultationSlotDocument = gql`
    mutation InsertConsultationSlot($consultationId: Int!, $dateFrom: timestamptz!, $dateTo: timestamptz!) {
  insert_consultation_slot_one(
    object: {consultationId: $consultationId, dateFrom: $dateFrom, dateTo: $dateTo}
  ) {
    ...consultationSlot
  }
}
    ${ConsultationSlotFragmentDoc}`;

export function useInsertConsultationSlotMutation() {
  return Urql.useMutation<InsertConsultationSlotMutation, InsertConsultationSlotMutationVariables>(InsertConsultationSlotDocument);
};
export const InsertConsultationSlotsDocument = gql`
    mutation InsertConsultationSlots($objects: [consultation_slot_insert_input!]!) {
  insert_consultation_slot(objects: $objects) {
    affected_rows
  }
}
    `;

export function useInsertConsultationSlotsMutation() {
  return Urql.useMutation<InsertConsultationSlotsMutation, InsertConsultationSlotsMutationVariables>(InsertConsultationSlotsDocument);
};
export const InsertDiscountDocument = gql`
    mutation InsertDiscount($code: String!, $dateFrom: timestamptz, $dateTo: timestamptz, $percent: numeric!, $type: discount_type_enum_enum!) {
  insert_discount_one(
    object: {code: $code, dateFrom: $dateFrom, dateTo: $dateTo, percent: $percent, type: $type}
  ) {
    id
  }
}
    `;

export function useInsertDiscountMutation() {
  return Urql.useMutation<InsertDiscountMutation, InsertDiscountMutationVariables>(InsertDiscountDocument);
};
export const UpsertDiscountConsultationDocument = gql`
    mutation UpsertDiscountConsultation($discountId: Int!, $consultationId: Int!, $maxCount: Int) {
  insert_discount_consultation_one(
    object: {discountId: $discountId, consultationId: $consultationId, maxCount: $maxCount}
    on_conflict: {constraint: discount_consultation_pkey, update_columns: [maxCount]}
  ) {
    discountId
    consultationId
    maxCount
  }
}
    `;

export function useUpsertDiscountConsultationMutation() {
  return Urql.useMutation<UpsertDiscountConsultationMutation, UpsertDiscountConsultationMutationVariables>(UpsertDiscountConsultationDocument);
};
export const UpsertDiscountTestDocument = gql`
    mutation UpsertDiscountTest($discountId: Int!, $testId: Int!, $maxCount: Int) {
  insert_discount_test_one(
    object: {discountId: $discountId, testId: $testId, maxCount: $maxCount}
    on_conflict: {constraint: discount_test_pkey, update_columns: [maxCount]}
  ) {
    discountId
    testId
    maxCount
  }
}
    `;

export function useUpsertDiscountTestMutation() {
  return Urql.useMutation<UpsertDiscountTestMutation, UpsertDiscountTestMutationVariables>(UpsertDiscountTestDocument);
};
export const UpsertDiscountTrainingDocument = gql`
    mutation UpsertDiscountTraining($discountId: Int!, $trainingId: Int!, $maxCount: Int) {
  insert_discount_training_one(
    object: {discountId: $discountId, trainingId: $trainingId, maxCount: $maxCount}
    on_conflict: {constraint: discount_training_pkey, update_columns: [maxCount]}
  ) {
    discountId
    trainingId
    maxCount
  }
}
    `;

export function useUpsertDiscountTrainingMutation() {
  return Urql.useMutation<UpsertDiscountTrainingMutation, UpsertDiscountTrainingMutationVariables>(UpsertDiscountTrainingDocument);
};
export const InsertLabUserDocument = gql`
    mutation InsertLabUser($email: String!, $name: String!, $laboratoryId: Int!) {
  insert_lab_user_one(
    object: {email: $email, name: $name, laboratoryId: $laboratoryId}
  ) {
    id
  }
}
    `;

export function useInsertLabUserMutation() {
  return Urql.useMutation<InsertLabUserMutation, InsertLabUserMutationVariables>(InsertLabUserDocument);
};
export const InsertLaboratoryDocument = gql`
    mutation InsertLaboratory($name: String!, $shortName: String, $url: String, $enabled: Boolean!, $useHL7: Boolean!, $logoFileId: Int) {
  insert_laboratory_one(
    object: {name: $name, shortName: $shortName, url: $url, enabled: $enabled, useHL7: $useHL7, logoFileId: $logoFileId}
  ) {
    id
  }
}
    `;

export function useInsertLaboratoryMutation() {
  return Urql.useMutation<InsertLaboratoryMutation, InsertLaboratoryMutationVariables>(InsertLaboratoryDocument);
};
export const InsertLaboratoryCollectionPointDocument = gql`
    mutation InsertLaboratoryCollectionPoint($laboratoryId: Int!, $name: String!, $address: String!, $postalCode: String!, $city: String!, $location: geography!, $openingHours: jsonb!, $isVoucherEnabled: Boolean!, $isExternalResults: Boolean!, $email: String) {
  insert_laboratory_collection_point_one(
    object: {laboratoryId: $laboratoryId, name: $name, address: $address, postalCode: $postalCode, city: $city, location: $location, openingHours: $openingHours, isVoucherEnabled: $isVoucherEnabled, isExternalResults: $isExternalResults, email: $email}
  ) {
    id
  }
}
    `;

export function useInsertLaboratoryCollectionPointMutation() {
  return Urql.useMutation<InsertLaboratoryCollectionPointMutation, InsertLaboratoryCollectionPointMutationVariables>(InsertLaboratoryCollectionPointDocument);
};
export const InsertLaboratoryShippingDocument = gql`
    mutation InsertLaboratoryShipping($email: String!, $phone: String!, $pointName: String!, $laboratoryId: Int!, $shippingId: bigint!) {
  insert_laboratory_shipping_one(
    object: {email: $email, phone: $phone, pointName: $pointName, laboratoryId: $laboratoryId, shippingId: $shippingId}
  ) {
    id
  }
}
    `;

export function useInsertLaboratoryShippingMutation() {
  return Urql.useMutation<InsertLaboratoryShippingMutation, InsertLaboratoryShippingMutationVariables>(InsertLaboratoryShippingDocument);
};
export const InsertLaboratoryTestDocument = gql`
    mutation InsertLaboratoryTest($testId: Int!, $price: numeric!, $waitingTime_i18n: jsonb!, $laboratoryId: Int!, $externalId: String) {
  insert_laboratory_test_one(
    object: {testId: $testId, price: $price, waitingTime_i18n: $waitingTime_i18n, laboratoryId: $laboratoryId, externalId: $externalId}
  ) {
    id
  }
}
    `;

export function useInsertLaboratoryTestMutation() {
  return Urql.useMutation<InsertLaboratoryTestMutation, InsertLaboratoryTestMutationVariables>(InsertLaboratoryTestDocument);
};
export const InsertMaterialDocument = gql`
    mutation InsertMaterial($name: String!) {
  insert_material_one(object: {name: $name}) {
    id
  }
}
    `;

export function useInsertMaterialMutation() {
  return Urql.useMutation<InsertMaterialMutation, InsertMaterialMutationVariables>(InsertMaterialDocument);
};
export const InsertNurseDocument = gql`
    mutation InsertNurse($email: String!, $name: String!, $phoneNumber: String!, $enabled: Boolean!, $geoEnabled: Boolean!, $auth2FAEnabled: Boolean!, $nurseTests: [nurse_test_insert_input!]!, $nurseMaterials: [nurse_material_insert_input!]!, $orderArea: geography!, $labArea: geography!) {
  insert_nurse_one(
    object: {email: $email, name: $name, phoneNumber: $phoneNumber, enabled: $enabled, geoEnabled: $geoEnabled, auth2FAEnabled: $auth2FAEnabled, orderArea: $orderArea, labArea: $labArea, nurseTests: {data: $nurseTests}, nurseMaterials: {data: $nurseMaterials}}
  ) {
    id
  }
}
    `;

export function useInsertNurseMutation() {
  return Urql.useMutation<InsertNurseMutation, InsertNurseMutationVariables>(InsertNurseDocument);
};
export const InsertOrderStateDocument = gql`
    mutation InsertOrderState($orderId: Int!, $state: order_state_enum_enum!) {
  insert_order_state_one(object: {orderId: $orderId, state: $state}) {
    id
  }
}
    `;

export function useInsertOrderStateMutation() {
  return Urql.useMutation<InsertOrderStateMutation, InsertOrderStateMutationVariables>(InsertOrderStateDocument);
};
export const InsertOrdersDocument = gql`
    mutation InsertOrders($orders: [order_insert_input!]!, $clientProfiles: [client_profile_insert_input!]! = []) {
  insert_order(objects: $orders) {
    returning {
      id
    }
  }
  insert_client_profile(objects: $clientProfiles) {
    returning {
      id
    }
  }
}
    `;

export function useInsertOrdersMutation() {
  return Urql.useMutation<InsertOrdersMutation, InsertOrdersMutationVariables>(InsertOrdersDocument);
};
export const InsertPushNotificationDocument = gql`
    mutation InsertPushNotification($heading_i18n: jsonb!, $content_i18n: jsonb!, $url: String, $pushNotificationClients: [push_notification_client_insert_input!]!) {
  insert_push_notification_one(
    object: {heading_i18n: $heading_i18n, content_i18n: $content_i18n, url: $url, pushNotificationClients: {data: $pushNotificationClients}}
  ) {
    id
  }
}
    `;

export function useInsertPushNotificationMutation() {
  return Urql.useMutation<InsertPushNotificationMutation, InsertPushNotificationMutationVariables>(InsertPushNotificationDocument);
};
export const InsertRateDocument = gql`
    mutation InsertRate($name: String!, $default: Boolean!, $area: geography, $collectionCost: numeric!, $collectionCost3Plus: numeric!, $collectionKitCost: numeric!, $deliveryCostPerKm: numeric!) {
  insert_rate_one(
    object: {name: $name, default: $default, area: $area, collectionCost: $collectionCost, collectionCost3Plus: $collectionCost3Plus, collectionKitCost: $collectionKitCost, deliveryCostPerKm: $deliveryCostPerKm}
  ) {
    id
  }
}
    `;

export function useInsertRateMutation() {
  return Urql.useMutation<InsertRateMutation, InsertRateMutationVariables>(InsertRateDocument);
};
export const InsertTagDocument = gql`
    mutation InsertTag($id: String!, $tag_i18n: jsonb!) {
  insert_tag_one(object: {id: $id, tag_i18n: $tag_i18n}) {
    id
  }
}
    `;

export function useInsertTagMutation() {
  return Urql.useMutation<InsertTagMutation, InsertTagMutationVariables>(InsertTagDocument);
};
export const InsertTestDocument = gql`
    mutation InsertTest($shortName_i18n: jsonb!, $name_i18n: jsonb!, $description_i18n: jsonb!, $preparation_i18n: jsonb!, $instructions_i18n: jsonb!, $labInstructions_i18n: jsonb!, $svgIcon: String, $testTags: [test_tag_insert_input!]!, $testMaterials: [test_material_insert_input!]!, $mostPopular: Boolean!, $bloodlabEligible: Boolean!, $fulfillment: fulfillment_type!) {
  insert_test_one(
    object: {shortName_i18n: $shortName_i18n, name_i18n: $name_i18n, description_i18n: $description_i18n, preparation_i18n: $preparation_i18n, instructions_i18n: $instructions_i18n, labInstructions_i18n: $labInstructions_i18n, svgIcon: $svgIcon, testTags: {data: $testTags}, testMaterials: {data: $testMaterials}, mostPopular: $mostPopular, bloodlabEligible: $bloodlabEligible, fulfillment: $fulfillment}
  ) {
    id
  }
}
    `;

export function useInsertTestMutation() {
  return Urql.useMutation<InsertTestMutation, InsertTestMutationVariables>(InsertTestDocument);
};
export const InsertTestsDocument = gql`
    mutation InsertTests($tests: [test_insert_input!]!) {
  insert_test(objects: $tests) {
    returning {
      id
    }
  }
}
    `;

export function useInsertTestsMutation() {
  return Urql.useMutation<InsertTestsMutation, InsertTestsMutationVariables>(InsertTestsDocument);
};
export const InsertTrainingDocument = gql`
    mutation InsertTraining($name_i18n: jsonb!, $description_i18n: jsonb!, $previewFileId: Int!, $videoFileId: Int!, $price: numeric!) {
  insert_training_one(
    object: {name_i18n: $name_i18n, description_i18n: $description_i18n, previewFileId: $previewFileId, videoFileId: $videoFileId, price: $price}
  ) {
    ...training
  }
}
    ${TrainingFragmentDoc}`;

export function useInsertTrainingMutation() {
  return Urql.useMutation<InsertTrainingMutation, InsertTrainingMutationVariables>(InsertTrainingDocument);
};
export const LogoutDocument = gql`
    mutation Logout {
  administrator_logout {
    result
  }
}
    `;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
};
export const PingDocument = gql`
    mutation Ping {
  ping {
    pong
  }
}
    `;

export function usePingMutation() {
  return Urql.useMutation<PingMutation, PingMutationVariables>(PingDocument);
};
export const RestoreOrderConsultationDocument = gql`
    mutation RestoreOrderConsultation($id: Int!) {
  update_order_consultation_by_pk(pk_columns: {id: $id}, _set: {deletedAt: null}) {
    id
    cost
    costBeforeDiscount
  }
}
    `;

export function useRestoreOrderConsultationMutation() {
  return Urql.useMutation<RestoreOrderConsultationMutation, RestoreOrderConsultationMutationVariables>(RestoreOrderConsultationDocument);
};
export const RestoreOrderTestDocument = gql`
    mutation RestoreOrderTest($id: Int!) {
  update_order_test_by_pk(pk_columns: {id: $id}, _set: {deletedAt: null}) {
    id
    cost
    costBeforeDiscount
  }
}
    `;

export function useRestoreOrderTestMutation() {
  return Urql.useMutation<RestoreOrderTestMutation, RestoreOrderTestMutationVariables>(RestoreOrderTestDocument);
};
export const RestoreOrderTrainingDocument = gql`
    mutation RestoreOrderTraining($id: Int!) {
  update_order_training_by_pk(pk_columns: {id: $id}, _set: {deletedAt: null}) {
    id
    cost
    costBeforeDiscount
  }
}
    `;

export function useRestoreOrderTrainingMutation() {
  return Urql.useMutation<RestoreOrderTrainingMutation, RestoreOrderTrainingMutationVariables>(RestoreOrderTrainingDocument);
};
export const SendOrderTestDocument = gql`
    mutation SendOrderTest($id: Int!, $now: timestamptz!) {
  update_order_test_by_pk(pk_columns: {id: $id}, _set: {finishedOn: $now}) {
    id
  }
}
    `;

export function useSendOrderTestMutation() {
  return Urql.useMutation<SendOrderTestMutation, SendOrderTestMutationVariables>(SendOrderTestDocument);
};
export const SoftDeleteLaboratoryCollectionPointDocument = gql`
    mutation SoftDeleteLaboratoryCollectionPoint($id: Int!, $deletedAt: timestamptz) {
  update_laboratory_collection_point(
    where: {id: {_eq: $id}}
    _set: {deletedAt: $deletedAt}
  ) {
    affected_rows
  }
}
    `;

export function useSoftDeleteLaboratoryCollectionPointMutation() {
  return Urql.useMutation<SoftDeleteLaboratoryCollectionPointMutation, SoftDeleteLaboratoryCollectionPointMutationVariables>(SoftDeleteLaboratoryCollectionPointDocument);
};
export const SoftDeleteOrderConsultationDocument = gql`
    mutation SoftDeleteOrderConsultation($id: Int!, $deletedAt: timestamptz!) {
  update_order_consultation_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: $deletedAt}
  ) {
    id
    cost
    costBeforeDiscount
  }
}
    `;

export function useSoftDeleteOrderConsultationMutation() {
  return Urql.useMutation<SoftDeleteOrderConsultationMutation, SoftDeleteOrderConsultationMutationVariables>(SoftDeleteOrderConsultationDocument);
};
export const SoftDeleteOrderTestDocument = gql`
    mutation SoftDeleteOrderTest($id: Int!, $deletedAt: timestamptz!) {
  update_order_test_by_pk(pk_columns: {id: $id}, _set: {deletedAt: $deletedAt}) {
    id
    cost
    costBeforeDiscount
  }
}
    `;

export function useSoftDeleteOrderTestMutation() {
  return Urql.useMutation<SoftDeleteOrderTestMutation, SoftDeleteOrderTestMutationVariables>(SoftDeleteOrderTestDocument);
};
export const SoftDeleteOrderTrainingDocument = gql`
    mutation SoftDeleteOrderTraining($id: Int!, $deletedAt: timestamptz!) {
  update_order_training_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: $deletedAt}
  ) {
    id
    cost
    costBeforeDiscount
  }
}
    `;

export function useSoftDeleteOrderTrainingMutation() {
  return Urql.useMutation<SoftDeleteOrderTrainingMutation, SoftDeleteOrderTrainingMutationVariables>(SoftDeleteOrderTrainingDocument);
};
export const GetTestsByCollectionPointAndNurseDocument = gql`
    query GetTestsByCollectionPointAndNurse($collectionPointId: Int!, $nurseId: Int!, $limit: Int = 100, $offset: Int = 0, $orderBy: [test_order_by!] = [{id: asc}]) {
  tests_by_collection_point_and_nurse(
    args: {collectionpointid: $collectionPointId, nurseid: $nurseId}
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    ...test
  }
}
    ${TestFragmentDoc}`;

export function useGetTestsByCollectionPointAndNurseQuery(options: Omit<Urql.UseQueryArgs<GetTestsByCollectionPointAndNurseQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTestsByCollectionPointAndNurseQuery, GetTestsByCollectionPointAndNurseQueryVariables>({ query: GetTestsByCollectionPointAndNurseDocument, ...options });
};
export const UpdateAdministratorNotificationDocument = gql`
    mutation UpdateAdministratorNotification($id: Int!, $scope: String!, $email: Boolean!, $sms: Boolean!) {
  update_administrator_notification_by_pk(
    pk_columns: {id: $id}
    _set: {scope: $scope, email: $email, sms: $sms}
  ) {
    id
  }
}
    `;

export function useUpdateAdministratorNotificationMutation() {
  return Urql.useMutation<UpdateAdministratorNotificationMutation, UpdateAdministratorNotificationMutationVariables>(UpdateAdministratorNotificationDocument);
};
export const UpdateAdministratorPhoneNumberDocument = gql`
    mutation UpdateAdministratorPhoneNumber($id: Int!, $phoneNumber: String!) {
  update_administrator_by_pk(
    pk_columns: {id: $id}
    _set: {phoneNumber: $phoneNumber}
  ) {
    id
    phoneNumber
  }
}
    `;

export function useUpdateAdministratorPhoneNumberMutation() {
  return Urql.useMutation<UpdateAdministratorPhoneNumberMutation, UpdateAdministratorPhoneNumberMutationVariables>(UpdateAdministratorPhoneNumberDocument);
};
export const UpdateClientDocument = gql`
    mutation UpdateClient($id: Int!, $email: String!, $auth2FAEnabled: Boolean!) {
  update_client_by_pk(
    pk_columns: {id: $id}
    _set: {email: $email, auth2FAEnabled: $auth2FAEnabled}
  ) {
    id
  }
}
    `;

export function useUpdateClientMutation() {
  return Urql.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument);
};
export const UpdateCollectionSlotDocument = gql`
    mutation UpdateCollectionSlot($id: Int!, $collectionPointId: Int!, $dateFrom: timestamptz!, $dateTo: timestamptz!) {
  update_collection_slot_by_pk(
    pk_columns: {id: $id}
    _set: {collectionPointId: $collectionPointId, dateFrom: $dateFrom, dateTo: $dateTo}
  ) {
    id
  }
}
    `;

export function useUpdateCollectionSlotMutation() {
  return Urql.useMutation<UpdateCollectionSlotMutation, UpdateCollectionSlotMutationVariables>(UpdateCollectionSlotDocument);
};
export const UpdateConsultationDocument = gql`
    mutation UpdateConsultation($id: Int!, $name_i18n: jsonb!, $description_i18n: jsonb!, $svgIcon: String, $price: numeric!) {
  update_consultation_by_pk(
    pk_columns: {id: $id}
    _set: {name_i18n: $name_i18n, description_i18n: $description_i18n, svgIcon: $svgIcon, price: $price}
  ) {
    id
  }
}
    `;

export function useUpdateConsultationMutation() {
  return Urql.useMutation<UpdateConsultationMutation, UpdateConsultationMutationVariables>(UpdateConsultationDocument);
};
export const UpdateConsultationSlotDocument = gql`
    mutation UpdateConsultationSlot($id: Int!, $consultationId: Int!, $dateFrom: timestamptz!, $dateTo: timestamptz!) {
  update_consultation_slot_by_pk(
    pk_columns: {id: $id}
    _set: {consultationId: $consultationId, dateFrom: $dateFrom, dateTo: $dateTo}
  ) {
    id
  }
}
    `;

export function useUpdateConsultationSlotMutation() {
  return Urql.useMutation<UpdateConsultationSlotMutation, UpdateConsultationSlotMutationVariables>(UpdateConsultationSlotDocument);
};
export const UpdateDiscountDocument = gql`
    mutation UpdateDiscount($id: Int!, $code: String!, $dateFrom: timestamptz, $dateTo: timestamptz, $percent: numeric!, $type: discount_type_enum_enum!) {
  update_discount_by_pk(
    pk_columns: {id: $id}
    _set: {code: $code, dateFrom: $dateFrom, dateTo: $dateTo, percent: $percent, type: $type}
  ) {
    id
  }
}
    `;

export function useUpdateDiscountMutation() {
  return Urql.useMutation<UpdateDiscountMutation, UpdateDiscountMutationVariables>(UpdateDiscountDocument);
};
export const UpdateFeatureFlagDocument = gql`
    mutation UpdateFeatureFlag($id: bigint!, $isEnabled: Boolean!) {
  update_feature_flags_by_pk(pk_columns: {id: $id}, _set: {enabled: $isEnabled}) {
    enabled
  }
}
    `;

export function useUpdateFeatureFlagMutation() {
  return Urql.useMutation<UpdateFeatureFlagMutation, UpdateFeatureFlagMutationVariables>(UpdateFeatureFlagDocument);
};
export const UpdateLabUserDocument = gql`
    mutation UpdateLabUser($email: String!, $id: Int!, $name: String!) {
  update_lab_user_by_pk(pk_columns: {id: $id}, _set: {email: $email, name: $name}) {
    id
  }
}
    `;

export function useUpdateLabUserMutation() {
  return Urql.useMutation<UpdateLabUserMutation, UpdateLabUserMutationVariables>(UpdateLabUserDocument);
};
export const UpdateLabUserPasswordDocument = gql`
    mutation UpdateLabUserPassword($email: String!, $password: String!) {
  lab_user_password_update(payload: {email: $email, password: $password}) {
    result
  }
}
    `;

export function useUpdateLabUserPasswordMutation() {
  return Urql.useMutation<UpdateLabUserPasswordMutation, UpdateLabUserPasswordMutationVariables>(UpdateLabUserPasswordDocument);
};
export const UpdateLaboratoryDocument = gql`
    mutation UpdateLaboratory($id: Int!, $name: String!, $shortName: String, $url: String, $enabled: Boolean!, $useHL7: Boolean!, $logoFileId: Int) {
  update_laboratory_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, shortName: $shortName, url: $url, enabled: $enabled, useHL7: $useHL7, logoFileId: $logoFileId}
  ) {
    id
  }
}
    `;

export function useUpdateLaboratoryMutation() {
  return Urql.useMutation<UpdateLaboratoryMutation, UpdateLaboratoryMutationVariables>(UpdateLaboratoryDocument);
};
export const UpdateLaboratoryCollectionPointDocument = gql`
    mutation UpdateLaboratoryCollectionPoint($id: Int!, $name: String!, $address: String!, $postalCode: String!, $city: String!, $location: geography!, $openingHours: jsonb, $isVoucherEnabled: Boolean, $isExternalResults: Boolean, $email: String) {
  update_laboratory_collection_point(
    where: {id: {_eq: $id}}
    _set: {name: $name, address: $address, postalCode: $postalCode, city: $city, location: $location, openingHours: $openingHours, isVoucherEnabled: $isVoucherEnabled, isExternalResults: $isExternalResults, email: $email}
  ) {
    affected_rows
  }
}
    `;

export function useUpdateLaboratoryCollectionPointMutation() {
  return Urql.useMutation<UpdateLaboratoryCollectionPointMutation, UpdateLaboratoryCollectionPointMutationVariables>(UpdateLaboratoryCollectionPointDocument);
};
export const UpdateLaboratoryShippingDocument = gql`
    mutation UpdateLaboratoryShipping($id: bigint!, $email: String!, $phone: String!, $pointName: String!) {
  update_laboratory_shipping_by_pk(
    pk_columns: {id: $id}
    _set: {email: $email, phone: $phone, pointName: $pointName}
  ) {
    id
  }
}
    `;

export function useUpdateLaboratoryShippingMutation() {
  return Urql.useMutation<UpdateLaboratoryShippingMutation, UpdateLaboratoryShippingMutationVariables>(UpdateLaboratoryShippingDocument);
};
export const UpdateLaboratoryTestDocument = gql`
    mutation UpdateLaboratoryTest($id: Int!, $testId: Int!, $laboratoryId: Int!, $price: numeric!, $waitingTime_i18n: jsonb!, $externalId: String) {
  update_laboratory_test_by_pk(
    pk_columns: {id: $id}
    _set: {testId: $testId, laboratoryId: $laboratoryId, price: $price, waitingTime_i18n: $waitingTime_i18n, externalId: $externalId}
  ) {
    id
  }
}
    `;

export function useUpdateLaboratoryTestMutation() {
  return Urql.useMutation<UpdateLaboratoryTestMutation, UpdateLaboratoryTestMutationVariables>(UpdateLaboratoryTestDocument);
};
export const UpdateMaterialDocument = gql`
    mutation UpdateMaterial($id: Int!, $name: String!) {
  update_material_by_pk(pk_columns: {id: $id}, _set: {name: $name}) {
    id
  }
}
    `;

export function useUpdateMaterialMutation() {
  return Urql.useMutation<UpdateMaterialMutation, UpdateMaterialMutationVariables>(UpdateMaterialDocument);
};
export const UpdateNurseDocument = gql`
    mutation UpdateNurse($email: String!, $id: Int!, $name: String!, $phoneNumber: String!, $enabled: Boolean!, $geoEnabled: Boolean!, $auth2FAEnabled: Boolean!, $nurseTests: [nurse_test_insert_input!]!, $nurseMaterials: [nurse_material_insert_input!]!, $orderArea: geography!, $labArea: geography!) {
  delete_nurse_test(where: {nurseId: {_eq: $id}}) {
    affected_rows
  }
  delete_nurse_material(where: {nurseId: {_eq: $id}}) {
    affected_rows
  }
  update_nurse_by_pk(
    pk_columns: {id: $id}
    _set: {email: $email, name: $name, phoneNumber: $phoneNumber, enabled: $enabled, geoEnabled: $geoEnabled, auth2FAEnabled: $auth2FAEnabled, orderArea: $orderArea, labArea: $labArea}
  ) {
    id
  }
  insert_nurse_test(objects: $nurseTests) {
    affected_rows
  }
  insert_nurse_material(objects: $nurseMaterials) {
    affected_rows
  }
}
    `;

export function useUpdateNurseMutation() {
  return Urql.useMutation<UpdateNurseMutation, UpdateNurseMutationVariables>(UpdateNurseDocument);
};
export const UpdateNursePasswordDocument = gql`
    mutation UpdateNursePassword($email: String!, $password: String!) {
  nurse_password_update(payload: {email: $email, password: $password}) {
    result
  }
}
    `;

export function useUpdateNursePasswordMutation() {
  return Urql.useMutation<UpdateNursePasswordMutation, UpdateNursePasswordMutationVariables>(UpdateNursePasswordDocument);
};
export const UpdateOrderCollectionNurseDocument = gql`
    mutation UpdateOrderCollectionNurse($orderId: Int!, $nurseId: Int!) {
  update_order_by_pk(pk_columns: {id: $orderId}, _set: {nurseId: $nurseId}) {
    id
  }
  update_order_collection(
    where: {orderId: {_eq: $orderId}}
    _set: {nurseId: $nurseId}
  ) {
    returning {
      id
    }
  }
}
    `;

export function useUpdateOrderCollectionNurseMutation() {
  return Urql.useMutation<UpdateOrderCollectionNurseMutation, UpdateOrderCollectionNurseMutationVariables>(UpdateOrderCollectionNurseDocument);
};
export const UpdateOrderConsultationFinishedOnDocument = gql`
    mutation UpdateOrderConsultationFinishedOn($id: Int!) {
  update_order_consultation_by_pk(pk_columns: {id: $id}, _set: {finishedOn: now}) {
    id
  }
}
    `;

export function useUpdateOrderConsultationFinishedOnMutation() {
  return Urql.useMutation<UpdateOrderConsultationFinishedOnMutation, UpdateOrderConsultationFinishedOnMutationVariables>(UpdateOrderConsultationFinishedOnDocument);
};
export const UpdateOrderTestDocument = gql`
    mutation UpdateOrderTest($id: Int!, $tubeCode: String!, $retrievedOn: timestamptz!, $firstName: String!, $lastName: String!, $identity: jsonb, $gender: gender_enum) {
  update_order_test_by_pk(
    pk_columns: {id: $id}
    _set: {tubeCode: $tubeCode, retrievedOn: $retrievedOn, firstName: $firstName, lastName: $lastName, identity: $identity, gender: $gender}
  ) {
    id
    tubeCode
    retrievedOn
    firstName
    lastName
    identity
    gender
  }
}
    `;

export function useUpdateOrderTestMutation() {
  return Urql.useMutation<UpdateOrderTestMutation, UpdateOrderTestMutationVariables>(UpdateOrderTestDocument);
};
export const UpdateOrderTotalCostDocument = gql`
    mutation UpdateOrderTotalCost($id: Int!, $totalCost: numeric!, $costBeforeDiscount: numeric) {
  update_order_by_pk(
    pk_columns: {id: $id}
    _set: {totalCost: $totalCost, costBeforeDiscount: $costBeforeDiscount}
  ) {
    id
    totalCost
    costBeforeDiscount
  }
}
    `;

export function useUpdateOrderTotalCostMutation() {
  return Urql.useMutation<UpdateOrderTotalCostMutation, UpdateOrderTotalCostMutationVariables>(UpdateOrderTotalCostDocument);
};
export const UpdateRateDocument = gql`
    mutation UpdateRate($id: Int!, $name: String!, $default: Boolean!, $area: geography, $collectionCost: numeric!, $collectionCost3Plus: numeric!, $collectionKitCost: numeric!, $deliveryCostPerKm: numeric!) {
  update_rate_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, default: $default, area: $area, collectionCost: $collectionCost, collectionCost3Plus: $collectionCost3Plus, collectionKitCost: $collectionKitCost, deliveryCostPerKm: $deliveryCostPerKm}
  ) {
    id
  }
}
    `;

export function useUpdateRateMutation() {
  return Urql.useMutation<UpdateRateMutation, UpdateRateMutationVariables>(UpdateRateDocument);
};
export const UpdateTagDocument = gql`
    mutation UpdateTag($id: String!, $tag_i18n: jsonb!) {
  update_tag_by_pk(pk_columns: {id: $id}, _set: {tag_i18n: $tag_i18n}) {
    id
    tag_i18n
  }
}
    `;

export function useUpdateTagMutation() {
  return Urql.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument);
};
export const UpdateTestDocument = gql`
    mutation UpdateTest($id: Int!, $shortName_i18n: jsonb!, $name_i18n: jsonb!, $description_i18n: jsonb!, $preparation_i18n: jsonb!, $instructions_i18n: jsonb!, $labInstructions_i18n: jsonb!, $svgIcon: String, $testTags: [test_tag_insert_input!]!, $testMaterials: [test_material_insert_input!]!, $mostPopular: Boolean!, $bloodlabEligible: Boolean!, $fulfillment: fulfillment_type!) {
  delete_test_tag(where: {testId: {_eq: $id}}) {
    affected_rows
  }
  delete_test_material(where: {testId: {_eq: $id}}) {
    affected_rows
  }
  update_test_by_pk(
    pk_columns: {id: $id}
    _set: {shortName_i18n: $shortName_i18n, name_i18n: $name_i18n, description_i18n: $description_i18n, preparation_i18n: $preparation_i18n, instructions_i18n: $instructions_i18n, labInstructions_i18n: $labInstructions_i18n, svgIcon: $svgIcon, mostPopular: $mostPopular, bloodlabEligible: $bloodlabEligible, fulfillment: $fulfillment}
  ) {
    id
  }
  insert_test_tag(objects: $testTags) {
    affected_rows
  }
  insert_test_material(objects: $testMaterials) {
    affected_rows
  }
}
    `;

export function useUpdateTestMutation() {
  return Urql.useMutation<UpdateTestMutation, UpdateTestMutationVariables>(UpdateTestDocument);
};
export const UpdateTrainingDocument = gql`
    mutation UpdateTraining($id: Int!, $name_i18n: jsonb!, $description_i18n: jsonb!, $previewFileId: Int!, $videoFileId: Int!, $price: numeric!) {
  update_training_by_pk(
    pk_columns: {id: $id}
    _set: {name_i18n: $name_i18n, description_i18n: $description_i18n, previewFileId: $previewFileId, videoFileId: $videoFileId, price: $price}
  ) {
    id
  }
}
    `;

export function useUpdateTrainingMutation() {
  return Urql.useMutation<UpdateTrainingMutation, UpdateTrainingMutationVariables>(UpdateTrainingDocument);
};
export const UpsertTestsDocument = gql`
    mutation UpsertTests($testInserts: [test_insert_input!]!, $testUpdates: [test_updates!]!, $testIds: [Int!]!, $testTags: [test_tag_insert_input!]!, $testMaterials: [test_material_insert_input!]!, $laboratoryTests: [laboratory_test_insert_input!]!) {
  insert_test(objects: $testInserts) {
    returning {
      id
    }
  }
  delete_test_tag(where: {testId: {_in: $testIds}}) {
    affected_rows
  }
  delete_test_material(where: {testId: {_in: $testIds}}) {
    affected_rows
  }
  delete_laboratory_test(where: {testId: {_in: $testIds}}) {
    affected_rows
  }
  update_test_many(updates: $testUpdates) {
    affected_rows
  }
  insert_test_tag(objects: $testTags) {
    affected_rows
  }
  insert_test_material(objects: $testMaterials) {
    affected_rows
  }
  insert_laboratory_test(objects: $laboratoryTests) {
    affected_rows
  }
}
    `;

export function useUpsertTestsMutation() {
  return Urql.useMutation<UpsertTestsMutation, UpsertTestsMutationVariables>(UpsertTestsDocument);
};